(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8059,4482,7987],{

/***/ 95834:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/homes/[market]",
      function () {
        return __webpack_require__(55729);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 77182:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X$": function() { return /* binding */ fetchArticlesByTags; },
/* harmony export */   "dY": function() { return /* binding */ fetchEntriesByTags; },
/* harmony export */   "u_": function() { return /* binding */ createContentfulClient; },
/* harmony export */   "x5": function() { return /* binding */ fetchEntriesById; },
/* harmony export */   "yR": function() { return /* binding */ fetchEntryById; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92336);
/* harmony import */ var components_globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* harmony import */ var contentful__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17490);
/* provided dependency */ var process = __webpack_require__(73656);






// guards against an unset DEPLOY_ENV variable or a mistakenly
// named DEPLOY_ENV variable (oopsproduction)
// We'll fallback to standard environment if we're not explicitly
// in a non-production environment
// Later this function can take the request context if we want to
// do cookie-based previews
var checkIfPreview = function() {
    return components_globals__WEBPACK_IMPORTED_MODULE_0__/* .DEPLOY_ENV */ .Zp && [
        "staging",
        "development",
        "localdev",
        "qa",
        "test"
    ].includes(components_globals__WEBPACK_IMPORTED_MODULE_0__/* .DEPLOY_ENV */ .Zp);
};
var createContentfulClient = function() {
    var isPreview = checkIfPreview();
    var contentfulClientOpts = null;
    if (isPreview) {
        contentfulClientOpts = {
            accessToken: process.env.CONTENTFUL_DELIVERY_PREVIEW_ACCESS_TOKEN,
            host: "preview.contentful.com",
            space: process.env.CONTENTFUL_SPACE_ID,
            environment: process.env.CONTENTFUL_ENVIRONMENT
        };
    } else {
        contentfulClientOpts = {
            accessToken: process.env.CONTENTFUL_DELIVERY_ACCESS_TOKEN,
            space: process.env.CONTENTFUL_SPACE_ID
        };
    }
    return contentful__WEBPACK_IMPORTED_MODULE_1__/* .createClient */ .e(contentfulClientOpts);
};
function fetchEntriesByTags(contentType, tags) {
    return _fetchEntriesByTags.apply(this, arguments);
}
function _fetchEntriesByTags() {
    _fetchEntriesByTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contentType, tags) {
        var options, limit, select, skip, order, _include, include, client, response, safeEntry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    if (tags === undefined) {
                        return [
                            2,
                            {
                                total: 0,
                                items: []
                            }
                        ];
                    }
                    limit = options.limit, select = options.select, skip = options.skip, order = options.order, _include = options.include, include = _include === void 0 ? 2 : _include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: contentType,
                            include: include,
                            "metadata.tags.sys.id[in]": tags.join(",")
                        }, order && {
                            order: order
                        }, select && {
                            select: select
                        }, limit && {
                            limit: limit
                        }, skip && {
                            skip: skip
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.total === 0) {
                        return [
                            2,
                            {
                                total: 0,
                                items: []
                            }
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    return [
                        2,
                        {
                            total: safeEntry.total,
                            items: safeEntry.items
                        }
                    ];
            }
        });
    });
    return _fetchEntriesByTags.apply(this, arguments);
}
function fetchArticlesByTags(tags) {
    return _fetchArticlesByTags.apply(this, arguments);
}
function _fetchArticlesByTags() {
    _fetchArticlesByTags = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(tags) {
        var options;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {};
            return [
                2,
                fetchEntriesByTags("article", tags, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, options), {
                    order: "-fields.publishDate"
                }))
            ];
        });
    });
    return _fetchArticlesByTags.apply(this, arguments);
}
function fetchEntryById(content_type, id) {
    return _fetchEntryById.apply(this, arguments);
}
function _fetchEntryById() {
    _fetchEntryById = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(content_type, id) {
        var options, select, include, client, response, safeEntry, entry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    select = options.select, include = options.include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: content_type
                        }, select && {
                            select: select
                        }, include && {
                            include: include
                        }), {
                            "sys.id[in]": "".concat(id)
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.items.length === 0) {
                        return [
                            2,
                            undefined
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    entry = safeEntry.items[0];
                    return [
                        2,
                        entry
                    ];
            }
        });
    });
    return _fetchEntryById.apply(this, arguments);
}
function fetchEntriesById(contentType, ids) {
    return _fetchEntriesById.apply(this, arguments);
}
function _fetchEntriesById() {
    _fetchEntriesById = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(contentType, ids) {
        var options, select, include, client, response, safeEntry;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {};
                    select = options.select, include = options.include;
                    client = createContentfulClient();
                    return [
                        4,
                        client.getEntries((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                            content_type: contentType
                        }, select && {
                            select: select
                        }, include && {
                            include: include
                        }), {
                            "sys.id[in]": ids.join(",")
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (response.items.length === 0) {
                        return [
                            2,
                            []
                        ];
                    }
                    safeEntry = JSON.parse(response.stringifySafe());
                    // contentful de-duplicates if you have multiple of the same entry id
                    // callers expect the same response shape as the input
                    // so if we call with ['id1', 'id2', 'id1']
                    // we need to include dupe entries
                    return [
                        2,
                        ids.map(function(id) {
                            return safeEntry.items.find(function(x) {
                                return x.sys.id === id;
                            });
                        })
                    ];
            }
        });
    });
    return _fetchEntriesById.apply(this, arguments);
}


/***/ }),

/***/ 92982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ articleV2; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Accordion/Accordion.tsx + 1 modules
var Accordion = __webpack_require__(94322);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ./src/components/articles-v2/renderer.tsx
var renderer = __webpack_require__(63206);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Container.tsx
var Container = __webpack_require__(51462);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/ComponentTheme.ts
var ComponentTheme = __webpack_require__(47456);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Typography.tsx
var Typography = __webpack_require__(91749);
// EXTERNAL MODULE: ./src/components/shared/CardCarouselV2.tsx
var CardCarouselV2 = __webpack_require__(80842);
// EXTERNAL MODULE: ./src/components/shared/Multicard/MulticardCard.tsx
var MulticardCard = __webpack_require__(67022);
// EXTERNAL MODULE: ../../node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/swiper.min.css
var swiper_min = __webpack_require__(57485);
// EXTERNAL MODULE: ../../node_modules/.pnpm/swiper@8.4.7/node_modules/swiper/modules/pagination/pagination.min.css
var pagination_min = __webpack_require__(59636);
;// CONCATENATED MODULE: ./src/components/articles-v2/Multicard.tsx















var columns = {
    Two: 2,
    Three: 3,
    Four: 4
};
var ArchBox = /*#__PURE__*/ react.forwardRef(function(_param, ref) /*#__PURE__*/ {
    var isArched = _param.isArched, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isArched"
    ]);
    return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, props), {
        "$platform-web": (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props["$platform-web"]), {
            borderRadius: isArched ? "99em 99em 8em 8em" : "24px"
        })
    }));
});
ArchBox.displayName = "ArchBox";
var AccordionCardDetails = function(param) {
    var card = param.card, isArched = param.isArched, idToDataLoader = param.idToDataLoader;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MulticardCard/* CardImage */.xu, {
                isArched: isArched,
                src: (ref3 = card.fields.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url,
                alt: ((ref6 = card.fields.image) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.fields) === null || ref7 === void 0 ? void 0 : ref7.description) || ((ref8 = card.fields.image) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : ref9.title)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
                variant: "regular",
                size: "medium",
                isFullWidth: true,
                analyticsName: "cosmos-articles-multicard-accordion",
                items: [
                    {
                        title: card.fields.title || "",
                        eyebrowText: card.fields.eyebrow,
                        description: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                            gap: "$2",
                            children: [
                                card.fields.subhead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    fontWeight: "$medium",
                                    color: "$contentPrimary",
                                    children: card.fields.subhead
                                }),
                                card.fields.description ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(renderer/* default.Component */.Z.Component, {
                                    body: card.fields.description,
                                    idToLoaderData: idToDataLoader,
                                    entryLookup: articleV2
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    display: "block"
                                })
                            ]
                        })
                    }, 
                ]
            })
        ]
    });
};
var CardSectionHeader = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        gap: "$2",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            children: [
                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                    title: fields.title,
                    titleAccent: fields.titleAccent,
                    titleSize: fields.titleSize === "Large" ? [
                        "64px",
                        null,
                        "88px"
                    ] : [
                        "64px"
                    ]
                }),
                (fields.subhead || fields.desc) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$4",
                    maxWidth: "$96",
                    children: [
                        fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                            children: fields.subhead
                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* SubheadSmall */.Jm, {
                            children: fields.subhead
                        })),
                        fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                            $largerThanLG: {
                                fontSize: 24
                            },
                            children: fields.desc
                        })
                    ]
                })
            ]
        })
    });
};
var RenderMulticard = function(entry, _, context) {
    var fields = entry.fields;
    var idToDataLoader = context === null || context === void 0 ? void 0 : context.idToLoaderData;
    var columnNumber = fields.columns ? columns[fields.columns] : 3;
    var componentTheme = fields.cardBackgroundColor ? (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.cardBackgroundColor) : (0,ComponentTheme/* getComponentThemeColors */._Y)("White 0");
    var isArched = fields.cardStyle === "Arch";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        overflow: "hidden",
        "$platform-web": {
            gridColumn: "1 / -1"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            gap: "$6",
            children: [
                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardSectionHeader, {
                        entry: entry
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardCarouselV2/* default */.Z, {
                    id: entry.sys.id,
                    cards: fields.cards,
                    componentTheme: componentTheme,
                    columnNumber: columnNumber,
                    isArched: isArched,
                    renderCard: function(card) {
                        var ref, ref1, ref2, ref3, ref4, ref5;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArchBox, {
                            pt: ((ref = card.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url) ? "$2" : "$22",
                            pb: ((ref3 = card.fields.image) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.fields) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.file) === null || ref5 === void 0 ? void 0 : ref5.url) ? "$2" : "$6",
                            px: "$6",
                            height: "min-content",
                            isArched: isArched,
                            backgroundColor: "$backgroundTertiary",
                            maxWidth: "90vw",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionCardDetails, {
                                card: card,
                                componentTheme: componentTheme,
                                isArched: isArched,
                                idToDataLoader: idToDataLoader
                            })
                        });
                    }
                })
            ]
        })
    });
};
// https://app.contentful.com/spaces/bjlp9d7o6h1o/content_types/componentMulticard/fields
var Multicard = {
    render: RenderMulticard
};
/* harmony default export */ var articles_v2_Multicard = (Multicard);

// EXTERNAL MODULE: ./src/components/shared/Articles.tsx
var Articles = __webpack_require__(76558);
;// CONCATENATED MODULE: ./src/components/articles-v2/AccordionList.tsx


var renderAccordionList = function(entry) {
    var items = (entry.fields.items || []).filter(Boolean).map(function(param) {
        var fields = param.fields;
        return {
            title: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
            description: (fields === null || fields === void 0 ? void 0 : fields.body) || ""
        };
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        width: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accordion/* Accordion */.U, {
            variant: "medium",
            size: "medium",
            isFullWidth: true,
            items: items,
            showDivider: true,
            analyticsName: "cosmos-articles-accordion-list"
        })
    });
};
var AccordionList = {
    render: renderAccordionList
};
/* harmony default export */ var articles_v2_AccordionList = (AccordionList);

// EXTERNAL MODULE: ../bricks-next/src/components/Link/Link.tsx
var Link = __webpack_require__(46320);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Row.tsx
var Row = __webpack_require__(34984);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowDown.mjs
var IconArrowDown = __webpack_require__(16884);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconArrowUp.mjs
var IconArrowUp = __webpack_require__(27167);
;// CONCATENATED MODULE: ./src/components/articles-v2/BasicMetric.tsx



var formatMetric = function(metricValue, metricFormat) {
    switch(metricFormat){
        case "currency":
            // just take whatever is inputted if it's less than 1000
            if (metricValue < 1000) {
                return "$".concat(metricValue);
            }
            return "$".concat(Math.round(metricValue / 1000).toFixed(0), "k");
        case "decimal":
            return metricValue.toLocaleString("en-US");
        case "number":
            return metricValue.toLocaleString("en-US");
        case "percent":
            return metricValue.toLocaleString("en-US", {
                style: "percent",
                maximumFractionDigits: 3
            });
        default:
            return "".concat(metricValue);
    }
};
var formatSource = function(source) {
    if (!source) {
        return "Opendoor";
    }
    try {
        var url = new URL(source);
        if (!url.protocol.startsWith("http")) {
            return source;
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            typography: "$bodySmall",
            href: source,
            analyticsName: "cosmos-articles-basic-metric-source",
            "aria-label": "",
            children: url.host
        });
    } catch (e) {
        return source;
    }
};
var renderBasicMetric = function(entry) {
    var fields = entry.fields;
    if (fields.value === undefined) {
        return null;
    }
    var relativeChange = null;
    if (fields.comparisonValue) {
        var x1 = fields.comparisonValue;
        var x2 = fields.value;
        relativeChange = (x2 - x1) / x1;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                alignItems: "center",
                gap: "$1",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderLarge",
                        $largerThanMD: {
                            typography: "$headerMedium"
                        },
                        color: "$contentAccentBrand",
                        children: formatMetric(fields.value, fields.format)
                    }),
                    relativeChange !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        justifyContent: "center",
                        alignItems: "center",
                        children: [
                            relativeChange < 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconArrowDown/* default */.Z, {
                                size: 14
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconArrowUp/* default */.Z, {
                                size: 14
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyXsmall",
                                $largerThanMD: {
                                    typography: "$bodySmall"
                                },
                                children: [
                                    Math.round(relativeChange * 100).toFixed(0),
                                    "%"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyMedium",
                children: fields.metricName
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$1",
                mt: "$2",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Metric: ",
                            fields.metricDescription
                        ]
                    }),
                    relativeChange !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Comparison: ",
                            fields.comparisonDescription
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodySmall",
                        color: "$contentSecondary",
                        children: [
                            "Source: ",
                            formatSource(fields.metricSource)
                        ]
                    })
                ]
            })
        ]
    }, fields.metricId || fields.metricName);
};
var BasicMetric = {
    render: renderBasicMetric
};
/* harmony default export */ var articles_v2_BasicMetric = (BasicMetric);

// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/dynamic.js
var dynamic = __webpack_require__(5984);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
;// CONCATENATED MODULE: ./src/components/articles-v2/EmailInput.tsx



var DynamicEmailInput = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8948), __webpack_require__.e(7154), __webpack_require__.e(2394), __webpack_require__.e(4921)]).then(__webpack_require__.bind(__webpack_require__, 24921)).then(function(mod) {
        return mod.EmailInput;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(24921)
            ];
        }
    },
    ssr: false
});
var renderEmailEntry = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            borderRadius: "$8x",
            marginBottom: "$9x",
            marginTop: "$9x",
            paddingVertical: "$10x",
            paddingHorizontal: "$10x",
            width: "100%",
            $largerThanSM: {
                marginBottom: "$10x",
                marginTop: "$10x",
                paddingVertical: "$16x",
                paddingHorizontal: "$16x",
                marginRight: -10
            },
            backgroundColor: "$backgroundAccentBrand",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                alignItems: "stretch",
                display: "inline-flex",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h2",
                        typography: "$subheaderSmall",
                        $largerThanSM: {
                            typography: "$subheaderLarge"
                        },
                        color: "$borderStateInactivePrimary",
                        marginBottom: "$10x",
                        children: fields.largeTitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        marginBottom: "$10x",
                        color: "$borderStateInactivePrimary",
                        children: fields.bodyText
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DynamicEmailInput, {
                        campaignName: "articles",
                        ctaText: fields.buttonText
                    })
                ]
            })
        })
    });
};
var EmailInputComponent = {
    render: renderEmailEntry
};
/* harmony default export */ var EmailInput = (EmailInputComponent);

// EXTERNAL MODULE: ./src/cms/renderer/index.tsx
var cms_renderer = __webpack_require__(51803);
// EXTERNAL MODULE: ./src/cms/renderer/assets.tsx
var assets = __webpack_require__(79388);
;// CONCATENATED MODULE: ./src/components/articles-v2/HighlightBox.tsx





var variantStyles = {
    default: {},
    leftBorder: {
        borderLeft: "3px solid #ddd"
    },
    dropShadow: {
        boxShadow: "0px 10px 22px rgba(29, 71, 123, 0.08), 0px 2px 12px rgba(29, 71, 123, 0.08)"
    }
};
var variantBgColor = {
    default: "$backgroundTertiary",
    leftBorder: "$backgroundTertiary",
    dropShadow: "$backgroundPrimary"
};
var renderHighlightBox = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var fields = entry.fields;
    var _variant, _variant1, ref11, ref12, ref13;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
            backgroundColor: (_variant = variantBgColor[fields.variant]) !== null && _variant !== void 0 ? _variant : variantBgColor.default,
            borderRadius: "$8x",
            my: "$20x",
            p: "$12x",
            flexWrap: "wrap",
            gap: "$10x",
            $largerThanXS: {
                p: "$24x"
            },
            "$platform-web": (_variant1 = variantStyles[fields.variant]) !== null && _variant1 !== void 0 ? _variant1 : variantStyles.default,
            children: [
                fields.image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    width: (ref11 = (ref = fields.image.fields.file) === null || ref === void 0 ? void 0 : (ref1 = ref.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.width) !== null && ref11 !== void 0 ? ref11 : 200,
                    maxWidth: "100%",
                    alignSelf: "center",
                    $largerThanXS: {
                        maxWidth: "50%"
                    },
                    "$platform-web": {
                        height: "auto"
                    },
                    children: (0,assets/* default */.Z)({
                        src: (ref3 = fields.image.fields.file) === null || ref3 === void 0 ? void 0 : ref3.url,
                        contentType: ((ref4 = fields.image.fields.file) === null || ref4 === void 0 ? void 0 : ref4.contentType) || "image/png",
                        width: (ref12 = (ref5 = fields.image.fields.file) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.details) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.image) === null || ref7 === void 0 ? void 0 : ref7.width) !== null && ref12 !== void 0 ? ref12 : 200,
                        height: (ref13 = (ref8 = fields.image.fields.file) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.details) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.image) === null || ref10 === void 0 ? void 0 : ref10.height) !== null && ref13 !== void 0 ? ref13 : 200
                    })
                }),
                fields.content && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    alignItems: "flex-start",
                    flex: 1,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cms_renderer/* default.Component */.Z.Component, {
                        body: fields.content,
                        idToLoaderData: {},
                        entryLookup: articleV2
                    })
                })
            ]
        })
    });
};
var HighlightBox = {
    render: renderHighlightBox
};
/* harmony default export */ var articles_v2_HighlightBox = (HighlightBox);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@contentful+rich-text-react-renderer@15.11.1_@types+react-dom@18.3.7_@types+react@18.3._9c86b3358aa3a0aab1d7dbae5bd5bd31/node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(52058);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@contentful+rich-text-types@15.11.1/node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(64786);
;// CONCATENATED MODULE: ./src/components/articles-v2/IconText.tsx






var pictureIconSize = 42;
var renderIconText = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var _obj;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        gap: "$half",
        p: "$half",
        children: [
            fields.textIcon ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$headerSmall",
                children: fields.textIcon
            }) : fields.pictureIcon && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                height: pictureIconSize,
                width: pictureIconSize,
                children: (0,assets/* default */.Z)({
                    src: (ref = fields.pictureIcon.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                    contentType: ((ref2 = fields.pictureIcon.fields) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.file) === null || ref3 === void 0 ? void 0 : ref3.contentType) || "image/png",
                    width: pictureIconSize,
                    height: pictureIconSize
                })
            }),
            fields.labelText && (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields.labelText, {
                renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        my: "auto",
                        children: children
                    });
                }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(node, children) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        ml: "$3",
                        href: node.data.uri,
                        target: "_blank",
                        analyticsName: "cosmos-articles-icon-text",
                        "aria-label": "",
                        children: children
                    });
                }), _obj)
            })
        ]
    });
};
var IconText = {
    render: renderIconText
};
/* harmony default export */ var articles_v2_IconText = (IconText);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.11.0_@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1__@types+react@18.3.28_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(89631);
;// CONCATENATED MODULE: ./src/components/articles-v2/Iframe.tsx



var IFrame = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("iframe", {
    target: "em7cj9e0"
})("position:absolute;top:0;left:0;width:100%;height:100%;border:0;");
var renderIframe = function(entry) {
    var fields = entry.fields;
    var aspectRatio = fields.ratio ? Math.round(100 / fields.ratio) + "%" : "100%";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            // @ts-expect-error, aspect ratio not supported
            paddingBottom: aspectRatio,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IFrame, {
                title: "contenful-iframe-component",
                src: fields.url,
                allow: "autoplay; fullscreen",
                allowFullScreen: true
            })
        })
    });
};
var IframeComponent = {
    render: renderIframe
};
/* harmony default export */ var Iframe = (IframeComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageAsset.tsx




var GifComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23;
    var ref24, ref25;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        marginVertical: "$10x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "hidden",
            width: (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width,
            height: "100%",
            maxWidth: "100%",
            position: "relative",
            children: (0,assets/* default */.Z)({
                src: (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : ref7.url,
                contentType: ((ref8 = fields.asset) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.file) === null || ref10 === void 0 ? void 0 : ref10.contentType) || "image/gif",
                description: fields.description,
                width: (ref24 = (ref11 = fields.asset) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.fields) === null || ref12 === void 0 ? void 0 : (ref13 = ref12.file) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.details) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.image) === null || ref15 === void 0 ? void 0 : ref15.width) !== null && ref24 !== void 0 ? ref24 : 100,
                height: (ref25 = (ref16 = fields.asset) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.file) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.details) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.image) === null || ref20 === void 0 ? void 0 : ref20.height) !== null && ref25 !== void 0 ? ref25 : 200
            })
        })
    }, ((ref21 = fields.asset) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.file) === null || ref23 === void 0 ? void 0 : ref23.url) || "backup-id");
};
var IconComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28;
    var ref29, ref30;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "inline-flex",
        marginVertical: 5,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "hidden",
            width: (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width,
            height: (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.height,
            position: "relative",
            children: (0,assets/* default */.Z)({
                src: (ref10 = fields.asset) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.file) === null || ref12 === void 0 ? void 0 : ref12.url,
                contentType: ((ref13 = fields.asset) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.file) === null || ref15 === void 0 ? void 0 : ref15.contentType) || "image/png",
                description: fields.description,
                width: (ref29 = (ref16 = fields.asset) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.fields) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.file) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.details) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.image) === null || ref20 === void 0 ? void 0 : ref20.width) !== null && ref29 !== void 0 ? ref29 : 100,
                height: (ref30 = (ref21 = fields.asset) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.fields) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.file) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.details) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.image) === null || ref25 === void 0 ? void 0 : ref25.height) !== null && ref30 !== void 0 ? ref30 : 200
            })
        })
    }, ((ref26 = fields.asset) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.fields) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.file) === null || ref28 === void 0 ? void 0 : ref28.url) || "backup-id");
};
var ImageComponent = function(fields) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22;
    var noTitleAndSource = !((ref = fields.title) === null || ref === void 0 ? void 0 : ref.trim()) && !((ref1 = fields.source) === null || ref1 === void 0 ? void 0 : ref1.trim());
    var ref23, ref24;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "100%",
        justifyContent: "center",
        marginVertical: "$6x",
        $largerThanSM: {
            marginVertical: "$16x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            backgroundColor: "$backgroundPrimary",
            minWidth: "100%",
            borderRadius: "$10x",
            shadow: "$default",
            flexDirection: "column",
            alignItems: "center",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    borderTopLeftRadius: "$10x",
                    borderTopRightRadius: "$10x",
                    borderBottomLeftRadius: noTitleAndSource ? "$10x" : undefined,
                    borderBottomRightRadius: noTitleAndSource ? "$10x" : undefined,
                    overflow: "hidden",
                    width: "100%",
                    children: (0,assets/* default */.Z)({
                        src: fields === null || fields === void 0 ? void 0 : (ref2 = fields.asset) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.fields) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.file) === null || ref4 === void 0 ? void 0 : ref4.url,
                        contentType: (fields === null || fields === void 0 ? void 0 : (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : ref7.contentType) || "image/png",
                        description: fields === null || fields === void 0 ? void 0 : fields.description,
                        width: (ref23 = fields === null || fields === void 0 ? void 0 : (ref8 = fields.asset) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.fields) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.file) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.details) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.image) === null || ref12 === void 0 ? void 0 : ref12.width) !== null && ref23 !== void 0 ? ref23 : 100,
                        height: (ref24 = fields === null || fields === void 0 ? void 0 : (ref13 = fields.asset) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.fields) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.file) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.details) === null || ref16 === void 0 ? void 0 : (ref17 = ref16.image) === null || ref17 === void 0 ? void 0 : ref17.height) !== null && ref24 !== void 0 ? ref24 : 200
                    })
                }),
                !noTitleAndSource && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    alignItems: "center",
                    padding: "$6x",
                    children: [
                        ((ref18 = fields.title) === null || ref18 === void 0 ? void 0 : ref18.trim()) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            marginBottom: 0,
                            children: fields.title
                        }),
                        ((ref19 = fields.source) === null || ref19 === void 0 ? void 0 : ref19.trim()) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            marginTop: 0,
                            children: [
                                "Source: ",
                                fields.source
                            ]
                        })
                    ]
                })
            ]
        }, (fields === null || fields === void 0 ? void 0 : (ref20 = fields.asset) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.fields) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.file) === null || ref22 === void 0 ? void 0 : ref22.url) || "backup-id")
    });
};
var components = {
    gif: GifComponent,
    icon: IconComponent,
    image: ImageComponent
};
var renderImageAsset = function(entry) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var fields = entry.fields;
    var width = fields === null || fields === void 0 ? void 0 : (ref = fields.asset) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.width;
    var height = fields === null || fields === void 0 ? void 0 : (ref5 = fields.asset) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.fields) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.file) === null || ref7 === void 0 ? void 0 : (ref8 = ref7.details) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.image) === null || ref9 === void 0 ? void 0 : ref9.height;
    var imageType = (fields === null || fields === void 0 ? void 0 : (ref10 = fields.asset) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.fields) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.file) === null || ref12 === void 0 ? void 0 : ref12.contentType) === "image/gif" && "gif" || width && height && width <= 128 && height <= 128 && "icon" || "image";
    var Component = components[imageType];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        minWidth: 200,
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Component, (0,_object_spread/* default */.Z)({}, fields))
    });
};
var ImageAsset = {
    render: renderImageAsset
};
/* harmony default export */ var articles_v2_ImageAsset = (ImageAsset);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageAssetLink.tsx



var getSafeHref = function(uri) {
    if (!uri) {
        return null;
    }
    try {
        var url = new URL(uri);
        return url.protocol === "http:" || url.protocol === "https:" ? uri : null;
    } catch (e) {
        return null;
    }
};
var renderImageLink = function(entry) {
    var ref;
    var href = getSafeHref(entry === null || entry === void 0 ? void 0 : (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.uri);
    var image = articles_v2_ImageAsset.render(entry.fields.image);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: href ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
            href: href,
            target: "_blank",
            rel: "noopener noreferrer",
            analyticsName: "cosmos-articles-image",
            children: image
        }) : image
    });
};
var ImageAssetLink = {
    render: renderImageLink
};
/* harmony default export */ var articles_v2_ImageAssetLink = (ImageAssetLink);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(42250);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/script.js
var script = __webpack_require__(2919);
var script_default = /*#__PURE__*/__webpack_require__.n(script);
;// CONCATENATED MODULE: ./src/components/articles-v2/InstagramImage.tsx





// Parameterized instagram embed code, in the future, will use the
// instagram_oembed endpoint from the facebook API.
// You have to ask for permission to use that API by showing the intended
// usage (which we can demonstrate with this embed logic).
// Note: do not edit the styling here (beyond the parameterized url + account)
// this is copied from clicking the "embed" link on a public instagram picture
var getInstaEmbed = function(instagramUrl, account) {
    return '<blockquote class="instagram-media" data-instgrm-permalink="'.concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" data-instgrm-version="14" style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"><div style="padding:16px;"> <a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" background:#FFFFFF; line-height:0; padding:0 0; text-align:center; text-decoration:none; width:100%;" target="_blank"> <div style=" display: flex; flex-direction: row; align-items: center;"> <div style="background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 40px; margin-right: 14px; width: 40px;"></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 100px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 60px;"></div></div></div><div style="padding: 19% 0;"></div> <div style="display:block; height:50px; margin:0 auto 12px; width:50px;"><svg width="50px" height="50px" viewBox="0 0 60 60" version="1.1" xmlns="https://www.w3.org/2000/svg" xmlns:xlink="https://www.w3.org/1999/xlink"><g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"><g transform="translate(-511.000000, -20.000000)" fill="#000000"><g><path d="M556.869,30.41 C554.814,30.41 553.148,32.076 553.148,34.131 C553.148,36.186 554.814,37.852 556.869,37.852 C558.924,37.852 560.59,36.186 560.59,34.131 C560.59,32.076 558.924,30.41 556.869,30.41 M541,60.657 C535.114,60.657 530.342,55.887 530.342,50 C530.342,44.114 535.114,39.342 541,39.342 C546.887,39.342 551.658,44.114 551.658,50 C551.658,55.887 546.887,60.657 541,60.657 M541,33.886 C532.1,33.886 524.886,41.1 524.886,50 C524.886,58.899 532.1,66.113 541,66.113 C549.9,66.113 557.115,58.899 557.115,50 C557.115,41.1 549.9,33.886 541,33.886 M565.378,62.101 C565.244,65.022 564.756,66.606 564.346,67.663 C563.803,69.06 563.154,70.057 562.106,71.106 C561.058,72.155 560.06,72.803 558.662,73.347 C557.607,73.757 556.021,74.244 553.102,74.378 C549.944,74.521 548.997,74.552 541,74.552 C533.003,74.552 532.056,74.521 528.898,74.378 C525.979,74.244 524.393,73.757 523.338,73.347 C521.94,72.803 520.942,72.155 519.894,71.106 C518.846,70.057 518.197,69.06 517.654,67.663 C517.244,66.606 516.755,65.022 516.623,62.101 C516.479,58.943 516.448,57.996 516.448,50 C516.448,42.003 516.479,41.056 516.623,37.899 C516.755,34.978 517.244,33.391 517.654,32.338 C518.197,30.938 518.846,29.942 519.894,28.894 C520.942,27.846 521.94,27.196 523.338,26.654 C524.393,26.244 525.979,25.756 528.898,25.623 C532.057,25.479 533.004,25.448 541,25.448 C548.997,25.448 549.943,25.479 553.102,25.623 C556.021,25.756 557.607,26.244 558.662,26.654 C560.06,27.196 561.058,27.846 562.106,28.894 C563.154,29.942 563.803,30.938 564.346,32.338 C564.756,33.391 565.244,34.978 565.378,37.899 C565.522,41.056 565.552,42.003 565.552,50 C565.552,57.996 565.522,58.943 565.378,62.101 M570.82,37.631 C570.674,34.438 570.167,32.258 569.425,30.349 C568.659,28.377 567.633,26.702 565.965,25.035 C564.297,23.368 562.623,22.342 560.652,21.575 C558.743,20.834 556.562,20.326 553.369,20.18 C550.169,20.033 549.148,20 541,20 C532.853,20 531.831,20.033 528.631,20.18 C525.438,20.326 523.257,20.834 521.349,21.575 C519.376,22.342 517.703,23.368 516.035,25.035 C514.368,26.702 513.342,28.377 512.574,30.349 C511.834,32.258 511.326,34.438 511.181,37.631 C511.035,40.831 511,41.851 511,50 C511,58.147 511.035,59.17 511.181,62.369 C511.326,65.562 511.834,67.743 512.574,69.651 C513.342,71.625 514.368,73.296 516.035,74.965 C517.703,76.634 519.376,77.658 521.349,78.425 C523.257,79.167 525.438,79.673 528.631,79.82 C531.831,79.965 532.853,80.001 541,80.001 C549.148,80.001 550.169,79.965 553.369,79.82 C556.562,79.673 558.743,79.167 560.652,78.425 C562.623,77.658 564.297,76.634 565.965,74.965 C567.633,73.296 568.659,71.625 569.425,69.651 C570.167,67.743 570.674,65.562 570.82,62.369 C570.966,59.17 571,58.147 571,50 C571,41.851 570.966,40.831 570.82,37.631"></path></g></g></g></svg></div><div style="padding-top: 8px;"> <div style=" color:#3897f0; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:550; line-height:18px;">View this post on Instagram</div></div><div style="padding: 12.5% 0;"></div> <div style="display: flex; flex-direction: row; margin-bottom: 14px; align-items: center;"><div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(0px) translateY(7px);"></div> <div style="background-color: #F4F4F4; height: 12.5px; transform: rotate(-45deg) translateX(3px) translateY(1px); width: 12.5px; flex-grow: 0; margin-right: 14px; margin-left: 2px;"></div> <div style="background-color: #F4F4F4; border-radius: 50%; height: 12.5px; width: 12.5px; transform: translateX(9px) translateY(-18px);"></div></div><div style="margin-left: 8px;"> <div style=" background-color: #F4F4F4; border-radius: 50%; flex-grow: 0; height: 20px; width: 20px;"></div> <div style=" width: 0; height: 0; border-top: 2px solid transparent; border-left: 6px solid #f4f4f4; border-bottom: 2px solid transparent; transform: translateX(16px) translateY(-4px) rotate(30deg)"></div></div><div style="margin-left: auto;"> <div style=" width: 0px; border-top: 8px solid #F4F4F4; border-right: 8px solid transparent; transform: translateY(16px);"></div> <div style=" background-color: #F4F4F4; flex-grow: 0; height: 12px; width: 16px; transform: translateY(-4px);"></div> <div style=" width: 0; height: 0; border-top: 8px solid #F4F4F4; border-left: 8px solid transparent; transform: translateY(-4px) translateX(8px);"></div></div></div> <div style="display: flex; flex-direction: column; flex-grow: 1; justify-content: center; margin-bottom: 24px;"> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; margin-bottom: 6px; width: 224px;"></div> <div style=" background-color: #F4F4F4; border-radius: 4px; flex-grow: 0; height: 14px; width: 144px;"></div></div></a><p style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; line-height:17px; margin-bottom:0; margin-top:8px; overflow:hidden; padding:8px 0 7px; text-align:center; text-overflow:ellipsis; white-space:nowrap;"><a href="').concat(instagramUrl, '?utm_source=ig_embed&amp;utm_campaign=loading" style=" color:#c9c8cd; font-family:Arial,sans-serif; font-size:14px; font-style:normal; font-weight:normal; line-height:17px; text-decoration:none;" target="_blank">A post shared by ').concat(account, "</a></p></div></blockquote>");
};
var renderInstagramImage = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
                    dangerouslySetInnerHTML: {
                        __html: getInstaEmbed(fields.sourceUrl, fields.sourceAccount || "@unkown")
                    },
                    css: /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)(".instagram-media{margin-left:auto !important;margin-right:auto !important;}")
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                    strategy: "lazyOnload",
                    src: "//www.instagram.com/embed.js"
                }, "instagram-embed")
            ]
        }, fields.sourceUrl)
    });
};
var InstagramImage = {
    render: renderInstagramImage
};
/* harmony default export */ var articles_v2_InstagramImage = (InstagramImage);

;// CONCATENATED MODULE: ./src/components/articles-v2/ImageCarousel.tsx




var renderImageCarousel = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "2 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            overflow: "scroll",
            flexDirection: "row",
            gap: "$10x",
            position: "relative",
            // align in the center on small screens to reduce excess spacing
            alignItems: "center",
            paddingBottom: "$6x",
            paddingRight: "$6x",
            width: "100%",
            $largerThanMD: {
                marginRight: "-10%"
            },
            hoverStyle: {
                shadow: "$default"
            },
            children: (ref = entry.fields.images) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "instagramImageAsset") {
                    return articles_v2_InstagramImage.render(x);
                }
                if (x.sys.contentType.sys.id === "imageAsset") {
                    return articles_v2_ImageAsset.render(x);
                }
                return null;
            })
        })
    });
};
var ImageCarouselComponent = {
    render: renderImageCarousel
};
/* harmony default export */ var ImageCarousel = (ImageCarouselComponent);

;// CONCATENATED MODULE: ./src/components/articles-v2/MetricsCard.tsx




var renderMetricsCard = function(entry) {
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            gap: "$5",
            py: "$3",
            width: "100%",
            flexWrap: "nowrap",
            flexDirection: "column",
            $largerThanSM: {
                flexWrap: "wrap",
                flexDirection: "row"
            },
            children: (ref = entry.fields.metrics) === null || ref === void 0 ? void 0 : ref.map(function(x) {
                if (x.sys.contentType.sys.id === "metricBasic") {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(react.Fragment, {
                        children: articles_v2_BasicMetric.render(x)
                    }, x.sys.id);
                }
                return null;
            })
        })
    });
};
var MetricsCard = {
    render: renderMetricsCard
};
/* harmony default export */ var articles_v2_MetricsCard = (MetricsCard);

;// CONCATENATED MODULE: ./src/components/articles-v2/Quote.tsx



var Blockquote = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("blockquote", {
    target: "e1fvqkdc0"
})("margin:0;position:relative;p::before{content:'“';display:inline-block;position:absolute;right:calc(100% + 16px);}");
var renderQuote = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        p: "$16x",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Blockquote, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$headerMedium",
                children: fields.content
            })
        })
    });
};
var Quote = {
    render: renderQuote
};
/* harmony default export */ var articles_v2_Quote = (Quote);

// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx + 1 modules
var NewSellerFlowAddressInput = __webpack_require__(37987);
// EXTERNAL MODULE: ./src/components/articles-v2/StickyAddressContext.tsx
var StickyAddressContext = __webpack_require__(97762);
;// CONCATENATED MODULE: ./src/components/articles-v2/SimpleCTA.tsx






var renderSimpleCTA = function(entry) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCTAInner, {
        entry: entry
    });
};
var SimpleCTAInner = function(param) {
    var entry = param.entry;
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var stickyAddress = (0,StickyAddressContext/* useStickyAddress */.v)();
    var ref4, ref5;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "embedded-entry-wrapper",
        "$platform-web": {
            gridColumn: "5 / -2"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            padding: stickyAddress ? "$12x" : "$10x",
            alignItems: stickyAddress ? "stretch" : "center",
            backgroundColor: "$backgroundTertiary",
            borderRadius: "$16x",
            flexDirection: "column",
            shadowOffset: stickyAddress ? {
                width: 0,
                height: 4
            } : undefined,
            shadowRadius: stickyAddress ? 24 : undefined
        }, stickyAddress ? {
            $largerThanMD: {
                display: "none"
            }
        } : {}), {
            children: [
                fields.headline && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h5",
                    typography: "$subheaderMedium",
                    textAlign: stickyAddress ? "left" : "center",
                    color: "$contentPrimary",
                    marginBottom: stickyAddress ? "$4x" : undefined,
                    children: fields.headline
                }),
                fields.description && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    textAlign: stickyAddress ? "left" : "center",
                    marginVertical: stickyAddress ? undefined : "$5x",
                    marginBottom: stickyAddress ? "$8x" : undefined,
                    typography: "$bodyMedium",
                    $largerThanXS: stickyAddress ? undefined : {
                        typography: "$bodyLarge"
                    },
                    color: "$contentTertiary",
                    children: fields.description
                }),
                stickyAddress ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "100%",
                    maxWidth: 480,
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                        inputLocation: "article-sticky-address",
                        trackingTaxonomy: "article_sticky_address",
                        analyticsPrefix: (ref4 = (ref = fields.headline) === null || ref === void 0 ? void 0 : ref.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")) !== null && ref4 !== void 0 ? ref4 : "article-inline-cta",
                        placeholder: (ref5 = (ref1 = stickyAddress.fields) === null || ref1 === void 0 ? void 0 : ref1.addressInputPlaceholderText) !== null && ref5 !== void 0 ? ref5 : "Enter your home address",
                        hideLabel: true,
                        trackingKeywords: (ref2 = stickyAddress.fields) === null || ref2 === void 0 ? void 0 : ref2.trackingKeyword,
                        channel: (ref3 = stickyAddress.fields) === null || ref3 === void 0 ? void 0 : ref3.channel,
                        size: "small"
                    })
                }) : fields.ctaLink && fields.ctaText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                    onPress: function() {
                        window.open(fields.ctaLink, "_blank");
                    },
                    analyticsName: "simple-cta-get-offer-button",
                    variant: "primary",
                    size: "small",
                    label: "Get a cash offer"
                })
            ]
        }))
    });
};
var SimpleCTA = {
    render: renderSimpleCTA
};
/* harmony default export */ var articles_v2_SimpleCTA = (SimpleCTA);

;// CONCATENATED MODULE: ./src/components/articles-v2/TwitterTweet.tsx




var TweetAnchor = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("a", {
    target: "e1unfm6n0"
})("color:transparent;");
//https://platform.twitter.com/widgets.js
var RenderTwitterTweet = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((script_default()), {
                src: "https://platform.twitter.com/widgets.js",
                strategy: "lazyOnload"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                className: "embedded-entry-wrapper",
                display: "flex",
                justifyContent: "center",
                "$platform-web": {
                    gridColumn: "5 / -2"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("blockquote", {
                    className: "twitter-tweet",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TweetAnchor, {
                        href: "https://twitter.com/x/status/" + fields.tweetId,
                        children: "Tweet Link"
                    })
                })
            })
        ]
    });
};
var TwitterTweet = {
    render: RenderTwitterTweet
};
/* harmony default export */ var articles_v2_TwitterTweet = (TwitterTweet);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/FAQsDisplay.tsx
var FAQsDisplay = __webpack_require__(38613);
;// CONCATENATED MODULE: ./src/cms/entries/articleV2.ts

















var articleV2EntryLookup = {
    block: {
        componentMetricsCard: articles_v2_MetricsCard,
        componentIconText: articles_v2_IconText,
        componentRelatedArticles: Articles/* default */.ZP,
        metricBasic: articles_v2_BasicMetric,
        ctaEmailCapture: EmailInput,
        componentImageCarousel: ImageCarousel,
        instagramImageAsset: articles_v2_InstagramImage,
        imageAsset: articles_v2_ImageAsset,
        componentAccordionList: articles_v2_AccordionList,
        componentImageAssetLink: articles_v2_ImageAssetLink,
        componentIframe: Iframe,
        componentQuotes: articles_v2_Quote,
        componentSimpleCta: articles_v2_SimpleCTA,
        componentTwitter: articles_v2_TwitterTweet,
        componentHighlightBox: articles_v2_HighlightBox,
        componentMulticard: articles_v2_Multicard,
        lpComponentFaqDisplay: FAQsDisplay/* default */.Z
    },
    inline: {
        ctaEmailCapture: EmailInput
    }
};
/* harmony default export */ var articleV2 = (articleV2EntryLookup);


/***/ }),

/***/ 42336:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ dynamicEntry; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92336);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5984);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);




// Keep this helper client-only. Next's dynamic import preloading depends on
// seeing the literal import() at the dynamic() callsite; hiding it behind this
// generic CMS helper can SSR HTML without preloading the matching client chunk.
var dynamicEntry = function(importFn) {
    var DynamicComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
        return importFn().then(function(mod) {
            // eslint-disable-next-line react/display-name
            var Component = function(props) {
                var inputProps = props.inputProps, loaderProps = props.loaderProps, context = props.context;
                return react__WEBPACK_IMPORTED_MODULE_0__.createElement(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, null, mod.default.render(inputProps, loaderProps, context));
            };
            return Component;
        });
    }, {
        ssr: false
    });
    var loaderWrapper = function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(inputProps, root, pageProps) {
            var mod;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            importFn()
                        ];
                    case 1:
                        mod = _state.sent();
                        if (mod.default.loader) {
                            return [
                                2,
                                mod.default.loader(inputProps, root, pageProps)
                            ];
                        }
                        return [
                            2,
                            null
                        ];
                }
            });
        });
        return function loaderWrapper(inputProps, root, pageProps) {
            return _ref.apply(this, arguments);
        };
    }();
    var Component = {
        render: function(inputProps, loaderProps, context) {
            return react__WEBPACK_IMPORTED_MODULE_0__.createElement(DynamicComponent, {
                inputProps: inputProps,
                loaderProps: loaderProps,
                context: context
            });
        },
        loader: loaderWrapper
    };
    return Component;
};


/***/ }),

/***/ 9758:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landingPageV2; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Row.tsx
var Row = __webpack_require__(34984);
// EXTERNAL MODULE: ../bricks-next/src/components/Link/Link.tsx
var Link = __webpack_require__(46320);
// EXTERNAL MODULE: ../bricks-next/src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(96101);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(57945);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/ContextualField.tsx + 2 modules
var ContextualField = __webpack_require__(20358);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Buttons.tsx
var Buttons = __webpack_require__(13530);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Container.tsx
var Container = __webpack_require__(51462);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/ExtraCtas.tsx


var ExtraCtas = function(param) {
    var ctas = param.ctas, componentTheme = param.componentTheme, bnTheme = param.bnTheme;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: ctas.map(function(cta, idx) {
            return cta.fields.text && cta.fields.url && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                "aria-label": "Go to page ".concat(cta.fields.text),
                analyticsName: "cosmos-landing-page-hero-cta-".concat(cta.fields.analyticsId),
                componentTheme: componentTheme,
                bnTheme: bnTheme,
                ctaStyle: cta.fields.ctaStyle,
                ctaDisplayText: cta.fields.text,
                ctaUrl: cta.fields.url,
                mt: "$0"
            }, idx);
        })
    });
};
/* harmony default export */ var shared_ExtraCtas = (ExtraCtas);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/heroConstants.ts
var heroConstants = __webpack_require__(83395);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/ComponentTheme.ts
var ComponentTheme = __webpack_require__(47456);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Typography.tsx
var Typography = __webpack_require__(91749);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/utils.ts
var utils = __webpack_require__(23366);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/BasicPageHeader.tsx













var RenderBasicPageHeader = function(entry) {
    var ref;
    var fields = entry.fields;
    // TODO: Remove the 'componentTheme' variable once all components using it are migrated to bricks-next.
    var componentTheme = fields.backgroundColor ? (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.backgroundColor) : (0,ComponentTheme/* getComponentThemeColors */._Y)("White 0");
    var foregroundColor = {
        Light: "$contentInversePrimary",
        Dark: "$contentPrimary"
    };
    var theme = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(fields.backgroundColor in ComponentTheme/* BNColorThemes */.CW ? fields.backgroundColor : ComponentTheme/* BNColorThemes.Light */.CW.Light);
    var imagePosition = fields.imagePosition || "None";
    var bgImage = imagePosition == "Background" && fields.image ? fields.image.fields.file.url : "";
    var noImage = fields.image === null || fields.image === undefined;
    var headlineLength = (fields === null || fields === void 0 ? void 0 : (ref = fields.title) === null || ref === void 0 ? void 0 : ref.length) || 0;
    var longHeadline = headlineLength > 20;
    var customCTAconfig = fields.customCtaConfig;
    var showCustomCTAButton = fields.customCtaButton, showDefaultCTALink = !showCustomCTAButton && (fields.ctaDisplayText || fields.ctaUrl || fields.extraCtas);
    var showAppStoreLinks = showCustomCTAButton && (customCTAconfig === null || customCTAconfig === void 0 ? void 0 : customCTAconfig.buttonStyle) === "appLinks";
    var appleStoreLink = customCTAconfig === null || customCTAconfig === void 0 ? void 0 : customCTAconfig.appStoreLink, googlePlayStoreLink = customCTAconfig === null || customCTAconfig === void 0 ? void 0 : customCTAconfig.playStoreLink;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        className: "lp-section",
        backgroundColor: theme.bgPrimary,
        style: {
            backgroundSize: "cover",
            backgroundPosition: "center center",
            backgroundImage: "url(".concat(bgImage, ")")
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
            noSectionSpacing: true,
            px: "$12x",
            py: fields.titleSize === "Large" ? "$50x" : "$44x",
            $largerThanSM: {
                py: fields.titleSize === "Large" ? "$32x" : "$28x",
                px: "$20x"
            },
            children: fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                minHeight: noImage ? "unset" : 510,
                gap: "$24x",
                $largerThanMD: {
                    minHeight: fields.layout === "Large" || noImage ? "unset" : 430,
                    maxHeight: fields.layout === "Large" || noImage ? "unset" : 744,
                    flexDirection: fields.layout === "Large" ? "column" : "row"
                },
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        gap: "$12x",
                        $largerThanMD: {
                            flex: 1,
                            flexBasis: fields.layout === "Large" ? "unset" : 0,
                            alignItems: fields.layout === "Large" ? "center" : "unset"
                        },
                        justifyContent: "center",
                        children: [
                            fields.eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Eyebrow */.j4, {
                                color: foregroundColor[fields.foregroundColor || "Dark"],
                                size: fields.eyebrowSize === "Large" ? "$bodyXlarge" : "$bodySmall",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                gap: "$16x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "h1",
                                                typography: fields.titleSize === "Large" || !longHeadline ? "$headerMedium" : "$headerSmall",
                                                $largerThanSM: {
                                                    typography: fields.titleSize === "Large" || !longHeadline ? "$displaySmall" : "$headerMedium"
                                                },
                                                $largerThanMD: {
                                                    textAlign: fields.layout === "Large" ? "center" : "unset",
                                                    typography: fields.titleSize === "Large" || !longHeadline ? "$displaySmall" : "$headerMedium"
                                                },
                                                display: "block",
                                                color: foregroundColor[fields.foregroundColor || "Dark"],
                                                children: (0,utils/* markdownToReactElement */.vl)(fields.title || "")
                                            }),
                                            fields.titleAccent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                color: theme.contentPrimaryAccent,
                                                typography: fields.titleSize === "Large" || !longHeadline ? "$headerMedium" : "$headerSmall",
                                                $largerThanSM: {
                                                    typography: fields.titleSize === "Large" || !longHeadline ? "$displaySmall" : "$headerMedium"
                                                },
                                                $largerThanMD: {
                                                    textAlign: fields.layout === "Large" ? "center" : "unset",
                                                    typography: fields.titleSize === "Large" || !longHeadline ? "$displaySmall" : "$headerMedium"
                                                },
                                                children: (0,utils/* markdownToReactElement */.vl)(fields.titleAccent || "")
                                            })
                                        ]
                                    }),
                                    fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        display: "block",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                                            color: foregroundColor[fields.foregroundColor || "Dark"],
                                            $largerThanMD: {
                                                textAlign: fields.layout === "Large" ? "center" : "unset",
                                                marginRight: fields.layout === "Large" ? 0 : "$16x"
                                            },
                                            children: fields.desc
                                        })
                                    }),
                                    fields.contextualField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        alignItems: "flex-start",
                                        width: "100%",
                                        mt: "$6",
                                        $largerThanMD: {
                                            alignItems: fields.layout === "Large" ? "center" : "flex-start",
                                            justifyContent: fields.layout === "Large" ? "center" : "flex-start"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContextualField/* default */.Z, {
                                            theme: componentTheme,
                                            contextFields: fields.contextualField,
                                            inputLocation: "basic-page-header"
                                        })
                                    }),
                                    showDefaultCTALink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        gap: "$4",
                                        mt: "$8",
                                        $largerThanMD: {
                                            justifyContent: fields.layout === "Large" ? "center" : "unset"
                                        },
                                        children: [
                                            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                                                "aria-label": "Go to page ".concat(fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText),
                                                analyticsName: "cosmos-landing-page-basic-page-header-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                                componentTheme: componentTheme,
                                                bnTheme: theme,
                                                ctaStyle: fields.ctaStyle,
                                                ctaDisplayText: fields.ctaDisplayText,
                                                ctaUrl: fields.ctaUrl,
                                                mt: "$0",
                                                children: fields.ctaDisplayText
                                            }),
                                            fields.extraCtas && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ExtraCtas, {
                                                ctas: fields.extraCtas,
                                                componentTheme: componentTheme
                                            })
                                        ]
                                    }),
                                    showAppStoreLinks && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                        flexDirection: "column",
                                        $largerThanSM: {
                                            flexDirection: "row"
                                        },
                                        justifyContent: "space-between",
                                        backgroundColor: "$backgroundTertiary",
                                        padding: "$6x",
                                        gap: "$4x",
                                        borderRadius: "$8x",
                                        width: "100%",
                                        marginTop: "$8x",
                                        $largerThanMD: {
                                            maxWidth: fields.layout === "Large" ? "100%" : "80%"
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "p",
                                                minWidth: "max-content",
                                                typography: "$bodySmall",
                                                fontWeight: "$medium",
                                                children: "Get the app"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                flexWrap: "wrap",
                                                gap: "$4x",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                        target: "_blank",
                                                        href: appleStoreLink,
                                                        "aria-label": "Opendoor Applestore button",
                                                        analyticsName: "cosmos-landing-page-v2-header-cta-applestore-link",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                                            source: {
                                                                uri: "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078078-95093.png?preset=square-2048",
                                                                width: 135,
                                                                height: 45
                                                            },
                                                            alt: "Opendoor Applestore",
                                                            width: 135,
                                                            height: 45
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                        target: "_blank",
                                                        href: googlePlayStoreLink,
                                                        "aria-label": "Opendoor Google play button",
                                                        analyticsName: "cosmos-landing-page-v2-header-cta-google-playstore-link",
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                                            source: {
                                                                uri: "https://images.opendoor.com/source/s3/imgdrop-production/2023-12-1702502078081-28903.png?preset=square-2048",
                                                                width: 135,
                                                                height: 45
                                                            },
                                                            alt: "Opendoor Google Play",
                                                            width: 135,
                                                            height: 45
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    fields.image && imagePosition === "Right" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                $largerThanMD: {
                                    flex: 1,
                                    flexBasis: fields.layout === "Large" ? "unset" : 0,
                                    minHeight: 430,
                                    maxHeight: 744,
                                    display: "flex"
                                },
                                $largerThanSM: {
                                    display: "block"
                                },
                                $smallerThanMD: {
                                    display: "none"
                                },
                                justifyContent: "center",
                                borderRadius: "$16x",
                                overflow: "hidden",
                                children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_DESKTOP_PROPS */.t6), {
                                    photoUrl: (0,utils/* contentfulToImagesWorkerUrl */.jx)(fields.image.fields.file.url)
                                }))
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                $largerThanSM: {
                                    display: "none"
                                },
                                $smallerThanMD: {
                                    display: "block"
                                },
                                justifyContent: "center",
                                borderRadius: "$16x",
                                overflow: "hidden",
                                children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_MOBILE_PROPS */.Sy), {
                                    photoUrl: (0,utils/* contentfulToImagesWorkerUrl */.jx)(fields.image.fields.file.url)
                                }))
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var BasicPageHeader = {
    render: RenderBasicPageHeader
};
/* harmony default export */ var landing_pages_v2_BasicPageHeader = (BasicPageHeader);

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconCircleCheckFilled.mjs
var IconCircleCheckFilled = __webpack_require__(10246);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareFees.tsx




var RenderCompareFees = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundPrimary",
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$6x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h2",
                                typography: "$subheaderLarge",
                                color: "$contentPrimary",
                                $smallerThanMD: {
                                    typography: "$subheaderMedium"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyLarge",
                                color: "$contentSecondary",
                                maxWidth: 580,
                                "$platform-web": {
                                    lineHeight: "1.6"
                                },
                                children: fields.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "column",
                        gap: "$16x",
                        $largerThanSM: {
                            flexDirection: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                flex: 1,
                                backgroundColor: "$backgroundSecondary",
                                borderRadius: "$8x",
                                p: "$20x",
                                $smallerThanMD: {
                                    p: "$12x"
                                },
                                gap: "$16x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "h3",
                                        typography: "$subheaderSmall",
                                        color: "$contentPrimary",
                                        children: fields.competitorCardTitle
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        gap: "$4x",
                                        children: fields.competitorFees.map(function(fee, idx) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                                        p: "$10x",
                                                        borderRadius: "$6x",
                                                        gap: "$1x",
                                                        backgroundColor: "$backgroundStateErrorSecondary",
                                                        borderWidth: 1,
                                                        borderColor: "$borderStateInactiveAccentError",
                                                        children: [
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                tag: "span",
                                                                typography: "$labelSmall",
                                                                color: "$contentSecondary",
                                                                children: fee.fields.label
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                                gap: "$4x",
                                                                alignItems: "baseline",
                                                                children: [
                                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                        tag: "span",
                                                                        typography: "$subheaderXsmall",
                                                                        fontWeight: "$medium",
                                                                        color: "$contentStateErrorDefault",
                                                                        children: fee.fields.value
                                                                    }),
                                                                    fee.fields.subValue && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                        tag: "span",
                                                                        typography: "$bodySmall",
                                                                        fontWeight: "$medium",
                                                                        color: "$contentSecondary",
                                                                        children: fee.fields.subValue
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                tag: "span",
                                                                typography: "$bodyXsmall",
                                                                color: "$contentSecondary",
                                                                children: fee.fields.note
                                                            })
                                                        ]
                                                    }),
                                                    idx < fields.competitorFees.length - 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodyXlarge",
                                                        fontWeight: "$medium",
                                                        color: "$contentStateErrorDefault",
                                                        textAlign: "center",
                                                        py: "$1x",
                                                        children: "+"
                                                    })
                                                ]
                                            }, fee.sys.id);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                        p: "$10x",
                                        borderRadius: "$6x",
                                        gap: "$1x",
                                        borderLeftWidth: 3,
                                        borderLeftColor: "$contentStateErrorDefault",
                                        backgroundColor: "$backgroundStateErrorSecondary",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$labelSmall",
                                                color: "$contentSecondary",
                                                children: fields.competitorTotalLabel
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$bodyXlarge",
                                                fontWeight: "$medium",
                                                color: "$contentStateErrorDefault",
                                                children: fields.competitorTotalValue
                                            }),
                                            fields.competitorAttribution && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$bodyXsmall",
                                                color: "$contentTertiary",
                                                children: fields.competitorAttribution
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                flex: 1,
                                backgroundColor: "$backgroundPrimary",
                                borderRadius: "$8x",
                                p: "$20x",
                                $smallerThanMD: {
                                    p: "$12x"
                                },
                                gap: "$16x",
                                borderWidth: 2,
                                borderColor: "$borderAccentBrand",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "h3",
                                        typography: "$subheaderSmall",
                                        color: "$contentPrimary",
                                        children: fields.opendoorCardTitle
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        gap: "$4x",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                            p: "$10x",
                                            borderRadius: "$6x",
                                            gap: "$1x",
                                            backgroundColor: "$backgroundSecondary",
                                            borderWidth: 1,
                                            borderColor: "$borderSecondary",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$labelSmall",
                                                    color: "$contentSecondary",
                                                    children: fields.opendoorFeeLabel
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$subheaderXsmall",
                                                    fontWeight: "$medium",
                                                    color: "$contentStateSuccessDefault",
                                                    children: fields.opendoorFeeValue
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$bodyXsmall",
                                                    color: "$contentSecondary",
                                                    children: fields.opendoorFeeNote
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        gap: "$8x",
                                        children: fields.opendoorBenefits.map(function(benefit, idx) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$6x",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircleCheckFilled/* default */.Z, {
                                                        size: 20,
                                                        color: (0,cjs.getToken)("$contentStateSuccessDefault", "color")
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodyMedium",
                                                        fontWeight: "$medium",
                                                        color: "$contentPrimary",
                                                        children: benefit
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                        p: "$10x",
                                        borderRadius: "$6x",
                                        gap: "$1x",
                                        borderLeftWidth: 3,
                                        borderLeftColor: "$borderAccentBrand",
                                        backgroundColor: "$backgroundSecondary",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$labelSmall",
                                                color: "$contentSecondary",
                                                children: fields.opendoorBottomLineLabel
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$bodyXlarge",
                                                fontWeight: "$medium",
                                                color: "$contentAccentBrand",
                                                children: fields.opendoorBottomLineValue
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var CompareFees = {
    render: RenderCompareFees
};
/* harmony default export */ var landing_pages_v2_CompareFees = (CompareFees);

// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx + 1 modules
var NewSellerFlowAddressInput = __webpack_require__(37987);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareFinalCta.tsx



var RenderCompareFinalCta = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundInversePrimary",
        py: "$50x",
        $smallerThanMD: {
            py: "$32x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            maxWidth: 1120,
            px: "$12x",
            mx: "auto",
            width: "100%",
            alignItems: "center",
            gap: "$20x",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$8x",
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "h2",
                            typography: "$subheaderLarge",
                            color: "$contentInversePrimary",
                            textAlign: "center",
                            $smallerThanMD: {
                                typography: "$subheaderMedium"
                            },
                            children: fields.title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodyLarge",
                            textAlign: "center",
                            maxWidth: 480,
                            color: "$contentInverseSecondary",
                            "$platform-web": {
                                lineHeight: "1.6"
                            },
                            children: fields.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$10x",
                    alignItems: "center",
                    width: "100%",
                    maxWidth: 480,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                                hideLabel: true,
                                inputLocation: fields.addressInputLocation || "cta-standalone",
                                analyticsPrefix: fields.addressInputAnalyticsPrefix || "compare-final",
                                trackingTaxonomy: "new_homepage",
                                placeholder: fields.addressInputPlaceholder || "Enter your home address",
                                channel: "DEFAULT",
                                size: "medium"
                            })
                        }),
                        fields.subtext && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodySmall",
                            color: "$contentInverseTertiary",
                            textAlign: "center",
                            children: fields.subtext
                        })
                    ]
                }),
                fields.linkText && fields.linkUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                    href: fields.linkUrl,
                    rel: "noopener",
                    analyticsName: "compare-final-cta-link",
                    typography: "$bodySmall",
                    variant: "secondaryInverse",
                    textDecorationLine: "underline",
                    children: fields.linkText
                })
            ]
        })
    });
};
var CompareFinalCta = {
    render: RenderCompareFinalCta
};
/* harmony default export */ var landing_pages_v2_CompareFinalCta = (CompareFinalCta);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareHero.tsx




var RenderCompareHero = function(entry) {
    var ref, ref1, ref2;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        $smallerThanLG: {
            py: "$20x"
        },
        backgroundColor: "$backgroundPrimary",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                gap: "$16x",
                alignItems: "center",
                $largerThanSM: {
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        flex: 1.1,
                        gap: "$10x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$10x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                        tag: "h1",
                                        typography: "$headerLarge",
                                        color: "$contentPrimary",
                                        $smallerThanMD: {
                                            typography: "$headerSmall"
                                        },
                                        $smallerThanLG: {
                                            typography: "$headerMedium"
                                        },
                                        children: [
                                            fields.title,
                                            " ",
                                            fields.titleAccent && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                color: "$contentAccentBrand",
                                                typography: "$headerLarge",
                                                $smallerThanMD: {
                                                    typography: "$headerSmall"
                                                },
                                                $smallerThanLG: {
                                                    typography: "$headerMedium"
                                                },
                                                children: fields.titleAccent
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodyLarge",
                                        color: "$contentSecondary",
                                        maxWidth: "$616x",
                                        "$platform-web": {
                                            lineHeight: "1.6"
                                        },
                                        children: fields.description
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$10x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                        maxWidth: "$516x",
                                        width: "100%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                                            hideLabel: true,
                                            inputLocation: fields.addressInputLocation || "hero-cta",
                                            analyticsPrefix: fields.addressInputAnalyticsPrefix || "compare-hero",
                                            trackingTaxonomy: "new_homepage",
                                            placeholder: fields.addressInputPlaceholder || "Enter your home address",
                                            channel: "DEFAULT",
                                            size: "medium"
                                        })
                                    }),
                                    fields.trustBadges && fields.trustBadges.length > 0 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        gap: "$12x",
                                        flexWrap: "wrap",
                                        children: fields.trustBadges.map(function(item) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$4x",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircleCheckFilled/* default */.Z, {
                                                        size: 18,
                                                        color: (0,cjs.getToken)("$contentStateSuccessDefault", "color")
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodySmall",
                                                        color: "$contentSecondary",
                                                        children: item
                                                    })
                                                ]
                                            }, item);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    fields.heroImage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flex: 0.9,
                        alignItems: "center",
                        justifyContent: "center",
                        $smallerThanLG: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                            source: {
                                uri: (ref = fields.heroImage) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url
                            },
                            alt: fields.heroImageAlt || "",
                            width: "100%",
                            maxWidth: 480,
                            height: 480,
                            borderRadius: "$8x",
                            "$platform-web": {
                                aspectRatio: "1",
                                objectFit: "cover"
                            }
                        })
                    })
                ]
            })
        })
    });
};
var CompareHero = {
    render: RenderCompareHero
};
/* harmony default export */ var landing_pages_v2_CompareHero = (CompareHero);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ComparePhotoTestimonials.tsx



var RenderComparePhotoTestimonials = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundPrimary",
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$6x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h2",
                                typography: "$subheaderLarge",
                                color: "$contentPrimary",
                                $smallerThanMD: {
                                    typography: "$subheaderMedium"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyLarge",
                                color: "$contentSecondary",
                                maxWidth: 580,
                                "$platform-web": {
                                    lineHeight: "1.6"
                                },
                                children: fields.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "column",
                        gap: "$12x",
                        $largerThanSM: {
                            flexDirection: "row"
                        },
                        children: fields.cards.map(function(card) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                flex: 1,
                                borderRadius: "$8x",
                                backgroundColor: "$backgroundSecondary",
                                "$platform-web": {
                                    overflow: "hidden"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                        source: {
                                            uri: (0,utils/* resizeTestimonialCardImageUrl */.$1)(card.fields.imageUrl)
                                        },
                                        alt: card.fields.imageAlt || card.fields.name,
                                        width: "100%",
                                        height: 220,
                                        "$platform-web": {
                                            objectFit: "cover",
                                            loading: "lazy"
                                        }
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                        p: "$12x",
                                        gap: "$10x",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                tag: "p",
                                                typography: "$bodySmall",
                                                color: "$contentPrimary",
                                                "$platform-web": {
                                                    lineHeight: "1.7"
                                                },
                                                children: [
                                                    "“",
                                                    card.fields.quote,
                                                    "”"
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                                gap: "$1x",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$labelSmall",
                                                        color: "$contentPrimary",
                                                        children: card.fields.name
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodyXsmall",
                                                        color: "$contentTertiary",
                                                        children: card.fields.location
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }, card.sys.id);
                        })
                    })
                ]
            })
        })
    });
};
var ComparePhotoTestimonials = {
    render: RenderComparePhotoTestimonials
};
/* harmony default export */ var landing_pages_v2_ComparePhotoTestimonials = (ComparePhotoTestimonials);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconStarFilled.mjs
var IconStarFilled = __webpack_require__(1492);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconStarHalfFilled.mjs
var IconStarHalfFilled = __webpack_require__(18063);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareReviews.tsx




var STAR_COLOR = "#E5A100";
var StarRating = function(param) {
    var rating = param.rating;
    var fullStars = Math.floor(rating);
    var hasHalf = rating - fullStars >= 0.3;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        gap: "$0dot5x",
        accessibilityRole: "image",
        accessibilityLabel: "".concat(rating, " out of 5 stars"),
        children: [
            Array.from({
                length: fullStars
            }, function(_, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconStarFilled/* default */.Z, {
                    size: 14,
                    color: STAR_COLOR,
                    "aria-hidden": "true"
                }, i);
            }),
            hasHalf && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconStarHalfFilled/* default */.Z, {
                size: 14,
                color: STAR_COLOR,
                "aria-hidden": "true"
            })
        ]
    });
};
var ReviewCard = function(param) {
    var review = param.review, variant = param.variant;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        p: "$12x",
        borderRadius: "$6x",
        gap: "$6x",
        backgroundColor: "$backgroundPrimary",
        borderWidth: 1,
        borderColor: variant === "opendoor" ? "$borderAccentBrand" : "$borderSecondary",
        children: [
            variant === "opendoor" && review.fields.starRating != null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating, {
                rating: review.fields.starRating
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodySmall",
                color: variant === "opendoor" ? "$contentPrimary" : "$contentSecondary",
                "$platform-web": {
                    lineHeight: "1.65"
                },
                children: [
                    "“",
                    review.fields.quote,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "span",
                typography: "$bodyXsmall",
                fontWeight: "$medium",
                color: variant === "opendoor" ? "$contentAccentBrand" : "$contentTertiary",
                children: [
                    variant === "competitor" ? "— " : "",
                    review.fields.attribution
                ]
            })
        ]
    });
};
var RenderCompareReviews = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$6x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h2",
                                typography: "$subheaderLarge",
                                color: "$contentPrimary",
                                $smallerThanMD: {
                                    typography: "$subheaderMedium"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyLarge",
                                color: "$contentSecondary",
                                maxWidth: 580,
                                children: fields.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "column",
                        gap: "$24x",
                        $largerThanSM: {
                            flexDirection: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                flex: 1,
                                gap: "$8x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        gap: "$6x",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$labelMedium",
                                                color: "$contentTertiary",
                                                children: fields.competitorName
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$2x",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating, {
                                                        rating: fields.competitorRating
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodyXsmall",
                                                        color: "$contentTertiary",
                                                        children: [
                                                            fields.competitorRating,
                                                            fields.competitorReviewCount ? " \xb7 ".concat(fields.competitorReviewCount) : ""
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        gap: "$8x",
                                        children: fields.competitorReviews.map(function(review) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewCard, {
                                                review: review,
                                                variant: "competitor"
                                            }, review.sys.id);
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                flex: 1,
                                gap: "$8x",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        gap: "$6x",
                                        alignItems: "center",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "span",
                                                typography: "$labelMedium",
                                                color: "$contentAccentBrand",
                                                children: "Opendoor"
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                                gap: "$2x",
                                                alignItems: "center",
                                                children: [
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarRating, {
                                                        rating: fields.opendoorRating
                                                    }),
                                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$bodyXsmall",
                                                        color: "$contentTertiary",
                                                        children: [
                                                            fields.opendoorRating,
                                                            " \xb7 ",
                                                            fields.opendoorReviewCount
                                                        ]
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        gap: "$8x",
                                        children: fields.opendoorReviews.map(function(review) {
                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewCard, {
                                                review: review,
                                                variant: "opendoor"
                                            }, review.sys.id);
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var CompareReviews = {
    render: RenderCompareReviews
};
/* harmony default export */ var landing_pages_v2_CompareReviews = (CompareReviews);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconCircleXFilled.mjs
var IconCircleXFilled = __webpack_require__(23786);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconMinus.mjs
var IconMinus = __webpack_require__(21917);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/CompareTable.tsx






var SENTIMENT_LABELS = {
    positive: "Advantage",
    negative: "Disadvantage",
    neutral: "Neutral"
};
var SentimentIcon = function(param) {
    var sentiment = param.sentiment;
    var icon;
    if (sentiment === "positive") {
        icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircleCheckFilled/* default */.Z, {
            size: 18,
            color: (0,cjs.getToken)("$contentStateSuccessDefault", "color"),
            "aria-hidden": "true"
        });
    } else if (sentiment === "negative") {
        icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCircleXFilled/* default */.Z, {
            size: 18,
            color: (0,cjs.getToken)("$contentStateErrorDefault", "color"),
            "aria-hidden": "true"
        });
    } else {
        icon = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconMinus/* default */.Z, {
            size: 18,
            color: (0,cjs.getToken)("$contentTertiary", "color"),
            "aria-hidden": "true"
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        accessibilityLabel: SENTIMENT_LABELS[sentiment] || sentiment,
        flexShrink: 0,
        children: icon
    });
};
var MobileCards = function(param) {
    var rows = param.rows, competitorLabel = param.competitorLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        gap: "$4x",
        children: rows.map(function(row) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                backgroundColor: "$backgroundPrimary",
                borderRadius: "$6x",
                p: "$10x",
                gap: "$6x",
                "$platform-web": {
                    boxShadow: "0 1px 2px rgba(20, 35, 58, 0.04), 0 4px 16px rgba(20, 35, 58, 0.04)"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        pb: "$4x",
                        borderBottomWidth: 1,
                        borderBottomColor: "$borderSecondary",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelSmall",
                            color: "$contentTertiary",
                            fontWeight: "$medium",
                            children: row.fields.category
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: "$contentTertiary",
                                children: competitorLabel
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SentimentIcon, {
                                        sentiment: row.fields.competitorSentiment
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodySmall",
                                        color: "$contentSecondary",
                                        children: row.fields.competitorText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                children: "Opendoor"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SentimentIcon, {
                                        sentiment: row.fields.opendoorSentiment
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        children: row.fields.opendoorText
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, row.fields.category);
        })
    });
};
var DesktopGrid = function(param) {
    var rows = param.rows, competitorLabel = param.competitorLabel, opendoorLabel = param.opendoorLabel;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$8x",
        accessibilityRole: "none"
    }, {
        role: "grid"
    }), {
        "$platform-web": {
            display: "grid",
            gridTemplateColumns: "20% 40% 40%",
            overflow: "hidden",
            boxShadow: "0 1px 2px rgba(20, 35, 58, 0.04), 0 4px 16px rgba(20, 35, 58, 0.04)"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                p: "$8x",
                backgroundColor: "$backgroundSecondary",
                accessibilityRole: "header"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                p: "$8x",
                backgroundColor: "$backgroundSecondary",
                accessibilityRole: "header",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$labelSmall",
                    fontWeight: "$medium",
                    color: "$contentTertiary",
                    children: competitorLabel
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                p: "$8x",
                borderLeftWidth: 3,
                borderLeftColor: "$contentAccentBrand",
                backgroundColor: "$backgroundSecondary",
                accessibilityRole: "header",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "span",
                    typography: "$labelSmall",
                    fontWeight: "$medium",
                    color: "$contentAccentBrand",
                    children: opendoorLabel
                })
            }),
            rows.map(function(row) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(react.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            p: "$8x",
                            borderTopWidth: 1,
                            borderTopColor: "$borderSecondary",
                            accessibilityRole: "header",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentSecondary",
                                children: row.fields.category
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            p: "$8x",
                            borderTopWidth: 1,
                            borderTopColor: "$borderSecondary",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SentimentIcon, {
                                        sentiment: row.fields.competitorSentiment
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodySmall",
                                        color: "$contentSecondary",
                                        children: row.fields.competitorText
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            p: "$8x",
                            borderLeftWidth: 3,
                            borderLeftColor: "$contentAccentBrand",
                            borderTopWidth: 1,
                            borderTopColor: "$borderSecondary",
                            backgroundColor: "$backgroundSecondary",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                alignItems: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SentimentIcon, {
                                        sentiment: row.fields.opendoorSentiment
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        children: row.fields.opendoorText
                                    })
                                ]
                            })
                        })
                    ]
                }, row.fields.category);
            })
        ]
    }));
};
var RenderCompareTable = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        py: "$40x",
        $smallerThanMD: {
            py: "$24x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            maxWidth: 1120,
            px: "$12x",
            width: "100%",
            mx: "auto",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$6x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                fontWeight: "$medium",
                                color: "$contentAccentBrand",
                                children: fields.eyebrow
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h2",
                                typography: "$subheaderLarge",
                                color: "$contentPrimary",
                                $smallerThanMD: {
                                    typography: "$subheaderMedium"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodyLarge",
                                color: "$contentSecondary",
                                maxWidth: 580,
                                children: fields.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "block",
                        $largerThanSM: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileCards, {
                            rows: fields.rows,
                            competitorLabel: fields.competitorLabel
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "none",
                        $largerThanSM: {
                            display: "block"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DesktopGrid, {
                            rows: fields.rows,
                            competitorLabel: fields.competitorLabel,
                            opendoorLabel: fields.opendoorLabel
                        })
                    })
                ]
            })
        })
    });
};
var CompareTable = {
    render: RenderCompareTable
};
/* harmony default export */ var landing_pages_v2_CompareTable = (CompareTable);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@contentful+rich-text-react-renderer@15.11.1_@types+react-dom@18.3.7_@types+react@18.3._9c86b3358aa3a0aab1d7dbae5bd5bd31/node_modules/@contentful/rich-text-react-renderer/dist/rich-text-react-renderer.es5.js
var rich_text_react_renderer_es5 = __webpack_require__(52058);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@contentful+rich-text-types@15.11.1/node_modules/@contentful/rich-text-types/dist/index.js
var dist = __webpack_require__(64786);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/ComparisonTable.module.css
var ComparisonTable_module = __webpack_require__(43547);
var ComparisonTable_module_default = /*#__PURE__*/__webpack_require__.n(ComparisonTable_module);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ComparisonTable.tsx








var Yes = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyLarge",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "unset",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M2 8.03846L6 11.5L14 4",
                stroke: "currentColor",
                strokeWidth: "2"
            })
        })
    });
};
var No = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        tag: "p",
        typography: "$bodyLarge",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "unset",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "16",
            height: "16",
            viewBox: "0 0 16 16",
            fill: "none",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M3 13.0007L13 3",
                    stroke: "currentColor",
                    strokeWidth: "2"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                    d: "M13 13L8.00005 7.99984L3 3",
                    stroke: "currentColor",
                    strokeWidth: "2"
                })
            ]
        })
    });
};
var Question = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        tag: "p",
        typography: "$subheaderMedium",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "unset",
        children: "?"
    });
};
var Dash = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
        tag: "p",
        typography: "$subheaderMedium",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "unset",
        children: "-"
    });
};
var _obj;
var options = {
    renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.TABLE, function(_, children) {
        return children;
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.TABLE_ROW, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tr", {
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.TABLE_CELL, function(_, children) {
        if (children[0].type == "u") {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("th", {
                scope: "row",
                children: children[0].props.children
            });
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("td", {
            children: children
        });
    }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_, children) {
        if (children[0] == "✓") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Yes, {});
        if (children[0] == "X") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(No, {});
        if (children[0] == "?") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Question, {});
        if (children[0] == "-") return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dash, {});
        return children[0];
    }), _obj)
};
var RenderComparisonTable = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var tableId = "comparison-table-".concat(entry.sys.id);
    // Contentful field is typed as 'Brand Blue 600' | 'Warm Grey 950' — map to semantic tokens
    var highlightColor = fields.highlightColor === "Warm Grey 950" ? (0,cjs.getToken)("$backgroundInversePrimary") : (0,cjs.getToken)("$contentAccentBrand");
    var borderPrimary = (0,cjs.getToken)("$borderPrimary");
    var hasBorder = fields.layout === "Border" || fields.layout === "Earth 200" || fields.layout === "Grey";
    var isNoBorder = fields.layout === "No Border";
    var hasBGAndBorder = fields.image && (fields.layout === "Earth 200" || fields.layout === "Grey");
    var alignClass = fields.tableTextAlign === "Center" ? (ComparisonTable_module_default()).centerAlign : (ComparisonTable_module_default()).leftAlign;
    var tableClasses = [
        (ComparisonTable_module_default()).table,
        alignClass,
        hasBorder && (ComparisonTable_module_default()).borderLayout,
        isNoBorder && (ComparisonTable_module_default()).noBorderLayout, 
    ].filter(Boolean).join(" ");
    // CSS variables for layout variants
    var cssVars = {
        "--border-primary": borderPrimary,
        "--accent-bg": (0,cjs.getToken)("$backgroundAccentBrand")
    };
    // Dynamic nth-child selectors for highlight/opendoor columns (can't use CSS variables in nth-child)
    var columnCss = "";
    if (fields.highlightColumn) {
        var col = fields.highlightColumn;
        var inverseText = (0,cjs.getToken)("$contentInversePrimary");
        columnCss += "\n      #".concat(tableId, " th:not([scope=row]):nth-child(").concat(col, ") { background-color: ").concat(highlightColor, "; color: ").concat(inverseText, "; }\n      #").concat(tableId, " td:nth-child(").concat(col, ") { border-left: 1px solid ").concat(highlightColor, "; border-right: 1px solid ").concat(highlightColor, "; }\n      #").concat(tableId, " tbody tr:last-child td:nth-child(").concat(col, ") { border-bottom: 1px solid ").concat(highlightColor, "; }\n    ");
    }
    if (fields.opendoorColumn) {
        columnCss += "\n      #".concat(tableId, " tbody td:nth-child(").concat(fields.opendoorColumn, ") { color: ").concat((0,cjs.getToken)("$contentAccentBrand"), "; }\n    ");
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.ZP, {
        py: "$6",
        children: [
            fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                title: fields.title,
                titleAccent: fields.titleAccent,
                titleSize: fields.titleSize,
                mb: "$16",
                mx: fields.titleAlign === "Center" ? "auto" : 0,
                textAlign: fields.titleAlign === "Center" ? "center" : "left"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "block",
                gap: "$5",
                backgroundColor: hasBGAndBorder ? "$backgroundTertiary" : undefined,
                borderRadius: hasBGAndBorder ? "$8x" : undefined,
                padding: hasBGAndBorder ? "$5" : 0,
                $largerThanMD: {
                    display: fields.image ? "flex" : "block",
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flex: fields.image ? 6 : undefined,
                        flexBasis: fields.image ? 0 : undefined,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            borderRadius: "$8x",
                            borderColor: fields.layout === "Border" ? "$borderPrimary" : undefined,
                            borderWidth: fields.layout === "Border" ? "$0dot5x" : undefined,
                            "$platform-web": {
                                overflow: "auto"
                            },
                            children: [
                                columnCss && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("style", {
                                    dangerouslySetInnerHTML: {
                                        __html: columnCss
                                    }
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("table", {
                                    id: tableId,
                                    className: tableClasses,
                                    style: cssVars,
                                    children: [
                                        fields.tableHeader && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("thead", {
                                            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields.tableHeader, options)
                                        }),
                                        fields.tableBody && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("tbody", {
                                            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(fields.tableBody, options)
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    fields.image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flex: 4,
                        flexBasis: fields.image ? 0 : undefined,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                            className: (ComparisonTable_module_default()).tableImage,
                            src: (ref = fields.image.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                            alt: ((ref2 = fields.image.fields) === null || ref2 === void 0 ? void 0 : ref2.description) || ((ref3 = fields.image.fields) === null || ref3 === void 0 ? void 0 : ref3.title)
                        })
                    })
                ]
            })
        ]
    });
};
var ComparisonTable = {
    render: RenderComparisonTable
};
/* harmony default export */ var landing_pages_v2_ComparisonTable = (ComparisonTable);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/ContactSection.tsx
var ContactSection = __webpack_require__(80557);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/FactBar.tsx



var ref;
var FactItem = function(param) {
    var fact = param.fact, analyticsId = param.analyticsId;
    var ref1;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        gap: "$1",
        flex: 1,
        minWidth: "$35",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXsmall",
                fontWeight: "$medium",
                color: "$contentTertiary",
                textTransform: "uppercase",
                children: fact.fields.label
            }),
            fact.fields.valueLink ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                href: fact.fields.valueLink,
                variant: "primary",
                typography: "$subheaderSmall",
                fontWeight: "$medium",
                analyticsName: "cosmos-landing-page-v2-fact-bar-".concat(analyticsId !== null && analyticsId !== void 0 ? analyticsId : "", "-").concat((ref = (ref1 = fact.sys) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref !== void 0 ? ref : ""),
                children: fact.fields.value
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$subheaderSmall",
                fontWeight: "$medium",
                color: "$contentPrimary",
                children: fact.fields.value
            })
        ]
    });
};
var renderFactBar = function(entry) {
    var _fields = entry.fields, items = _fields.items, eyebrow = _fields.eyebrow, analyticsId = _fields.analyticsId;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        noSectionSpacing: true,
        backgroundColor: "$backgroundTertiary",
        paddingVertical: "$8",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            gap: "$3",
            children: [
                eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    typography: "$bodyMedium",
                    fontWeight: "$medium",
                    color: "$contentTertiary",
                    children: eyebrow
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    flexDirection: "column",
                    gap: "$6",
                    $largerThanSM: {
                        flexDirection: "row",
                        flexWrap: "wrap"
                    },
                    children: items.map(function(fact, i) {
                        var ref1;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FactItem, {
                            fact: fact,
                            analyticsId: analyticsId
                        }, (ref = (ref1 = fact.sys) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref !== void 0 ? ref : i);
                    })
                })
            ]
        })
    });
};
var FactBar = {
    render: renderFactBar
};
/* harmony default export */ var landing_pages_v2_FactBar = (FactBar);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/FAQsDisplay.tsx
var FAQsDisplay = __webpack_require__(38613);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCContactUs.tsx
var FCContactUs = __webpack_require__(99782);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCHero.tsx
var FCHero = __webpack_require__(95534);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMap.tsx
var FCMap = __webpack_require__(49581);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCMissionStatement.tsx
var FCMissionStatement = __webpack_require__(81054);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCProductOptions.tsx
var FCProductOptions = __webpack_require__(72034);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTestimonialCarousel.tsx
var FCTestimonialCarousel = __webpack_require__(96889);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCThreeSteps.tsx
var FCThreeSteps = __webpack_require__(23208);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/FCTrustBanner.tsx
var FCTrustBanner = __webpack_require__(43649);
// EXTERNAL MODULE: ../../node_modules/.pnpm/framer-motion@6.5.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/framer-motion/dist/es/render/dom/motion.mjs + 142 modules
var motion = __webpack_require__(4701);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/motion/MotionVariants.ts
var MotionVariants = __webpack_require__(90198);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Sheet.tsx
var Sheet = __webpack_require__(38243);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/Feature5050.tsx










var bricksBgToToken = {
    white0: "$backgroundPrimary",
    warmgrey100: "$backgroundSecondary",
    earth100: "$backgroundSecondary",
    earth200: "$backgroundTertiary",
    brandBlue600: "$backgroundAccentBrand",
    warmgrey200: "$backgroundTertiary",
    warmgrey800: "$backgroundInversePrimary",
    warmgrey950: "$backgroundInversePrimary",
    neutrals100: "$backgroundInversePrimary"
};
var Feature5050Image = function(param) {
    var isArched = param.isArched, imageSrc = param.imageSrc, imageAlt = param.imageAlt;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "block",
        overflow: "hidden",
        width: "100%",
        aspectRatio: 1,
        $largerThanSM: {
            height: "100%",
            aspectRatio: "auto"
        },
        style: {
            borderRadius: isArched ? "99em 99em 8em 8em" : "2em"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
            source: {
                uri: imageSrc
            },
            alt: imageAlt,
            width: "100%",
            height: "100%",
            objectFit: "cover"
        })
    });
};
var CtaSheet = function(param) {
    var entry = param.entry, componentTheme = param.componentTheme;
    var fields = entry.fields;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ctaRef = (0,react.useRef)(null);
    var exitComplete = function() {
        var ref;
        (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    var onKeyDown = function(e) {
        if (e.key === " " || e.key === "Spacebar") {
            setIsVisible(true);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            fields.ctaDisplayText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                "aria-label": fields.ctaSheetLabel || "Open dialog",
                analyticsName: "cosmos-landing-page-feature5050-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                componentTheme: componentTheme,
                ctaStyle: fields.ctaStyle,
                ctaDisplayText: fields.ctaDisplayText,
                mt: "$0",
                tabIndex: 0,
                onKeyDown: onKeyDown,
                ref: ctaRef,
                onPress: function() {
                    return setIsVisible(true);
                },
                children: fields.ctaDisplayText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sheet/* default */.Z, {
                entry: fields.ctaSheet,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete
            })
        ]
    });
};
var RenderFeature5050 = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    var componentTheme = (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.backgroundColor);
    var bgColor = componentTheme.bg ? String(componentTheme.bg) : "white0";
    var bgToken = bricksBgToToken[bgColor] || "$backgroundPrimary";
    var _isArched = fields.isArched, isArched = _isArched === void 0 ? false : _isArched, _imagePosition = fields.imagePosition, imagePosition = _imagePosition === void 0 ? "Right" : _imagePosition;
    var gridLayout = {
        display: "grid"
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
            variants: MotionVariants/* show */.$Z,
            initial: "start",
            animate: "end",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "block",
                backgroundColor: bgToken,
                $largerThanSM: gridLayout,
                "$platform-web": {
                    gridTemplateColumns: "repeat(2, 1fr)",
                    justifyItems: "center"
                },
                borderRadius: "$12x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        backgroundColor: bgToken,
                        height: "100%",
                        justifyContent: "flex-end",
                        pb: "$14",
                        pt: "$16",
                        px: "$6",
                        $largerThanMD: {
                            pb: "$27",
                            pt: "$29"
                        },
                        $largerThanLG: {
                            pl: imagePosition === "Left" ? "$24" : "$16",
                            pr: imagePosition === "Left" ? "$16" : "$24"
                        },
                        gap: "$6",
                        width: "100%",
                        borderRadius: "$12x",
                        "$platform-web": {
                            gridColumn: imagePosition === "Left" ? "2 / -1" : "1 / 2",
                            gridRow: "1 / -1",
                            textAlign: "left"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$2",
                                children: [
                                    fields.eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Eyebrow */.j4, {
                                        children: fields.eyebrow
                                    }),
                                    fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                                        title: fields.title,
                                        titleAccent: fields.titleAccent
                                    }),
                                    fields.subhead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                                        children: fields.subhead
                                    }),
                                    fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                                        mt: "$4x",
                                        children: fields.desc
                                    })
                                ]
                            }),
                            fields.ctaDisplayText && (fields.ctaUrl || fields.ctaSheet) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                display: "block",
                                children: [
                                    fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                                        "aria-label": "Go to page ".concat(fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText),
                                        analyticsName: "cosmos-landing-page-feature5050-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                        componentTheme: componentTheme,
                                        ctaStyle: fields.ctaStyle,
                                        ctaDisplayText: fields.ctaDisplayText,
                                        ctaUrl: fields.ctaUrl,
                                        mt: "$0",
                                        children: fields.ctaDisplayText
                                    }),
                                    fields.ctaDisplayText && fields.ctaSheet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CtaSheet, {
                                        entry: entry,
                                        componentTheme: componentTheme
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "block",
                        backgroundColor: bgToken,
                        width: "100%",
                        p: "$4",
                        borderRadius: "$12x",
                        "$platform-web": {
                            gridColumn: imagePosition === "Left" ? "1 / 2" : "2 / -1",
                            gridRow: "1 / -1"
                        },
                        children: fields.image && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Feature5050Image, {
                            isArched: isArched,
                            imageSrc: (ref = fields.image.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url,
                            imageAlt: ((ref2 = fields.image.fields) === null || ref2 === void 0 ? void 0 : ref2.description) || ((ref3 = fields.image.fields) === null || ref3 === void 0 ? void 0 : ref3.title)
                        })
                    })
                ]
            })
        })
    });
};
var Feature5050 = {
    render: RenderFeature5050
};
/* harmony default export */ var landing_pages_v2_Feature5050 = (Feature5050);

;// CONCATENATED MODULE: ./src/components/shared/SpinningGradient.tsx


var SpinningGradient = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        position: "relative",
        backgroundColor: "$backgroundInversePrimary",
        marginTop: 200,
        $smallerThanMD: {
            marginTop: 100
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "relative",
                zIndex: 2,
                children: children
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                style: {
                    overflow: "visible"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    className: "blur",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        className: "gradient-mask",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            className: "spinning-gradient"
                        })
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var shared_SpinningGradient = (SpinningGradient);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.11.0_@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1__@types+react@18.3.28_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(89631);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/ArchSVG.tsx


var Arch = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)("svg", {
    target: "e1rwlihv0"
})("display:block;height:auto;position:relative;top:1px;width:100%;");
var ArchSVG = function(param) {
    var color = param.color;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Arch, {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1440",
        height: "124",
        viewBox: "0 0 1440 124",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M720 0C468.014 0 225.817 42.2127 0 120V124H1440V120C1214.18 42.2127 971.986 0 720 0Z",
            fill: color || "currentColor"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/styles/SharedStyles.ts
var SharedStyles = __webpack_require__(16451);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeaderStandalone.tsx













var HeaderStandalone_CtaSheet = function(param) {
    var entry = param.entry, componentTheme = param.componentTheme, bnTheme = param.bnTheme;
    var fields = entry.fields;
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ctaRef = (0,react.useRef)(null);
    // When animation is complete
    var exitComplete = function() {
        var ref;
        (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    // Make visual buttons work like Buttons
    var onKeyDown = function(e) {
        if (e.key === " " || e.key === "Spacebar") {
            setIsVisible(true);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            fields.ctaDisplayText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                "aria-label": fields.ctaSheetLabel || "Open dialog",
                analyticsName: "cosmos-landing-page-cta-standalone-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                componentTheme: componentTheme,
                bnTheme: bnTheme,
                ctaStyle: fields.ctaStyle,
                ctaDisplayText: fields.ctaDisplayText,
                tabIndex: 0,
                onKeyDown: onKeyDown,
                ref: ctaRef,
                onPress: function() {
                    return setIsVisible(true);
                },
                mt: "$6",
                children: fields.ctaDisplayText
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sheet/* default */.Z, {
                entry: fields.ctaSheet,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete
            })
        ]
    });
};
var HeaderContent = function(param) {
    var theme = param.theme, fields = param.fields, componentTheme = param.componentTheme, entry = param.entry;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        paddingVertical: "$10x",
        $largerThanMD: {
            paddingVertical: "$20x"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            gap: "$14x",
            $largerThanSM: {
                flexDirection: "row"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    css: (0,_object_spread/* default */.Z)({}, SharedStyles/* StackStyle */.yH),
                    $largerThanSM: {
                        flex: 6,
                        flexBasis: fields.layout === "Two Columns" ? 0 : "unset"
                    },
                    children: [
                        fields.eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Eyebrow */.j4, {
                            textAlign: fields.textAlign === "Center" ? "center" : "auto",
                            color: theme.contentPrimary,
                            children: fields.eyebrow
                        }),
                        fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                            title: fields.title,
                            titleAccent: fields.titleAccent,
                            titleSize: fields.titleSize,
                            textAlign: fields.textAlign === "Center" ? "center" : "auto",
                            marginHorizontal: fields.textAlign === "Center" ? "auto" : "unset",
                            titleColor: theme.contentPrimary,
                            titleAccentColor: theme.contentPrimaryAccent,
                            overRideTitleTag: "h1"
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            css: (0,_object_spread/* default */.Z)({}, SharedStyles/* StackStyle */.yH),
                            mx: fields.textAlign === "Center" ? "auto" : 0,
                            children: [
                                fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                                    mb: 0,
                                    $largerThanMD: {
                                        maxWidth: "48ch"
                                    },
                                    textAlign: fields.textAlign === "Center" ? "center" : "auto",
                                    children: fields.subhead
                                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* SubheadSmall */.Jm, {
                                    mb: 0,
                                    $largerThanMD: {
                                        maxWidth: "48ch"
                                    },
                                    textAlign: fields.textAlign === "Center" ? "center" : "auto",
                                    children: fields.subhead
                                })),
                                fields.layout !== "Two Columns" && fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                                    textAlign: fields.textAlign === "Center" ? "center" : "auto",
                                    children: fields.desc
                                }),
                                fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Buttons/* LPLink */.o, {
                                    "aria-label": "Go to page ".concat(fields.ctaDisplayText),
                                    analyticsName: "cosmos-landing-page-cta-standalone-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                    componentTheme: componentTheme,
                                    ctaStyle: fields.ctaStyle,
                                    ctaDisplayText: fields.ctaDisplayText,
                                    ctaUrl: fields.ctaUrl,
                                    mx: fields.textAlign === "Center" ? "auto" : "unset",
                                    width: "max-content"
                                }),
                                fields.ctaDisplayText && fields.ctaSheet && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderStandalone_CtaSheet, {
                                    entry: entry,
                                    componentTheme: componentTheme,
                                    bnTheme: theme
                                }),
                                fields.contextualField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    display: "flex",
                                    width: "100%",
                                    justifyContent: fields.textAlign === "Center" ? "center" : "flex-start",
                                    mt: 7,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContextualField/* default */.Z, {
                                        theme: componentTheme,
                                        contextFields: fields.contextualField,
                                        inputLocation: "header-standalone"
                                    })
                                })
                            ]
                        })
                    ]
                }),
                fields.layout === "Two Columns" && fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    $largerThanSM: {
                        flex: 4,
                        flexBasis: 0
                    },
                    $largerThanMD: {
                        marginRight: "$20x"
                    },
                    alignSelf: "flex-end",
                    marginHorizontal: fields.textAlign === "Center" ? "auto" : "unset",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                        textAlign: fields.textAlign === "Center" ? "center" : "auto",
                        children: fields.desc
                    })
                })
            ]
        })
    });
};
var RenderHeaderStandalone = function(entry) {
    var fields = entry.fields;
    var componentTheme = (0,ComponentTheme/* getComponentThemeColors */._Y)(fields.backgroundColor);
    var theme = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(fields.backgroundColor in ComponentTheme/* BNColorThemes */.CW ? fields === null || fields === void 0 ? void 0 : fields.backgroundColor : ComponentTheme/* BNColorThemes.Light */.CW.Light);
    var layoutBackgroundColor = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(fields.layoutBackgroundColor && fields.layoutBackgroundColor in ComponentTheme/* BNColorThemes */.CW ? fields === null || fields === void 0 ? void 0 : fields.layoutBackgroundColor : ComponentTheme/* BNColorThemes.Light */.CW.Light);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        className: "lp-section",
        backgroundColor: layoutBackgroundColor.bgPrimary,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                children: fields.showArch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ArchSVG, {
                    // @ts-expect-error theme.bgPrimary is a color token
                    color: (0,cjs.getToken)(theme.bgPrimary, "color")
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "relative",
                backgroundColor: theme.bgPrimary,
                children: fields.showGradientBackground ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_SpinningGradient, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContent, {
                        theme: theme,
                        fields: fields,
                        componentTheme: componentTheme,
                        entry: entry
                    })
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeaderContent, {
                    theme: theme,
                    fields: fields,
                    componentTheme: componentTheme,
                    entry: entry
                })
            })
        ]
    });
};
var HeaderStandalone = {
    render: RenderHeaderStandalone
};
/* harmony default export */ var landing_pages_v2_HeaderStandalone = (HeaderStandalone);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/PressBox.tsx
var PressBox = __webpack_require__(34476);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/OpendoorLogo.tsx
var OpendoorLogo = __webpack_require__(86691);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroCTA.tsx















var HERO_IMAGE_SIZES = [
    {
        minWidth: 0,
        maxWidth: 375,
        preset: "square-256"
    },
    {
        minWidth: 375,
        maxWidth: 768,
        preset: "square-512"
    },
    {
        minWidth: 768,
        maxWidth: 1201,
        preset: "square-512"
    },
    {
        minWidth: 1201,
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var HERO_IMAGE_PROPS = {
    sizes: HERO_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    borderRadius: "$8x"
};
var showLogo = {
    start: {
        opacity: 0
    },
    end: {
        opacity: 1,
        transition: {
            ease: "linear",
            delay: 0,
            duration: 0.3
        }
    }
};
var showArch = {
    start: {
        y: 0
    },
    end: {
        y: "-100%",
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            delay: 0.35,
            duration: 1
        }
    }
};
var showText = {
    start: {
        opacity: 0
    },
    end: {
        opacity: 1,
        transition: {
            delay: 1.4,
            duration: 0.3,
            type: "linear"
        }
    }
};
// Set default theme to generate button colors
var defaultTheme = (0,ComponentTheme/* getComponentThemeColors */._Y)("White 0");
var ctaStyleToButtonVariant = function(ctaStyle) {
    switch(ctaStyle){
        case "Secondary":
        case "Tertiary":
            return "secondary";
        default:
            return "primary";
    }
};
var DoorwayLayout = function(param) {
    var entry = param.entry;
    var ref;
    var fields = entry.fields;
    var hasLogos = fields.pressLogos && ((ref = fields.pressLogos) === null || ref === void 0 ? void 0 : ref.length) > 1;
    var showPressSection = fields.showPressSection;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        className: "lp-section",
        display: "block",
        mx: "auto",
        maxWidth: "$1440x",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                width: "100%",
                height: "$616x",
                $largerThanMD: {
                    height: "$768x"
                },
                gap: "$8x",
                "$platform-web": {
                    display: "grid",
                    gridTemplate: "1fr / 1fr"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        zIndex: 5,
                        "$platform-web": {
                            display: "grid",
                            gridArea: "1 / 1 / -1 / -1",
                            placeItems: "end center"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
                            variants: showText,
                            initial: "start",
                            animate: "end",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$16x",
                                pb: hasLogos ? "$8x" : "$16x",
                                $largerThanSM: hasLogos ? undefined : {
                                    pb: "$40x"
                                },
                                px: "$10x",
                                "$platform-web": {
                                    textAlign: "center"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                        gap: "$8x",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "h1",
                                                color: "$backgroundPrimary",
                                                typography: fields.titleSize === "Small" ? "$headerSmall" : "$headerMedium",
                                                $largerThanSM: {
                                                    typography: fields.titleSize === "Small" ? "$headerMedium" : "$displaySmall"
                                                },
                                                $largerThanMD: {
                                                    typography: // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
                                                    fields.titleSize === "XLarge" ? "$displayLarge" : fields.titleSize === "Small" ? "$headerMedium" : "$displaySmall"
                                                },
                                                mx: "auto",
                                                maxWidth: "$516x",
                                                children: (0,utils/* markdownToReactElement */.vl)(fields.title || "")
                                            }),
                                            fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "p",
                                                color: "$backgroundPrimary",
                                                typography: "$bodyMedium",
                                                $largerThanMD: {
                                                    typography: "$bodyLarge",
                                                    mx: "auto"
                                                },
                                                mx: "$10x",
                                                $smallerThanMD: {
                                                    maxWidth: "$382x"
                                                },
                                                children: (0,utils/* markdownToReactElement */.vl)(fields.desc || "")
                                            })
                                        ]
                                    }),
                                    (fields.ctaDisplayText && fields.ctaUrl || fields.extraCtas) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        flexWrap: "wrap",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        gap: "$8x",
                                        pb: hasLogos ? "$16x" : undefined,
                                        children: [
                                            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                                "aria-label": "Go to page ".concat(fields.ctaDisplayText),
                                                analyticsName: "cosmos-landing-page-cta-standalone-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                                variant: ctaStyleToButtonVariant(fields.ctaStyle),
                                                size: "medium",
                                                label: fields.ctaDisplayText,
                                                href: fields.ctaUrl
                                            }),
                                            fields.extraCtas && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ExtraCtas, {
                                                ctas: fields.extraCtas,
                                                componentTheme: defaultTheme
                                            })
                                        ]
                                    }),
                                    fields.contextualField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContextualField/* default */.Z, {
                                            theme: defaultTheme,
                                            contextFields: fields.contextualField,
                                            inputLocation: "hero-cta"
                                        })
                                    }),
                                    fields.bottomCtaDisplayText && fields.bottomCtaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                        "aria-label": "Go to page ".concat(fields === null || fields === void 0 ? void 0 : fields.bottomCtaDisplayText),
                                        analyticsName: "cosmos-landing-page-cta-standalone-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                        variant: "secondaryInverse",
                                        size: "medium",
                                        label: fields.bottomCtaDisplayText,
                                        href: fields.bottomCtaUrl
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
                        variants: showArch,
                        initial: "start",
                        animate: "end",
                        style: {
                            gridArea: "1 / 1 / -1 / -1",
                            height: "100%",
                            width: "100%",
                            pointerEvents: "none",
                            position: "absolute",
                            top: 0,
                            zIndex: 2
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            backgroundColor: "$backgroundPrimary",
                            minHeight: "100%",
                            width: "100%",
                            "$platform-web": {
                                display: "grid",
                                placeItems: "center"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
                                    variants: showLogo,
                                    initial: "start",
                                    animate: "end",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpendoorLogo/* OpendoorLogo */.o, {})
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                    height: "$10x",
                                    width: "100%",
                                    backgroundColor: "$backgroundPrimary",
                                    left: 0,
                                    position: "absolute",
                                    top: "100%",
                                    transform: "translateY(-8px)"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                    style: {
                                        height: "auto",
                                        left: 0,
                                        position: "absolute",
                                        top: "100%",
                                        width: "100%"
                                    },
                                    xmlns: "http://www.w3.org/2000/svg",
                                    width: "1442",
                                    height: "737",
                                    viewBox: "0 0 1442 737",
                                    fill: "none",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                        d: "M1442 0H0V737C0 338.803 322.803 16 721 16C1119.2 16 1442 338.803 1442 737V0Z",
                                        fill: "#FFF"
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        alignSelf: "flex-end",
                        backgroundColor: "$backgroundInversePrimary",
                        height: "100%",
                        zIndex: 1,
                        overflow: "hidden",
                        "$platform-web": {
                            gridArea: "1 / 1 / -1 / -1"
                        },
                        children: fields.doorwayImageUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                            height: "100%",
                            width: "100%",
                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HERO_IMAGE_PROPS), {
                                borderRadius: undefined,
                                photoUrl: fields === null || fields === void 0 ? void 0 : fields.doorwayImageUrl
                            }))
                        })
                    })
                ]
            }),
            !!showPressSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(motion/* motion.div */.E.div, {
                variants: showText,
                initial: "start",
                animate: "end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressBox/* PressBox */.j, {
                    width: "100%"
                })
            })
        ]
    });
};
var CollageLayout = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var minH = "calc(90vh - 56px)";
    var collageImageTopLeft = fields.collageImageUrlTopLeft;
    var collageImageBottomLeft = fields.collageImageUrlBottomLeft;
    var collageImageBottomRight = fields.collageImageUrlBottomRight;
    var showPressSection = fields.showPressSection;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* default */.ZP, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                gap: "$8x",
                $largerThanMD: {
                    minHeight: minH,
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        gap: "$8x",
                        $largerThanMD: {
                            alignSelf: "center",
                            flex: 5,
                            minWidth: 0
                        },
                        $largerThanLG: {
                            flex: 4
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h1",
                                typography: fields.titleSize === "Small" ? "$headerSmall" : "$headerMedium",
                                $largerThanSM: {
                                    typography: fields.titleSize === "Small" ? "$headerMedium" : "$displaySmall",
                                    maxWidth: "$636x"
                                },
                                children: (0,utils/* markdownToReactElement */.vl)(fields.title || "")
                            }),
                            fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: fields.titleSize === "Small" ? "$bodyLarge" : "$bodyXlarge",
                                color: "$contentPrimary",
                                $largerThanMD: {
                                    typography: "$bodyLarge",
                                    maxWidth: "$450x"
                                },
                                children: (0,utils/* markdownToReactElement */.vl)(fields.desc || "")
                            }),
                            (fields.ctaDisplayText && fields.ctaUrl || fields.extraCtas) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                flexWrap: "wrap",
                                alignItems: "center",
                                gap: "$8x",
                                pb: "$6x",
                                children: [
                                    fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                        "aria-label": "Go to page ".concat(fields.ctaDisplayText),
                                        analyticsName: "cosmos-landing-page-cta-standalone-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                        variant: ctaStyleToButtonVariant(fields.ctaStyle),
                                        size: "medium",
                                        label: fields.ctaDisplayText,
                                        href: fields.ctaUrl
                                    }),
                                    fields.extraCtas && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(shared_ExtraCtas, {
                                        ctas: fields.extraCtas,
                                        componentTheme: defaultTheme
                                    })
                                ]
                            }),
                            fields.contextualField && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ContextualField/* default */.Z, {
                                theme: defaultTheme,
                                contextFields: fields.contextualField,
                                inputLocation: "hero-cta"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                        justifyContent: "center",
                        $largerThanMD: {
                            flex: 7
                        },
                        $largerThanLG: {
                            flex: 8
                        },
                        gap: "$4x",
                        $largerThanSM: {
                            gap: "$8x"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                $largerThanSM: {
                                    gap: "$8x"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                        height: "$180x",
                                        $largerThanMD: {
                                            height: "$250x"
                                        },
                                        overflow: "hidden",
                                        flexGrow: 1,
                                        flexShrink: 1,
                                        flexBasis: 0,
                                        children: collageImageTopLeft && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            height: "100%",
                                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HERO_IMAGE_PROPS), {
                                                photoUrl: collageImageTopLeft
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        backgroundColor: "$backgroundTertiary",
                                        height: "$180x",
                                        $largerThanMD: {
                                            height: "$250x"
                                        },
                                        width: "$110x",
                                        $largerThanSM: {
                                            width: "$200x"
                                        },
                                        flexShrink: 0,
                                        pb: "$4x",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden",
                                        // style prop used because bricks-next doesn't support custom border-radius
                                        // values (only tokens), and $platform-web gets overridden by the component's
                                        // inline styles. style prop applies last and ensures the arch shape renders.
                                        style: {
                                            borderRadius: "99em 99em 16em 16em"
                                        },
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                            width: "$34x",
                                            $largerThanSM: {
                                                width: "$48x"
                                            },
                                            $largerThanMD: {
                                                width: "$64x"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
                                                xmlns: "http://www.w3.org/2000/svg",
                                                width: "100%",
                                                height: "auto",
                                                viewBox: "0 0 34 49",
                                                fill: "none",
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                                                    d: "M24.4441 18.9269C24.4441 7.0532 22.4319 2.13138 16.8995 2.13138C12.0206 2.13138 9.55613 5.58163 9.55613 17.557C9.55613 29.3799 11.4675 34.2511 17.1006 34.2511C22.08 34.2511 24.4441 30.8513 24.4441 18.9269ZM0 18.6226C0 5.2772 9.10359 0 17.2013 0C25.8522 0 34 5.22662 34 17.8107C34 31.2573 24.8966 36.3825 16.7987 36.3825C8.14802 36.3825 0 30.8009 0 18.6226ZM32.2246 47.1186C31.3991 46.014 28.2194 41.7583 28.2194 41.7583C27.9211 41.359 27.4099 41.118 26.8612 41.118H7.13884C6.59022 41.118 6.07901 41.359 5.78067 41.7583L1.77607 47.1179C1.64903 47.2878 1.58162 47.4857 1.58162 47.688V48.5061C1.58162 48.7789 1.80076 49 2.07118 49H31.9289C32.1993 49 32.4185 48.7789 32.4185 48.5061V47.688C32.4185 47.4857 32.3516 47.2884 32.2246 47.1186Z",
                                                    fill: "#9D9893"
                                                })
                                            })
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$4x",
                                $largerThanSM: {
                                    gap: "$8x"
                                },
                                width: "100%",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        height: "$180x",
                                        $largerThanMD: {
                                            height: "$250x"
                                        },
                                        overflow: "hidden",
                                        flexGrow: 1.7,
                                        flexShrink: 1,
                                        flexBasis: 0,
                                        children: collageImageBottomLeft && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            width: "100%",
                                            height: "100%",
                                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HERO_IMAGE_PROPS), {
                                                photoUrl: collageImageBottomLeft
                                            }))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                        height: "$180x",
                                        $largerThanMD: {
                                            height: "$250x"
                                        },
                                        overflow: "hidden",
                                        flexGrow: 1.3,
                                        flexShrink: 1,
                                        flexBasis: 0,
                                        children: collageImageBottomRight && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            width: "100%",
                                            height: "100%",
                                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HERO_IMAGE_PROPS), {
                                                photoUrl: collageImageBottomRight
                                            }))
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!showPressSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                pt: "$16x",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressBox/* PressBox */.j, {
                    // @ts-expect-error we don't have 20px in novo.radii
                    borderRadius: [
                        "20px",
                        null
                    ]
                })
            })
        ]
    });
};
var RenderHeroCTA = function(entry) {
    var fields = entry.fields;
    return fields.layout === "Doorway" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DoorwayLayout, {
        entry: entry
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CollageLayout, {
        entry: entry
    });
};
var getHeroCTAImageUrls = function(fields) {
    if (fields.layout === "Doorway") {
        return fields.doorwayImageUrl ? [
            fields.doorwayImageUrl
        ] : [];
    }
    return [
        fields.collageImageUrlTopLeft,
        fields.collageImageUrlBottomLeft,
        fields.collageImageUrlBottomRight, 
    ].filter(function(url) {
        return Boolean(url);
    });
};
var heroCTALoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = getHeroCTAImageUrls(input.fields).flatMap(function(photoUrl) {
                var sources = (0,pictures/* generatePresetPictureSetProps */.$c)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, HERO_IMAGE_PROPS), {
                    photoUrl: photoUrl
                })).sources;
                return sources;
            });
            loaderReturn = {
                preloadImages: preloadImages
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroCTALoader(input) {
        return _ref.apply(this, arguments);
    };
}();
var HeroCTA = {
    render: RenderHeroCTA,
    loader: heroCTALoader
};
/* harmony default export */ var landing_pages_v2_HeroCTA = (HeroCTA);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(67236);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx + 3 modules
var HeroV2WithMarkers = __webpack_require__(40066);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/Grid.tsx
var Grid = __webpack_require__(97828);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ImageCard.tsx




var RenderImageCard = function(entry) {
    var fields = entry.fields;
    var desktopImageSourceUrl = fields === null || fields === void 0 ? void 0 : fields.desktopImage;
    var mobileImageSourceUrl = fields === null || fields === void 0 ? void 0 : fields.mobileImage;
    var mobileDescriptionDisplay = (fields === null || fields === void 0 ? void 0 : fields.hideDescriptionOnMobile) ? "none" : "block"; // By default, we hide description on mobile
    var isSmallPadding = (fields === null || fields === void 0 ? void 0 : fields.verticalPadding) === "Small";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        analyticsName: "cosmos-landing-page-image-card-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Grid/* default */.Z, {
            backgroundColor: "$backgroundSecondary",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                "$platform-web": {
                    gridColumn: Grid/* gridStyles.colSpan12 */.m.colSpan12
                },
                flexDirection: "column",
                width: "100%",
                height: "$500x",
                my: isSmallPadding ? "$10x" : "$68x",
                $largerThanXS: {
                    height: "$616x",
                    my: isSmallPadding ? "$16x" : "$24x"
                },
                $largerThanSM: {
                    height: "$452x",
                    flexDirection: "row",
                    my: isSmallPadding ? "$24x" : "$68x"
                },
                $largerThanMD: {
                    height: "$719x"
                },
                borderRadius: "$12x",
                overflow: "hidden",
                backgroundColor: "$backgroundPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                        overflow: "hidden",
                        $largerThanSM: {
                            flex: 1,
                            flexBasis: 0,
                            flexShrink: 1
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                            p: "$16x",
                            flexShrink: 1,
                            $largerThanSM: {
                                p: "$20x"
                            },
                            $largerThanMD: {
                                p: "$32x"
                            },
                            justifyContent: "flex-start",
                            children: [
                                (fields === null || fields === void 0 ? void 0 : fields.subtitle) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                                    flexGrow: 1,
                                    pb: "$6x",
                                    $largerThanSM: {
                                        pb: "$0x"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Subhead */.vF, {
                                        children: fields.subtitle
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                            width: "100%",
                                            maxWidth: "$200x",
                                            minHeight: "$75x",
                                            $largerThanXS: {
                                                maxWidth: "$250x",
                                                minHeight: "$93x"
                                            },
                                            $largerThanSM: {
                                                maxWidth: "$272x",
                                                minHeight: "$105x"
                                            },
                                            $largerThanMD: {
                                                maxWidth: "$430x",
                                                minHeight: "$168x"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                tag: "h2",
                                                typography: "$headerSmall",
                                                display: "block",
                                                mb: "$8x",
                                                color: "$contentPrimary",
                                                $largerThanMD: {
                                                    typography: "$headerLarge"
                                                },
                                                children: [
                                                    fields.title,
                                                    fields.secondaryTitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                        tag: "span",
                                                        typography: "$headerSmall",
                                                        color: "$contentTertiary",
                                                        $largerThanMD: {
                                                            typography: "$headerLarge"
                                                        },
                                                        children: [
                                                            " ",
                                                            fields.secondaryTitle
                                                        ]
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                                            display: mobileDescriptionDisplay,
                                            $largerThanSM: {
                                                display: "block"
                                            },
                                            $largerThanMD: {
                                                fontSize: 18
                                            },
                                            children: fields.description
                                        }),
                                        (fields === null || fields === void 0 ? void 0 : fields.ctaLink) && (fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                            variant: "primary",
                                            "aria-label": "Go to page to ".concat(fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText),
                                            analyticsName: "cosmos-landing-page-image-card-cta-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                            onPress: function() {
                                                return (fields === null || fields === void 0 ? void 0 : fields.ctaLink) && window.location.assign(fields === null || fields === void 0 ? void 0 : fields.ctaLink);
                                            },
                                            mt: "$12x",
                                            $largerThanSM: {
                                                mt: "$16x"
                                            },
                                            $largerThanMD: {
                                                mt: "$24x"
                                            },
                                            size: "small",
                                            width: "$180x",
                                            minHeight: "$48x",
                                            label: fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flex: 1,
                        flexBasis: 0,
                        flexShrink: 1,
                        $largerThanSM: {
                            p: "$8x"
                        },
                        $largerThanMD: {
                            p: "$10x"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            "$platform-web": {
                                display: "grid"
                            },
                            overflow: "hidden",
                            width: "100%",
                            height: "100%",
                            $largerThanSM: {
                                borderRadius: "$8x"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("picture", {
                                style: {
                                    display: "contents"
                                },
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("source", {
                                        media: "(min-width: 768px)",
                                        srcSet: desktopImageSourceUrl
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("img", {
                                        src: mobileImageSourceUrl,
                                        alt: "illustration of a home",
                                        loading: "lazy",
                                        decoding: "async",
                                        style: {
                                            display: "block",
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            objectPosition: "80%"
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var ImageCard = {
    render: RenderImageCard
};
/* harmony default export */ var landing_pages_v2_ImageCard = (ImageCard);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/LinkList.tsx



var RenderLinkList = function(entry) {
    var ref;
    var fields = entry.fields, sys = entry.sys;
    var locale = sys.locale;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        py: "$4",
        display: "flex",
        alignItems: "center",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            tag: "ul",
            padding: "$0",
            role: "list",
            flexDirection: "row",
            borderRadius: "$full",
            borderWidth: "$0dot5x",
            borderStyle: "solid",
            borderColor: "$borderPrimary",
            "$platform-web": {
                display: "inline-flex",
                listStyle: "none",
                paddingInlineStart: 0
            },
            zIndex: 3,
            children: (ref = fields.links) === null || ref === void 0 ? void 0 : ref.map(function(link, idx) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    tag: "li",
                    "$platform-web": {
                        display: "inline-flex"
                    },
                    children: locale !== "es" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        "aria-label": "Go to page ".concat(link.fields.text),
                        analyticsName: "cosmos-landing-page-link-list-".concat(fields.analyticsId || "", "-").concat(link.fields.text),
                        backgroundColor: link.fields.active ? "$backgroundAccentBrand" : "$transparent",
                        color: link.fields.active ? "$contentInversePrimary" : "$contentAccentBrand",
                        href: link.fields.url,
                        py: "$2",
                        px: "$6",
                        fontWeight: "$medium",
                        borderRadius: "$full",
                        variant: link.fields.active ? "secondaryInverse" : "primary",
                        "$platform-web": {
                            textDecorationLine: "none"
                        },
                        children: link.fields.text
                    })
                }, idx);
            })
        })
    });
};
var LinkList = {
    render: RenderLinkList
};
/* harmony default export */ var landing_pages_v2_LinkList = (LinkList);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconCheck.mjs
var IconCheck = __webpack_require__(6997);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconChevronRight.mjs
var IconChevronRight = __webpack_require__(7702);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/List.tsx










var ListItemIcon = function(param) {
    var isNumbered = param.isNumbered, hasCheckmark = param.hasCheckmark, isLight = param.isLight, index = param.index, iconBg = param.iconBg, iconColor = param.iconColor;
    if (!isNumbered && !hasCheckmark) return null;
    var size = isLight ? 40 : 24;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "$2x",
        backgroundColor: iconBg,
        width: size,
        height: size,
        minWidth: size,
        minHeight: size,
        mt: "$half",
        flexShrink: 0,
        children: isNumbered ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            tag: "span",
            typography: "$bodyLarge",
            fontWeight: "$medium",
            color: iconColor,
            children: index + 1
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconCheck/* default */.Z, {
            size: 16,
            color: iconColor,
            strokeWidth: 2
        })
    });
};
var ItemDetails = function(param) {
    var item = param.item, _theme = param.theme, theme = _theme === void 0 ? {} : _theme;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        position: "relative",
        pr: item.fields.url ? "$10x" : "$0",
        gap: "$2",
        minWidth: "$0",
        flexShrink: 1,
        children: [
            item.fields.eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Eyebrow */.j4, {
                mt: "$2",
                color: theme.contentPrimary,
                children: item.fields.eyebrow
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h4",
                color: theme.contentPrimary,
                typography: "$subheaderSmall",
                children: item.fields.title
            }),
            item.fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                color: theme.contentPrimary,
                typography: "$bodyLarge",
                display: "block",
                children: (0,utils/* markdownToReactElement */.vl)(item.fields.desc)
            }),
            (item.fields.url || item.fields.ctaSheet) && !item.fields.hideArrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                style: {
                    position: "absolute",
                    left: "100%",
                    marginTop: -8,
                    top: "50%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconChevronRight/* default */.Z, {
                    size: 16,
                    color: (0,cjs.getToken)("$contentTertiary", "color"),
                    strokeWidth: 2
                })
            })
        ]
    });
};
var ItemSheet = function(_param) {
    var item = _param.item, listItemTitleSize = _param.listItemTitleSize, theme = _param.theme, props = (0,_object_without_properties/* default */.Z)(_param, [
        "item",
        "listItemTitleSize",
        "theme"
    ]);
    var ref = (0,react.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ctaRef = (0,react.useRef)(null);
    var exitComplete = function() {
        var ref;
        (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        minWidth: "$0",
        flexShrink: 1,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                ref: ctaRef,
                onPress: function() {
                    return setIsVisible(true);
                },
                "aria-label": props["aria-label"] || "Open dialog",
                analyticsName: props.analyticsName || "",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                "$platform-web": {
                    textAlign: "left"
                },
                "data-group": true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemDetails, {
                    item: item,
                    theme: theme,
                    listItemTitleSize: listItemTitleSize
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Sheet/* default */.Z, {
                entry: item.fields.ctaSheet,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete
            })
        ]
    });
};
var RenderList = function(entry) {
    var ref;
    var fields = entry.fields;
    var listBgColor = fields.listItemBg in ComponentTheme/* BNColorThemes */.CW ? fields.listItemBg : ComponentTheme/* BNColorThemes.Light */.CW.Light;
    var layoutBgColor = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(fields.bgColor && fields.bgColor in ComponentTheme/* BNColorThemes */.CW ? fields.bgColor : ComponentTheme/* BNColorThemes.Light */.CW.Light);
    var theme = (0,ComponentTheme/* getBNComponentThemeColors */.u$)(listBgColor);
    // List Item Icon Options
    var isNumbered = fields.listItemIcon === "Number";
    var hasCheckmark = fields.listItemIcon === "Checkmark";
    var isLight = listBgColor === ComponentTheme/* BNColorThemes.Light */.CW.Light;
    var iconBg = isLight ? (0,cjs.getToken)("$backgroundTertiary", "color") : "transparent";
    var iconColor = !isLight ? (0,cjs.getTokenValue)(theme.contentPrimary, "color") : "#000000";
    // List Layout Options
    var headerAbove = fields.listLayout === "Header Above" || fields.listLayout === "Header Above with Two Column List";
    var twoColumnList = fields.listLayout === "Header Above with Two Column List" || fields.listLayout === "Header Left with Two Column List";
    var listItemTitleSize = headerAbove ? "18px" : "24px";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        backgroundColor: layoutBgColor.bgPrimary,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            $largerThanSM: {
                flexDirection: headerAbove ? "column" : "row"
            },
            gap: "$4",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    flex: 4,
                    $largerThanSM: {
                        flexBasis: "100%"
                    },
                    mb: "$5",
                    pr: "$5",
                    gap: "$4",
                    children: [
                        fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* TitleWithAccent */.aI, {
                            overRideTitleTag: fields.titleTag,
                            title: fields.title,
                            titleAccent: fields.titleAccent,
                            titleSize: fields.titleSize,
                            $largerThanSM: {
                                typography: "$headerLarge"
                            },
                            color: layoutBgColor.contentPrimary
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            display: "block",
                            // @ts-expect-error "ch" units aren't accepted by bricks-next but they're valid for web styles
                            $largerThanSM: {
                                maxWidth: headerAbove ? "60ch" : "100%"
                            },
                            children: [
                                fields.subhead && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "h4",
                                    display: "block",
                                    typography: fields.titleSize === "Large" ? "$subheaderXsmall" : "$labelMedium",
                                    $largerThanSM: {
                                        typography: fields.titleSize === "Large" ? "$subheaderSmall" : "$labelMedium"
                                    },
                                    fontWeight: "$medium",
                                    color: layoutBgColor.inactivePrimary,
                                    children: fields.subhead
                                }),
                                fields.desc && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Typography/* Desc */.Xe, {
                                    children: fields.desc
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    display: "block",
                    flex: 6,
                    $largerThanSM: {
                        flexBasis: "100%"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                            tag: isNumbered ? "ol" : "ul",
                            m: "$0",
                            p: "$0",
                            gap: isLight ? "$0" : "$2",
                            role: "list",
                            $largerThanSM: {
                                flexDirection: twoColumnList ? "row" : "column",
                                flexWrap: twoColumnList ? "wrap" : undefined
                            },
                            style: {
                                listStyle: "none"
                            },
                            children: (ref = fields.listItems) === null || ref === void 0 ? void 0 : ref.map(function(item, idx) {
                                var ref, ref1, ref2;
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    backgroundColor: theme.bgPrimary,
                                    "$platform-web": {
                                        flexBasis: twoColumnList ? "47%" : "unset"
                                    },
                                    borderRadius: isLight ? undefined : "$8x",
                                    tag: "li",
                                    display: "flex",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    gap: "$5",
                                    py: isLight ? "$6" : "$7",
                                    pl: isLight ? "$0" : "$6",
                                    pr: isLight ? "$0" : "$7",
                                    borderBottomColor: isLight ? "$borderPrimary" : undefined,
                                    borderBottomWidth: isLight ? "$0dot5x" : undefined,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListItemIcon, {
                                            isNumbered: isNumbered,
                                            hasCheckmark: hasCheckmark,
                                            isLight: isLight,
                                            index: idx,
                                            iconBg: iconBg,
                                            iconColor: iconColor
                                        }),
                                        item.fields.url ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                            href: item.fields.url,
                                            "aria-label": "",
                                            analyticsName: "cosmos-landing-page-list-item-".concat((ref = item.fields) === null || ref === void 0 ? void 0 : ref.analyticsId),
                                            variant: fields.bgColor === "Dark" ? "secondaryInverse" : "primary",
                                            textDecorationLine: "none",
                                            "data-group": true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemDetails, {
                                                item: item,
                                                theme: theme,
                                                listItemTitleSize: listItemTitleSize
                                            })
                                        }) : item.fields.ctaSheet ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemSheet, {
                                            item: item,
                                            theme: theme,
                                            "aria-label": item.fields.ctaSheetLabel || "Open dialog",
                                            analyticsName: "cosmos-landing-page-list-item-".concat((ref1 = item.fields) === null || ref1 === void 0 ? void 0 : ref1.analyticsId),
                                            listItemTitleSize: listItemTitleSize
                                        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                            "aria-label": "",
                                            analyticsName: "cosmos-landing-page-list-item-".concat((ref2 = item.fields) === null || ref2 === void 0 ? void 0 : ref2.analyticsId),
                                            textDecorationLine: "none",
                                            "data-group": true,
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ItemDetails, {
                                                item: item,
                                                theme: theme,
                                                listItemTitleSize: listItemTitleSize
                                            })
                                        })
                                    ]
                                }, idx);
                            })
                        }),
                        fields.seeMoreLinkText && fields.seeMoreLinkUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            display: "block",
                            mt: "$8",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                variant: fields.bgColor === "Dark" ? "secondaryInverse" : "primary",
                                analyticsName: "",
                                "aria-label": "See More",
                                href: fields.seeMoreLinkUrl,
                                fontWeight: "$medium",
                                textDecorationLine: fields.bgColor === "Dark" ? "underline" : undefined,
                                children: fields.seeMoreLinkText
                            })
                        })
                    ]
                })
            ]
        })
    });
};
var List = {
    render: RenderList
};
/* harmony default export */ var landing_pages_v2_List = (List);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCHeroCard.tsx
var LWCHeroCard = __webpack_require__(83530);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCImageCard.tsx
var LWCImageCard = __webpack_require__(26923);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/LWCTextSection.tsx
var LWCTextSection = __webpack_require__(21277);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/MapBackgroundHero.tsx
var MapBackgroundHero = __webpack_require__(81131);
// EXTERNAL MODULE: ../observability/src/global.ts
var global = __webpack_require__(96602);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(22225);
;// CONCATENATED MODULE: ./src/helpers/marketMetrics.ts
/**
 * Market Metrics Helper
 *
 * Provides utilities for fetching and formatting market-level statistics
 * from Athena's sellerDashboardMetrics service.
 */ 


/**
 * Fetches current market-level metrics for a given market identifier
 *
 * @param marketIdentifier - The market identifier (e.g., "atlanta", "phoenix", "dallas")
 * @returns Market metrics including homes sold, new listings, delistings, and week-over-week changes
 */ function getMarketMetrics(marketIdentifier) {
    return _getMarketMetrics.apply(this, arguments);
}
function _getMarketMetrics() {
    _getMarketMetrics = (0,_async_to_generator/* default */.Z)(function(marketIdentifier) {
        var ref, result;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetMarketMetricsQuery({
                            marketIdentifier: marketIdentifier
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        result === null || result === void 0 ? void 0 : (ref = result.sellerDashboardMetrics) === null || ref === void 0 ? void 0 : ref.getMarketMetrics
                    ];
            }
        });
    });
    return _getMarketMetrics.apply(this, arguments);
}

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/MarketStats.tsx
/**
 * Market Stats
 *
 * A simplified Contentful component that displays market-level statistics.
 * Uses the marketIdentifier from CMS to fetch and display market metrics.
 */ 






var Sentry = global/* globalObservability.getSentryClient */.w.getSentryClient();
/**
 * Data loader function - called server-side during getServerSideProps
 * This fetches the market metrics data from Athena before rendering
 */ var loader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(entry) {
        var marketIdentifier, metrics, error, ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    marketIdentifier = entry.fields.marketIdentifier;
                    if (!marketIdentifier) {
                        return [
                            2,
                            null
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        getMarketMetrics(marketIdentifier)
                    ];
                case 2:
                    metrics = _state.sent();
                    return [
                        2,
                        metrics
                    ];
                case 3:
                    error = _state.sent();
                    Sentry === null || Sentry === void 0 ? void 0 : (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
                        captureContext: {
                            extra: {
                                marketIdentifier: marketIdentifier,
                                entryId: entry.sys.id
                            }
                        }
                    });
                    return [
                        2,
                        null
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return function loader(entry) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Individual stat card component
 */ var StatCard = function(param) {
    var value = param.value, change = param.change, label = param.label, sublabel = param.sublabel, _reverseTrendColor = param.reverseTrendColor, reverseTrendColor = _reverseTrendColor === void 0 ? false : _reverseTrendColor, _fullWidth = param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth;
    var getTrendColor = function(changeValue) {
        if (changeValue === null || changeValue === undefined) {
            return "$contentSecondary";
        }
        if (reverseTrendColor) {
            return changeValue > 0 ? "$borderStateErrorDefault" : "$backgroundAccentBrand";
        }
        return changeValue < 0 ? "$borderStateErrorDefault" : "$backgroundAccentBrand";
    };
    var formatChange = function(changeValue) {
        if (changeValue === null || changeValue === undefined) return "";
        var arrow = changeValue < 0 ? "↘" : "↗";
        var percentage = Math.round(Math.abs(changeValue) * 100);
        return "".concat(arrow, " ").concat(percentage, "%");
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        position: "relative",
        marginTop: "$4x",
        padding: "$10x",
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$8x",
        width: "100%",
        $largerThanSM: {
            width: fullWidth ? "100%" : "calc(50% - 4px)"
        },
        children: [
            change !== undefined && change !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodySmall",
                color: getTrendColor(change),
                position: "absolute",
                top: "$10x",
                right: "$10x",
                children: formatChange(change)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h4",
                typography: "$headerSmall",
                color: "$contentPrimary",
                children: typeof value === "number" ? value.toLocaleString("en-US") : value
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodySmall",
                marginTop: "$4x",
                color: "$contentPrimary",
                children: [
                    label,
                    sublabel && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                            sublabel
                        ]
                    })
                ]
            })
        ]
    });
};
/**
 * Main render function - renders the market stats
 *
 * @param entry - The Contentful entry for this component
 * @param metrics - Pre-fetched market metrics data from the loader
 */ var RenderMarketStats = function(entry, metrics) {
    if (!metrics) {
        return null;
    }
    var fields = entry.fields;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        width: "100%",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* LandingPageSectionContainer */.IX, {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                paddingVertical: "$20x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "flex",
                        flexDirection: "column",
                        marginBottom: "$8x",
                        $largerThanSM: {
                            flexDirection: "row",
                            justifyContent: "space-between"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            $largerThanSM: {
                                width: "60%"
                            },
                            children: [
                                fields.title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "h2",
                                    typography: "$subheaderMedium",
                                    color: "$contentPrimary",
                                    children: fields.title
                                }),
                                fields.subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodyMedium",
                                    color: "$contentSecondary",
                                    marginTop: "$6x",
                                    children: fields.subtitle
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        display: "flex",
                        flexDirection: "column",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                display: "flex",
                                flexDirection: "column",
                                gap: "$2x",
                                width: "100%",
                                $largerThanSM: {
                                    flexDirection: "row",
                                    gap: "$2x",
                                    alignItems: "stretch",
                                    flexWrap: "nowrap"
                                },
                                children: [
                                    metrics.newListings !== undefined && metrics.newListings !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCard, {
                                        value: metrics.newListings,
                                        change: metrics.newListingsWow,
                                        label: "New listings",
                                        sublabel: "This week"
                                    }),
                                    metrics.homesOnMarket !== undefined && metrics.homesOnMarket !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCard, {
                                        value: metrics.homesOnMarket,
                                        change: metrics.homesOnMarketWow,
                                        label: "Homes on market",
                                        sublabel: "Currently active"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                display: "flex",
                                flexDirection: "column",
                                gap: "$2x",
                                width: "100%",
                                $largerThanSM: {
                                    flexDirection: "row",
                                    gap: "$2x",
                                    alignItems: "stretch",
                                    flexWrap: "nowrap"
                                },
                                children: [
                                    metrics.delistings !== undefined && metrics.delistings !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCard, {
                                        value: metrics.delistings,
                                        change: metrics.delistingsWow,
                                        label: "Homes delisted",
                                        sublabel: "This week"
                                    }),
                                    metrics.homesSold !== undefined && metrics.homesSold !== null && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatCard, {
                                        value: metrics.homesSold,
                                        change: metrics.homesSoldWow,
                                        label: "Homes sold",
                                        sublabel: "This week"
                                    })
                                ]
                            })
                        ]
                    }),
                    metrics.timePeriod && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        marginTop: "$12x",
                        tag: "p",
                        typography: "$labelSmall",
                        color: "$contentSecondary",
                        textAlign: "center",
                        children: [
                            "Last updated on",
                            " ",
                            new Date(metrics.timePeriod).toLocaleDateString("en-US", {
                                month: "long",
                                day: "numeric",
                                year: "numeric",
                                timeZone: "UTC"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var MarketStats = {
    render: RenderMarketStats,
    loader: loader
};
/* harmony default export */ var landing_pages_v2_MarketStats = (MarketStats);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/NarrativeLockups.tsx






var LOCKUP_ROW_DESKTOP = {
    flexDirection: "row",
    gap: "$24x"
};
var LOCKUP_HEADER_DESKTOP = {
    flexBasis: 320,
    flexShrink: 0
};
var SECTION_TITLE_MOBILE = {
    typography: "$headerSmall"
};
var hasText = function(node) {
    var ref;
    if (!node || typeof node !== "object") {
        return false;
    }
    var richTextNode = node;
    if (typeof richTextNode.value === "string" && richTextNode.value.trim()) {
        return true;
    }
    var ref1;
    return (ref1 = (ref = richTextNode.content) === null || ref === void 0 ? void 0 : ref.some(function(child) {
        return hasText(child);
    })) !== null && ref1 !== void 0 ? ref1 : false;
};
var isEmptyRichText = function(document) {
    var ref;
    if (!(document === null || document === void 0 ? void 0 : (ref = document.content) === null || ref === void 0 ? void 0 : ref.length)) {
        return true;
    }
    return !document.content.some(function(node) {
        return hasText(node);
    });
};
var richTextOptions = function(analyticsId) {
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.PARAGRAPH, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyLarge",
                color: "$contentPrimary",
                display: "block",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_2, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h3",
                typography: "$subheaderMedium",
                color: "$contentPrimary",
                display: "block",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.HEADING_3, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "h4",
                typography: "$subheaderSmall",
                color: "$contentPrimary",
                display: "block",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.UL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                tag: "ul",
                gap: "$3x",
                paddingLeft: "$10x",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.OL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                tag: "ol",
                gap: "$3x",
                paddingLeft: "$10x",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.LIST_ITEM, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                tag: "li",
                children: children
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.BLOCKS.QUOTE, function(_, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                tag: "blockquote",
                gap: "$4x",
                paddingLeft: "$6x",
                borderLeftWidth: 3,
                borderLeftColor: "$borderPrimary",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    gap: "$4x",
                    children: children
                })
            });
        }), (0,_define_property/* default */.Z)(_obj, dist.INLINES.HYPERLINK, function(node, children) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                href: node.data.uri,
                variant: "primary",
                analyticsName: "cosmos-landing-page-v2-narrative-lockups-".concat(analyticsId !== null && analyticsId !== void 0 ? analyticsId : "link"),
                children: children
            });
        }), _obj)
    };
};
var NarrativeLockup = function(param) {
    var lockup = param.lockup, analyticsId = param.analyticsId, showTopline = param.showTopline;
    var _fields = lockup.fields, eyebrow = _fields.eyebrow, title = _fields.title, body = _fields.body;
    if (!eyebrow && !title && (!body || isEmptyRichText(body))) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$10x",
        paddingTop: showTopline ? "$14x" : 0,
        borderTopWidth: showTopline ? 1 : 0,
        borderTopColor: "$borderPrimary",
        $largerThanMD: LOCKUP_ROW_DESKTOP,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$3x",
                $largerThanMD: LOCKUP_HEADER_DESKTOP,
                children: [
                    eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$labelXsmall",
                        fontWeight: "$medium",
                        color: "$contentTertiary",
                        textTransform: "uppercase",
                        display: "block",
                        children: eyebrow
                    }),
                    title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h2",
                        typography: "$headerSmall",
                        color: "$contentPrimary",
                        display: "block",
                        children: title
                    })
                ]
            }),
            body && !isEmptyRichText(body) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                gap: "$8x",
                flex: 1,
                maxWidth: 880,
                children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(body, richTextOptions(analyticsId))
            })
        ]
    });
};
var RenderNarrativeLockups = function(entry) {
    var _fields = entry.fields, analyticsId = _fields.analyticsId, eyebrow = _fields.eyebrow, title = _fields.title, intro = _fields.intro, items = _fields.items;
    var _showTopline;
    var showTopline = (_showTopline = entry.fields.showTopline) !== null && _showTopline !== void 0 ? _showTopline : true;
    if (!(items === null || items === void 0 ? void 0 : items.length)) {
        return null;
    }
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        noSectionSpacing: true,
        paddingVertical: "$20x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            gap: "$18",
            children: [
                (eyebrow || title || intro && !isEmptyRichText(intro)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                    gap: "$4x",
                    maxWidth: "$200x",
                    children: [
                        eyebrow && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$labelXsmall",
                            fontWeight: "$medium",
                            color: "$contentTertiary",
                            textTransform: "uppercase",
                            display: "block",
                            children: eyebrow
                        }),
                        title && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "h2",
                            typography: "$headerMedium",
                            color: "$contentPrimary",
                            display: "block",
                            $smallerThanMD: SECTION_TITLE_MOBILE,
                            children: title
                        }),
                        intro && !isEmptyRichText(intro) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                            gap: "$4x",
                            children: (0,rich_text_react_renderer_es5/* documentToReactComponents */.h)(intro, richTextOptions(analyticsId))
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    gap: "$18",
                    children: items.map(function(lockup, index) {
                        var ref1;
                        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NarrativeLockup, {
                            lockup: lockup,
                            analyticsId: analyticsId,
                            showTopline: showTopline
                        }, (ref = (ref1 = lockup.sys) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref !== void 0 ? ref : index);
                    })
                })
            ]
        })
    });
};
var NarrativeLockups = {
    render: RenderNarrativeLockups
};
/* harmony default export */ var landing_pages_v2_NarrativeLockups = (NarrativeLockups);

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(57854);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/OpenPositions.tsx










var BOARDS = [
    "opendoor",
    "osn"
];
var isBoard = function(s) {
    return BOARDS.includes(s);
};
var BOARD_LABEL = {
    opendoor: "Opendoor",
    osn: "OS National"
};
var ripplingListUrl = function(board) {
    return "https://api.rippling.com/platform/api/ats/v1/board/".concat(board, "/jobs");
};
var ripplingDetailUrl = function(board, uuid) {
    return "https://ats.rippling.com/api/v2/board/".concat(board, "/jobs/").concat(uuid);
};
var ripplingApplyUrl = function(board, uuid) {
    return "https://ats.rippling.com/".concat(board, "/jobs/").concat(uuid, "/apply");
};
var _name;
var locName = function(loc) {
    return typeof loc === "string" ? loc : (_name = loc.name) !== null && _name !== void 0 ? _name : "";
};
var locWorkplace = function(loc) {
    return typeof loc === "string" ? {
        name: loc
    } : loc;
};
var PROD_HOST = "https://www.opendoor.com";
var slugify = function(s) {
    return s.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "").slice(0, 80).replace(/-+$/g, "");
};
var jobPath = function(job) {
    var tail = "".concat(slugify(job.name), "-").concat(job.uuid);
    return job.board === "opendoor" ? "/careers/open-positions/jobs/".concat(tail) : "/careers/open-positions/jobs/".concat(job.board, "/").concat(tail);
};
var jobAbsoluteUrl = function(job) {
    return "".concat(PROD_HOST).concat(jobPath(job));
};
var UUID_AT_END_RE = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
// Pull (board, uuid) from a URL like:
//   /careers/open-positions/jobs/<slug>-<uuid>          → opendoor (implicit)
//   /careers/open-positions/jobs/osn/<slug>-<uuid>      → osn (explicit)
//   /careers/open-positions/jobs?req_id=<uuid>          → opendoor (legacy)
var extractJobRef = function(url) {
    try {
        var u = new URL(url, PROD_HOST);
        var segments = u.pathname.split("/").filter(Boolean);
        // Find the "jobs" segment, then inspect what follows.
        var jobsIdx = segments.indexOf("jobs");
        if (jobsIdx >= 0) {
            var rest = segments.slice(jobsIdx + 1);
            var board;
            var tail;
            if (rest.length === 1) {
                // Implicit opendoor: /jobs/<slug>-<uuid>
                board = "opendoor";
                tail = rest[0];
            } else if (rest.length === 2 && isBoard(rest[0])) {
                // Explicit board: /jobs/<board>/<slug>-<uuid>
                board = rest[0];
                tail = rest[1];
            } else {
                return null;
            }
            var tailMatch = tail.match(UUID_AT_END_RE);
            if (tailMatch) return {
                board: board,
                uuid: tailMatch[0].toLowerCase()
            };
        }
        // Backwards compat: ?req_id=<uuid> always referred to the Opendoor board.
        var reqId = u.searchParams.get("req_id");
        if (reqId && UUID_AT_END_RE.test(reqId)) {
            return {
                board: "opendoor",
                uuid: reqId.toLowerCase()
            };
        }
    } catch (e) {
        return null;
    }
    return null;
};
var HEADING_RE = /^[A-Z][\w\s&,/'-]{0,60}$/;
// Strip styling tags, decode entities, collapse whitespace within a paragraph or list item.
var stripInline = function(s) {
    return s.replace(/<br\s*\/?>/gi, "\n").replace(/<\/?(?:span|strong|em|b|i|u)[^>]*>/gi, "").replace(/<a[^>]*>([\s\S]*?)<\/a>/gi, "$1").replace(/<[^>]+>/g, "").replace(/[ \t]+/g, " ").replace(/[ \t]+\n/g, "\n").replace(/\n[ \t]+/g, "\n").trim();
};
// Promote a heading-eligible single line ("**Section**", "Section:", "Section") into a heading
// block, otherwise emit a paragraph. Used for paragraphs that may carry markdown-in-text intent.
var lineToBlock = function(line) {
    var cleaned = line.replace(/^\*\*\s*/, "").replace(/\s*\*\*\s*$/, "").replace(/:\s*$/, "").replace(/\*\*/g, "").trim();
    if (cleaned.length > 0 && cleaned.length <= 60 && HEADING_RE.test(cleaned)) {
        return {
            kind: "heading",
            text: cleaned
        };
    }
    return {
        kind: "paragraph",
        text: line.replace(/\*\*/g, "").trim()
    };
};
var segmentToBlocks = function(segment) {
    var lines = segment.split(/\n/).map(function(l) {
        return l.trim();
    }).filter(Boolean);
    if (lines.length === 0) return [];
    if (lines.length > 1 && lines.every(function(l) {
        return /^[*•-]\s+/.test(l);
    })) {
        return [
            {
                kind: "list",
                items: lines.map(function(l) {
                    return l.replace(/^[*•-]\s+/, "");
                })
            }
        ];
    }
    if (lines.length === 1) return [
        lineToBlock(lines[0])
    ];
    return [
        {
            kind: "paragraph",
            text: lines.join(" ").replace(/\*\*/g, "").trim()
        }
    ];
};
// Rippling content varies wildly: some roles use real <h1-3>/<ul>/<li>, others store
// everything as a single styled <p> with markdown-in-text. Extract structural HTML at the
// tag level and fall back to text-block parsing only when a paragraph has no structure.
var parseRipplingDescription = function(raw) {
    var cleaned = raw.replace(/<\/?meta[^>]*>/gi, "").replace(/<script[\s\S]*?<\/script>/gi, "").replace(/&quot;/g, '"').replace(/&nbsp;/g, " ").replace(/&amp;/g, "&").replace(/&#39;/g, "'");
    var blocks = [];
    var tagRe = /<(h[1-6]|ul|ol|p)\b[^>]*>([\s\S]*?)<\/\1>/gi;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var match = _step.value;
            var tag = match[1].toLowerCase();
            var inner = match[2];
            if (/^h[1-6]$/.test(tag)) {
                var text = stripInline(inner);
                if (text) blocks.push({
                    kind: "heading",
                    text: text
                });
                return "continue";
            }
            if (tag === "ul" || tag === "ol") {
                var items = [];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = inner.matchAll(/<li[^>]*>([\s\S]*?)<\/li>/gi)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion = (_step1 = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var li = _step1.value;
                        var t = stripInline(li[1]);
                        if (t) items.push(t);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                if (items.length) blocks.push({
                    kind: "list",
                    items: items
                });
                return "continue";
            }
            // <p>: may be a single sentence, a heading-shaped phrase, or — for the Finance-style
            // recruiter-paste case — a whole multi-section blob with <br><br> dividers and
            // markdown bullets inside.
            var text1 = stripInline(inner);
            if (!text1) return "continue";
            var segments = text1.split(/\n{2,}/).map(function(s) {
                return s.trim();
            }).filter(Boolean);
            if (segments.length === 1) {
                var _blocks;
                (_blocks = blocks).push.apply(_blocks, (0,_to_consumable_array/* default */.Z)(segmentToBlocks(segments[0])));
            } else {
                var _blocks1;
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = segments[Symbol.iterator](), _step2; !(_iteratorNormalCompletion1 = (_step2 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var seg = _step2.value;
                        (_blocks1 = blocks).push.apply(_blocks1, (0,_to_consumable_array/* default */.Z)(segmentToBlocks(seg)));
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
            }
        };
        for(var _iterator = cleaned.matchAll(tagRe)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return blocks;
};
var DescriptionBlocks = function(param) {
    var blocks = param.blocks;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
        gap: "$20x",
        children: blocks.map(function(block, idx) {
            if (block.kind === "heading") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h3",
                    typography: "$subheaderXsmall",
                    color: "$contentPrimary",
                    children: block.text
                }, idx);
            }
            if (block.kind === "list") {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    gap: "$10x",
                    paddingLeft: "$4x",
                    children: block.items.map(function(item, i) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                            gap: "$8x",
                            alignItems: "flex-start",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    paddingTop: "$1x",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$labelLarge",
                                        color: "$contentSecondary",
                                        children: "•"
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    flexShrink: 1,
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodyLarge",
                                        color: "$contentPrimary",
                                        children: item
                                    })
                                })
                            ]
                        }, i);
                    })
                }, idx);
            }
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyLarge",
                color: "$contentPrimary",
                children: block.text
            }, idx);
        })
    });
};
var formatPosted = function(iso) {
    var days = Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
    if (Number.isNaN(days)) return "";
    if (days < 1) return "Posted today";
    if (days < 2) return "Posted yesterday";
    if (days < 7) return "Posted ".concat(days, " days ago");
    if (days < 30) return "Posted ".concat(Math.floor(days / 7), " weeks ago");
    return "Posted ".concat(new Date(iso).toLocaleDateString("en-US", {
        month: "long",
        day: "numeric"
    }));
};
var dropUndefined = function(obj) {
    return Object.fromEntries(Object.entries(obj).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), v = _param[1];
        return v !== undefined;
    }));
};
var buildJobPostingSchema = function(job) {
    var ref, ref1;
    var rawLoc = (ref = job.workLocations) === null || ref === void 0 ? void 0 : ref[0];
    var loc = rawLoc ? locWorkplace(rawLoc) : undefined;
    var schema = {
        "@context": "https://schema.org/",
        "@type": "JobPosting",
        title: job.name,
        description: "".concat(job.description.company, "\n").concat(job.description.role),
        datePosted: job.createdOn,
        url: jobAbsoluteUrl(job),
        directApply: false,
        hiringOrganization: {
            "@type": "Organization",
            name: job.companyName,
            sameAs: "https://www.opendoor.com",
            logo: "https://www.opendoor.com/icons/opendoor-logo.svg"
        }
    };
    if ((ref1 = job.employmentType) === null || ref1 === void 0 ? void 0 : ref1.id) schema.employmentType = job.employmentType.id;
    if (loc) {
        var isRemote = loc.workplaceType === "REMOTE";
        schema.jobLocationType = isRemote ? "TELECOMMUTE" : undefined;
        schema.jobLocation = {
            "@type": "Place",
            address: dropUndefined({
                "@type": "PostalAddress",
                addressLocality: loc.city,
                addressRegion: loc.state,
                addressCountry: loc.country
            })
        };
    }
    return dropUndefined(schema);
};
var OpenPositionCard = function(param) {
    var job = param.job;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        justifyContent: "space-between",
        borderColor: "$borderPrimary",
        borderStyle: "solid",
        borderWidth: "$default",
        borderRadius: "$12x",
        paddingHorizontal: "$20x",
        paddingVertical: "$16x",
        gap: "$8x",
        $largerThanSM: {
            flexDirection: "row",
            alignItems: "center"
        },
        hoverStyle: {
            borderColor: "$borderStateHoverPrimary"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                width: "100%",
                $largerThanSM: {
                    width: "50%"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                        analyticsName: "open-position",
                        size: "large",
                        color: "$contentAccentBrand",
                        typography: "$labelLarge",
                        variant: "primary",
                        href: jobPath(job),
                        target: "_blank",
                        children: job.name
                    }),
                    job.board !== "opendoor" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$labelSmall",
                        color: "$contentTertiary",
                        marginTop: "$4x",
                        children: BOARD_LABEL[job.board]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                width: "100%",
                $largerThanSM: {
                    width: "50%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    typography: "$bodyLarge",
                    color: "$contentSecondary",
                    $largerThanSM: {
                        textAlign: "right"
                    },
                    children: job.locationLabels.length === 0 ? "Multiple locations" : job.locationLabels.join(" \xb7 ")
                })
            })
        ]
    });
};
var ListingView = function(param) {
    var resolved = param.resolved;
    var departmentFilters = resolved.departmentFilters, officeFilters = resolved.officeFilters, jobsByDepartment = resolved.jobsByDepartment;
    var ref = (0,react.useState)(), selectedDepartment = ref[0], setSelectedDepartment = ref[1];
    var ref1 = (0,react.useState)(), selectedOffice = ref1[0], setSelectedOffice = ref1[1];
    var filteredByDepartment = selectedDepartment && selectedDepartment !== "all" ? jobsByDepartment.filter(function(d) {
        return d.label === selectedDepartment;
    }) : jobsByDepartment;
    var filtered = selectedOffice && selectedOffice !== "all" ? filteredByDepartment.map(function(d) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, d), {
            jobs: d.jobs.filter(function(j) {
                return j.locationLabels.includes(selectedOffice);
            })
        });
    }).filter(function(d) {
        return d.jobs.length > 0;
    }) : filteredByDepartment;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: "$16x",
                marginBottom: "$32x",
                $largerThanSM: {
                    flexDirection: "row"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "100%",
                        flexGrow: 1,
                        $largerThanSM: {
                            width: 285
                        },
                        $largerThanMD: {
                            flexGrow: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: "Department",
                            size: "medium",
                            "aria-labelledby": "Select Department",
                            options: departmentFilters,
                            placeholderOption: {
                                label: "All Departments",
                                value: "all"
                            },
                            onValueChange: function(value) {
                                return setSelectedDepartment(value);
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "100%",
                        flexGrow: 1,
                        $largerThanSM: {
                            width: 285
                        },
                        $largerThanMD: {
                            flexGrow: 0
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: "Office",
                            size: "medium",
                            "aria-labelledby": "Select Office",
                            options: officeFilters,
                            placeholderOption: {
                                label: "All Offices",
                                value: "all"
                            },
                            onValueChange: function(value) {
                                return setSelectedOffice(value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                marginVertical: "$10x",
                children: filtered.map(function(dept) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        marginBottom: "$32x",
                        gap: "$20x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h2",
                                typography: "$headerSmall",
                                children: dept.label
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                                gap: "$8x",
                                children: dept.jobs.map(function(job) {
                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OpenPositionCard, {
                                        job: job
                                    }, job.uuid);
                                })
                            })
                        ]
                    }, dept.label);
                })
            })
        ]
    });
};
var JobDetailView = function(param) {
    var resolved = param.resolved;
    var ref;
    var job = resolved.job;
    if (!job) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
            py: "$50x",
            gap: "$8x",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "h1",
                    typography: "$headerSmall",
                    children: "This role isn’t available"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    typography: "$bodyLarge",
                    color: "$contentSecondary",
                    children: "The position may have been filled or removed."
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                    analyticsName: "back-to-listing",
                    color: "$contentAccentBrand",
                    typography: "$labelLarge",
                    variant: "primary",
                    href: "/careers/open-positions",
                    children: "View all open positions →"
                })
            ]
        });
    }
    var _workLocations;
    var allLocationNames = ((_workLocations = job.workLocations) !== null && _workLocations !== void 0 ? _workLocations : []).map(locName).filter(function(n) {
        return Boolean(n);
    });
    var primaryLocation;
    if (allLocationNames.length === 0) {
        primaryLocation = "Multiple locations";
    } else if (allLocationNames.length > 2) {
        primaryLocation = "".concat(allLocationNames.length, " locations");
    } else {
        primaryLocation = allLocationNames.join(" \xb7 ");
    }
    var employment = (ref = job.employmentType) === null || ref === void 0 ? void 0 : ref.id;
    var posted = formatPosted(job.createdOn);
    var applyHref = ripplingApplyUrl(job.board, job.uuid);
    var wordSet = function(s) {
        return new Set(s.toLowerCase().replace(/[^a-z0-9\s]/g, " ").split(/\s+/).filter(function(w) {
            return w.length > 2;
        }));
    };
    var titleWords = wordSet(job.name);
    var stripDuplicateTitle = function(blocks) {
        return blocks.filter(function(b) {
            if (b.kind !== "heading") return true;
            var headingWords = Array.from(wordSet(b.text));
            if (headingWords.length === 0) return true;
            var overlap = headingWords.filter(function(w) {
                return titleWords.has(w);
            }).length;
            var isDupe = overlap >= 2 && overlap >= headingWords.length * 0.7;
            return !isDupe;
        });
    };
    var roleBlocks = stripDuplicateTitle(parseRipplingDescription(job.description.role));
    var companyBlocks = stripDuplicateTitle(parseRipplingDescription(job.description.company));
    var metaItems = [
        primaryLocation,
        employment,
        posted
    ].filter(Boolean);
    var eyebrowParts = [
        job.department.base_department.toUpperCase()
    ];
    if (job.board !== "opendoor") {
        eyebrowParts.push(BOARD_LABEL[job.board].toUpperCase());
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        gap: "$32x",
        $largerThanMD: {
            width: 768
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$20x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$labelSmall",
                        color: "$contentTertiary",
                        children: eyebrowParts.join(" \xb7 ")
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h1",
                        typography: "$displaySmall",
                        color: "$contentPrimary",
                        children: job.name
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Row/* Row */.X, {
                        gap: "$8x",
                        flexWrap: "wrap",
                        alignItems: "center",
                        children: metaItems.map(function(item, i) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                gap: "$8x",
                                alignItems: "center",
                                children: [
                                    i > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodyLarge",
                                        color: "$contentTertiary",
                                        children: "\xb7"
                                    }) : null,
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "span",
                                        typography: "$bodyLarge",
                                        color: "$contentSecondary",
                                        children: item
                                    })
                                ]
                            }, i);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "apply-now-hero",
                        size: "large",
                        variant: "primary",
                        label: "Apply now",
                        href: applyHref,
                        alignSelf: "flex-start"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                height: "$1x",
                backgroundColor: "$borderPrimary",
                width: "100%"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionBlocks, {
                blocks: roleBlocks
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                paddingTop: "$8x",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DescriptionBlocks, {
                    blocks: companyBlocks
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$16x",
                padding: "$32x",
                backgroundColor: "$backgroundSecondary",
                borderRadius: "$8x",
                alignItems: "flex-start",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "h3",
                        typography: "$subheaderMedium",
                        color: "$contentPrimary",
                        children: "Ready to apply?"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        color: "$contentSecondary",
                        children: "You’ll be redirected to our application portal to submit your resume and answer a few questions."
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "apply-now-footer",
                        size: "large",
                        variant: "primary",
                        label: "Apply for this role",
                        href: applyHref,
                        alignSelf: "flex-start"
                    })
                ]
            })
        ]
    });
};
var OpenPositionsCTA = function(entry, resolvedData) {
    var isDetail = entry.fields.pageType === "Job Description";
    var ref, ref1, ref2, ref3, ref4, ref5;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* LandingPageSectionContainer */.IX, {
        minHeight: 400,
        paddingBottom: "$36x",
        children: isDetail ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(JobDetailView, {
            resolved: {
                job: (ref = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.job) !== null && ref !== void 0 ? ref : null,
                jobPostingSchema: (ref1 = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.jobPostingSchema) !== null && ref1 !== void 0 ? ref1 : null,
                seoOverride: (ref2 = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.seoOverride) !== null && ref2 !== void 0 ? ref2 : null
            }
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListingView, {
            resolved: {
                departmentFilters: (ref3 = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.departmentFilters) !== null && ref3 !== void 0 ? ref3 : [],
                officeFilters: (ref4 = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.officeFilters) !== null && ref4 !== void 0 ? ref4 : [],
                jobsByDepartment: (ref5 = resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.jobsByDepartment) !== null && ref5 !== void 0 ? ref5 : []
            }
        })
    });
};
var EMPTY_LISTING = {
    departmentFilters: [],
    officeFilters: [],
    jobsByDepartment: []
};
var fetchBoardJobs = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(board, signal) {
        var res, jobs;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(ripplingListUrl(board), {
                            signal: signal
                        })
                    ];
                case 1:
                    res = _state.sent();
                    if (res.status !== 200) return [
                        2,
                        []
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 2:
                    jobs = _state.sent();
                    return [
                        2,
                        jobs.map(function(j) {
                            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, j), {
                                board: board
                            });
                        })
                    ];
            }
        });
    });
    return function fetchBoardJobs(board, signal) {
        return _ref.apply(this, arguments);
    };
}();
var fetchListing = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var controller, timer, jobs, results, e, byKey, offices, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, job, ref, loc, key, existing, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, job1, byDept, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, job2, ref1, ref2, dept, jobsByDepartment, departmentFilters, officeFilters;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    controller = new AbortController();
                    timer = setTimeout(function() {
                        return controller.abort();
                    }, 5000);
                    jobs = [];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        Promise.allSettled(BOARDS.map(function(b) {
                            return fetchBoardJobs(b, controller.signal);
                        }))
                    ];
                case 2:
                    results = _state.sent();
                    jobs = results.flatMap(function(r) {
                        return r.status === "fulfilled" ? r.value : [];
                    });
                    return [
                        3,
                        5
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        EMPTY_LISTING
                    ];
                case 4:
                    clearTimeout(timer);
                    return [
                        7
                    ];
                case 5:
                    if (jobs.length === 0) return [
                        2,
                        EMPTY_LISTING
                    ];
                    byKey = new Map();
                    offices = new Set();
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = jobs[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            job = _step.value;
                            ;
                            loc = (ref = job.workLocation) === null || ref === void 0 ? void 0 : ref.label;
                            if (loc) offices.add(loc);
                            key = "".concat(job.board, ":").concat(job.uuid);
                            existing = byKey.get(key);
                            if (existing) {
                                if (loc && !existing.locationLabels.includes(loc)) existing.locationLabels.push(loc);
                                continue;
                            }
                            byKey.set(key, {
                                board: job.board,
                                uuid: job.uuid,
                                name: job.name,
                                department: job.department,
                                locationLabels: loc ? [
                                    loc
                                ] : []
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = byKey.values()[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            job1 = _step1.value;
                            job1.locationLabels.sort(function(a, b) {
                                return a.localeCompare(b);
                            });
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    byDept = new Map();
                    _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                    try {
                        for(_iterator2 = byKey.values()[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                            job2 = _step2.value;
                            ;
                            ;
                            dept = (ref2 = (ref1 = job2.department) === null || ref1 === void 0 ? void 0 : ref1.label) !== null && ref2 !== void 0 ? ref2 : "Other";
                            if (!byDept.has(dept)) byDept.set(dept, []);
                            byDept.get(dept).push(job2);
                        }
                    } catch (err) {
                        _didIteratorError2 = true;
                        _iteratorError2 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                _iterator2.return();
                            }
                        } finally{
                            if (_didIteratorError2) {
                                throw _iteratorError2;
                            }
                        }
                    }
                    jobsByDepartment = Array.from(byDept.entries()).map(function(param) {
                        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), label = _param[0], list = _param[1];
                        return {
                            label: label,
                            jobs: list.sort(function(a, b) {
                                return a.name.localeCompare(b.name);
                            })
                        };
                    }).sort(function(a, b) {
                        return a.label.localeCompare(b.label);
                    });
                    departmentFilters = jobsByDepartment.map(function(d) {
                        return {
                            label: d.label,
                            value: d.label
                        };
                    });
                    officeFilters = Array.from(offices).sort(function(a, b) {
                        return a.localeCompare(b);
                    }).map(function(label) {
                        return {
                            label: label,
                            value: label
                        };
                    });
                    return [
                        2,
                        {
                            departmentFilters: departmentFilters,
                            officeFilters: officeFilters,
                            jobsByDepartment: jobsByDepartment
                        }
                    ];
            }
        });
    });
    return function fetchListing() {
        return _ref.apply(this, arguments);
    };
}();
var fetchDetail = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var board, uuid, controller, timer, ref, res, raw, job, primaryLocation, seoOverride, _err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    board = param.board, uuid = param.uuid;
                    controller = new AbortController();
                    timer = setTimeout(function() {
                        return controller.abort();
                    }, 5000);
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        4,
                        5,
                        6
                    ]);
                    return [
                        4,
                        fetch(ripplingDetailUrl(board, uuid), {
                            signal: controller.signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (res.status !== 200) return [
                        2,
                        {
                            job: null,
                            jobPostingSchema: null,
                            seoOverride: null
                        }
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 3:
                    raw = _state.sent();
                    if (!(raw === null || raw === void 0 ? void 0 : raw.uuid) || !(raw === null || raw === void 0 ? void 0 : raw.name) || !(raw === null || raw === void 0 ? void 0 : raw.description)) {
                        return [
                            2,
                            {
                                job: null,
                                jobPostingSchema: null,
                                seoOverride: null
                            }
                        ];
                    }
                    job = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, raw), {
                        board: board
                    });
                    primaryLocation = ((ref = job.workLocations) === null || ref === void 0 ? void 0 : ref[0]) ? locName(job.workLocations[0]) || "Multiple locations" : "Multiple locations";
                    seoOverride = {
                        title: "".concat(job.name, " - Opendoor"),
                        canonicalUrl: jobAbsoluteUrl(job),
                        metaDescription: "".concat(job.name, " at ").concat(job.companyName, " — ").concat(primaryLocation, ". Apply on opendoor.com."),
                        ogTitle: "".concat(job.name, " - Opendoor"),
                        ogUrl: jobAbsoluteUrl(job),
                        ogDescription: "".concat(job.name, " at ").concat(job.companyName, " — ").concat(primaryLocation, ".")
                    };
                    return [
                        2,
                        {
                            job: job,
                            jobPostingSchema: buildJobPostingSchema(job),
                            seoOverride: seoOverride
                        }
                    ];
                case 4:
                    _err = _state.sent();
                    return [
                        2,
                        {
                            job: null,
                            jobPostingSchema: null,
                            seoOverride: null
                        }
                    ];
                case 5:
                    clearTimeout(timer);
                    return [
                        7
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchDetail(_) {
        return _ref.apply(this, arguments);
    };
}();
var openPositionsLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(entry, _root, pageProps) {
        var ref;
        return (0,tslib_es6.__generator)(this, function(_state) {
            if (entry.fields.pageType === "Job Description") {
                if (!(pageProps === null || pageProps === void 0 ? void 0 : pageProps.url)) return [
                    2,
                    {
                        job: null,
                        jobPostingSchema: null,
                        seoOverride: null
                    }
                ];
                ref = extractJobRef(pageProps.url);
                if (!ref) return [
                    2,
                    {
                        job: null,
                        jobPostingSchema: null,
                        seoOverride: null
                    }
                ];
                return [
                    2,
                    fetchDetail(ref)
                ];
            }
            return [
                2,
                fetchListing()
            ];
        });
    });
    return function openPositionsLoader(entry, _root, pageProps) {
        return _ref.apply(this, arguments);
    };
}();
var OpenPositions = {
    render: OpenPositionsCTA,
    loader: openPositionsLoader
};
/* harmony default export */ var landing_pages_v2_OpenPositions = (OpenPositions);

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/PartnerCaseStudy.tsx




var CARD_DESKTOP = {
    padding: "$16x",
    gap: "$8x"
};
var QUOTE_DESKTOP = {
    typography: "$subheaderXsmall"
};
var ATTRIBUTION_DESKTOP = {
    gap: "$8x"
};
var VERIFY_PATTERN = /\s*\[VERIFY[^\]]*\]\s*/gi;
var getImageUrl = function(entry) {
    var ref, ref1, ref2;
    return (ref = entry.fields.partnerLogo) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url;
};
var getImageAlt = function(entry) {
    var ref, ref1;
    var _fields = entry.fields, partnerLogo = _fields.partnerLogo, quoteAuthor = _fields.quoteAuthor, partnerName = _fields.partnerName;
    return (partnerLogo === null || partnerLogo === void 0 ? void 0 : (ref = partnerLogo.fields) === null || ref === void 0 ? void 0 : ref.description) || (partnerLogo === null || partnerLogo === void 0 ? void 0 : (ref1 = partnerLogo.fields) === null || ref1 === void 0 ? void 0 : ref1.title) || quoteAuthor || partnerName || "";
};
var hasVerifyToken = function(text) {
    return Boolean(text === null || text === void 0 ? void 0 : text.match(VERIFY_PATTERN));
};
var cleanVerifyText = function(text) {
    if (!text) {
        return "";
    }
    return text.replace(VERIFY_PATTERN, " ").replace(/\s+,/g, ",").replace(/,\s*$/g, "").replace(/\s{2,}/g, " ").trim();
};
var getQuoteRole = function(author, role) {
    if (/\[VERIFY\s+name\]/i.test(author !== null && author !== void 0 ? author : "") && /\[VERIFY\s+title\]/i.test(role !== null && role !== void 0 ? role : "")) {
        return "VERIFY name + title";
    }
    return cleanVerifyText(role);
};
var VerifyBadge = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        backgroundColor: "$backgroundStateErrorSecondary",
        borderRadius: "$2x",
        px: "$2x",
        py: "$1x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
            tag: "span",
            typography: "$labelXsmall",
            color: "$contentStateErrorDefault",
            display: "block",
            children: "VERIFY"
        })
    });
};
var CaseStudyImage = function(param) {
    var imageUrl = param.imageUrl, alt = param.alt;
    var source = (0,react.useMemo)(function() {
        return {
            uri: imageUrl
        };
    }, [
        imageUrl
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
        source: source,
        alt: alt,
        width: "$40x",
        height: "$40x",
        variant: "circle"
    });
};
var RenderPartnerCaseStudy = function(entry) {
    var ref;
    var fields = entry.fields;
    var imageUrl = getImageUrl(entry);
    var quote = cleanVerifyText(fields.quote);
    var quoteAuthor = cleanVerifyText(fields.quoteAuthor);
    var quoteRole = getQuoteRole(fields.quoteAuthor, fields.quoteRole);
    var showVerifyBadge = hasVerifyToken(fields.quote) || hasVerifyToken(fields.quoteAuthor) || hasVerifyToken(fields.quoteRole);
    var hasAttribution = quoteAuthor || quoteRole;
    if (!quote && !hasAttribution) {
        return null;
    }
    var _analyticsId, ref1;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        noSectionSpacing: true,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
            alignItems: "center",
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                analyticsName: "cosmos-landing-page-partner-case-study-".concat((ref1 = (_analyticsId = fields.analyticsId) !== null && _analyticsId !== void 0 ? _analyticsId : (ref = entry.sys) === null || ref === void 0 ? void 0 : ref.id) !== null && ref1 !== void 0 ? ref1 : fields.internalName),
                trackImpression: true,
                backgroundColor: "$backgroundTertiary",
                borderColor: "$borderPrimary",
                borderRadius: "$8x",
                borderWidth: 1,
                gap: "$8x",
                maxWidth: "$768x",
                padding: "$10x",
                width: "100%",
                $largerThanSM: CARD_DESKTOP,
                children: [
                    quote && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        fontWeight: "$medium",
                        color: "$contentPrimary",
                        display: "block",
                        $largerThanSM: QUOTE_DESKTOP,
                        children: [
                            "“",
                            quote,
                            "”"
                        ]
                    }),
                    hasAttribution && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                        alignItems: "center",
                        gap: "$6x",
                        $largerThanSM: ATTRIBUTION_DESKTOP,
                        children: [
                            imageUrl ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaseStudyImage, {
                                imageUrl: imageUrl,
                                alt: getImageAlt(entry)
                            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                width: "$40x",
                                height: "$40x",
                                borderRadius: "$full",
                                backgroundColor: "$backgroundPrimary",
                                borderColor: "$borderPrimary",
                                borderWidth: 1,
                                alignItems: "center",
                                justifyContent: "center",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "span",
                                    typography: "$labelXsmall",
                                    color: "$contentTertiary",
                                    children: "(photo)"
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                                gap: "$1x",
                                children: [
                                    quoteAuthor && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                                        gap: "$2x",
                                        alignItems: "center",
                                        flexWrap: "wrap",
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                tag: "p",
                                                typography: "$labelLarge",
                                                color: "$contentPrimary",
                                                display: "block",
                                                children: quoteAuthor
                                            }),
                                            showVerifyBadge && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifyBadge, {})
                                        ]
                                    }),
                                    quoteRole && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodySmall",
                                        color: "$contentTertiary",
                                        display: "block",
                                        children: quoteRole
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var PartnerCaseStudy = {
    render: RenderPartnerCaseStudy
};
/* harmony default export */ var landing_pages_v2_PartnerCaseStudy = (PartnerCaseStudy);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/PhotoTestimonials.tsx
var PhotoTestimonials = __webpack_require__(96309);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/Checkmark.tsx
var Checkmark = __webpack_require__(9825);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(50544);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/reviews/stop-words.json
var stop_words_namespaceObject = JSON.parse('["a","able","about","above","abroad","according","accordingly","across","actually","adj","after","afterwards","again","against","ago","ahead","aint","all","allow","allows","almost","alone","along","alongside","already","also","although","always","am","amid","amidst","among","amongst","an","and","another","any","anybody","anyhow","anyone","anything","anyway","anyways","anywhere","apart","appear","appreciate","appropriate","are","arent","around","as","as","aside","ask","asking","associated","at","available","away","awfully","b","back","backward","backwards","be","became","because","become","becomes","becoming","been","before","beforehand","begin","behind","being","believe","below","beside","besides","best","better","between","beyond","both","brief","but","by","c","came","can","cannot","cant","cant","caption","cause","causes","certain","certainly","changes","clearly","cmon","co","co.","com","come","comes","concerning","consequently","consider","considering","contain","containing","contains","corresponding","could","couldnt","course","cs","currently","d","dare","darent","definitely","described","despite","did","didnt","different","directly","do","does","doesnt","doing","done","dont","down","downwards","during","e","each","edu","eg","eight","eighty","either","else","elsewhere","end","ending","enough","entirely","especially","et","etc","even","ever","evermore","every","everybody","everyone","everything","everywhere","ex","exactly","example","except","f","fairly","far","farther","few","fewer","fifth","first","five","followed","following","follows","for","forever","former","formerly","forth","forward","found","four","from","further","furthermore","g","get","gets","getting","given","gives","go","goes","going","gone","got","gotten","greetings","h","had","hadnt","half","happens","hardly","has","hasnt","have","havent","having","he","hed","hell","hello","help","hence","her","here","hereafter","hereby","herein","heres","hereupon","hers","herself","hes","hi","him","himself","his","hither","hopefully","how","howbeit","however","hundred","i","id","ie","if","ignored","ill","im","immediate","in","inasmuch","inc","inc.","indeed","indicate","indicated","indicates","inner","inside","insofar","instead","into","inward","is","isnt","it","itd","itll","its","its","itself","ive","j","just","k","keep","keeps","kept","know","known","knows","l","last","lately","later","latter","latterly","least","less","lest","let","lets","like","liked","likely","likewise","little","look","looking","looks","low","lower","ltd","m","made","mainly","make","makes","many","may","maybe","maynt","me","mean","meantime","meanwhile","merely","might","mightnt","mine","minus","miss","more","moreover","most","mostly","mr","mrs","much","must","mustnt","my","myself","n","name","namely","nd","near","nearly","necessary","need","neednt","needs","neither","never","neverf","neverless","nevertheless","new","next","nine","ninety","no","nobody","non","none","nonetheless","noone","no-one","nor","normally","not","nothing","notwithstanding","novel","now","nowhere","o","obviously","of","off","often","oh","ok","okay","old","on","once","one","ones","ones","only","onto","opposite","or","other","others","otherwise","ought","oughtnt","our","ours","ourselves","out","outside","over","overall","own","p","particular","particularly","past","per","perhaps","placed","please","plus","possible","presumably","probably","provided","provides","q","que","quite","qv","r","rather","rd","re","really","reasonably","recent","recently","regarding","regardless","regards","relatively","respectively","right","round","s","said","same","saw","say","saying","says","second","secondly","see","seeing","seem","seemed","seeming","seems","seen","self","selves","sensible","sent","serious","seriously","seven","several","shall","shant","she","shed","shell","shes","should","shouldnt","since","six","so","some","somebody","someday","somehow","someone","something","sometime","sometimes","somewhat","somewhere","soon","sorry","specified","specify","specifying","still","sub","such","sup","sure","t","take","taken","taking","tell","tends","th","than","thank","thanks","thanx","that","thatll","thats","thats","thatve","the","their","theirs","them","themselves","then","thence","there","thereafter","thereby","thered","therefore","therein","therell","therere","theres","theres","thereupon","thereve","these","they","theyd","theyll","theyre","theyve","thing","things","think","third","thirty","this","thorough","thoroughly","those","though","three","through","throughout","thru","thus","till","to","together","too","took","toward","towards","tried","tries","truly","try","trying","ts","twice","two","u","un","under","underneath","undoing","unfortunately","unless","unlike","unlikely","until","unto","up","upon","upwards","us","use","used","useful","uses","using","usually","v","value","various","versus","very","via","viz","vs","w","want","wants","was","wasnt","way","we","wed","welcome","well","well","went","were","were","werent","weve","what","whatever","whatll","whats","whatve","when","whence","whenever","where","whereafter","whereas","whereby","wherein","wheres","whereupon","wherever","whether","which","whichever","while","whilst","whither","who","whod","whoever","whole","wholl","whom","whomever","whos","whose","why","will","willing","wish","with","within","without","wonder","wont","would","wouldnt","x","y","yes","yet","you","youd","youll","your","youre","yours","yourself","yourselves","youve","z","zero"]');
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/reviews/api.ts





var REVIEWS_API_URL = "https://api.reviews.co.uk/merchant/reviews?store=opendoor-com&per_page=250";
var answerToProductType = {
    "I bought my home with Opendoor": "buy",
    "I sold my home to Opendoor": "sell",
    "I sold my home to Opendoor AND bought a new one with Opendoor": "trade-in"
};
var buildFeedItems = function(reviewData) {
    var categorizedReviews = reviewData.reviews.reduce(function(acc, currReview) {
        var productType = currReview.productData.productType;
        if (!acc[productType]) {
            acc[productType] = [];
        }
        acc[productType].push({
            type: "review",
            reviewInfo: currReview
        });
        return acc;
    }, {});
    return Object.entries(categorizedReviews).reduce(function(acc, param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), key = _param[0], val = _param[1];
        acc[key] = addFeedInserts(val, reviewData.stats).slice(0, 45);
        return acc;
    }, {});
};
// Space the disclaimers every 4th element down
var addFeedInserts = function(items, stats) {
    return items.reduce(function(acc, curr, i) {
        switch(i){
            case 3:
                acc.push({
                    type: "disclaimer"
                });
                break;
            case 6:
                acc.push({
                    type: "reviewsio",
                    stats: stats
                });
                break;
            case 9:
                acc.push({
                    type: "bbb"
                });
                break;
        }
        acc.push(curr);
        return acc;
    }, []);
};
var capitalize = function(input) {
    return input.charAt(0).toUpperCase() + input.slice(1).toLowerCase();
};
var normalizeCity = function(userCity) {
    var regex = /(\w+)(\W?)+,(\W?)+(\w+)/;
    var match = regex.exec(userCity);
    if (match) {
        return "".concat(capitalize(match[1]), ", ").concat(match[4]);
    }
    if (userCity.includes("_")) {
        return userCity.split("_").map(capitalize).join(" ");
    }
    if (userCity.includes("/")) {
        return userCity.split("/").map(capitalize).join("/");
    }
    return userCity.split(/\s+/).map(capitalize).join(" ");
};
var isReviewEligible = function(review) {
    //Remove ratings < 3
    if (review.rating < 3) {
        return false;
    }
    //Filter ratings that is not from a verified buyer
    if (review.reviewer.verified_buyer !== "yes") {
        return false;
    }
    var questions = review.ratings;
    var cityQuestion = {
        userEntry: questions.find(function(q) {
            return q.name.startsWith("In what city did you work with Opendoor");
        }),
        branchQuestion: (review.branch || {}).name
    };
    var cityIsAvailable = cityQuestion.branchQuestion || cityQuestion.userEntry;
    var productTypeQuestion = questions.find(function(q) {
        return q.name.startsWith("How did you work with Opendoor");
    });
    // remove ratings that does not have city or product speciifcation
    if (!(cityIsAvailable && productTypeQuestion)) {
        return false;
    }
    // Remove ratings that does not have Product Type Question score
    if (!answerToProductType[productTypeQuestion.score]) {
        return false;
    }
    return true;
};
var fetchReviewerInformation = function(review) {
    // process reviewer information
    var reviewer = review.reviewer;
    var updatedReviewer = {
        verifiedBuyer: true
    };
    if (reviewer.first_name && reviewer.last_name) {
        // Join first and last name
        updatedReviewer.name = [
            reviewer.first_name,
            reviewer.last_name
        ].filter(function(x) {
            return x;
        }).join(" ");
        updatedReviewer.unidentified = false;
    } else {
        updatedReviewer.unidentified = true;
    }
    var questions = review.ratings;
    var preferredNameQuestion = questions.find(function(q) {
        return q.name.startsWith("Your name");
    });
    if (preferredNameQuestion && preferredNameQuestion.score) {
        updatedReviewer.name = preferredNameQuestion.score;
    }
    return updatedReviewer;
};
var fetchAllReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var firstPage, requestUrls, i, reviewsResponse, allReviews;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        fetch(REVIEWS_API_URL).then(function(res) {
                            return res.json();
                        })
                    ];
                case 1:
                    firstPage = _state.sent();
                    requestUrls = [];
                    for(i = 0; i < firstPage.total_pages; i++){
                        requestUrls.push("".concat(REVIEWS_API_URL, "&page=").concat(i));
                    }
                    return [
                        4,
                        Promise.all(requestUrls.map(function(url) {
                            return fetch(url).then(function(resp) {
                                return resp.json();
                            });
                        }))
                    ];
                case 2:
                    reviewsResponse = _state.sent();
                    allReviews = reviewsResponse.reduce(function(acc, curr) {
                        return acc.concat(curr.reviews);
                    }, []);
                    return [
                        2,
                        {
                            stats: reviewsResponse[0].stats,
                            allReviews: allReviews
                        }
                    ];
            }
        });
    });
    return function fetchAllReviews() {
        return _ref.apply(this, arguments);
    };
}();
var processReviews = function(allReviews) {
    var recommended = 0;
    try {
        var adaptedReviews = allReviews.sort(function(a, b) {
            return Date.parse(b.date_created) - Date.parse(a.date_created);
        }).reduce(function(acc, curr) {
            if (curr.rating >= 3) {
                recommended++;
            }
            if (!isReviewEligible(curr)) return acc;
            var newReview = {
                reviewer: {},
                productData: {}
            };
            newReview.rating = curr.rating;
            newReview.reviewComment = curr.comments;
            newReview.reviewer = fetchReviewerInformation(curr);
            var questions = curr.ratings;
            var cityQuestion = {
                userEntry: questions.find(function(q) {
                    return q.name.startsWith("In what city did you work with Opendoor");
                }),
                branchQuestion: (curr.branch || {}).name
            };
            var productTypeQuestion = questions.find(function(q) {
                return q.name.startsWith("How did you work with Opendoor");
            });
            newReview.productData.city = normalizeCity(cityQuestion.branchQuestion || cityQuestion.userEntry.score);
            newReview.productData.productType = answerToProductType[productTypeQuestion.score];
            acc.push(newReview);
            return acc;
        }, []);
        return {
            filteredReviews: adaptedReviews,
            recommended: recommended
        };
    } catch (err) {
        // eslint-disable-next-line no-console
        console.log("error occured while processing reviews", err);
        return {
            filteredReviews: [],
            recommended: 0
        };
    }
};
var fetchReviews = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, allReviews, stats, ref1, filteredReviews, recommended, reviewsStats, reviewsResult, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchAllReviews()
                    ];
                case 1:
                    ref = _state.sent(), allReviews = ref.allReviews, stats = ref.stats;
                    ref1 = processReviews(allReviews), filteredReviews = ref1.filteredReviews, recommended = ref1.recommended;
                    console.log(recommended, allReviews.length);
                    reviewsStats = {
                        averageRating: Number(stats.average_rating),
                        totalReviews: Number(stats.total_reviews),
                        recommendedPercent: Math.round(recommended / allReviews.length * 100)
                    };
                    reviewsResult = {
                        reviews: filteredReviews,
                        stats: reviewsStats
                    };
                    return [
                        2,
                        {
                            productTypeFeeds: buildFeedItems(reviewsResult),
                            stats: reviewsStats
                        }
                    ];
                case 2:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.log("error occured while processing reviews", err);
                    return [
                        2,
                        {
                            productTypeFeeds: {
                                sell: [],
                                buy: [],
                                "trade-in": []
                            },
                            stats: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchReviews() {
        return _ref.apply(this, arguments);
    };
}();
// Given a potential header, and a character cutoff, split the header before it
// passes the character limit, and remove up to 3 trailing "linkWords", so we
// don't end on an "and", "to", etc.
var determineHeadingSplit = function(content, charCutoff, linkWordsLimit) {
    var words = content.split(/\s+/).filter(function(t) {
        return t.length > 0;
    });
    var charCount = 0;
    var headingWords = [];
    var restWords = [];
    for(var i = 0; i < words.length; i++){
        charCount += words[i].length;
        if (charCount > charCutoff) {
            restWords = restWords.concat(words.slice(i));
            break;
        }
        headingWords.push(words[i]);
    }
    var i1 = 0;
    while(i1 < linkWordsLimit){
        if (stop_words_namespaceObject.find(function(link) {
            return headingWords[headingWords.length - 1].replace(/\W+/g, "").toLowerCase() === link;
        })) {
            restWords.unshift(headingWords.pop());
        } else {
            break;
        }
        i1++;
    }
    return [
        headingWords,
        restWords,
        restWords.length > 0
    ];
};
var commentParts = function(comment) {
    // fix bad Opendoor branding, and open listings branding
    var normalizedComment = comment.replace(/Open\s+Door|OpenDoor|OPENDOOR|opendoor|open\s+door/g, "Opendoor").replace(/open\s+[lL]istings|OpenListings|openlistings|open\s+listing/, "Open Listings");
    var ref = (0,_to_array/* default */.Z)(normalizedComment.split(".")), likelyHeading = ref[0], rest = ref.slice(1);
    var likelyBody = rest.join(". ");
    var likelyBodyWords = likelyBody.split(/\s+/);
    // Add back the period that split removed.
    // eslint-disable-next-line prefer-const
    var ref1 = (0,_sliced_to_array/* default */.Z)(determineHeadingSplit(likelyHeading, 60, 3), 3), headingWords = ref1[0], restWords = ref1[1], ellipsize = ref1[2];
    var bodyWords = restWords.concat(likelyBodyWords);
    // if the body is small enough (less than 5 words), we just return it as the
    // heading, and skip ellipsizing it
    if (bodyWords.length < 5) {
        headingWords = headingWords.concat(bodyWords);
        bodyWords = [];
        ellipsize = false;
    }
    return {
        heading: headingWords.join(" "),
        body: bodyWords.join(" "),
        ellipsize: ellipsize,
        STOP_WORDS: stop_words_namespaceObject
    };
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/reviews/index.tsx







var ProductType;
(function(ProductType) {
    ProductType["buy"] = "buy";
    ProductType["sell"] = "sell";
    ProductType["tradeIn"] = "trade-in";
})(ProductType || (ProductType = {}));
var FILTER_OPTIONS = [
    {
        label: "Sold to Opendoor",
        value: ProductType.sell
    },
    {
        label: "Bought with Opendoor",
        value: ProductType.buy
    },
    {
        label: "Bought and sold with Opendoor",
        value: ProductType.tradeIn
    }, 
];
var productTypeToExplainer = {
    sell: {
        heading: "Seller",
        description: "These reviews are from customers that sold their home directly to Opendoor."
    },
    buy: {
        heading: "Buyer",
        description: "These reviews are from customers that bought their home with Opendoor."
    },
    "trade-in": {
        heading: "Trade-in",
        description: "These reviews are from customers that sold their home directly to Opendoor and purchased their new home at the same time."
    }
};
var typeToProduct = {
    buy: "Buyer",
    sell: "Seller",
    "trade-in": "Buyer and seller"
};
var typeToReviewContext = {
    buy: "Bought with Opendoor",
    sell: "Sold to Opendoor",
    "trade-in": "Bought and sold with Opendoor"
};
var STAR_RATING_URI = "https://images.opendoor.com/source/s3/imgdrop-production/2024-11-1732263853253-76957.svg?service=cosmos";
var STAR_RATING_SOURCE = {
    height: 16,
    width: 16,
    uri: STAR_RATING_URI
};
var ThirdParyVerification = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        paddingVertical: "$16x",
        paddingHorizontal: "$10x",
        borderRadius: "$12x",
        gap: "$12x",
        $largerThanSM: {
            paddingHorizontal: "$56x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $largerThanSM: {
                    flexDirection: "row"
                },
                alignItems: "center",
                gap: "$4x",
                justifyContent: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$subheaderSmall",
                        children: "Third Party"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        gap: "$4x",
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelMedium",
                                color: "$contentAccentBrand",
                                children: "Verified Review"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkmark/* default */.Z, {
                                size: 20,
                                color: "$contentAccentBrand"
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$bodyLarge",
                justifyContent: "center",
                textAlign: "center",
                children: "All reviews published on this page were submitted to a 3rd party review site. Each review has been been verified using additional trust signals to ensure it is genuine/authentic."
            })
        ]
    });
};
var ReviewsIoCard = function(param) {
    var reviewsIo = param.reviewsIo;
    var ref, ref1, ref2;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        paddingVertical: "$16x",
        borderRadius: "$12x",
        gap: "$12x",
        $largerThanSM: {
            flexDirection: "row",
            paddingHorizontal: "$56x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                alignItems: "center",
                gap: "$8x",
                justifyContent: "space-around",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                        alt: "Reviews io logo",
                        source: {
                            height: 28,
                            width: 175,
                            uri: "https://images.opendoor.com/source/s3/imgdrop-production/2024-11-1732437828073-65898.png?service=cosmos"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "row",
                        children: Array.from({
                            length: 5
                        }).map(function(_val, index) {
                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                                alt: "Star Rating",
                                source: STAR_RATING_SOURCE
                            }, index);
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        typography: "$bodySmall",
                        tag: "p",
                        children: [
                            (ref = reviewsIo.stats) === null || ref === void 0 ? void 0 : ref.averageRating,
                            " Rating | ",
                            (ref1 = reviewsIo.stats) === null || ref1 === void 0 ? void 0 : ref1.totalReviews,
                            " reviews"
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: "$8x",
                justifyContent: "space-around",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        typography: "$headerSmall",
                        tag: "p",
                        textAlign: "center",
                        children: [
                            (ref2 = reviewsIo.stats) === null || ref2 === void 0 ? void 0 : ref2.recommendedPercent,
                            "%"
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        typography: "$bodySmall",
                        tag: "p",
                        textAlign: "center",
                        children: "of reviewers recommend Opendoor"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        variant: "secondaryInverse",
                        label: "See reviews.io",
                        size: "small",
                        analyticsName: "reviews-io-link",
                        href: "https://www.reviews.io/company-reviews/store/opendoor-com",
                        target: "_blank"
                    })
                ]
            })
        ]
    });
};
var BbbOrgCard = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        backgroundColor: "$backgroundSecondary",
        paddingVertical: "$16x",
        borderRadius: "$12x",
        gap: "$12x",
        $largerThanSM: {
            flexDirection: "row",
            paddingHorizontal: "$56x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                alignItems: "center",
                gap: "$8x",
                justifyContent: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                        alt: "BBB logo",
                        source: {
                            height: 54,
                            width: 175,
                            uri: "https://images.opendoor.com/source/s3/imgdrop-production/2024-11-1732441222067-81668.png?service=cosmos"
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        typography: "$bodySmall",
                        tag: "p",
                        children: "Accredited since: 10/15/2015"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: "$8x",
                justifyContent: "space-around",
                alignItems: "center",
                flex: 1,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        typography: "$headerSmall",
                        tag: "p",
                        textAlign: "center",
                        "$platform-web": {
                            color: "#015A78"
                        },
                        children: "A+"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        typography: "$bodySmall",
                        tag: "p",
                        textAlign: "center",
                        children: "BBB rating"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        variant: "secondaryInverse",
                        label: "Visit BBB.org",
                        size: "small",
                        analyticsName: "BBB Link Button",
                        href: "https://www.bbb.org/us/az/tempe/profile/real-estate-services/opendoor-1126-1000060421/customer-reviews",
                        target: "_blank",
                        "$platform-web": {
                            backgroundColor: "#015A78"
                        }
                    })
                ]
            })
        ]
    });
};
var VerifiedReview = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "row",
        alignItems: "center",
        gap: "$2x",
        flexShrink: 0,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelSmall",
                color: "$contentAccentBrand",
                children: "Verified Review"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkmark/* default */.Z, {
                size: 20,
                color: "$contentAccentBrand"
            })
        ]
    });
};
var reviews_ReviewCard = function(param) {
    var review = param.review;
    var ref;
    var ref1 = commentParts(review.reviewComment), heading = ref1.heading, body = ref1.body, ellipsize = ref1.ellipsize;
    var reviewerName = (ref = review.reviewer.name) === null || ref === void 0 ? void 0 : ref.trim();
    var cityContext = review.productData.city ? " in ".concat(review.productData.city) : "";
    var reviewerContext = reviewerName ? "".concat(typeToReviewContext[review.productData.productType]).concat(cityContext) : "".concat(typeToProduct[review.productData.productType]).concat(cityContext);
    var ratingLabel = "".concat(review.rating, " out of 5 stars");
    var renderRatings = function() {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            flexDirection: "row",
            accessibilityRole: "image",
            accessibilityLabel: ratingLabel,
            children: Array.from({
                length: review.rating
            }).map(function(_val, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                    alt: "",
                    source: STAR_RATING_SOURCE
                }, index);
            })
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        paddingHorizontal: "$10x",
        paddingVertical: "$10x",
        borderWidth: "$0dot5x",
        borderRadius: "$8x",
        borderColor: "$borderPrimary",
        backgroundColor: "$backgroundPrimary",
        gap: "$8x",
        minWidth: 0,
        $largerThanSM: {
            paddingHorizontal: "$14x",
            paddingVertical: "$12x"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "flex-start",
                gap: "$6x",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        gap: "$3x",
                        minWidth: 0,
                        children: [
                            renderRatings(),
                            reviewerName && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                typography: "$bodyLarge",
                                tag: "p",
                                color: "$contentPrimary",
                                fontWeight: "$medium",
                                children: reviewerName
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                typography: "$bodySmall",
                                tag: "p",
                                color: "$contentSecondary",
                                children: reviewerContext
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(VerifiedReview, {})
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                minWidth: 0,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        typography: "$bodyXlarge",
                        tag: "h3",
                        color: "$contentPrimary",
                        fontWeight: "$medium",
                        "$platform-web": {
                            overflowWrap: "anywhere"
                        },
                        children: [
                            heading,
                            ellipsize && "..."
                        ]
                    }),
                    (body === null || body === void 0 ? void 0 : body.trim()) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        typography: "$bodyMedium",
                        tag: "p",
                        color: "$contentPrimary",
                        marginTop: "$4x",
                        $largerThanSM: {
                            typography: "$bodyLarge"
                        },
                        "$platform-web": {
                            overflowWrap: "anywhere"
                        },
                        children: body.trim()
                    })
                ]
            })
        ]
    });
};
var ReviewList = function(_entry, resolvedData) {
    var ref = (0,react.useState)(ProductType.sell), filterType = ref[0], setFilterType = ref[1];
    var ref1 = (0,react.useState)(10), reviewCount = ref1[0], setReviewCount = ref1[1];
    var typedResolvedData = resolvedData;
    if (!(typedResolvedData === null || typedResolvedData === void 0 ? void 0 : typedResolvedData.productTypeFeeds)) {
        return null;
    }
    var allFeedData = typedResolvedData.productTypeFeeds[filterType || ProductType.sell];
    var explainer = productTypeToExplainer[filterType || ProductType.sell];
    var paginatedFeedData = allFeedData.slice(0, reviewCount);
    var hasMoreReviews = reviewCount < allFeedData.length;
    var renderFeedItem = function(feedItem, key) {
        switch(feedItem.type){
            case "review":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(reviews_ReviewCard, {
                    review: feedItem.reviewInfo
                }, key);
            case "disclaimer":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThirdParyVerification, {});
            case "reviewsio":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewsIoCard, {
                    reviewsIo: feedItem
                });
            case "bbb":
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BbbOrgCard, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Container/* LandingPageSectionContainer */.IX, {
        minHeight: 400,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: "$12x",
                $largerThanSM: {
                    flexDirection: "row",
                    justifyContent: "space-between"
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        justifyContent: "space-between",
                        gap: "$8x",
                        $largerThanSM: {
                            width: 315
                        },
                        $largerThanMD: {
                            width: 525
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h3",
                                typography: "$subheaderLarge",
                                children: explainer.heading
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "h3",
                                typography: "$bodyLarge",
                                children: explainer.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "100%",
                        $largerThanSM: {
                            width: 315
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            required: true,
                            title: "Review types",
                            size: "small",
                            options: FILTER_OPTIONS,
                            prefilledValue: ProductType.sell,
                            onValueChange: function(value) {
                                setReviewCount(10);
                                setFilterType(value);
                            }
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                marginTop: "$16x",
                marginBottom: hasMoreReviews ? 0 : "$16x",
                gap: "$16x",
                children: paginatedFeedData.map(function(feedItem, index) {
                    return renderFeedItem(feedItem, index);
                })
            }),
            hasMoreReviews && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                width: "100%",
                flexDirection: "row",
                justifyContent: "center",
                alignItems: "center",
                paddingVertical: "$8x",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                    onPress: function() {
                        return setReviewCount(function(count) {
                            return count + 10;
                        });
                    },
                    variant: "primary",
                    size: "small",
                    label: "Load More",
                    analyticsName: "load-more-reviews"
                })
            })
        ]
    });
};
var reviewsLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var ref, productTypeFeeds, stats, err;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        fetchReviews()
                    ];
                case 1:
                    ref = _state.sent(), productTypeFeeds = ref.productTypeFeeds, stats = ref.stats;
                    // JSON.parse(JSON.stringify(...)) strips undefined values which can't be serialized by Next.js
                    return [
                        2,
                        JSON.parse(JSON.stringify({
                            productTypeFeeds: productTypeFeeds,
                            stats: stats
                        }))
                    ];
                case 2:
                    err = _state.sent();
                    // eslint-disable-next-line no-console
                    console.log("error occured while processing reviews", err);
                    return [
                        2,
                        {
                            productTypeFeeds: {
                                sell: [],
                                buy: [],
                                "trade-in": []
                            },
                            stats: null
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function reviewsLoader() {
        return _ref.apply(this, arguments);
    };
}();
var Reviews = {
    render: ReviewList,
    loader: reviewsLoader
};
/* harmony default export */ var reviews = (Reviews);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/Spacer.tsx
var Spacer = __webpack_require__(6902);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StandaloneText.tsx
var StandaloneText = __webpack_require__(94479);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/StatGrid.tsx



var TILE_ROW_RESPONSIVE = {
    flexDirection: "row",
    flexWrap: "wrap"
};
var TILE_TABLET = {
    flexBasis: "46%",
    flexGrow: 1
};
var TILE_DESKTOP = {
    flexBasis: 0,
    flexGrow: 1
};
var VALUE_RESPONSIVE = {
    typography: "$headerMedium"
};
var StatGridItems = function(param) {
    var items = param.items;
    var ref;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: items.map(function(stat, i) {
            var ref1;
            /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
                gap: "$3x",
                minWidth: "$80x",
                $largerThanSM: TILE_TABLET,
                $largerThanMD: TILE_DESKTOP,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$displaySmall",
                        fontWeight: "$medium",
                        color: "$contentPrimary",
                        $smallerThanMD: VALUE_RESPONSIVE,
                        display: "block",
                        children: stat.fields.value
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentTertiary",
                        display: "block",
                        children: stat.fields.description
                    })
                ]
            }, (ref = (ref1 = stat.sys) === null || ref1 === void 0 ? void 0 : ref1.id) !== null && ref !== void 0 ? ref : i);
        })
    });
};
var renderStatGrid = function(entry) {
    var items = entry.fields.items;
    if (!(items === null || items === void 0 ? void 0 : items.length)) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Container/* default */.ZP, {
        noSectionSpacing: true,
        paddingVertical: "$16x",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            flexDirection: "column",
            gap: "$12x",
            $largerThanSM: TILE_ROW_RESPONSIVE,
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StatGridItems, {
                items: items
            })
        })
    });
};
var StatGrid = {
    render: renderStatGrid
};
/* harmony default export */ var landing_pages_v2_StatGrid = (StatGrid);

// EXTERNAL MODULE: ./src/cms/entries/dynamicEntry.ts
var dynamicEntry = __webpack_require__(42336);
;// CONCATENATED MODULE: ./src/cms/entries/landingPageV2.ts

































// OpenPositions renders the careers listing + JD detail from SSR-fetched
// Rippling data — no useMedia, no iframes, no third-party widgets, so it's
// safe to static-import. Eliminates the dynamic({ssr:false}) hydration flash
// that would otherwise CLS the listing cards / JD body in after first paint.





// StandaloneText is statically imported so its rich-text body — including
// in-content `id` anchors authored via `lpComponentHeaderWithId` — is present
// in the SSR'd HTML. Deferring it to client render breaks deep links like
// /privacy#ccpa because the anchor target does not exist when the browser
// performs its hash scroll on first paint.



var Calculator = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8948), __webpack_require__.e(7154), __webpack_require__.e(2394), __webpack_require__.e(1267)]).then(__webpack_require__.bind(__webpack_require__, 64634));
});
var FeatureCarousel = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6443).then(__webpack_require__.bind(__webpack_require__, 36443));
});
// CarouselCards swaps mobile/desktop subtrees via useMedia, so it stays
// client-only.
var CarouselCards = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 9544).then(__webpack_require__.bind(__webpack_require__, 99544));
});
var CompareVideoTestimonial = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6366).then(__webpack_require__.bind(__webpack_require__, 26366));
});
// import CountdownTimer from 'components/landing-pages-v2/CountdownTimer';
var CTAStandalone = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 2802).then(__webpack_require__.bind(__webpack_require__, 2802));
});
// Browser-only carousel, media, iframe, and third-party widget runtimes stay client-only.
var ExternalLinks = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 7703).then(__webpack_require__.bind(__webpack_require__, 27703));
});
var Multicard = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6512).then(__webpack_require__.bind(__webpack_require__, 16512));
});
var Quotation = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 6831).then(__webpack_require__.bind(__webpack_require__, 36831));
});
var TrustpilotWidget = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 3757).then(__webpack_require__.bind(__webpack_require__, 63757));
});
var VideoPlayer = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 3254).then(__webpack_require__.bind(__webpack_require__, 73254));
});
var TimeSavingsCalculator = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8092), __webpack_require__.e(86)]).then(__webpack_require__.bind(__webpack_require__, 90086));
});
// CustomBlock eagerly imports its registered blocks (e.g. ConquestingOrchard
// branches on useMedia), so it stays client-only until those blocks are
// CSS-stable.
var CustomBlock = (0,dynamicEntry/* dynamicEntry */.f)(function() {
    return __webpack_require__.e(/* import() */ 8467).then(__webpack_require__.bind(__webpack_require__, 28467));
});
var landingPageV2EntryLookup = {
    block: {
        compareHero: landing_pages_v2_CompareHero,
        compareTable: landing_pages_v2_CompareTable,
        compareFees: landing_pages_v2_CompareFees,
        compareReviews: landing_pages_v2_CompareReviews,
        compareVideoTestimonial: CompareVideoTestimonial,
        comparePhotoTestimonials: landing_pages_v2_ComparePhotoTestimonials,
        compareFinalCta: landing_pages_v2_CompareFinalCta,
        lpComponentMapBackgroundHero: MapBackgroundHero/* default */.Z,
        lpComponentCarouselCards: CarouselCards,
        lpComponentImageCard: landing_pages_v2_ImageCard,
        lpComponentFaqDisplay: FAQsDisplay/* default */.Z,
        lpComponentHeroV2: HeroV2/* default */.ZP,
        lpComponentContactSection: ContactSection/* default */.Z,
        lpComponentLwcTextSection: LWCTextSection/* default */.Z,
        lpComponentLwcHeroCard: LWCHeroCard/* default */.Z,
        lpComponentLwcImageCard: LWCImageCard/* default */.Z,
        lpComponentHeroV2WithMarkers: HeroV2WithMarkers/* default */.Z,
        lpComponentCTAStandalone: CTAStandalone,
        lpComponentComparisonTable: landing_pages_v2_ComparisonTable,
        lpComponentFeature5050: landing_pages_v2_Feature5050,
        lpComponentFeatureCarousel: FeatureCarousel,
        lpComponentHeaderStandalone: landing_pages_v2_HeaderStandalone,
        lpComponentHeroCta: landing_pages_v2_HeroCTA,
        lpComponentList: landing_pages_v2_List,
        lpComponentStandaloneText: StandaloneText/* default */.Z,
        lpComponentMulticard: Multicard,
        lpComponentNarrativeLockups: landing_pages_v2_NarrativeLockups,
        lpComponentFactBar: landing_pages_v2_FactBar,
        lpComponentBasicPageHeader: landing_pages_v2_BasicPageHeader,
        lpComponentLinkList: landing_pages_v2_LinkList,
        lpComponentQuotation: Quotation,
        lpComponentSpacer: Spacer/* default */.Z,
        lpComponentStatGrid: landing_pages_v2_StatGrid,
        lpComponentOpenPositions: landing_pages_v2_OpenPositions,
        lpComponentPartnerCaseStudy: landing_pages_v2_PartnerCaseStudy,
        lpComponentOpendoorReviews: reviews,
        lpComponentCalculator: Calculator,
        lpComponentTimeSavingsCalculator: TimeSavingsCalculator,
        // lpComponentCountdownTimer: CountdownTimer,
        lpComponentVideoPlayer: VideoPlayer,
        lpComponentMarketStats: landing_pages_v2_MarketStats,
        trustpilotWidget: TrustpilotWidget,
        componentRelatedExternalLinks: ExternalLinks,
        fcHero: FCHero/* default */.Z,
        fcTrustBanner: FCTrustBanner/* default */.Z,
        fcThreeSteps: FCThreeSteps/* default */.Z,
        fcProductOptions: FCProductOptions/* default */.Z,
        fcTestimonialCarousel: FCTestimonialCarousel/* default */.Z,
        fcMap: FCMap/* default */.Z,
        fcMissionStatement: FCMissionStatement/* default */.Z,
        fcContactUs: FCContactUs/* default */.Z,
        lpComponentCustomBlock: CustomBlock,
        lpComponentPhotoTestimonials: PhotoTestimonials/* default */.Z
    },
    inline: {}
};
/* harmony default export */ var landingPageV2 = (landingPageV2EntryLookup);


/***/ }),

/***/ 79388:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ isAsset; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(54999);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46320);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5984);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23335);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);





// Prevents hydration errors by only rendering on client
var ReactPlayer = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 7051).then(__webpack_require__.t.bind(__webpack_require__, 97051, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(97051)
            ];
        }
    },
    ssr: false
});
var isAsset = function(x) {
    return x.file && x.file.url && x.file.contentType;
};
var isImageAsset = function(asset) {
    var ref;
    return asset.file.contentType.startsWith("image/") && ((ref = asset.file.details) === null || ref === void 0 ? void 0 : ref.image) != null;
};
var isVideoAsset = function(asset) {
    return asset.file.contentType.startsWith("video/");
};
var contentfulLoader = function(props) {
    var src = props.src, width = props.width, quality = props.quality;
    return "".concat(src, "?w=").concat(width, "&q=").concat(quality || 75);
};
var renderImage = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
        loader: contentfulLoader,
        layout: "responsive",
        src: props.src,
        sizes: "(max-width: 992px) 100vw, 50vw",
        alt: props.description || "Article image",
        width: props.width,
        height: props.height
    });
};
var VideoPlayer = function(props) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isPlaying = ref[0], setIsPlaying = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true), showPlayButton = ref1[0], setShowPlayButton = ref1[1];
    var playerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var handlePlayClick = function() {
        setIsPlaying(true);
        setShowPlayButton(false);
    };
    var handlePause = function() {
        setIsPlaying(false);
        setShowPlayButton(true);
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        position: "relative",
        pt: "56.25%" // 16:9 aspect ratio
        ,
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        borderRadius: "$16x",
        backgroundColor: "$backgroundInversePrimary",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(ReactPlayer, {
                ref: playerRef,
                url: props.src,
                controls: true,
                playing: isPlaying,
                onPlay: handlePlayClick,
                onPause: handlePause,
                playsinline: true,
                width: "100%",
                height: "100%",
                style: {
                    position: "absolute",
                    left: 0,
                    top: 0
                }
            }),
            showPlayButton && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .PressableBox */ .K, {
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                cursor: "pointer",
                zIndex: 10,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                onPress: handlePlayClick,
                "aria-label": "Play video",
                analyticsName: "video-play-button",
                style: {
                    width: "80px",
                    height: "80px",
                    borderRadius: "50%",
                    backgroundColor: "rgba(0, 0, 0, 0.7)"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("svg", {
                    width: "28",
                    height: "28",
                    viewBox: "0 0 28 28",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("path", {
                        d: "M21 14.5833L9.33337 22.1667L9.33337 7L21 14.5833Z",
                        fill: "white"
                    })
                })
            })
        ]
    });
};
var renderAsset = function(props) {
    // Create a ContentfulAsset-like object to use with helper functions
    var asset = {
        file: {
            url: props.src,
            contentType: props.contentType,
            details: {
                image: props.width && props.height ? {
                    width: props.width,
                    height: props.height
                } : undefined
            }
        },
        description: props.description
    };
    if (isImageAsset(asset)) {
        return renderImage({
            src: props.src,
            description: props.description,
            width: props.width,
            height: props.height
        });
    } else if (isVideoAsset(asset)) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(VideoPlayer, {
            src: props.src,
            description: props.description
        });
    }
    // Fallback for unsupported asset types
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyMedium",
                children: [
                    "Unsupported asset type: ",
                    props.contentType
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Link */ .r, {
                href: props.src,
                target: "_blank",
                "aria-label": "Download ".concat(props.description || "asset"),
                analyticsName: "asset-download",
                variant: "primary",
                children: [
                    "Download ",
                    props.description || "asset"
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (renderAsset);


/***/ }),

/***/ 51803:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ getLinkForAnchorTagWithId; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(84802);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52058);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64786);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96602);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85466);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79758);
/* harmony import */ var _assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79388);














var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_6__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var getLinkForAnchorTagWithId = function(input) {
    var output = "";
    for(var i = 0; i < input.length; i++){
        var curr = input[i];
        if (curr === "-") {
            output = output + "-";
            continue;
        }
        if (curr.match(/\s/)) {
            output = output + "-";
            continue;
        }
        if (curr.match(/\W/)) {
            continue;
        }
        output = output + curr.toLowerCase();
    }
    output = output.replace(/-$/, "");
    var id = output.replaceAll(/-+/g, "-");
    return "#".concat(id);
};
var EntryErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(EntryErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(EntryErrorBoundary);
    function EntryErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, EntryErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = EntryErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
            captureContext: {
                extra: {
                    errorInfo: errorInfo,
                    entry: this.props.entry,
                    loaderData: this.props.loaderData
                }
            }
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    EntryErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return EntryErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
/***
 * If you're not in prod and you add a "?dev" query param to your url it will
 * wrap each component and apply a label so you know exactly which component you're
 * currently looking at.
 */ var DevOverlay = function(param) {
    var contentTypeId = param.contentTypeId, children = param.children;
    var ref = useState(false), showOverlay = ref[0], setShowOverlay = ref[1];
    useEffect(function() {
        setShowOverlay(new URLSearchParams(window.location.search).has("dev"));
    }, []);
    if (!showOverlay) {
        return children;
    }
    return /*#__PURE__*/ _jsxs("div", {
        "data-dev-overlay": contentTypeId,
        style: {
            position: "relative",
            display: "flow-root"
        },
        children: [
            /*#__PURE__*/ _jsx("style", {
                children: "\n        [data-dev-overlay]::before {\n          content: attr(data-dev-overlay);\n          position: absolute;\n          top: 0;\n          left: 0;\n          background: salmon;\n          color: white;\n          font-size: 12px;\n          padding: 2px 6px;\n          border-bottom-right-radius: 4px;\n          pointer-events: none;\n          z-index: 9999;\n        }\n        [data-dev-overlay]::after {\n          content: '';\n          position: absolute;\n          inset: 0;\n          border: 2px solid salmon;\n          pointer-events: none;\n          z-index: 9999;\n        }\n      "
            }),
            children
        ]
    });
};
var hasEmbeddedEntryTargetId = function(node) {
    var ref, ref1, ref2;
    return node.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY && typeof ((ref = node.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : ref2.id) === "string";
};
var RendererComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    return new RichTextRenderer(props).render();
}, function(prev, next) {
    return Object.entries(prev).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return lodash_isEqual__WEBPACK_IMPORTED_MODULE_3___default()(v, next[k]);
    });
});
RendererComponent.displayName = "RichTextRenderer";
var isAllText = function(content) {
    return content.every(function(c) {
        return _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.helpers.isText(c);
    });
};
var RichTextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function RichTextRenderer(param) {
        var body = param.body, idToLoaderData = param.idToLoaderData, entryLookup = param.entryLookup;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(this, RichTextRenderer);
        var ref, ref1;
        this.body = body;
        this.idToLoaderData = idToLoaderData;
        this.entryLookup = entryLookup;
        this.options = this.getOption();
        this.generatedIds = {};
        this.firstBlockEntryId = (ref1 = (ref = body.content) === null || ref === void 0 ? void 0 : ref.find(hasEmbeddedEntryTargetId)) === null || ref1 === void 0 ? void 0 : ref1.data.target.sys.id;
    }
    var _proto = RichTextRenderer.prototype;
    _proto.generateId = function generateId(content) {
        if (!isAllText(content)) {
            return null;
        }
        // Type hint, in the "skipId" section, we verified there
        // are only
        var input = content.reduce(function(acc, curr) {
            return acc + curr.value;
        }, "");
        var output = "";
        for(var i = 0; i < input.length; i++){
            var curr = input[i];
            // replace any non word charager with an empty space
            // skip dashes with this
            if (curr === "-") {
                output = output + "-";
                continue;
            }
            // whitespace
            if (curr.match(/\s/)) {
                output = output + "-";
                continue;
            }
            if (curr.match(/\W/)) {
                continue;
            }
            output = output + curr.toLowerCase();
        }
        var id = output.replaceAll(/-+/g, "-");
        // handle duplicates - we'll just increase the appended
        // index if we have a duplicate id
        if (id in this.generatedIds) {
            this.generatedIds[id] += 1;
            id = "".concat(id, "-").concat(this.generatedIds[id]);
        } else {
            this.generatedIds[id] = 0;
        }
        return id;
    };
    _proto.getOption = function getOption() {
        var _this = this;
        var _obj;
        return {
            renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h1",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$1",
                    mb: "$1",
                    color: "$contentPrimary",
                    typography: "$subheaderLarge",
                    $largerThanMD: {
                        typography: "$headerMedium"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h2",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$6",
                    mb: "$4",
                    color: "$contentPrimary",
                    typography: "$subheaderSmall",
                    $largerThanMD: {
                        typography: "$subheaderLarge"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h3",
                    id: id !== null && id !== void 0 ? id : "",
                    mt: "$5",
                    mb: "$3",
                    color: "$contentPrimary",
                    typography: "$subheaderXsmall",
                    $largerThanMD: {
                        typography: "$subheaderSmall"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Col */ .J, {
                    borderRadius: "$4x",
                    py: "$3",
                    px: "$3",
                    width: "100%",
                    backgroundColor: "$backgroundTertiary",
                    $largerThanMD: {
                        py: "$5",
                        px: "$6"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.block[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(entryData) {
                var ref, ref1, ref2, ref3;
                var fields = entryData.data.target.fields;
                if (!(0,_assets__WEBPACK_IMPORTED_MODULE_5__/* .isAsset */ .X)(fields)) {
                    return null;
                }
                return (0,_assets__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                    src: fields.file.url,
                    description: fields.description,
                    contentType: fields.file.contentType,
                    width: (ref = fields.file.details) === null || ref === void 0 ? void 0 : (ref1 = ref.image) === null || ref1 === void 0 ? void 0 : ref1.width,
                    height: (ref2 = fields.file.details) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.image) === null || ref3 === void 0 ? void 0 : ref3.height
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.inline[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                    tag: "h4",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$labelLarge",
                    $largerThanMD: {
                        typography: "$subheaderSmall"
                    },
                    "$platform-web": {
                        scrollMarginTop: "80px"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(entry, children) {
                var paragraphEntryContent = entry.content;
                if (!Array.isArray(children)) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                        tag: "p",
                        mb: "$2",
                        typography: "$bodyMedium",
                        $largerThanMD: {
                            typography: "$bodyLarge"
                        },
                        children: children
                    });
                }
                // Don't render empty paragraph where the node only contains whitespace text
                var isEmptyParagraph = paragraphEntryContent.length === 1 && paragraphEntryContent[0].nodeType == "text" && typeof paragraphEntryContent[0].value === "string" && paragraphEntryContent[0].value.trim().length === 0;
                if (isEmptyParagraph) {
                    return null;
                }
                var zipped = paragraphEntryContent.map(function(e, i) {
                    return [
                        e,
                        children[i]
                    ];
                });
                var ref = zipped.reduce(function(acc, curr) {
                    var _curr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                    if (_$entry.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY) {
                        acc.inline = acc.inline.concat(child);
                        return acc;
                    }
                    acc.standard = acc.standard.concat(child);
                    return acc;
                }, {
                    inline: [],
                    standard: []
                }), inline = ref.inline, standard = ref.standard;
                // note: this re-orders the text components, i.e. if you have
                // test <inline entry> test2, it will be rendered as
                // <inline entry> test test2. This doesn't seem ideal, but works
                // for our use-case. We may want to disallow inline embedded entries
                // in the future, and just use the block type.
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .Fragment */ .HY, {
                    children: [
                        inline,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Text */ .x, {
                            tag: "p",
                            my: "$5",
                            typography: "$bodyMedium",
                            $largerThanMD: {
                                typography: "$bodyLarge"
                            },
                            children: standard
                        })
                    ]
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                var target = "_blank";
                if (// https://opendoor.atlassian.net/jira/servicedesk/projects/ENGBUGS/queues/custom/1337/ENGBUGS-47459
                // we want all articles referenced in our articles to open in a new tab
                // we only add production urls to contentful
                !node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_4__/* .COSMOS_URLS.production */ .zu.production + "/articles") && (node.data.uri.startsWith("#") || node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_4__/* .COSMOS_URLS.production */ .zu.production))) {
                    target = "_self";
                }
                var hrefLink = node.data.uri;
                if (node.data.uri.startsWith("#") && node.content[0].nodeType === "text") {
                    var anchorHref = getLinkForAnchorTagWithId(node.content[0].value);
                    hrefLink = anchorHref;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Link */ .r, {
                    href: hrefLink,
                    analyticsName: "cosmos-articles-renderer",
                    "aria-label": "",
                    target: target,
                    typography: "$bodyMedium",
                    $largerThanMD: {
                        typography: "$bodyLarge"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "table",
                    "$platform-web": {
                        display: "table",
                        borderCollapse: "collapse"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                        tag: "tbody",
                        "$platform-web": {
                            display: "table-row-group"
                        },
                        children: children
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "td",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "tr",
                    "$platform-web": {
                        display: "table-row"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Box */ .x, {
                    tag: "th",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), _obj)
        };
    };
    /**
   * Render an entry safely, with Error Boundaries and safe server-side try-catch
   */ _proto.renderEntry = function renderEntry(entryComponent, entryData) {
        var ref, ref1, ref2, ref3;
        var entryId = entryData.data.target.sys.id;
        var loaderData = this.idToLoaderData[entryId];
        var ref4 = this, body = ref4.body, idToLoaderData = ref4.idToLoaderData;
        var component;
        /**
     * Render the entry safely server-side
     */ try {
            component = entryComponent.render(entryData.data.target, loaderData, {
                body: body,
                idToLoaderData: idToLoaderData,
                isFirstBlockEntry: entryId === this.firstBlockEntryId,
                entryLookup: this.entryLookup
            });
        } catch (e) {
            var _obj, ref5;
            (ref5 = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_6__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref5 === void 0 ? void 0 : ref5.call(_obj, e, {
                data: {
                    target: entryData.data.target,
                    loaderData: loaderData
                }
            });
            return null;
        }
        var contentTypeId = (ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(EntryErrorBoundary, {
            entry: entryData.data.target,
            loaderData: loaderData,
            children:  false ? /*#__PURE__*/ 0 : component
        });
    };
    /**
   * Custom memoized rich text renderer, only re-render it at a top-level if the body
   * input has changed (deep diff). Prevents re-renders if something at the top level
   * is misbehaving.
   */ _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_12__/* .Fragment */ .HY, {
            children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(this.body, this.options)
        });
    };
    return RichTextRenderer;
}();
RichTextRenderer.Component = RendererComponent;
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ }),

/***/ 97762:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ StickyAddressProvider; },
/* harmony export */   "v": function() { return /* binding */ useStickyAddress; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);

var StickyAddressContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var StickyAddressProvider = StickyAddressContext.Provider;
var useStickyAddress = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(StickyAddressContext);
};


/***/ }),

/***/ 63206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4656);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(13459);
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(99758);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84802);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52058);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64786);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96602);
/* harmony import */ var cms_renderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51803);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85466);
/* harmony import */ var lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(lodash_isEqual__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _cms_renderer_assets__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79388);
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(79758);















var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_7__/* .globalObservability.getSentryClient */ .w.getSentryClient();
var EntryErrorBoundary = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(EntryErrorBoundary, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(EntryErrorBoundary);
    function EntryErrorBoundary(props) {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this, EntryErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            hasError: false
        };
        return _this;
    }
    var _proto = EntryErrorBoundary.prototype;
    _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
        var ref;
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error, {
            captureContext: {
                extra: {
                    errorInfo: errorInfo,
                    entry: this.props.entry,
                    loaderData: this.props.loaderData
                }
            }
        });
    };
    _proto.render = function render() {
        if (this.state.hasError) {
            return null;
        }
        return this.props.children;
    };
    EntryErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError() {
        // Update state so the next render will show the fallback UI.
        return {
            hasError: true
        };
    };
    return EntryErrorBoundary;
}(react__WEBPACK_IMPORTED_MODULE_0__.Component);
var scrollAnchorStyle = {
    scrollMarginTop: "80px"
};
var RendererComponent = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.memo)(function(props) {
    return new RichTextRenderer(props).render();
}, function(prev, next) {
    return Object.entries(prev).every(function(param) {
        var _param = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(param, 2), k = _param[0], v = _param[1];
        return lodash_isEqual__WEBPACK_IMPORTED_MODULE_4___default()(v, next[k]);
    });
});
RendererComponent.displayName = "RichTextRenderer";
var isAllText = function(content) {
    return content.every(function(c) {
        return _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.helpers.isText(c);
    });
};
var RichTextRenderer = /*#__PURE__*/ function() {
    "use strict";
    function RichTextRenderer(param) {
        var body = param.body, idToLoaderData = param.idToLoaderData, entryLookup = param.entryLookup;
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(this, RichTextRenderer);
        this.body = body;
        this.idToLoaderData = idToLoaderData;
        this.entryLookup = entryLookup;
        this.options = this.getOption();
        this.generatedIds = {};
    }
    var _proto = RichTextRenderer.prototype;
    _proto.generateId = function generateId(content) {
        if (!isAllText(content)) {
            return null;
        }
        // Type hint, in the "skipId" section, we verified there
        // are only
        var input = content.reduce(function(acc, curr) {
            return acc + curr.value;
        }, "");
        var output = "";
        for(var i = 0; i < input.length; i++){
            var curr = input[i];
            // replace any non word charager with an empty space
            // skip dashes with this
            if (curr === "-") {
                output = output + "-";
                continue;
            }
            // whitespace
            if (curr.match(/\s/)) {
                output = output + "-";
                continue;
            }
            if (curr.match(/\W/)) {
                continue;
            }
            output = output + curr.toLowerCase();
        }
        var id = output.replaceAll(/-+/g, "-");
        // handle duplicates - we'll just increase the appended
        // index if we have a duplicate id
        if (id in this.generatedIds) {
            this.generatedIds[id] += 1;
            id = "".concat(id, "-").concat(this.generatedIds[id]);
        } else {
            this.generatedIds[id] = 0;
        }
        return id;
    };
    _proto.getOption = function getOption() {
        var _this = this;
        var _obj;
        return {
            renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_1, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h1",
                    typography: "$subheaderLarge",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_2, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderMedium",
                    tag: "h2",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_3, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h3",
                    typography: "$subheaderSmall",
                    id: id !== null && id !== void 0 ? id : "",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.HEADING_4, function(node, children) {
                var id = _this.generateId(node.content);
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                    display: "block",
                    tag: "h4",
                    id: id !== null && id !== void 0 ? id : "",
                    typography: "$subheaderXsmall",
                    style: scrollAnchorStyle,
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.QUOTE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "blockquote",
                    borderRadius: "$4x",
                    mx: "$0",
                    p: "$3",
                    $largerThanMD: {
                        p: "$5"
                    },
                    width: "100%",
                    backgroundColor: "$backgroundStateHoverSecondary",
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.block[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.EMBEDDED_ASSET, function(entryData) {
                var ref, ref1, ref2, ref3, ref4;
                var fields = entryData.data.target.fields;
                if (!(0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_5__/* .isAsset */ .X)(fields)) {
                    return null;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    className: "embedded-entry-wrapper",
                    "$platform-web": {
                        gridColumn: "2 / -2"
                    },
                    children: (0,_cms_renderer_assets__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        src: (ref = fields.file) === null || ref === void 0 ? void 0 : ref.url,
                        description: fields.description,
                        width: (ref1 = fields.file.details) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.width,
                        height: (ref3 = fields.file.details) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : ref4.height,
                        contentType: fields.file.contentType
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY, function(entryData) {
                var ref, ref1, ref2, ref3;
                var entryComponent = _this.entryLookup.inline[(ref = entryData.data.target) === null || ref === void 0 ? void 0 : (ref1 = ref.sys) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.contentType) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.sys) === null || ref3 === void 0 ? void 0 : ref3.id];
                if (!entryComponent) {
                    return null;
                }
                return _this.renderEntry(entryComponent, entryData);
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.PARAGRAPH, function(entry, children) {
                var paragraphEntryContent = entry.content;
                if (!Array.isArray(children)) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                        display: "block",
                        tag: "p",
                        typography: "$bodyLarge",
                        children: children
                    });
                }
                // Don't render empty paragraph where the node only contains whitespace text
                var isEmptyParagraph = paragraphEntryContent.length === 1 && paragraphEntryContent[0].nodeType == "text" && typeof paragraphEntryContent[0].value === "string" && paragraphEntryContent[0].value.trim().length === 0;
                if (isEmptyParagraph) {
                    return null;
                }
                var zipped = paragraphEntryContent.map(function(e, i) {
                    return [
                        e,
                        children[i]
                    ];
                });
                var ref = zipped.reduce(function(acc, curr) {
                    var _curr = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(curr, 2), _$entry = _curr[0], child = _curr[1];
                    if (_$entry.nodeType === _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.EMBEDDED_ENTRY) {
                        acc.inline = acc.inline.concat(child);
                        return acc;
                    }
                    acc.standard = acc.standard.concat(child);
                    return acc;
                }, {
                    inline: [],
                    standard: []
                }), inline = ref.inline, standard = ref.standard;
                // note: this re-orders the text components, i.e. if you have
                // test <inline entry> test2, it will be rendered as
                // <inline entry> test test2. This doesn't seem ideal, but works
                // for our use-case. We may want to disallow inline embedded entries
                // in the future, and just use the block type.
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
                    children: [
                        inline,
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Text */ .x, {
                            display: "block",
                            tag: "p",
                            typography: "$bodyMedium",
                            children: standard
                        })
                    ]
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.INLINES.HYPERLINK, function(node, children) {
                var target = "_blank";
                if (// https://opendoor.atlassian.net/jira/servicedesk/projects/ENGBUGS/queues/custom/1337/ENGBUGS-47459
                // we want all articles referenced in our articles to open in a new tab
                // we only add production urls to contentful
                !node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_6__/* .COSMOS_URLS.production */ .zu.production + "/articles") && (node.data.uri.startsWith("#") || node.data.uri.startsWith(_components_globals__WEBPACK_IMPORTED_MODULE_6__/* .COSMOS_URLS.production */ .zu.production))) {
                    target = "_self";
                }
                var hrefLink = node.data.uri;
                if (node.data.uri.startsWith("#") && node.content[0].nodeType === "text") {
                    var anchorHref = (0,cms_renderer__WEBPACK_IMPORTED_MODULE_3__/* .getLinkForAnchorTagWithId */ ._)(node.content[0].value);
                    hrefLink = anchorHref;
                }
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_16__/* .Link */ .r, {
                    href: hrefLink,
                    analyticsName: "cosmos-articles-renderer",
                    "aria-label": "",
                    target: target,
                    typography: "$bodyMedium",
                    $largerThanMD: {
                        typography: "$bodyLarge"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "table",
                    "$platform-web": {
                        display: "table",
                        borderCollapse: "collapse"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                        tag: "tbody",
                        "$platform-web": {
                            display: "table-row-group"
                        },
                        children: children
                    })
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "td",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_ROW, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "tr",
                    "$platform-web": {
                        display: "table-row"
                    },
                    children: children
                });
            }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_2__.BLOCKS.TABLE_HEADER_CELL, function(_, children) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Box */ .x, {
                    tag: "th",
                    pr: "$3",
                    $largerThanSM: {
                        pr: "$4"
                    },
                    $largerThanMD: {
                        pr: "$5"
                    },
                    "$platform-web": {
                        display: "table-cell",
                        textAlign: "left",
                        verticalAlign: "middle"
                    },
                    children: children
                });
            }), _obj)
        };
    };
    /**
   * Render an entry safely, with Error Boundaries and safe server-side try-catch
   */ _proto.renderEntry = function renderEntry(entryComponent, entryData) {
        var loaderData = this.idToLoaderData[entryData.data.target.sys.id];
        var ref = this, body = ref.body, idToLoaderData = ref.idToLoaderData;
        var component;
        /**
     * Render the entry safely server-side
     */ try {
            component = entryComponent.render(entryData.data.target, loaderData, {
                body: body,
                idToLoaderData: idToLoaderData,
                entryLookup: this.entryLookup
            });
        } catch (e) {
            var _obj, ref1;
            (ref1 = (_obj = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_7__/* .globalObservability.getSentryClient */ .w.getSentryClient()).captureException) === null || ref1 === void 0 ? void 0 : ref1.call(_obj, e, {
                data: {
                    target: entryData.data.target,
                    loaderData: loaderData
                }
            });
            return null;
        }
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(EntryErrorBoundary, {
            entry: entryData.data.target,
            loaderData: loaderData,
            children: component
        });
    };
    /**
   * Custom memoized rich text renderer, only re-render it at a top-level if the body
   * input has changed (deep diff). Prevents re-renders if something at the top level
   * is misbehaving.
   */ _proto.render = function render() {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_13__/* .Fragment */ .HY, {
            children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_1__/* .documentToReactComponents */ .h)(this.body, this.options)
        });
    };
    return RichTextRenderer;
}();
RichTextRenderer.Component = RendererComponent;
/* harmony default export */ __webpack_exports__["Z"] = (RichTextRenderer);


/***/ }),

/***/ 20530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E": function() { return /* binding */ addressNotFound; },
/* harmony export */   "K": function() { return /* binding */ extractStreetNumber; }
/* harmony export */ });
var extractStreetNumber = function(address) {
    var ref;
    var regex = /\b\d+[A-Za-z]*(?:-\d+[A-Za-z]*)?\b/;
    var matches = address === null || address === void 0 ? void 0 : (ref = address.street1) === null || ref === void 0 ? void 0 : ref.match(regex);
    return matches ? matches[0] : null;
};
var addressNotFound = function(errorData) {
    var msg = typeof errorData === "string" ? errorData : errorData.message;
    return msg.indexOf("NOT_FOUND") === 2;
};


/***/ }),

/***/ 80557:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56865);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34984);
/* harmony import */ var components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91749);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97828);




var RenderContactButton = function(entry) {
    var fields = entry.fields;
    var analyticsName = "cosmos-landing-page-contact-button-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .z, {
        variant: "primary",
        size: "small",
        label: fields.text,
        analyticsName: analyticsName,
        "aria-label": fields.text,
        onPress: function() {
            window.location.href = fields.href;
        },
        "$platform-web": {
            width: "fit-content"
        }
    }, analyticsName);
};
var RenderContactSection = function(entry) {
    var ref;
    var fields = entry.fields;
    var analyticsName = "cosmos-landing-page-contact-section-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
            analyticsName: analyticsName,
            trackImpression: true,
            gap: "$16x",
            py: "$40x",
            "$platform-web": {
                gridColumn: "span 12 / span 12"
            },
            $largerThanMD: {
                alignItems: "center"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                    gap: "$10x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                            $largerThanMD: {
                                flexDirection: "row",
                                justifyContent: "center",
                                gap: "$6x"
                            },
                            gap: "$4x",
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                    tag: "h2",
                                    typography: "$headerSmall",
                                    $largerThanMD: {
                                        typography: "$headerMedium"
                                    },
                                    children: fields === null || fields === void 0 ? void 0 : fields.title
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                    tag: "h2",
                                    typography: "$headerSmall",
                                    $largerThanMD: {
                                        typography: "$headerMedium"
                                    },
                                    children: fields === null || fields === void 0 ? void 0 : fields.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__/* .Desc */ .Xe, {
                            $largerThanMD: {
                                fontSize: 24
                            },
                            children: fields === null || fields === void 0 ? void 0 : fields.description
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                    gap: "$4x",
                    alignItems: "flex-start",
                    $largerThanLG: {
                        gap: "$10x"
                    },
                    flexWrap: "wrap",
                    children: (ref = entry.fields.contactButtons) === null || ref === void 0 ? void 0 : ref.map(function(contactButton) {
                        return RenderContactButton(contactButton);
                    })
                })
            ]
        })
    });
};
var ContactSection = {
    render: RenderContactSection
};
/* harmony default export */ __webpack_exports__["Z"] = (ContactSection);


/***/ }),

/***/ 20358:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_ContextualField; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx + 1 modules
var NewSellerFlowAddressInput = __webpack_require__(37987);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/icon.tsx

var CaretDownIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M7 9L13 15L19 9",
            stroke: "white",
            strokeWidth: "2"
        })
    });
};
var CaretUpIcon = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "25",
        height: "25",
        viewBox: "0 0 25 25",
        fill: "none",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            d: "M19 15L13 9L7 15",
            stroke: "white",
            strokeWidth: "2"
        })
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/ListBox.module.css
var ListBox_module = __webpack_require__(75422);
var ListBox_module_default = /*#__PURE__*/__webpack_require__.n(ListBox_module);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/ListBox.tsx





var Options = function(param) {
    var height = param.height, maxHeight = param.maxHeight, children = param.children;
    return maxHeight ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "block",
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$8x",
        left: -4,
        maxHeight: maxHeight,
        p: "$3",
        pb: "$18",
        position: "absolute",
        bottom: -4,
        right: -4,
        "$platform-web": {
            overflow: "auto",
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 1px"
        },
        className: (ListBox_module_default()).optionsList,
        children: children
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        display: "block",
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$8x",
        left: -4,
        height: height,
        p: "$3",
        pb: "$18",
        position: "absolute",
        bottom: -4,
        right: -4,
        overflow: "hidden",
        "$platform-web": {
            boxShadow: "rgba(0, 0, 0, 0.1) 0px 1px 3px 1px"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            display: "block",
            "$platform-web": {
                overflow: "auto"
            },
            position: "absolute",
            top: 0,
            bottom: "$20",
            left: 0,
            right: 0,
            px: "$2",
            className: (ListBox_module_default()).optionsScroll,
            children: children
        })
    });
};
var ListBox = function(param) {
    var analyticsId = param.analyticsId, ctaDisplayText = param.ctaDisplayText, children = param.children, listBoxButton = param.listBoxButton, listBoxInput = param.listBoxInput, showDropdown = param.showDropdown, onClick = param.onClick;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        width: "100%",
        my: "$3",
        position: "relative",
        maxWidth: "$113",
        zIndex: 500,
        children: [
            showDropdown && children,
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                p: "$1",
                pl: "$3",
                backgroundColor: "$backgroundPrimary",
                borderRadius: "$8x",
                borderColor: "$borderAccentBrand",
                borderWidth: "$0dot5x",
                width: "100%",
                borderStyle: "solid",
                zIndex: 3,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    display: "block",
                    "$platform-web": {
                        display: "grid",
                        gridTemplateColumns: "1fr auto"
                    },
                    alignItems: "center",
                    gap: "$4",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            display: "block",
                            "$platform-web": {
                                gridColumn: "1 / 2",
                                textAlign: "left"
                            },
                            children: listBoxInput ? listBoxInput : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodyMedium",
                                color: "$contentSecondary",
                                "$platform-web": {
                                    letterSpacing: "-1.4px"
                                },
                                pl: "$2",
                                children: ctaDisplayText
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            display: "block",
                            "$platform-web": {
                                gridColumn: "2 / -1"
                            },
                            children: listBoxButton ? listBoxButton : // height to avoid jumpiness with buy/sell toggle
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                onPress: function() {
                                    return onClick && onClick();
                                },
                                "aria-label": "Go to page ".concat(ctaDisplayText),
                                analyticsName: "cosmos-landing-page-contextual-field-".concat(analyticsId),
                                height: "$15",
                                px: "$6",
                                width: "auto",
                                overflow: "hidden",
                                position: "relative",
                                backgroundColor: "$backgroundAccentBrand",
                                borderRadius: "$8x",
                                alignItems: "center",
                                justifyContent: "center",
                                hoverStyle: {
                                    backgroundColor: "$backgroundStateHoverAccentBrand"
                                },
                                focusVisibleStyle: {
                                    backgroundColor: "$backgroundStateHoverAccentBrand"
                                },
                                pressStyle: {
                                    backgroundColor: "$backgroundStateHoverAccentBrand"
                                },
                                className: (ListBox_module_default()).ctaButton,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                    tag: "span",
                                    zIndex: 5,
                                    "$platform-web": {
                                        color: "white"
                                    },
                                    children: showDropdown ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaretDownIcon, {}) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CaretUpIcon, {})
                                })
                            })
                        })
                    ]
                })
            })
        ]
    });
};
ListBox.Options = Options;
var AgentSelectListBox = function(param) {
    var theme = param.theme, linkOptions = param.linkOptions;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var links;
    if ((linkOptions === null || linkOptions === void 0 ? void 0 : linkOptions.length) > 0) {
        links = linkOptions;
    } else {
        links = [
            {
                label: "Sell to Opendoor",
                href: "/w/agents#alp-agents"
            },
            {
                label: "Buy an Opendoor home",
                href: "/w/agents#alp-buy"
            },
            {
                label: "Why agents use Opendoor",
                href: "/w/agents#alp-testimonials"
            }, 
        ];
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListBox, {
        showDropdown: isOpen,
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        analyticsId: "agent-select",
        theme: theme,
        ctaDisplayText: "For Agents",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListBox.Options, {
            theme: theme,
            height: "$62",
            children: links.map(function(option, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                    href: option.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    backgroundColor: "$backgroundPrimary",
                    borderWidth: 0,
                    borderBottomWidth: i === links.length - 1 ? 0 : 1,
                    borderStyle: "solid",
                    borderColor: "$borderSecondary",
                    justifyContent: "flex-start",
                    alignItems: "flex-start",
                    width: "100%",
                    px: "$3",
                    py: "$4",
                    "aria-label": "Go to page ".concat(option.label),
                    analyticsName: "cosmos-agents-sell-to-opendoor-".concat(option.label.toLowerCase().replace(" ", "-")),
                    hoverStyle: {
                        backgroundColor: "$backgroundPrimary"
                    },
                    focusVisibleStyle: {
                        backgroundColor: "$backgroundPrimary"
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$bodyMedium",
                        color: "$contentTertiary",
                        children: option.label
                    })
                }, i);
            })
        })
    });
};
var SupportListBox = function(param) {
    var theme = param.theme;
    var ref = (0,react.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var linkOptions = [
        {
            label: "Email",
            text: "support@opendoor.com",
            href: "mailto:support@opendoor.com"
        },
        {
            label: "Call",
            text: "1-888-352-7075",
            href: "tel:+18883527075"
        },
        {
            label: "Visit",
            text: "Opendoor Help Center",
            href: "https://help.opendoor.com"
        }, 
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListBox, {
        showDropdown: isOpen,
        onClick: function() {
            return setIsOpen(!isOpen);
        },
        analyticsId: "agent-select",
        theme: theme,
        ctaDisplayText: "How can we help?",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ListBox.Options, {
            theme: theme,
            height: "$62",
            children: linkOptions.map(function(option, i) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PressableBox/* PressableBox */.K, {
                    href: option.href,
                    target: "_blank",
                    rel: "noopener noreferrer",
                    backgroundColor: "$backgroundPrimary",
                    borderWidth: 0,
                    borderBottomWidth: i === linkOptions.length - 1 ? 0 : 1,
                    borderStyle: "solid",
                    borderColor: "$borderSecondary",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "baseline",
                    width: "100%",
                    px: "$3",
                    py: "$4",
                    "aria-label": "Go to page ".concat(option.label),
                    analyticsName: "cosmos-agents-sell-to-opendoor-".concat(option.label.toLowerCase().replace(" ", "-")),
                    hoverStyle: {
                        backgroundColor: "$backgroundPrimary"
                    },
                    focusVisibleStyle: {
                        backgroundColor: "$backgroundPrimary"
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$labelMedium",
                            color: "$contentTertiary",
                            children: [
                                option.label,
                                ":"
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentTertiary",
                            children: [
                                " ",
                                option.text
                            ]
                        })
                    ]
                }, i);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ContextualField.tsx




var ContextualField = function(param) {
    var contextFields = param.contextFields, theme = param.theme, inputLocation = param.inputLocation;
    var fields = contextFields.fields;
    // set the page set for address entry on home guide alt landing page
    var pageSetPath = contextFields.fields.analyticsId === "homeguide-ae" ? "?seller_flow=home_guide_nav_entry" : undefined;
    // build agent links array
    var agentLinkOptions = [];
    if (contextFields.fields.agentLinkOneText && contextFields.fields.agentLinkOneUrl) {
        agentLinkOptions.push({
            label: contextFields.fields.agentLinkOneText,
            href: contextFields.fields.agentLinkOneUrl
        });
    }
    if (contextFields.fields.agentLinkTwoText && contextFields.fields.agentLinkTwoUrl) {
        agentLinkOptions.push({
            label: contextFields.fields.agentLinkTwoText,
            href: contextFields.fields.agentLinkTwoUrl
        });
    }
    if (contextFields.fields.agentLinkThreeText && contextFields.fields.agentLinkThreeUrl) {
        agentLinkOptions.push({
            label: contextFields.fields.agentLinkThreeText,
            href: contextFields.fields.agentLinkThreeUrl
        });
    }
    switch(fields.contextualField){
        case "address-search":
            var _channel, _channel1;
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "desktop-address-search",
                        zIndex: 2,
                        $largerThanSM: {
                            width: 512
                        },
                        $smallerThanMD: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                            hideLabel: true,
                            inputLocation: inputLocation,
                            analyticsPrefix: contextFields.fields.analyticsId || "",
                            trackingTaxonomy: "new_homepage",
                            placeholder: fields.addressInputPlaceholderText || "Enter your home address",
                            pageSetPath: pageSetPath,
                            trackingKeywords: contextFields.fields.trackingKeyword,
                            channel: (_channel = fields.channel) !== null && _channel !== void 0 ? _channel : "DEFAULT"
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "mobile-address-search",
                        $largerThanSM: {
                            display: "none"
                        },
                        width: "100%",
                        zIndex: 2,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, {
                            hideLabel: true,
                            inputLocation: inputLocation,
                            analyticsPrefix: contextFields.fields.analyticsId || "",
                            trackingTaxonomy: "new_homepage",
                            placeholder: fields.addressInputPlaceholderTextSmall || "Enter your home address",
                            pageSetPath: pageSetPath,
                            trackingKeywords: contextFields.fields.trackingKeyword,
                            channel: (_channel1 = fields.channel) !== null && _channel1 !== void 0 ? _channel1 : "DEFAULT"
                        })
                    })
                ]
            });
        case "agents":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AgentSelectListBox, {
                theme: theme,
                linkOptions: agentLinkOptions
            });
        case "support":
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SupportListBox, {
                theme: theme
            });
        default:
            return null;
    }
};
/* harmony default export */ var landing_pages_v2_ContextualField = (ContextualField);


/***/ }),

/***/ 38613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78049);
/* harmony import */ var _contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(90754);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34984);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24439);
/* harmony import */ var components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91749);
/* harmony import */ var components_shared_Divider__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(49957);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(62071);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _cms_renderer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(51803);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97828);









var isDocument = function(value) {
    return typeof value === "object" && value !== null && value.nodeType === "document";
};
var buildFaqSchema = function(faQs) {
    return {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: faQs.filter(function(faq) {
            return Boolean(faq === null || faq === void 0 ? void 0 : faq.fields);
        }).map(function(faq) {
            var _fields = faq.fields, title = _fields.title, body = _fields.body;
            return {
                "@type": "Question",
                name: title !== null && title !== void 0 ? title : "",
                acceptedAnswer: {
                    "@type": "Answer",
                    text: isDocument(body) ? (0,_contentful_rich_text_plain_text_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToPlainTextString */ .a)(body) : ""
                }
            };
        })
    };
};
var RenderFAQsDisplay = function(entry, _loaderProps, context) {
    var ref;
    var fields = entry.fields;
    var faqSchema = (fields === null || fields === void 0 ? void 0 : fields.faQs) && fields.faQs.length > 0 ? buildFaqSchema(fields.faQs) : null;
    var ref1;
    var entryLookup = (ref1 = context === null || context === void 0 ? void 0 : context.entryLookup) !== null && ref1 !== void 0 ? ref1 : {
        block: {},
        inline: {}
    };
    var viewAllLink = (fields === null || fields === void 0 ? void 0 : fields.viewMoreLinkUrl) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Link */ .r, {
        "aria-label": "View more FAQs",
        analyticsName: "cosmos-landing-page-faqs-display-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        href: fields === null || fields === void 0 ? void 0 : fields.viewMoreLinkUrl,
        children: [
            "View all FAQ",
            " ",
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                size: 16,
                style: {
                    color: "#0D76D6",
                    verticalAlign: "middle"
                }
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
        children: [
            faqSchema && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("script", {
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(faqSchema).replace(/</g, "\\u003c")
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                analyticsName: "cosmos-landing-page-faqs-display-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                trackImpression: true,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    backgroundColor: "$backgroundSecondary",
                    py: "$32x",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                        "$platform-web": {
                            gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_4__/* .gridStyles.colSpan12 */ .m.colSpan12
                        },
                        width: "100%",
                        flexDirection: "column",
                        $largerThanSM: {
                            flexDirection: "row",
                            pr: "$10x"
                        },
                        $largerThanMD: {
                            pr: "$4x"
                        },
                        alignContent: "center",
                        pr: "$4x",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                            width: "100%",
                            gap: "$28x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X, {
                                    width: "100%",
                                    justifyContent: "space-between",
                                    alignItems: "flex-end",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .TitleWithAccent */ .aI, {
                                            title: fields === null || fields === void 0 ? void 0 : fields.title,
                                            maxWidth: "unset",
                                            mb: "$0x"
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                            display: "none",
                                            $largerThanSM: {
                                                display: "flex"
                                            },
                                            pb: "$4x",
                                            children: viewAllLink
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                        children: fields === null || fields === void 0 ? void 0 : (ref = fields.faQs) === null || ref === void 0 ? void 0 : ref.map(function(faq, idx) {
                                            var ref, ref1;
                                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                                        my: "$20x",
                                                        $largerThanSM: {
                                                            my: "$10x"
                                                        },
                                                        $largerThanMD: {
                                                            my: "$24x"
                                                        },
                                                        display: idx === 0 ? "none" : "flex",
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_shared_Divider__WEBPACK_IMPORTED_MODULE_11__/* .Divider */ .i, {})
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                                                        gap: "$10x",
                                                        $largerThanSM: {
                                                            flexDirection: "row",
                                                            gap: "15%",
                                                            alignItems: "flex-start"
                                                        },
                                                        $largerThanLG: {
                                                            pr: "$44x"
                                                        },
                                                        width: "100%",
                                                        flexDirection: "column",
                                                        children: [
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                                                width: "100%",
                                                                $largerThanSM: {
                                                                    width: "35%"
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_1__/* .Subhead */ .vF, {
                                                                    $largerThanMD: {
                                                                        fontSize: 24
                                                                    },
                                                                    children: faq === null || faq === void 0 ? void 0 : (ref = faq.fields) === null || ref === void 0 ? void 0 : ref.title
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                                                width: "100%",
                                                                $largerThanSM: {
                                                                    width: "55%",
                                                                    mt: -20
                                                                },
                                                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_cms_renderer__WEBPACK_IMPORTED_MODULE_3__/* ["default"].Component */ .Z.Component, {
                                                                    body: faq === null || faq === void 0 ? void 0 : (ref1 = faq.fields) === null || ref1 === void 0 ? void 0 : ref1.body,
                                                                    idToLoaderData: {},
                                                                    entryLookup: entryLookup
                                                                })
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Col */ .J, {
                                    $largerThanSM: {
                                        display: "none"
                                    },
                                    children: viewAllLink
                                })
                            ]
                        })
                    })
                })
            })
        ]
    });
};
var FAQsDisplay = {
    render: RenderFAQsDisplay
};
/* harmony default export */ __webpack_exports__["Z"] = (FAQsDisplay);


/***/ }),

/***/ 99782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22901);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69886);



var ContactButton = function(param) {
    var label = param.label, href = param.href, analyticsName = param.analyticsName;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Link */ .r, {
        href: href,
        analyticsName: analyticsName,
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "$backgroundPrimary",
        borderRadius: "$4x",
        paddingHorizontal: "$8x",
        minHeight: 40,
        minWidth: 176,
        textDecorationLine: "none",
        $smallerThanMD: {
            width: "100%",
            maxWidth: "$240x"
        },
        $largerThanSM: {
            minHeight: 50,
            minWidth: 220,
            borderRadius: "$6x"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
            tag: "span",
            typography: "$bodySmall",
            fontWeight: "$medium",
            color: "$contentPrimary",
            $largerThanSM: {
                typography: "$bodyLarge"
            },
            children: label
        })
    });
};
var DEFAULT_HEADING = "Questions? We’re here.";
var DEFAULT_SUBTITLE = "Tell us about your situation. We’ll help you figure out the best path forward.";
var DEFAULT_BUTTONS = [
    {
        label: "Visit our help center",
        href: "https://help.opendoor.com/",
        analyticsName: "cosmos-fc-contact-us-help-center"
    }, 
];
var RenderFCContactUs = function(entry) {
    var ref;
    var fields = entry.fields;
    var heading = (fields === null || fields === void 0 ? void 0 : fields.heading) || DEFAULT_HEADING;
    var subtitle = (fields === null || fields === void 0 ? void 0 : fields.subtitle) || DEFAULT_SUBTITLE;
    var buttons = (fields === null || fields === void 0 ? void 0 : (ref = fields.contactButtons) === null || ref === void 0 ? void 0 : ref.length) ? fields.contactButtons.map(function(param) {
        var _fields = param.fields, text = _fields.text, href = _fields.href, analyticsId = _fields.analyticsId;
        return {
            label: text,
            href: href,
            analyticsName: "cosmos-fc-contact-us-".concat(analyticsId)
        };
    }) : DEFAULT_BUTTONS;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__/* .FCContentContainerWrapper */ .W, {
        style: {
            backgroundColor: "#ECE9E7"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__/* .FCContentContainer */ .$, {
            py: "$40x",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                alignItems: "center",
                justifyContent: "center",
                $largerThanSM: {
                    gap: "$24x"
                },
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                        $largerThanSM: {
                            gap: "$12x"
                        },
                        gap: "$4x",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                                tag: "h2",
                                typography: "$labelXlarge",
                                textAlign: "center",
                                color: "$contentPrimary",
                                $largerThanSM: {
                                    typography: "$headerSmall"
                                },
                                children: heading
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                                tag: "p",
                                typography: "$bodySmall",
                                color: "$contentPrimary",
                                textAlign: "center",
                                maxWidth: 663,
                                $largerThanSM: {
                                    typography: "$bodyXlarge"
                                },
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                        flexDirection: "column",
                        alignItems: "center",
                        gap: "$6x",
                        $largerThanSM: {
                            flexDirection: "row",
                            flexWrap: "wrap",
                            justifyContent: "center",
                            gap: "$24x"
                        },
                        width: "100%",
                        children: buttons.map(function(button) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(ContactButton, {
                                label: button.label,
                                href: button.href,
                                analyticsName: button.analyticsName
                            }, button.analyticsName);
                        })
                    })
                ]
            })
        })
    });
};
var FCContactUs = {
    render: RenderFCContactUs
};
/* harmony default export */ __webpack_exports__["Z"] = (FCContactUs);


/***/ }),

/***/ 95534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78049);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42250);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89631);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(64978);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56865);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(77462);
/* harmony import */ var components_shared_NewSellerFlowAddressInput__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37987);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69886);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23366);







var HeroBackgroundImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("img", {
    target: "e1x770a0"
})("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:center top;@media (min-width:768px){object-position:center center;}");
var StyledAddressBox = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
    target: "e1x770a1"
})("div > div{border-color:", (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__.getToken)("$borderAccentBrand"), " !important;}");
// override the button styles for the address entry
var StyledActionButton = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
    target: "e1x770a2"
})("height:60px !important;/* make the button actually line up properly — use position instead of\n     transform so press animations don’t clobber the offset */\n  position:relative;top:-17.5px;left:14px;");
var RenderFCHero = function(entry) {
    var fields = entry.fields;
    var mobileBackgroundUrl = fields.mobileHeroImageUrl;
    var desktopBackgroundUrl = fields.desktopHeroImageUrl;
    var fallbackBackgroundUrl = mobileBackgroundUrl || desktopBackgroundUrl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .Global */ .xB, {
                styles: [
                    (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("html{scroll-behavior:smooth;}")
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_8__/* .FCContentContainerWrapper */ .W, {
                position: "relative",
                height: "70vh",
                zIndex: 2,
                $largerThanSM: {
                    maxHeight: 600
                },
                children: [
                    fallbackBackgroundUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)("picture", {
                        children: [
                            desktopBackgroundUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("source", {
                                media: "(min-width: 768px)",
                                srcSet: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .resizeImageUrl */ .rX)(desktopBackgroundUrl, 2800)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(HeroBackgroundImage, {
                                src: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .resizeImageUrl */ .rX)(fallbackBackgroundUrl, 1536),
                                alt: "",
                                loading: "eager"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_8__/* .FCContentContainer */ .$, {
                        position: "relative",
                        zIndex: 1,
                        justifyContent: "flex-end",
                        paddingVertical: "$15x",
                        $largerThanSM: {
                            paddingVertical: "$16x",
                            justifyContent: "center"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                            backgroundColor: "$backgroundPrimary",
                            borderRadius: "$6x",
                            padding: "$12x",
                            position: "relative",
                            zIndex: 10,
                            width: "100%",
                            $largerThanSM: {
                                width: 554,
                                alignSelf: "flex-start",
                                padding: "$24x",
                                transformOrigin: "left center",
                                gap: "$24x"
                            },
                            gap: "$12x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                                    gap: "$8x",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                            tag: "h1",
                                            typography: "$headerMedium",
                                            color: "$contentPrimary",
                                            $largerThanSM: {
                                                typography: "$displaySmall"
                                            },
                                            children: fields.title
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$bodyMedium",
                                            color: "$contentPrimary",
                                            maxWidth: 530,
                                            $largerThanSM: {
                                                typography: "$bodyXlarge"
                                            },
                                            children: fields.subtitle
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledAddressBox, {
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_shared_NewSellerFlowAddressInput__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        placeholder: fields.addressPlaceholderText,
                                        hideLabel: true,
                                        inputLocation: "hero-cta",
                                        trackingTaxonomy: "new_homepage",
                                        actionButton: function(onPress, isLoading) {
                                            // Render both the desktop CTA button and the mobile suffix
                                            // icon, toggled by CSS, so SSR and hydration produce the same
                                            // DOM regardless of viewport.
                                            /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                                                children: [
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                                                        display: "none",
                                                        $largerThanSM: {
                                                            display: "flex"
                                                        },
                                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(StyledActionButton, {
                                                            variant: "primary",
                                                            size: "medium",
                                                            label: isLoading ? "Loading" : fields.ctaButtonText,
                                                            analyticsName: "cosmos-fc-hero-cta",
                                                            disabled: isLoading,
                                                            onPress: function(e) {
                                                                var ref;
                                                                e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
                                                                onPress === null || onPress === void 0 ? void 0 : onPress();
                                                            }
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                                                        $largerThanSM: {
                                                            display: "none"
                                                        },
                                                        children: isLoading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                                                            position: "relative",
                                                            px: "$4",
                                                            display: "block",
                                                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .ButtonLoadingAnimation */ .V, {
                                                                variant: "secondary",
                                                                size: "xsmall"
                                                            })
                                                        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                                                    })
                                                ]
                                            });
                                        }
                                    })
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
};
var FCHero = {
    render: RenderFCHero
};
/* harmony default export */ __webpack_exports__["Z"] = (FCHero);


/***/ }),

/***/ 49581:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56865);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69886);
/* harmony import */ var _shared_Marker__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24241);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23366);







var MAP_BACKGROUND_IMAGE_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2026-02-1770659423528-20363.png?service=cosmos";
var MAP_MARKER_IMAGE_URLS = {
    leftTop: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416264-57298.png?service=cosmos",
    rightTop: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416269-85419.png?preset=square-2048",
    leftMiddle: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416260-76025.png?preset=square-2048",
    leftBottom: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416240-88834.png?service=cosmos",
    rightBottom: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416253-95450.png?preset=square-2048"
};
var PulsingMarker = function(_param) /*#__PURE__*/ {
    var $largerThanSM = _param.$largerThanSM, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "$largerThanSM"
    ]);
    return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        height: "$40x",
        width: "$101x",
        $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            height: "$51x",
            width: "$129x"
        }, $largerThanSM),
        className: _shared_Marker__WEBPACK_IMPORTED_MODULE_0__/* .MarkerPulseClassName */ .XM
    }, restProps));
};
var RenderFCMap = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__/* .FCContentContainerWrapper */ .W, {
        position: "relative",
        width: "100%",
        overflow: "hidden",
        style: {
            backgroundColor: "#051a44",
            backgroundImage: "url(".concat((0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapBackgroundImageUrl */ .kp)(MAP_BACKGROUND_IMAGE_URL), ")"),
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat"
        },
        minHeight: "$382x",
        $largerThanSM: {
            minHeight: "$616x"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(PulsingMarker, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftTop),
                left: "10%",
                top: "17%",
                $largerThanXS: {
                    top: "12%"
                },
                $largerThanSM: {
                    top: "12%"
                },
                animationDelay: "2s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(PulsingMarker, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.rightTop),
                right: "7%",
                top: "4%",
                $largerThanSM: {
                    right: "30%",
                    top: "7%"
                },
                animationDelay: "0.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(PulsingMarker, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftMiddle),
                display: "none",
                $largerThanSM: {
                    display: "flex"
                },
                left: "8%",
                top: "40%",
                animationDelay: "0.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(PulsingMarker, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftBottom),
                left: "15%",
                top: "80%",
                $largerThanSM: {
                    top: "85%"
                }
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(PulsingMarker, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.rightBottom),
                right: "4%",
                top: "90%",
                $largerThanXS: {
                    top: "85%"
                },
                $largerThanSM: {
                    right: "15%",
                    top: "60%"
                },
                animationDelay: "2.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__/* .FCContentContainer */ .$, {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                    justifyContent: "center",
                    alignItems: "center",
                    flex: 1,
                    gap: "$12x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                            gap: "$12x",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    tag: "h2",
                                    typography: "$headerMedium",
                                    textAlign: "center",
                                    color: "$contentInversePrimary",
                                    $largerThanSM: {
                                        typography: "$displaySmall",
                                        fontSize: 60
                                    },
                                    children: fields.title
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$labelXlarge",
                                    fontWeight: "$medium",
                                    textAlign: "center",
                                    color: "$contentInversePrimary",
                                    marginTop: "$4x",
                                    maxWidth: "$616x",
                                    children: fields.subtitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Button */ .z, {
                            variant: "primary",
                            size: "small",
                            label: fields.ctaButtonText,
                            analyticsName: "cosmos-fc-map-cta",
                            href: fields.ctaUrl,
                            marginTop: "$14x",
                            $largerThanSM: {
                                size: "large"
                            }
                        })
                    ]
                })
            })
        ]
    });
};
var FCMap = {
    render: RenderFCMap
};
/* harmony default export */ __webpack_exports__["Z"] = (FCMap);


/***/ }),

/***/ 81054:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var _emotion_styled__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89631);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69886);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23366);





var BackgroundImage = /*#__PURE__*/ (0,_emotion_styled__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("img", {
    target: "eiqec0u0"
})("position:absolute;inset:0;width:100%;height:100%;object-fit:cover;object-position:right center;@media (max-width:420px){object-position:65% 30%;}");
// Neutral warm-grey behind the absolutely-positioned photo, so the section
// doesn't flash from page-white to image while the photo decodes.
var PHOTO_FALLBACK_COLOR = "#3F3832";
var RenderFCMissionStatement = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__/* .FCContentContainerWrapper */ .W, {
        position: "relative",
        overflow: "hidden",
        style: {
            backgroundColor: PHOTO_FALLBACK_COLOR
        },
        $largerThanSM: {
            minHeight: 600
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)("picture", {
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("source", {
                        media: "(min-width: 768px)",
                        srcSet: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeImageUrl */ .rX)(fields.imageUrl, 1600)
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(BackgroundImage, {
                        src: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeImageUrl */ .rX)(fields.imageUrl, 1536),
                        alt: "",
                        loading: "lazy",
                        decoding: "async"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_3__/* .FCContentContainer */ .$, {
                position: "relative",
                zIndex: 1,
                alignItems: "center",
                justifyContent: "center",
                pb: "$12x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        height: "50vw",
                        $largerThanSM: {
                            display: "none"
                        }
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                        backgroundColor: "$backgroundPrimary",
                        paddingHorizontal: "$10x",
                        px: "$12x",
                        py: "$24x",
                        $largerThanSM: {
                            px: "$30x",
                            py: "$30x"
                        },
                        alignItems: "center",
                        gap: "$5x",
                        maxWidth: 720,
                        borderRadius: "$6x",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                tag: "p",
                                $largerThanSM: {
                                    typography: "$subheaderMedium"
                                },
                                typography: "$labelLarge",
                                textAlign: "center",
                                style: {
                                    color: "#0040E6"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                tag: "p",
                                typography: "$labelSmall",
                                $largerThanSM: {
                                    typography: "$labelLarge"
                                },
                                textAlign: "center",
                                children: fields.body
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FCMissionStatement = {
    render: RenderFCMissionStatement
};
/* harmony default export */ __webpack_exports__["Z"] = (FCMissionStatement);


/***/ }),

/***/ 72034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56865);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10246);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(69886);




var ProductCard = function(param) {
    var tag = param.tag, title = param.title, subtitle = param.subtitle, bullets = param.bullets;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
        borderRadius: "$6x",
        overflow: "hidden",
        style: {
            backgroundColor: "#ece9e7"
        },
        flex: 1,
        $largerThanSM: {
            flexBasis: 0
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
                style: {
                    backgroundColor: "#051a44"
                },
                px: "$12x",
                $largerThanMD: {
                    px: "$16x"
                },
                py: "$10x",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    tag: "span",
                    typography: "$labelSmall",
                    textTransform: "uppercase",
                    style: {
                        color: "#FFF"
                    },
                    children: tag
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
                padding: "$12x",
                $largerThanMD: {
                    padding: "$24x"
                },
                gap: "$12x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
                        gap: "$4x",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "h3",
                                typography: "$subheaderMedium",
                                $largerThanMD: {
                                    typography: "$headerMedium"
                                },
                                color: "$contentAccentBrand",
                                children: title
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "p",
                                typography: "$labelSmall",
                                $largerThanMD: {
                                    typography: "$labelXlarge"
                                },
                                color: "$contentPrimary",
                                children: subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
                        gap: "$6x",
                        children: bullets.map(function(bullet, i) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
                                alignItems: "center",
                                gap: "$4x",
                                $largerThanMD: {
                                    gap: "$12x"
                                },
                                justifyContent: "flex-start",
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                                        flexShrink: 0,
                                        width: 24,
                                        height: 24,
                                        $largerThanMD: {
                                            width: 32,
                                            height: 32
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                            size: 32,
                                            color: "#0040e6",
                                            style: {
                                                width: "100%",
                                                height: "100%"
                                            }
                                        })
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                        tag: "span",
                                        typography: "$bodyMedium",
                                        color: "$contentPrimary",
                                        $largerThanMD: {
                                            typography: "$bodyXlarge"
                                        },
                                        children: bullet
                                    })
                                ]
                            }, i);
                        })
                    })
                ]
            })
        ]
    });
};
var RenderFCProductOptions = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_6__/* .FCContentContainerWrapper */ .W, {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_6__/* .FCContentContainer */ .$, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
                alignItems: "center",
                justifyContent: "center",
                py: "$40x",
                gap: "$12x",
                $largerThanSM: {
                    gap: "$24x"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                        tag: "h2",
                        $largerThanMD: {
                            typography: "$displayXsmall"
                        },
                        typography: "$headerMedium",
                        textAlign: "center",
                        color: "$contentPrimary",
                        maxWidth: 700,
                        children: fields.title
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        flexDirection: "column",
                        width: "100%",
                        gap: "$5x",
                        $largerThanSM: {
                            flexDirection: "row"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(ProductCard, {
                                tag: fields.card1Tag,
                                title: fields.card1Title,
                                subtitle: fields.card1Subtitle,
                                bullets: [
                                    fields.card1Bullet1,
                                    fields.card1Bullet2,
                                    fields.card1Bullet3
                                ]
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(ProductCard, {
                                tag: fields.card2Tag,
                                title: fields.card2Title,
                                subtitle: fields.card2Subtitle,
                                bullets: [
                                    fields.card2Bullet1,
                                    fields.card2Bullet2,
                                    fields.card2Bullet3
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Col */ .J, {
                        gap: "$6x",
                        $largerThanSM: {
                            gap: "$12x"
                        },
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "p",
                                typography: "$labelMedium",
                                $largerThanSM: {
                                    typography: "$subheaderXsmall"
                                },
                                textAlign: "center",
                                children: fields.footerText
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                                variant: "primary",
                                size: "medium",
                                label: fields.ctaButtonText,
                                analyticsName: "cosmos-fc-product-options-cta",
                                href: fields.ctaUrl
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var FCProductOptions = {
    render: RenderFCProductOptions
};
/* harmony default export */ __webpack_exports__["Z"] = (FCProductOptions);


/***/ }),

/***/ 96889:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54999);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(34984);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(7702);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23366);





var inheritStyle = {
    fontSize: "inherit !important",
    fontWeight: "inherit !important",
    lineHeight: "inherit !important",
    letterSpacing: "inherit !important"
};
var renderHighlightedTitle = function(title, highlightedText) {
    if (!highlightedText || !(title === null || title === void 0 ? void 0 : title.includes(highlightedText))) return title;
    return title.split(highlightedText).map(function(part, i) {
        return i === 0 ? part : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
            tag: "span",
            typography: "$headerSmall",
            color: "$contentPrimary",
            css: inheritStyle,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    tag: "span",
                    typography: "$headerSmall",
                    color: "$contentAccentBrand",
                    css: inheritStyle,
                    children: highlightedText
                }),
                part
            ]
        }, i);
    });
};
var TestimonialCard = function(param) {
    var entry = param.entry;
    var ref, ref1, ref2;
    var fields = entry.fields;
    var imageUrl = (ref = fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url;
    var resizedImageUrl = imageUrl ? (0,_shared_utils__WEBPACK_IMPORTED_MODULE_1__/* .resizeTestimonialCardImageUrl */ .$1)(imageUrl) : null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
        width: 350,
        minWidth: 350,
        minHeight: 495,
        borderRadius: "$10x",
        overflow: "hidden",
        backgroundColor: "$backgroundPrimary",
        flex: 1,
        padding: "$4x",
        pb: "$16x",
        children: [
            resizedImageUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                paddingHorizontal: "$4x",
                paddingTop: "$4x",
                paddingBottom: 12,
                overflow: "hidden",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Image */ .E, {
                    source: {
                        uri: resizedImageUrl
                    },
                    alt: fields.name,
                    width: "100%",
                    height: 200,
                    style: {
                        borderRadius: 10
                    },
                    "$platform-web": {
                        objectFit: "cover",
                        loading: "lazy"
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                padding: "$6x",
                flex: 1,
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "p",
                                typography: "$labelSmall",
                                style: {
                                    fontWeight: 600,
                                    fontSize: 16
                                },
                                color: "$contentPrimary",
                                textAlign: "center",
                                children: fields.name
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "p",
                                typography: "$bodySmall",
                                textAlign: "center",
                                style: {
                                    fontSize: 15,
                                    fontWeight: 400,
                                    lineHeight: "110%",
                                    letterSpacing: "-0.15px",
                                    color: "rgba(63, 56, 50, 0.75)"
                                },
                                children: fields.locationContext
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                        tag: "p",
                        typography: "$bodyLarge",
                        color: "$contentPrimary",
                        marginTop: "$4x",
                        marginHorizontal: 12,
                        flex: 1,
                        textAlign: "center",
                        style: {
                            fontSize: 18,
                            fontWeight: 400,
                            lineHeight: "150%",
                            letterSpacing: "-0.18px"
                        },
                        children: [
                            "”",
                            fields.quote,
                            "”"
                        ]
                    }),
                    fields.readMoreUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                        alignItems: "center",
                        marginTop: "$4x",
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("a", {
                            href: fields.readMoreUrl,
                            style: {
                                textDecoration: "none"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentAccentBrand",
                                textTransform: "uppercase",
                                style: {
                                    fontSize: 12,
                                    fontWeight: 700,
                                    lineHeight: "normal",
                                    letterSpacing: "1.2px"
                                },
                                children: "read more"
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var ArrowButton = function(param) {
    var direction = param.direction, onClick = param.onClick;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .PressableBox */ .K, {
        p: "$5x",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        style: {
            backgroundColor: "#0040e6"
        },
        borderRadius: 50,
        "aria-label": direction === "left" ? "Previous testimonial" : "Next testimonial",
        onPress: onClick,
        analyticsName: "testimonials",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
            size: 40,
            color: "white",
            style: {
                transform: direction === "left" ? "rotate(180deg)" : undefined
            }
        })
    });
};
var RenderFCTestimonialCarousel = function(entry) {
    var ref;
    var fields = entry.fields;
    var scrollRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var scroll = function(direction) {
        if (!scrollRef.current) return;
        var scrollAmount = direction === "left" ? -370 : 370;
        scrollRef.current.scrollBy({
            left: scrollAmount,
            behavior: "smooth"
        });
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
        width: "100%",
        style: {
            backgroundColor: "#ece9e7"
        },
        pt: "$40x",
        pb: "$50x",
        gap: "$40x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                justifyContent: "center",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    tag: "h2",
                    typography: "$displayXsmall",
                    textAlign: "center",
                    color: "$contentPrimary",
                    maxWidth: 923,
                    $smallerThanLG: {
                        typography: "$headerLarge",
                        px: "$30x"
                    },
                    children: renderHighlightedTitle(fields.title, fields.highlightedText)
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                gap: "$30x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                        ref: scrollRef,
                        gap: 20,
                        css: {
                            "&::-webkit-scrollbar": {
                                display: "none"
                            },
                            paddingLeft: "40px !important",
                            paddingRight: "40px !important",
                            scrollPaddingLeft: 40,
                            "@media (min-width: 640px)": {
                                paddingLeft: "80px !important",
                                paddingRight: "80px !important",
                                scrollPaddingLeft: 80
                            },
                            "@media (min-width: 1024px)": {
                                paddingLeft: "128px !important",
                                paddingRight: "128px !important",
                                scrollPaddingLeft: 128
                            }
                        },
                        style: {
                            overflowX: "auto",
                            scrollSnapType: "x mandatory",
                            scrollbarWidth: "none"
                        },
                        children: (ref = fields.cards) === null || ref === void 0 ? void 0 : ref.map(function(card) {
                            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                                style: {
                                    scrollSnapAlign: "start"
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(TestimonialCard, {
                                    entry: card
                                })
                            }, card.sys.id);
                        })
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Row */ .X, {
                        maxWidth: 1440,
                        width: "100%",
                        marginHorizontal: "auto",
                        justifyContent: "center",
                        gap: "$10x",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ArrowButton, {
                                direction: "left",
                                onClick: function() {
                                    return scroll("left");
                                }
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ArrowButton, {
                                direction: "right",
                                onClick: function() {
                                    return scroll("right");
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
var FCTestimonialCarousel = {
    render: RenderFCTestimonialCarousel
};
/* harmony default export */ __webpack_exports__["Z"] = (FCTestimonialCarousel);


/***/ }),

/***/ 23208:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55128);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(69886);



var StepCircle = function(param) {
    var number = param.number;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        width: 120,
        height: 120,
        borderRadius: "$full",
        style: {
            borderColor: "rgba(255,255,255,1)",
            borderWidth: 4
        },
        alignItems: "center",
        justifyContent: "center",
        $largerThanMD: {
            width: 170,
            height: 170
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
            tag: "span",
            typography: "$displaySmall",
            fontWeight: "$regular",
            color: "$contentInversePrimary",
            style: {
                lineHeight: "1.2",
                fontWeight: 300
            },
            css: {
                fontSize: "64px !important",
                "@media (min-width: 1201px)": {
                    fontSize: "105px !important"
                }
            },
            children: number
        })
    });
};
var StepCard = function(param) {
    var stepNumber = param.stepNumber, title = param.title, description = param.description;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
        alignItems: "center",
        gap: "$12x",
        width: "100%",
        maxWidth: 326,
        flexShrink: 1,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(StepCircle, {
                number: stepNumber
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
                gap: "$4x",
                $largerThanMD: {
                    gap: "$12x"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                        tag: "h3",
                        $largerThanMD: {
                            typography: "$subheaderXsmall"
                        },
                        typography: "$labelLarge",
                        color: "$contentInversePrimary",
                        textAlign: "center",
                        children: title
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                        tag: "p",
                        typography: "$bodySmall",
                        $largerThanMD: {
                            typography: "$bodyLarge"
                        },
                        color: "$contentInversePrimary",
                        textAlign: "center",
                        children: description
                    })
                ]
            })
        ]
    });
};
var RenderFCThreeSteps = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_4__/* .FCContentContainerWrapper */ .W, {
        style: {
            backgroundColor: "#051a44"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_4__/* .FCContentContainer */ .$, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
                alignItems: "center",
                justifyContent: "center",
                py: "$24x",
                gap: "$30x",
                $largerThanMD: {
                    paddingVertical: "$40x"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
                        gap: "$6x",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                                tag: "h2",
                                typography: "$headerMedium",
                                textAlign: "center",
                                color: "$contentInversePrimary",
                                $largerThanMD: {
                                    typography: "$displayXsmall"
                                },
                                children: fields.title
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Text */ .x, {
                                tag: "p",
                                typography: "$bodyMedium",
                                textAlign: "center",
                                color: "$contentInversePrimary",
                                maxWidth: 630,
                                $largerThanMD: {
                                    typography: "$bodyXlarge"
                                },
                                children: fields.subtitle
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
                        flexDirection: "column",
                        width: "100%",
                        flex: 1,
                        $smallerThanLG: {
                            gap: "$24x"
                        },
                        alignItems: "center",
                        justifyContent: "center",
                        $largerThanSM: {
                            flexDirection: "row",
                            justifyContent: "space-evenly"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(StepCard, {
                                stepNumber: 1,
                                title: fields.step1Title,
                                description: fields.step1Description
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(StepCard, {
                                stepNumber: 2,
                                title: fields.step2Title,
                                description: fields.step2Description
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(StepCard, {
                                stepNumber: 3,
                                title: fields.step3Title,
                                description: fields.step3Description
                            })
                        ]
                    })
                ]
            })
        })
    });
};
var FCThreeSteps = {
    render: RenderFCThreeSteps
};
/* harmony default export */ __webpack_exports__["Z"] = (FCThreeSteps);


/***/ }),

/***/ 43649:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(46320);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1492);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18063);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39877);
/* harmony import */ var _shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69886);




var ReviewStars = function(param) {
    var rating = param.rating;
    var rounded = Math.round(rating * 2) / 2;
    var fullStars = Math.floor(rounded);
    var hasHalf = rounded % 1 !== 0;
    var emptyStars = 5 - fullStars - (hasHalf ? 1 : 0);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X, {
        gap: "$2x",
        alignItems: "center",
        children: [
            Array.from({
                length: fullStars
            }, function(_, i) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                    size: 24,
                    color: "#051a44"
                }, "full-".concat(i));
            }),
            hasHalf && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                size: 24,
                color: "#051a44"
            }, "half"),
            Array.from({
                length: emptyStars
            }, function(_, i) {
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: 24,
                    color: "#051a44"
                }, "empty-".concat(i));
            })
        ]
    });
};
var RenderFCTrustBanner = function(entry) {
    var ref, ref1, ref2, ref3;
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__/* .FCContentContainerWrapper */ .W, {
        alignItems: "center",
        style: {
            backgroundColor: "#ECE9E7"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_shared_FCLayout__WEBPACK_IMPORTED_MODULE_5__/* .FCContentContainer */ .$, {
            alignItems: "center",
            width: "100%",
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                    py: "$12x",
                    alignItems: "center",
                    gap: fields.reviewStars > 0 ? "$12x" : "$6x",
                    width: "100%",
                    $largerThanSM: {
                        display: "none"
                    },
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                            gap: "$6x",
                            width: "100%",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            textAlign: "center",
                                            children: fields.textSection1Headline
                                        }),
                                        fields.textSection1Description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            textAlign: "center",
                                            children: fields.textSection1Description
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                                    alignItems: "center",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            textAlign: "center",
                                            children: fields.textSection2Headline
                                        }),
                                        fields.textSection2Description && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$labelSmall",
                                            textAlign: "center",
                                            children: fields.textSection2Description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Col */ .J, {
                            gap: "$2x",
                            alignItems: "center",
                            children: [
                                fields.reviewStars > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(ReviewStars, {
                                    rating: fields.reviewStars
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .r, {
                                    href: fields.linkUrl,
                                    target: ((ref = fields.linkUrl) === null || ref === void 0 ? void 0 : ref.startsWith("#")) ? undefined : "_blank",
                                    rel: ((ref1 = fields.linkUrl) === null || ref1 === void 0 ? void 0 : ref1.startsWith("#")) ? undefined : "noopener noreferrer",
                                    analyticsName: "opendoor-reviews",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        tag: "p",
                                        typography: fields.reviewStars > 0 ? "$labelXsmall" : "$labelSmall",
                                        textDecorationLine: "underline",
                                        children: fields.linkText
                                    })
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Row */ .X, {
                    alignItems: "center",
                    gap: "$8x",
                    py: "$14x",
                    display: "none",
                    $largerThanSM: {
                        display: "flex"
                    },
                    children: [
                        fields.reviewStars > 0 && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(ReviewStars, {
                            rating: fields.reviewStars
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                            tag: "p",
                            typography: "$labelXlarge",
                            style: {
                                color: "#051a44"
                            },
                            children: [
                                fields.textSection1Headline,
                                fields.textSection1Description ? " ".concat(fields.textSection1Description) : "",
                                " |",
                                " ",
                                fields.textSection2Headline,
                                fields.textSection2Description ? " ".concat(fields.textSection2Description) : "",
                                " |",
                                " ",
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .r, {
                                    href: fields.linkUrl,
                                    target: ((ref2 = fields.linkUrl) === null || ref2 === void 0 ? void 0 : ref2.startsWith("#")) ? undefined : "_blank",
                                    rel: ((ref3 = fields.linkUrl) === null || ref3 === void 0 ? void 0 : ref3.startsWith("#")) ? undefined : "noopener noreferrer",
                                    analyticsName: "opendoor-reviews",
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                        tag: "span",
                                        display: "inline",
                                        typography: "$labelXlarge",
                                        textDecorationLine: "underline",
                                        children: fields.linkText
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var FCTrustBanner = {
    render: RenderFCTrustBanner
};
/* harmony default export */ __webpack_exports__["Z"] = (FCTrustBanner);


/***/ }),

/***/ 97828:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "m": function() { return /* binding */ gridStyles; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55128);





var gridStyles = {
    colSpan12: "span 12 / span 12"
};
function Grid(_param) {
    var backgroundColor = _param.backgroundColor, children = _param.children, _verticalMargin = _param.verticalMargin, verticalMargin = _verticalMargin === void 0 ? false : _verticalMargin, _horizontalMargin = _param.horizontalMargin, horizontalMargin = _horizontalMargin === void 0 ? true : _horizontalMargin, _maxWidth = _param.maxWidth, maxWidth = _maxWidth === void 0 ? "$1440x" : _maxWidth, mr = _param.mr, ml = _param.ml, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "backgroundColor",
        "children",
        "verticalMargin",
        "horizontalMargin",
        "maxWidth",
        "mr",
        "ml"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        justifyContent: "center"
    }, props), {
        backgroundColor: backgroundColor,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
            width: "100%",
            maxWidth: maxWidth,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                flexShrink: 1,
                "$platform-web": {
                    display: "grid",
                    gridTemplateColumns: "repeat(12, minmax(0, 1fr))"
                },
                columnGap: "$0x",
                $largerThanXS: {
                    columnGap: "$8x"
                },
                $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    columnGap: "$10x"
                }, horizontalMargin && !mr ? {
                    mr: "$20x"
                } : {}, horizontalMargin && !ml ? {
                    ml: "$20x"
                } : {}, verticalMargin ? {
                    my: "$20x"
                } : {}),
                $largerThanMD: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, horizontalMargin && !mr ? {
                    mr: "$32x"
                } : {}, horizontalMargin && !ml ? {
                    ml: "$32x"
                } : {}, verticalMargin ? {
                    my: "$32x"
                } : {}),
                my: verticalMargin ? "$10x" : undefined,
                width: "100%",
                mr: mr || (horizontalMargin ? "$10x" : undefined),
                ml: ml || (horizontalMargin ? "$10x" : undefined),
                children: children
            })
        })
    }));
}
/* harmony default export */ __webpack_exports__["Z"] = (Grid);


/***/ }),

/***/ 67236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "bv": function() { return /* binding */ RenderHeroV2; },
  "ZP": function() { return /* binding */ landing_pages_v2_HeroV2; },
  "Wv": function() { return /* binding */ getHeroV2PreloadImages; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../auth-fe/src/AuthContext.ts
var AuthContext = __webpack_require__(51087);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/router.js
var next_router = __webpack_require__(93287);
// EXTERNAL MODULE: ./src/helpers/markets.ts
var markets = __webpack_require__(83349);
// EXTERNAL MODULE: ./src/components/shared/performance/pictures.tsx
var pictures = __webpack_require__(57945);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/header/glass/constants.ts
var constants = __webpack_require__(198);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/heroConstants.ts
var heroConstants = __webpack_require__(83395);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+styled@11.11.0_@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1__@types+react@18.3.28_react@18.3.1/node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(89631);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroImages.tsx







var HeroImageContainer = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Box/* Box */.x, {
    target: "e19icmec0"
})({
    position: "relative",
    width: "100%",
    objectFit: "cover",
    borderRadius: "540px 540px 0px 0px",
    aspectRatio: "4 / 5",
    overflow: "hidden",
    "@media screen and (min-width: 768px)": {
        borderRadius: "540px 540px 36px 36px"
    }
});
var HeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl, lowBandwidth = param.lowBandwidth;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                $largerThanMD: {
                    display: "block"
                },
                children: imageDesktopUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_DESKTOP_PROPS */.t6), {
                        photoUrl: imageDesktopUrl,
                        preload: false
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "block",
                $largerThanMD: {
                    display: "none"
                },
                children: imageMobileUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImageContainer, {
                    children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread/* default */.Z)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_IMAGE_MOBILE_PROPS */.Sy), {
                        photoUrl: imageMobileUrl,
                        preload: false
                    }), lowBandwidth ? {
                        quality: 50
                    } : {}))
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(19137);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconSearch.mjs
var IconSearch = __webpack_require__(23470);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(42250);
// EXTERNAL MODULE: ../bricks-next/src/components/Image/Image.tsx + 1 modules
var Image = __webpack_require__(96101);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/TextButton.tsx
var TextButton = __webpack_require__(55285);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/Checkmark.tsx
var Checkmark = __webpack_require__(9825);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/SocialProofBox.tsx




var STUBBED_REVIEWS = [
    {
        rating: 5,
        reviewer: {
            city: "San Antonio",
            productType: "sell"
        }
    },
    {
        rating: 5,
        reviewer: {
            city: "Oklahoma City",
            productType: "sell"
        }
    },
    {
        rating: 5,
        reviewer: {
            city: "Phoenix",
            productType: "sell"
        }
    }, 
];
var usePrefersReducedMotion = function() {
    var ref = (0,react.useState)(false), prefersReducedMotion = ref[0], setPrefersReducedMotion = ref[1];
    (0,react.useEffect)(function() {
        var ref;
        if (false) {}
        setPrefersReducedMotion((ref = window.matchMedia("(prefers-reduced-motion: reduce)")) === null || ref === void 0 ? void 0 : ref.matches);
    }, []);
    return prefersReducedMotion;
};
var SocialProofBox = function(param) {
    var _autoplayInterval = param.autoplayInterval, autoplayInterval = _autoplayInterval === void 0 ? 4000 : _autoplayInterval;
    var prefersReducedMotion = usePrefersReducedMotion();
    var intervalRef = (0,react.useRef)();
    var ref = (0,react.useState)(0), currentReviewIndex = ref[0], setCurrentReviewIndex = ref[1];
    (0,react.useEffect)(function() {
        if (prefersReducedMotion) {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
            return;
        }
        intervalRef.current = setInterval(function() {
            setCurrentReviewIndex(function(prevIndex) {
                return prevIndex === STUBBED_REVIEWS.length - 1 ? 0 : prevIndex + 1;
            });
        }, autoplayInterval);
        return function() {
            return clearInterval(intervalRef.current);
        };
    }, [
        prefersReducedMotion,
        autoplayInterval
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CarouselFormat, {
        reviews: STUBBED_REVIEWS,
        currentIndex: currentReviewIndex,
        interval: autoplayInterval
    });
};
var FiveStarBanner = function(param) {
    var rating = param.rating;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        flexDirection: "row",
        gap: "$1x",
        children: new Array(rating).fill("star").map(function(_, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image/* Image */.E, {
                alt: "Rating star",
                source: {
                    height: 16,
                    uri: "https://images.opendoor.com/source/s3/imgdrop-production/2024-11-1732263853253-76957.svg?service=cosmos&preset=square-2048",
                    width: 16
                }
            }, index);
        })
    });
};
// takes the interval with `infinite` instead of redrawing
// the content constantly to trigger animation, may diverge over time
var fadeInCss = function(interval, index) {
    return /*#__PURE__*/ (0,emotion_react_browser_esm/* css */.iv)("transition:all 1s ease-in-out;animation:fadeIn-", index, " ", interval, "ms infinite ease-in-out;@keyframes fadeIn-", index, "{0%{opacity:0;}25%{opacity:1;}100%{opacity:0;}}");
};
var ReviewNav = function() {
    var goToReviews = (0,react.useCallback)(function() {
        return window.location.assign("https://opendoor.com/reviews");
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
        analyticsName: "social-proof-carousel-see-reviews",
        "aria-label": "See reviews",
        onPress: goToReviews,
        variant: "primary",
        label: "See reviews",
        fontWeight: "regular",
        size: "small",
        width: 88,
        alignItems: "flex-end",
        $smallerThanLG: {
            size: "xsmall",
            width: 76
        }
    });
};
var CarouselFormat = function(param) {
    var reviews = param.reviews, currentIndex = param.currentIndex, interval = param.interval;
    var ref;
    var prefersReducedMotion = usePrefersReducedMotion();
    if (reviews.length === 0) return null;
    var currentReview = reviews[currentIndex];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "row",
        justifyContent: "space-between",
        gap: "$5x",
        borderRadius: "$12x",
        width: 652,
        padding: "$12x",
        style: {
            background: "rgba(242, 241, 240, 0.64)",
            backdropFilter: "blur(20px)",
            flex: "auto"
        },
        $smallerThanLG: {
            width: "100%",
            padding: "$8x",
            flexDirection: "column",
            gap: "$2x"
        },
        $smallerThanMD: {
            minHeight: 128,
            borderRadius: "$borderAllowance"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "column",
                width: "100%",
                style: {
                    flex: "auto"
                },
                css: prefersReducedMotion ? null : fadeInCss(interval, currentIndex),
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FiveStarBanner, {
                        rating: currentReview.rating
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "$2x",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                $smallerThanLG: {
                                    typography: "$bodyXsmall"
                                },
                                children: [
                                    "Seller in\xa0",
                                    currentReview.reviewer.city
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$labelSmall",
                                color: "$contentAccentBrand",
                                $smallerThanLG: {
                                    typography: "$labelXsmall"
                                },
                                children: ((ref = currentReview.reviewer) === null || ref === void 0 ? void 0 : ref.name) || "Verified Customer"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Checkmark/* default */.Z, {
                                size: 20,
                                color: "$contentAccentBrand"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        display: "flex",
                        justifyContent: "space-between",
                        flexDirection: "row",
                        gap: "$4x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodyMedium",
                            color: "$contentPrimary",
                            $smallerThanLG: {
                                typography: "$bodySmall"
                            },
                            whiteSpace: "nowrap",
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            children: (currentReview === null || currentReview === void 0 ? void 0 : currentReview.excerpt) || "A great experience from the beginning..."
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "flex",
                justifyContent: "flex-end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReviewNav, {})
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx + 1 modules
var NewSellerFlowAddressInput = __webpack_require__(37987);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroTitleAndAddress.tsx










var HeroHeadline = function(param) {
    var title = param.title, subtitle = param.subtitle, isTreatment = param.isTreatment, textColor = param.textColor;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$8",
        alignItems: "center",
        $largerThanSM: isTreatment ? {
            alignItems: "flex-start",
            mb: "$4"
        } : undefined,
        $largerThanMD: isTreatment ? undefined : {
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                tag: "h1",
                typography: "$displayXsmall",
                textAlign: "center"
            }, textColor ? {
                color: textColor
            } : {}), {
                $largerThanSM: isTreatment ? {
                    textAlign: "left"
                } : {
                    typography: "$displaySmall"
                },
                $largerThanMD: isTreatment ? {} : {
                    typography: "$displayMedium",
                    textAlign: "left"
                },
                style: isTreatment ? {
                    lineHeight: "80%"
                } : {},
                children: title
            })),
            subtitle && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                tag: "p",
                typography: "$bodyMedium",
                textAlign: "center"
            }, textColor ? {
                color: textColor
            } : {}), {
                $largerThanSM: isTreatment ? {
                    typography: "$bodyLarge",
                    textAlign: "left"
                } : {
                    typography: "$bodyLarge"
                },
                $largerThanMD: isTreatment ? undefined : {
                    textAlign: "left"
                },
                children: subtitle
            }))
        ]
    });
};
var HeroAddressSection = function(param) {
    var showAddressInput = param.showAddressInput, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, isTreatment = param.isTreatment, textColor = param.textColor;
    if (!showAddressInput) return null;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        width: "100%",
        zIndex: 10,
        className: "hp-reskin-v2-address-entry-wrapper",
        $largerThanSM: isTreatment ? {
            marginBottom: "$4"
        } : undefined,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                id: "desktop-address-search",
                display: "none",
                $largerThanLG: {
                    display: "block"
                },
                children: renderDesktopInput()
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                id: "mobile-address-search",
                display: "block",
                $largerThanLG: {
                    display: "none"
                },
                children: renderMobileInput()
            }),
            isTreatment && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                typography: "$bodyMedium",
                tag: "p",
                color: textColor || "$contentSecondary",
                textAlign: "center",
                marginTop: "$4",
                $largerThanSM: {
                    textAlign: "left"
                },
                children: "No obligation. Takes 5 minutes. Your information stays private."
            })
        ]
    });
};
var HeroCtaButtonsSection = function(param) {
    var _ctaButton1Text = param.ctaButton1Text, ctaButton1Text = _ctaButton1Text === void 0 ? "Missing label" : _ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, _ctaButton2Text = param.ctaButton2Text, ctaButton2Text = _ctaButton2Text === void 0 ? "Missing label" : _ctaButton2Text, ctaButton2Url = param.ctaButton2Url, analyticsPrefix = param.analyticsPrefix;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        gap: "$6",
        alignItems: "center",
        $largerThanMD: {
            flexDirection: "row",
            alignItems: "flex-start"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-1"),
                label: ctaButton1Text,
                size: "large",
                variant: "primary",
                href: ctaButton1Url
            }),
            showCtaButton2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "".concat(analyticsPrefix, "-cta-button-2"),
                label: ctaButton2Text,
                size: "large",
                variant: "secondary",
                href: ctaButton2Url
            })
        ]
    });
};
var addressInputCommonProps = function(analyticsId, trackingKeyword) {
    return {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2".concat(analyticsId ? "-".concat(analyticsId) : ""),
        trackingTaxonomy: "new_homepage",
        trackingKeywords: trackingKeyword
    };
};
var TreatmentSearchButton = function(param) {
    var analyticsPrefix = param.analyticsPrefix, onPress = param.onPress, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
        disabled: isLoading,
        analyticsName: analyticsPrefix,
        "aria-label": "Search",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        width: "$15",
        height: "$16",
        borderRadius: "$9x",
        backgroundColor: "$backgroundAccentBrand",
        cursor: "pointer",
        opacity: isLoading ? 0.7 : 1,
        "$platform-web": {
            marginTop: "-20px",
            marginRight: "-16px"
        },
        onPress: function(e) {
            var ref;
            e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            onPress === null || onPress === void 0 ? void 0 : onPress();
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconSearch/* default */.Z, {
            size: 24,
            color: "white",
            stroke: 2
        })
    });
};
var StyledDefaultActionButton = /*#__PURE__*/ (0,emotion_styled_browser_esm/* default */.Z)(Button/* Button */.z, {
    target: "e14lmup10"
})("height:60px !important;margin-top:-17.5px;margin-right:-15px;");
var DefaultActionButton = function(param) {
    var label = param.label, analyticsPrefix = param.analyticsPrefix, onPress = param.onPress, isLoading = param.isLoading;
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledDefaultActionButton, {
        disabled: isLoading,
        analyticsName: analyticsPrefix,
        label: isLoading ? "Loading" : label,
        size: "medium",
        variant: "primary",
        onPress: function(e) {
            var ref;
            e === null || e === void 0 ? void 0 : (ref = e.stopPropagation) === null || ref === void 0 ? void 0 : ref.call(e);
            onPress === null || onPress === void 0 ? void 0 : onPress();
        }
    });
};
var HeroTitleAndAddress = function(param) {
    var analyticsId = param.analyticsId, title = param.title, subtitle = param.subtitle, showAddressInput = param.showAddressInput, showSocialSection = param.showSocialSection, renderDesktopInput = param.renderDesktopInput, renderMobileInput = param.renderMobileInput, additionalAddressContent = param.additionalAddressContent, addressEntryRef = param.addressEntryRef, _addressCtaText = param.addressCtaText, addressCtaText = _addressCtaText === void 0 ? "Get cash offer" : _addressCtaText, _addressCtaTextSmall = param.addressCtaTextSmall, addressCtaTextSmall = _addressCtaTextSmall === void 0 ? "Get offer" : _addressCtaTextSmall, addressCtaPlaceholderText = param.addressCtaPlaceholderText, addressCtaPlaceholderTextSmall = param.addressCtaPlaceholderTextSmall, trackingKeyword = param.trackingKeyword, showCtaButtonsContainer = param.showCtaButtonsContainer, ctaButton1Text = param.ctaButton1Text, ctaButton1Url = param.ctaButton1Url, showCtaButton2 = param.showCtaButton2, ctaButton2Text = param.ctaButton2Text, ctaButton2Url = param.ctaButton2Url, textColor = param.textColor;
    var analyticsPrefix = (0,HeroShared/* useHeroContext */.bx)().analyticsPrefix;
    var isTreatment = (0,constants/* isTreatmentAnalyticsId */.Zl)(analyticsId);
    var aiCommonProps = addressInputCommonProps(analyticsId, trackingKeyword);
    var DefaultInput = function(param) {
        var placeholder = param.placeholder, ctaLabel = param.ctaLabel;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aiCommonProps), {
            placeholder: placeholder,
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultActionButton, {
                    analyticsPrefix: analyticsPrefix,
                    label: ctaLabel,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    var TreatmentInput = function(param) {
        var placeholder = param.placeholder;
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, aiCommonProps), {
            placeholder: placeholder,
            actionButton: function(onPress, isLoading) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentSearchButton, {
                    analyticsPrefix: analyticsPrefix,
                    onPress: onPress,
                    isLoading: isLoading
                });
            }
        }));
    };
    var desktopInput = function() {
        if (isTreatment) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentInput, {
                placeholder: addressCtaPlaceholderText || "Enter your home address"
            });
        }
        if (renderDesktopInput) {
            return renderDesktopInput();
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultInput, {
            placeholder: addressCtaPlaceholderText || "Enter your home address",
            ctaLabel: addressCtaText
        });
    };
    var mobileInput = function() {
        if (isTreatment) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TreatmentInput, {
                placeholder: addressCtaPlaceholderTextSmall || "Enter an address"
            });
        }
        if (renderMobileInput) {
            return renderMobileInput();
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DefaultInput, {
            placeholder: addressCtaPlaceholderTextSmall || "Enter an address",
            ctaLabel: addressCtaTextSmall
        });
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        id: "title-and-address-entry",
        flexDirection: "column",
        width: "100%",
        gap: isTreatment ? "$4" : "$8",
        $largerThanSM: {
            gap: isTreatment ? "$0" : "$8"
        },
        $largerThanLG: {
            gap: isTreatment ? "$0" : "$8"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroHeadline, {
                title: title,
                subtitle: subtitle,
                isTreatment: isTreatment,
                textColor: textColor
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                display: "none",
                ref: function(el) {
                    return addressEntryRef(el);
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                display: "flex",
                flexDirection: "column",
                alignItems: isTreatment ? "flex-start" : "center",
                gap: "$4",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroAddressSection, {
                        showAddressInput: showAddressInput,
                        renderDesktopInput: desktopInput,
                        renderMobileInput: mobileInput,
                        additionalContent: additionalAddressContent,
                        isTreatment: isTreatment,
                        textColor: textColor
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $smallerThanLG: {
                            display: "inherit"
                        },
                        $largerThanMD: {
                            display: "none"
                        },
                        width: "100%",
                        children: showSocialSection && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                            autoplayInterval: 3000
                        })
                    })
                ]
            }),
            showCtaButtonsContainer && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroCtaButtonsSection, {
                ctaButton1Text: ctaButton1Text,
                ctaButton1Url: ctaButton1Url,
                showCtaButton2: showCtaButton2,
                ctaButton2Text: ctaButton2Text,
                ctaButton2Url: ctaButton2Url,
                analyticsPrefix: analyticsPrefix
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/PressBox.tsx
var PressBox = __webpack_require__(34476);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/StickyCTAUtility/StickyCTAUtility.tsx
var StickyCTAUtility = __webpack_require__(23107);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.module.css
var HeroV2_module = __webpack_require__(10586);
var HeroV2_module_default = /*#__PURE__*/__webpack_require__.n(HeroV2_module);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2.tsx



















var FULLBLEED_HERO_FALLBACK_COLOR = "#2D1D12";
var FullBleedHero = function(param) {
    var fields = param.fields, headline = param.headline, customization = param.customization, analyticsPrefix = param.analyticsPrefix, hideStickyCta = param.hideStickyCta, showStickyCTAUtility = param.showStickyCTAUtility, addressEntryRef = param.addressEntryRef;
    var variant = (customization === null || customization === void 0 ? void 0 : customization.variant) || "default";
    var imageUrl = constants/* FULLBLEED_HERO_IMAGE_URL */.Do;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroShared/* HeroProvider */.yL, {
        variant: variant,
        analyticsPrefix: analyticsPrefix,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            "data-hero": true,
            analyticsName: (customization === null || customization === void 0 ? void 0 : customization.analyticsName) || "cosmos-landing-page-hero-v2-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
            trackImpression: true,
            inViewThreshold: 0.3,
            position: "relative",
            maxWidth: "$432",
            mx: "auto",
            pt: constants/* GLASS_HEADER_HEIGHT */.$C,
            borderBottomLeftRadius: "$6x",
            borderBottomRightRadius: "$6x",
            minHeight: "$100",
            height: 500,
            style: {
                backgroundColor: FULLBLEED_HERO_FALLBACK_COLOR
            },
            $largerThanSM: {
                minHeight: "$115"
            },
            $largerThanMD: {
                minHeight: "$125",
                borderBottomLeftRadius: "$9x",
                borderBottomRightRadius: "$9x"
            },
            children: [
                !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                    isVisible: showStickyCTAUtility
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    overflow: "hidden",
                    borderBottomLeftRadius: "$6x",
                    borderBottomRightRadius: "$6x",
                    $largerThanMD: {
                        borderBottomLeftRadius: "$9x",
                        borderBottomRightRadius: "$9x"
                    },
                    children: [
                        imageUrl && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            className: (HeroV2_module_default()).heroImageWrapper,
                            children: (0,pictures/* generatePresetPictureSet */.eY)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_FULLBLEED_IMAGE_PROPS */.$B), {
                                photoUrl: imageUrl,
                                objectFit: "cover",
                                preload: false
                            }))
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "66%",
                            height: "100%",
                            className: (HeroV2_module_default()).heroLeftGradient
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "$23",
                            zIndex: 1,
                            className: (HeroV2_module_default()).heroTopGradient
                        })
                    ]
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    position: "relative",
                    zIndex: 2,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    height: "100%",
                    px: "$5",
                    py: "$10",
                    maxWidth: "$328",
                    mx: "auto",
                    style: {
                        color: (0,cjs.getToken)("$contentInversePrimary", "color")
                    },
                    minHeight: 400 - constants/* GLASS_HEADER_HEIGHT */.$C,
                    $largerThanSM: {
                        pt: "$25",
                        minHeight: 460 - constants/* GLASS_HEADER_HEIGHT */.$C,
                        alignItems: "flex-start"
                    },
                    $largerThanMD: {
                        pt: "$14",
                        minHeight: 500 - constants/* GLASS_HEADER_HEIGHT */.$C
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        maxWidth: "80%",
                        $largerThanSM: {
                            maxWidth: "50%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitleAndAddress, {
                            analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                            title: headline,
                            subtitle: fields === null || fields === void 0 ? void 0 : fields.subtitle,
                            showAddressInput: fields === null || fields === void 0 ? void 0 : fields.showAddressInputCta,
                            showSocialSection: false,
                            textColor: "$contentInversePrimary",
                            renderDesktopInput: customization === null || customization === void 0 ? void 0 : customization.renderDesktopInput,
                            renderMobileInput: customization === null || customization === void 0 ? void 0 : customization.renderMobileInput,
                            additionalAddressContent: customization === null || customization === void 0 ? void 0 : customization.additionalAddressContent,
                            addressEntryRef: addressEntryRef,
                            addressCtaText: fields === null || fields === void 0 ? void 0 : fields.addressCtaText,
                            addressCtaTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaTextSmall,
                            addressCtaPlaceholderText: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderText,
                            addressCtaPlaceholderTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderTextSmall,
                            showCtaButtonsContainer: fields === null || fields === void 0 ? void 0 : fields.showCtaButtonsContainer,
                            ctaButton1Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Text,
                            ctaButton1Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Url,
                            showCtaButton2: fields === null || fields === void 0 ? void 0 : fields.showCtaButton2,
                            ctaButton2Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Text,
                            ctaButton2Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Url,
                            trackingKeyword: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
                        })
                    })
                })
            ]
        })
    });
};
var getHeroV2PreloadImages = function(fields) {
    if ((0,constants/* isTreatmentAnalyticsId */.Zl)(fields.analyticsId)) {
        return (0,pictures/* generatePresetPictureSetProps */.$c)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, heroConstants/* HERO_FULLBLEED_IMAGE_PROPS */.$B), {
            photoUrl: constants/* FULLBLEED_HERO_IMAGE_URL */.Do
        })).sources;
    }
    return (0,HeroShared/* preloadHeroImages */.DB)({
        imageDesktopUrl: fields.imageDesktopUrl,
        imageMobileUrl: fields.imageMobileUrl
    });
};
var ControlHero = function(param) {
    var fields = param.fields, customization = param.customization, addressEntryRef = param.addressEntryRef;
    var router = (0,next_router.useRouter)();
    var headlineMarketIdentifier = router.query.headline_market_name;
    var headlineMarketDisplayName = (0,markets/* getMarketDisplayNameForHeroV2 */.O_)(headlineMarketIdentifier);
    var displayMarketNameInHeadline = headlineMarketDisplayName && "showMarketNameInHeadline" in fields && fields.showMarketNameInHeadline && !(customization === null || customization === void 0 ? void 0 : customization.headline);
    var headline = (customization === null || customization === void 0 ? void 0 : customization.headline) !== undefined ? customization.headline : (fields === null || fields === void 0 ? void 0 : fields.title) + (displayMarketNameInHeadline ? " in ".concat(headlineMarketDisplayName) : "");
    var hasBothSocialAndPress = (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && (fields === null || fields === void 0 ? void 0 : fields.showPressSection);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: "90%",
        mx: "auto",
        paddingHorizontal: "$10",
        $largerThanSM: {
            paddingBottom: hasBothSocialAndPress ? "$16" : "$0"
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            flexDirection: "column",
            justifyContent: "space-between",
            rowGap: "$10",
            position: "relative",
            $smallerThanSM: {
                paddingTop: "$10"
            },
            $largerThanSM: {
                flexDirection: "row",
                columnGap: "$8",
                rowGap: "$4"
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    $largerThanSM: {
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        width: "40%",
                        flexShrink: 0
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroTitleAndAddress, {
                        analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                        title: headline,
                        subtitle: fields === null || fields === void 0 ? void 0 : fields.subtitle,
                        showAddressInput: fields === null || fields === void 0 ? void 0 : fields.showAddressInputCta,
                        showSocialSection: fields === null || fields === void 0 ? void 0 : fields.showSocialSection,
                        renderDesktopInput: customization === null || customization === void 0 ? void 0 : customization.renderDesktopInput,
                        renderMobileInput: customization === null || customization === void 0 ? void 0 : customization.renderMobileInput,
                        additionalAddressContent: customization === null || customization === void 0 ? void 0 : customization.additionalAddressContent,
                        addressEntryRef: addressEntryRef,
                        addressCtaText: fields === null || fields === void 0 ? void 0 : fields.addressCtaText,
                        addressCtaTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaTextSmall,
                        addressCtaPlaceholderText: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderText,
                        addressCtaPlaceholderTextSmall: fields === null || fields === void 0 ? void 0 : fields.addressCtaPlaceholderTextSmall,
                        showCtaButtonsContainer: fields === null || fields === void 0 ? void 0 : fields.showCtaButtonsContainer,
                        ctaButton1Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Text,
                        ctaButton1Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton1Url,
                        showCtaButton2: fields === null || fields === void 0 ? void 0 : fields.showCtaButton2,
                        ctaButton2Text: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Text,
                        ctaButton2Url: fields === null || fields === void 0 ? void 0 : fields.ctaButton2Url,
                        trackingKeyword: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    position: "relative",
                    $largerThanSM: {
                        width: "50%",
                        flexShrink: 0
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroImages, {
                            imageDesktopUrl: fields === null || fields === void 0 ? void 0 : fields.imageDesktopUrl,
                            imageMobileUrl: fields === null || fields === void 0 ? void 0 : fields.imageMobileUrl,
                            lowBandwidth: customization === null || customization === void 0 ? void 0 : customization.lowBandwidth
                        }),
                        customization === null || customization === void 0 ? void 0 : customization.children
                    ]
                }),
                ((fields === null || fields === void 0 ? void 0 : fields.showSocialSection) || (fields === null || fields === void 0 ? void 0 : fields.showPressSection)) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    id: "desktop-press-box",
                    position: "absolute",
                    left: "50%",
                    transform: "translateX(-50%)",
                    zIndex: 1,
                    $largerThanLG: {
                        bottom: 32
                    },
                    $largerThanSM: {
                        bottom: hasBothSocialAndPress ? -100 : -40
                    },
                    $smallerThanMD: {
                        position: "relative"
                    },
                    children: [
                        (fields === null || fields === void 0 ? void 0 : fields.showSocialSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            $smallerThanMD: {
                                display: "inherit"
                            },
                            $smallerThanLG: {
                                display: "none"
                            },
                            $largerThanMD: {
                                display: "inherit"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SocialProofBox, {
                                autoplayInterval: 3000
                            })
                        }),
                        (fields === null || fields === void 0 ? void 0 : fields.showPressSection) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            marginTop: "$8",
                            $smallerThanMD: {
                                marginTop: 0
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressBox/* PressBox */.j, {})
                        })
                    ]
                })
            ]
        })
    });
};
var RenderHeroV2 = function(entry, resolvedData, customization) {
    var router = (0,next_router.useRouter)();
    var authentication = (0,AuthContext/* useAuth */.aC)().authentication;
    var fields = entry.fields;
    var isFullBleedHero = (0,constants/* isTreatmentAnalyticsId */.Zl)(fields.analyticsId);
    var hideStickyCta = (customization === null || customization === void 0 ? void 0 : customization.hideStickyCtaOverride) !== undefined ? Boolean(customization.hideStickyCtaOverride) : (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated";
    var headlineMarketIdentifier = router.query.headline_market_name;
    var headlineMarketDisplayName = (0,markets/* getMarketDisplayNameForHeroV2 */.O_)(headlineMarketIdentifier);
    var displayMarketNameInHeadline = headlineMarketDisplayName && "showMarketNameInHeadline" in fields && fields.showMarketNameInHeadline && !(customization === null || customization === void 0 ? void 0 : customization.headline);
    var headline = (customization === null || customization === void 0 ? void 0 : customization.headline) !== undefined ? customization.headline : (fields === null || fields === void 0 ? void 0 : fields.title) + (displayMarketNameInHeadline ? " in ".concat(headlineMarketDisplayName) : "");
    var ref = (0,HeroShared/* useStickyCTA */.AJ)(), addressEntryRef = ref.addressEntryRef, showStickyCTAUtility = ref.showStickyCTAUtility;
    var variant = (customization === null || customization === void 0 ? void 0 : customization.variant) || "default";
    var analyticsPrefix = "cosmos-landing-page-hero-v2".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : "");
    if (isFullBleedHero) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FullBleedHero, {
            fields: fields,
            headline: headline,
            customization: customization,
            analyticsPrefix: analyticsPrefix,
            hideStickyCta: hideStickyCta,
            showStickyCTAUtility: showStickyCTAUtility,
            addressEntryRef: addressEntryRef
        });
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeroShared/* HeroProvider */.yL, {
        variant: variant,
        analyticsPrefix: analyticsPrefix,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            analyticsName: (customization === null || customization === void 0 ? void 0 : customization.analyticsName) || "cosmos-landing-page-hero-v2-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
            trackImpression: true,
            inViewThreshold: 0.3,
            children: [
                !hideStickyCta && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StickyCTAUtility/* StickyCTAUtility */.V, {
                    analyticsId: fields === null || fields === void 0 ? void 0 : fields.analyticsId,
                    isVisible: showStickyCTAUtility
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ControlHero, {
                    fields: fields,
                    customization: customization,
                    addressEntryRef: addressEntryRef
                })
            ]
        })
    });
};
var heroV2Loader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = getHeroV2PreloadImages(input.fields);
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root)
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2Loader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2 = {
    render: function(entry, resolvedData) {
        return RenderHeroV2(entry, resolvedData);
    },
    loader: heroV2Loader
};

/* harmony default export */ var landing_pages_v2_HeroV2 = (HeroV2);


/***/ }),

/***/ 40066:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ landing_pages_v2_HeroV2WithMarkers; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../auth-fe/src/AuthContext.ts
var AuthContext = __webpack_require__(51087);
// EXTERNAL MODULE: ./src/helpers/ReturnExperienceContext.tsx
var ReturnExperienceContext = __webpack_require__(69814);
// EXTERNAL MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx + 1 modules
var NewSellerFlowAddressInput = __webpack_require__(37987);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/HeroV2.tsx + 3 modules
var HeroV2 = __webpack_require__(67236);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(96492);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/RightArrow.tsx
var RightArrow = __webpack_require__(3468);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ./src/helpers/returnExperience.tsx
var returnExperience = __webpack_require__(86669);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(79758);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/returnExperienceUrls.ts

var getOfferDashboardUrl = function(addressToken) {
    if (addressToken) {
        return "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/sell/").concat(addressToken);
    }
    return "".concat(globals/* CONSUMER_FE_URL */.ed, "/dashboard/sell");
};
var getSellerFlowUrl = function(sellerInputUUID, sellerFlowLastCompletedSlug) {
    if (!sellerInputUUID) {
        return globals/* COSMOS_URL */.EQ;
    }
    if (sellerFlowLastCompletedSlug) {
        return "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(sellerInputUUID, "/").concat(sellerFlowLastCompletedSlug);
    }
    return "".concat(globals/* CONSUMER_FE_URL */.ed, "/seller-lead/").concat(sellerInputUUID);
};

;// CONCATENATED MODULE: ./src/components/landing-pages-v2/ReturnExperience.tsx





var AltCTAButton = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* IconButton */.hU, {
        analyticsName: "cosmos-return-experience-".concat(returnExperience/* ExperienceType */.g[props.experience], "-icon-button"),
        icon: {
            Component: RightArrow/* default */.Z,
            label: "".concat(props.actionText)
        },
        onPress: function() {
            return props.url && window.location.assign(props.url);
        },
        size: "small",
        variant: "default",
        trackImpression: true
    });
};
var getActiveOfferExpiryText = function() {
    var daysToExpire = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
    var expiryText = "expires in 2 days";
    if (daysToExpire < 1) {
        expiryText = "expires today";
    } else if (daysToExpire < 2) {
        expiryText = "expires in 1 day";
    } else if (daysToExpire < 3) {
        expiryText = "expires in 2 days";
    } else if (daysToExpire === 3) {
        expiryText = "expires in 3 days";
    }
    return expiryText;
};
var Headline = function(props) {
    switch(props.experience){
        case returnExperience/* ExperienceType.direct_mailer */.g.direct_mailer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Get started on your offer"
            });
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Get your updated offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Finish your offer",
                    props.smallerThanMD ? "" : " today"
                ]
            });
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: "Your offer increased"
            });
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    "Your offer ",
                    getActiveOfferExpiryText(props.daysToExpire)
                ]
            });
        default:
            return null;
    }
};
var ExperienceCTAButton = function(props) {
    var offerDashUrl = getOfferDashboardUrl(props.addressToken);
    switch(props.experience){
        case returnExperience/* ExperienceType.offer_expired */.g.offer_expired:
            {
                var baseUrl = offerDashUrl;
                var params = new URLSearchParams({
                    refresh_offer: "true",
                    refresh_source: "homepage_experience"
                }).toString();
                var refreshUrl = "".concat(baseUrl, "?").concat(params);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                    actionText: "Refresh".concat(props.smallerThanMD ? " " : " your ", "offer"),
                    url: refreshUrl,
                    experience: props.experience
                });
            }
        case returnExperience/* ExperienceType.incomplete_flow */.g.incomplete_flow:
            {
                var sellerFlowUrl = getSellerFlowUrl(props.sellerInputUUID, props.sellerFlowLastCompletedSlug);
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                    actionText: "Resume".concat(props.smallerThanMD ? " " : " your ", "offer"),
                    url: sellerFlowUrl,
                    experience: props.experience
                });
            }
        case returnExperience/* ExperienceType.offer_increased */.g.offer_increased:
        case returnExperience/* ExperienceType.offer_expiring */.g.offer_expiring:
        case returnExperience/* ExperienceType.offer_decreased */.g.offer_decreased:
        case returnExperience/* ExperienceType.active_offer */.g.active_offer:
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AltCTAButton, {
                actionText: "View".concat(props.smallerThanMD ? " " : " your ", "offer"),
                url: offerDashUrl,
                experience: props.experience
            });
        default:
            return null;
    }
};
var ReturnExperienceHero = function() {
    var returnExperienceData = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().returnExperienceData;
    var smallerThanSM = (0,cjs.useMedia)().smallerThanSM;
    if (!returnExperienceData || (returnExperienceData === null || returnExperienceData === void 0 ? void 0 : returnExperienceData.experienceType) === null) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        animation: "contentfulArchAnimation",
        animateOnly: [
            "opacity",
            "transform"
        ],
        enterStyle: {
            y: -30,
            opacity: 0
        },
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        top: -27,
        p: 16,
        pt: 43,
        analyticsName: "cosmos-return-experience-address-entry-slide-in",
        backgroundColor: "$backgroundSecondary",
        borderBottomRightRadius: 20,
        borderBottomLeftRadius: 20,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                gap: 5,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentPrimary",
                        typography: "$labelSmall",
                        $largerThanMD: {
                            typography: "$labelMedium"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, {
                            experience: returnExperienceData.experienceType,
                            currentOfferPriceCents: returnExperienceData.currentOfferHeadlinePriceCents,
                            previousOfferPriceCents: returnExperienceData.previousOfferHeadlinePriceCents,
                            daysToExpire: returnExperienceData.offerExpiresInDays,
                            smallerThanMD: smallerThanSM
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        color: "$contentSecondary",
                        typography: "$bodySmall",
                        children: returnExperienceData.address
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ExperienceCTAButton, {
                experience: returnExperienceData.experienceType,
                sellerInputUUID: returnExperienceData.sellerInputUUID,
                customerUUID: returnExperienceData.customerUUID,
                addressToken: returnExperienceData.addressToken,
                sellerFlowLastCompletedSlug: returnExperienceData.sellerFlowLastCompletedSlug,
                smallerThanMD: false
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/Marker.tsx
var Marker = __webpack_require__(24241);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/shared/hero/HeroMarkers.tsx


var HeroMarkers = function(param) {
    var cashOfferMarkerImage = param.cashOfferMarkerImage, newOfferMarkerImage = param.newOfferMarkerImage, highestOfferMarkerImage = param.highestOfferMarkerImage;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                imageSource: cashOfferMarkerImage,
                lazy: false,
                left: "57%",
                top: "40%",
                height: "$60x",
                width: "$157x",
                className: Marker/* MarkerFadeInClassName */.eO,
                $largerThanSM: {
                    left: "60%",
                    top: "40%"
                },
                $largerThanMD: {
                    left: "50%",
                    top: "25%",
                    height: "$80x",
                    width: "$200x"
                },
                animationDelay: "0.5s"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                imageSource: newOfferMarkerImage,
                lazy: false,
                right: "55%",
                top: "45%",
                height: "$60x",
                width: "$157x",
                className: Marker/* MarkerFadeInClassName */.eO,
                $largerThanSM: {
                    right: "52%",
                    top: "43%"
                },
                $largerThanMD: {
                    right: "57%",
                    top: "30%",
                    height: "$80x",
                    width: "$200x"
                },
                animationDelay: "1.5s"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Marker/* default */.ZP, {
                imageSource: highestOfferMarkerImage,
                lazy: false,
                right: "35%",
                top: "20%",
                height: "$60x",
                width: "$157x",
                className: Marker/* MarkerFadeInClassName */.eO,
                $largerThanSM: {
                    right: "40%",
                    top: "22%"
                },
                $largerThanMD: {
                    right: "36%",
                    top: "7%",
                    height: "$80x",
                    width: "$200x"
                },
                animationDelay: "2.5s"
            })
        ]
    });
};
/* harmony default export */ var hero_HeroMarkers = (HeroMarkers);

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/hero/HeroShared.tsx
var HeroShared = __webpack_require__(19137);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/HeroV2WithMarkers.tsx












var RenderHeroV2WithMarkers = function(entry, resolvedData) {
    var fields = entry.fields;
    var authentication = (0,AuthContext/* useAuth */.aC)().authentication;
    var showReturnExperience = (0,ReturnExperienceContext/* useReturnExperienceContext */.$)().showReturnExperience;
    var addressInputCommonProps = {
        hideLabel: true,
        inputLocation: "hero-cta",
        analyticsPrefix: "cosmos-landing-page-hero-v2-with-markers".concat((fields === null || fields === void 0 ? void 0 : fields.analyticsId) ? "-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId) : ""),
        trackingTaxonomy: "new_homepage",
        trackingKeywords: fields === null || fields === void 0 ? void 0 : fields.trackingKeyword
    };
    // Convert resolvedData to match HeroV2's expected format
    var heroV2ResolvedData = resolvedData ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, resolvedData), {
        stickyCTA: resolvedData.stickyCTA || undefined
    }) : undefined;
    var customization = {
        variant: "withMarkers",
        hideStickyCtaOverride: entry.sys.locale === "es" || (resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.stickyCTA) === "None" || authentication.state === "authenticated",
        renderDesktopInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderText || "Enter your home address"
            }));
        },
        renderMobileInput: function() {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(NewSellerFlowAddressInput/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, addressInputCommonProps), {
                placeholder: fields.addressCtaPlaceholderTextSmall || "Enter an address"
            }));
        },
        additionalAddressContent: showReturnExperience && entry.sys.locale !== "es" && !((fields === null || fields === void 0 ? void 0 : fields.analyticsId) === "syw-address-entry-direct-mail") ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ReturnExperienceHero, {}) : undefined,
        imageContainerStyles: {
            $largerThanMD: {
                width: "50%",
                justifyContent: "flex-end"
            }
        },
        desktopPressBoxBottom: "$15x",
        headline: (fields === null || fields === void 0 ? void 0 : fields.title) || "",
        analyticsName: "cosmos-landing-page-hero-v2-with-markers-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(hero_HeroMarkers, {
            cashOfferMarkerImage: fields.cashOfferMarkerImage,
            newOfferMarkerImage: fields.newOfferMarkerImage,
            highestOfferMarkerImage: fields.highestOfferMarkerImage
        })
    };
    return (0,HeroV2/* RenderHeroV2 */.bv)(entry, heroV2ResolvedData, customization);
};
var heroV2WithMarkersLoader = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input, root) {
        var preloadImages, loaderReturn;
        return (0,tslib_es6.__generator)(this, function(_state) {
            preloadImages = (0,HeroV2/* getHeroV2PreloadImages */.Wv)(input.fields);
            loaderReturn = {
                preloadImages: preloadImages,
                stickyCTA: (0,HeroShared/* getStickyCTAFromRoot */.Ul)(root) || null
            };
            return [
                2,
                loaderReturn
            ];
        });
    });
    return function heroV2WithMarkersLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var HeroV2WithMarkers = {
    render: RenderHeroV2WithMarkers,
    loader: heroV2WithMarkersLoader
};
/* harmony default export */ var landing_pages_v2_HeroV2WithMarkers = (HeroV2WithMarkers);


/***/ }),

/***/ 83530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34984);
/* harmony import */ var _shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57945);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97828);
/* harmony import */ var _LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82466);
/* harmony import */ var _LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2__);




var slugify = function(str) {
    return str.toLowerCase().replace(/[^a-z0-9\s-]/g, "").trim().replace(/\s+/g, "-");
};

// Hardcoded breakpoints from @opendoor/bricks/theme/novo: [0, 375, 768, 1201, 1440]
var PICTURE_SIZES = [
    {
        minWidth: 0,
        maxWidth: 375,
        preset: "square-256"
    },
    {
        minWidth: 375,
        maxWidth: 768,
        preset: "square-512"
    },
    {
        minWidth: 768,
        maxWidth: 1201,
        preset: "square-512"
    },
    {
        minWidth: 1201,
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var RenderLWCHeroCard = function(entry, _resolvedData, context) {
    var fields = entry.fields;
    var isVideoAsset = (fields === null || fields === void 0 ? void 0 : fields.clipImage) && (fields === null || fields === void 0 ? void 0 : fields.videoUrl);
    var isFirstBlockEntry = Boolean(context === null || context === void 0 ? void 0 : context.isFirstBlockEntry);
    var titleSlug = (fields === null || fields === void 0 ? void 0 : fields.title) ? slugify(fields.title) : undefined;
    var containerClassName = [
        (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().containerMinHeight),
        isVideoAsset ? (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().containerVideoMaxHeight) : (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().containerImageMaxHeight), 
    ].join(" ");
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
        analyticsName: "cosmos-landing-page-lwc-hero-card-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                id: titleSlug || undefined,
                style: {
                    scrollMarginTop: 96
                },
                className: containerClassName,
                "$platform-web": {
                    gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_1__/* .gridStyles.colSpan12 */ .m.colSpan12
                },
                backgroundColor: "$backgroundSecondary",
                borderRadius: "$16x",
                mb: "$10x",
                $largerThanSM: {
                    mb: "$12x",
                    flexDirection: "row",
                    pl: "$32x",
                    pr: "$0x",
                    pb: "$0x",
                    gap: "$6x",
                    height: "$382x",
                    alignItems: "flex-start",
                    justifyContent: "space-between"
                },
                $largerThanMD: {
                    pl: "$40x",
                    height: "$616x"
                },
                justifyContent: "space-between",
                pl: "$16x",
                pr: "$16x",
                pb: "$16x",
                gap: "$16x",
                height: "$452x",
                $largerThanXS: {
                    height: "$616x"
                },
                flexDirection: "column",
                alignItems: "center",
                overflow: "hidden",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                        pt: "$16x",
                        $largerThanSM: {
                            pt: "$32x",
                            px: "$0x",
                            pb: "$32x",
                            height: "100%",
                            maxWidth: "$310x"
                        },
                        $largerThanMD: {
                            pt: "$40x",
                            px: "$0x",
                            pb: "$40x",
                            maxWidth: "$500x"
                        },
                        px: "$0x",
                        justifyContent: "space-between",
                        width: "100%",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                                display: (fields === null || fields === void 0 ? void 0 : fields.heroCardName) ? "flex" : "none",
                                $largerThanSM: {
                                    display: "flex"
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                    tag: "h3",
                                    display: "block",
                                    typography: "$bodyLarge",
                                    fontWeight: "$medium",
                                    $largerThanMD: {
                                        typography: "$subheaderMedium"
                                    },
                                    color: "$contentPrimary",
                                    mb: "$24x",
                                    children: fields.heroCardName
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                                width: "100%",
                                $largerThanSM: {
                                    width: "83%"
                                },
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                        tag: "h3",
                                        display: "block",
                                        typography: "$subheaderMedium",
                                        $largerThanSM: {
                                            typography: "$headerSmall"
                                        },
                                        $largerThanMD: {
                                            typography: "$headerMedium"
                                        },
                                        color: "$contentPrimary",
                                        children: fields.title
                                    }),
                                    fields.titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                        tag: "h3",
                                        display: "block",
                                        typography: "$subheaderMedium",
                                        $largerThanSM: {
                                            typography: "$headerSmall"
                                        },
                                        $largerThanMD: {
                                            typography: "$headerMedium"
                                        },
                                        color: "$contentStateInactivePrimary",
                                        children: fields.titleAccent
                                    }),
                                    fields.body && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                        tag: "h3",
                                        display: "block",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        mt: "$10x",
                                        children: fields.body
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                        width: "100%",
                        height: "100%",
                        minHeight: "$310x",
                        position: "relative",
                        flexShrink: 1,
                        borderRadius: "$12x",
                        overflow: "hidden",
                        $largerThanSM: {
                            borderRadius: 0
                        },
                        children: isVideoAsset ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                            className: (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().videoFlexWrapper),
                            height: "100%",
                            width: "100%",
                            justifyContent: "center",
                            $largerThanSM: {
                                justifyContent: "flex-end",
                                pt: "$24x"
                            },
                            alignItems: "flex-end",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
                                width: "100%",
                                justifyContent: "center",
                                $largerThanSM: {
                                    justifyContent: "flex-end",
                                    minWidth: "$284x"
                                },
                                $largerThanXS: {
                                    maxHeight: "$430x"
                                },
                                $largerThanMD: {
                                    minWidth: "$500x",
                                    maxHeight: 9999
                                },
                                height: "100%",
                                overflow: "hidden",
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("video", {
                                    className: (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().video),
                                    height: "100%",
                                    width: "100%",
                                    src: fields === null || fields === void 0 ? void 0 : fields.videoUrl,
                                    autoPlay: true,
                                    muted: true,
                                    loop: true,
                                    playsInline: true,
                                    preload: isFirstBlockEntry ? "auto" : "metadata"
                                })
                            })
                        }) : (fields === null || fields === void 0 ? void 0 : fields.cardImage) ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                            className: (_LWCHeroCard_module_css__WEBPACK_IMPORTED_MODULE_2___default().imagePositionWrapper),
                            position: "absolute",
                            width: "100%",
                            height: "100%",
                            left: "$0",
                            bottom: "$0",
                            children: (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__/* .generatePresetPictureSet */ .eY)({
                                photoUrl: fields === null || fields === void 0 ? void 0 : fields.cardImage,
                                sizes: PICTURE_SIZES,
                                debugImageSizes: false,
                                preload: isFirstBlockEntry,
                                lazy: !isFirstBlockEntry,
                                objectFit: "cover"
                            })
                        }) : null
                    })
                ]
            })
        })
    });
};
var LWCHeroCard = {
    render: RenderLWCHeroCard
};
/* harmony default export */ __webpack_exports__["Z"] = (LWCHeroCard);


/***/ }),

/***/ 26923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56865);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(97828);




var RenderLWCImageCard = function(entry) {
    var fields = entry.fields, sys = entry.sys;
    var desktopImageSourceUrl = fields === null || fields === void 0 ? void 0 : fields.desktopImage;
    var mobileImageSourceUrl = fields === null || fields === void 0 ? void 0 : fields.mobileImage;
    var isSmallPadding = (fields === null || fields === void 0 ? void 0 : fields.verticalPadding) === "Small";
    if (sys.locale === "es") return;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
        analyticsName: "cosmos-landing-page-lwc-image-card-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
            backgroundColor: "$backgroundSecondary",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                "$platform-web": {
                    gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_0__/* .gridStyles.colSpan12 */ .m.colSpan12
                },
                flexDirection: "column",
                width: "100%",
                height: "$500x",
                my: isSmallPadding ? "$10x" : "$56x",
                $largerThanXS: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    height: "$616x"
                }, isSmallPadding ? {
                    my: "$16x"
                } : {
                    my: "$80x"
                }),
                $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                    flexDirection: "row",
                    height: "$452x"
                }, isSmallPadding ? {
                    my: "$24x"
                } : {}),
                $largerThanMD: {
                    height: "$719x"
                },
                overflow: "hidden",
                backgroundColor: "$backgroundPrimary",
                borderRadius: "$16x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                        p: "$16x",
                        pr: "$12x",
                        pb: "$22x",
                        $largerThanSM: {
                            pr: "$16x",
                            pb: "$16x"
                        },
                        $largerThanMD: {
                            p: "$32x"
                        },
                        $largerThanLG: {
                            p: "$40x"
                        },
                        justifyContent: "flex-start",
                        children: [
                            (fields === null || fields === void 0 ? void 0 : fields.subtitle) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Row */ .X, {
                                flexGrow: 1,
                                pb: "$6x",
                                $largerThanSM: {
                                    pb: "$0x"
                                },
                                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                    tag: "h3",
                                    display: "block",
                                    typography: "$bodyLarge",
                                    fontWeight: "$medium",
                                    color: "$contentPrimary",
                                    children: fields.subtitle
                                })
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, {
                                        width: "100%",
                                        maxWidth: "$200x",
                                        $largerThanXS: {
                                            maxWidth: "$310x"
                                        },
                                        $largerThanSM: {
                                            maxWidth: "$272x"
                                        },
                                        $largerThanMD: {
                                            maxWidth: "$500x"
                                        },
                                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, {
                                            tag: "h3",
                                            display: "block",
                                            typography: "$subheaderMedium",
                                            $largerThanMD: {
                                                typography: "$headerLarge"
                                            },
                                            children: fields.title
                                        })
                                    }),
                                    (fields === null || fields === void 0 ? void 0 : fields.ctaLink) && (fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                                        variant: "primary",
                                        "aria-label": "Go to page to ".concat(fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText),
                                        analyticsName: "cosmos-landing-page-lwc-image-card-cta-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                                        onPress: function() {
                                            return (fields === null || fields === void 0 ? void 0 : fields.ctaLink) && window.location.assign(fields === null || fields === void 0 ? void 0 : fields.ctaLink);
                                        },
                                        mt: "$15x",
                                        size: "small",
                                        maxWidth: "$165x",
                                        label: fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                        flex: 1,
                        flexBasis: 0,
                        $largerThanSM: {
                            p: "$8x"
                        },
                        $largerThanMD: {
                            p: "$10x"
                        },
                        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
                            "$platform-web": {
                                display: "grid"
                            },
                            overflow: "hidden",
                            width: "100%",
                            height: "100%",
                            $largerThanSM: {
                                borderRadius: "$8x"
                            },
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsxs */ .BX)("picture", {
                                style: {
                                    display: "contents"
                                },
                                children: [
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("source", {
                                        media: "(min-width: 768px)",
                                        srcSet: desktopImageSourceUrl
                                    }),
                                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)("img", {
                                        src: mobileImageSourceUrl,
                                        alt: "illustration of a home",
                                        loading: "lazy",
                                        decoding: "async",
                                        style: {
                                            display: "block",
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            objectPosition: "80%"
                                        }
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
var LWCImageCard = {
    render: RenderLWCImageCard
};
/* harmony default export */ __webpack_exports__["Z"] = (LWCImageCard);


/***/ }),

/***/ 21277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22901);
/* harmony import */ var components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91749);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97828);




var RenderLWCTextSection = function(entry) {
    var fields = entry.fields;
    var analyticsName = "cosmos-landing-page-lwc-text-section-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
        analyticsName: analyticsName,
        trackImpression: true,
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .x, {
                "$platform-web": {
                    gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_1__/* .gridStyles.colSpan12 */ .m.colSpan12
                },
                width: "100%",
                flexDirection: "column",
                gap: "$10x",
                mt: "$32x",
                mb: "$24x",
                $largerThanXS: {
                    mt: "$50x",
                    mb: "$32x"
                },
                $largerThanSM: {
                    gap: "$16x",
                    mt: "$40x",
                    mb: "$40x"
                },
                $largerThanLG: {
                    flexDirection: "row",
                    justifyContent: "space-between",
                    alignItems: "center"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Col */ .J, {
                    width: "100%",
                    gap: "$4x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__/* .TitleWithAccent */ .aI, {
                            title: fields === null || fields === void 0 ? void 0 : fields.title,
                            maxWidth: "unset"
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__/* .Desc */ .Xe, {
                            $largerThanMD: {
                                fontSize: 24
                            },
                            children: fields === null || fields === void 0 ? void 0 : fields.description
                        })
                    ]
                })
            })
        })
    });
};
var LWCTextSection = {
    render: RenderLWCTextSection
};
/* harmony default export */ __webpack_exports__["Z"] = (LWCTextSection);


/***/ }),

/***/ 81131:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(56865);
/* harmony import */ var components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(91749);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97828);
/* harmony import */ var _shared_Marker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(24241);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23366);






var MAP_BACKGROUND_IMAGE_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1689881024134-43912.jpg?preset=square-2048";
var MAP_MARKER_IMAGE_URLS = {
    leftTop: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416264-57298.png?preset=square-2048",
    rightTop: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416269-85419.png?preset=square-2048",
    leftMiddle: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416260-76025.png?preset=square-2048",
    leftBottom: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416240-88834.png?preset=square-2048",
    rightBottom: "https://images.opendoor.com/source/s3/imgdrop-production/2023-04-1682635416253-95450.png?preset=square-2048"
};
var RenderMapBackgroundHero = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
        analyticsName: "cosmos-landing-page-map-background-hero-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        trackImpression: true,
        position: "relative",
        justifyContent: "center",
        width: "100%",
        $largerThanXS: {
            minHeight: "$652x"
        },
        $largerThanSM: {
            minHeight: "$548x",
            py: "$16x"
        },
        $largerThanMD: {
            minHeight: "$848x"
        },
        alignItems: "center",
        py: "$10x",
        mt: "$50x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                zIndex: 0,
                width: "100%",
                height: "100%",
                position: "absolute",
                top: 0,
                left: 0,
                right: 0,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
                    alt: "map background hero",
                    source: {
                        uri: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapBackgroundImageUrl */ .kp)(MAP_BACKGROUND_IMAGE_URL)
                    },
                    resizeMode: "cover",
                    width: "100%",
                    height: "100%"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftTop),
                left: "10%",
                top: "17%",
                height: "$40x",
                width: "$101x",
                $largerThanXS: {
                    top: "12%"
                },
                $largerThanSM: {
                    top: "12%",
                    height: "$51x",
                    width: "$129x"
                },
                className: _shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* .MarkerPulseClassName */ .XM,
                animationDelay: "2s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.rightTop),
                right: "7%",
                top: "4%",
                height: "$40x",
                width: "$101x",
                $largerThanSM: {
                    right: "30%",
                    top: "7%",
                    height: "$51x",
                    width: "$129x"
                },
                className: _shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* .MarkerPulseClassName */ .XM,
                animationDelay: "0.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftMiddle),
                display: "none",
                left: "8%",
                top: "40%",
                height: "$40x",
                width: "$101x",
                $largerThanSM: {
                    display: "flex",
                    height: "$51x",
                    width: "$129x"
                },
                className: _shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* .MarkerPulseClassName */ .XM,
                animationDelay: "0.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.leftBottom),
                left: "15%",
                top: "80%",
                height: "$40x",
                width: "$101x",
                $largerThanSM: {
                    top: "85%",
                    height: "$51x",
                    width: "$129x"
                },
                className: _shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* .MarkerPulseClassName */ .XM
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                imageSource: (0,_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .resizeMapMarkerImageUrl */ .j5)(MAP_MARKER_IMAGE_URLS.rightBottom),
                right: "4%",
                top: "90%",
                height: "$40x",
                width: "$101x",
                $largerThanXS: {
                    top: "85%"
                },
                $largerThanSM: {
                    right: "15%",
                    top: "60%",
                    height: "$51x",
                    width: "$129x"
                },
                className: _shared_Marker__WEBPACK_IMPORTED_MODULE_2__/* .MarkerPulseClassName */ .XM,
                animationDelay: "2.5s"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                justifyContent: "center",
                position: "relative",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                    "$platform-web": {
                        gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_1__/* .gridStyles.colSpan12 */ .m.colSpan12
                    },
                    justifyContent: "center",
                    zIndex: 1,
                    alignItems: "center",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Col */ .J, {
                            mb: "$12x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    tag: "h2",
                                    typography: "$headerSmall",
                                    display: "block",
                                    color: "$contentInversePrimary",
                                    textAlign: "center",
                                    $largerThanSM: {
                                        typography: "$headerMedium"
                                    },
                                    $largerThanMD: {
                                        typography: "$headerLarge"
                                    },
                                    children: fields === null || fields === void 0 ? void 0 : fields.title
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    tag: "h2",
                                    typography: "$headerSmall",
                                    display: "block",
                                    color: "$contentInverseSecondary",
                                    textAlign: "center",
                                    $largerThanSM: {
                                        typography: "$headerMedium"
                                    },
                                    $largerThanMD: {
                                        typography: "$headerLarge"
                                    },
                                    opacity: 0.65,
                                    children: fields === null || fields === void 0 ? void 0 : fields.secondaryTitle
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Row */ .X, {
                            width: "100%",
                            $largerThanXS: {
                                maxWidth: "$272x"
                            },
                            $largerThanMD: {
                                maxWidth: "$375x"
                            },
                            justifyContent: "center",
                            mb: "$24x",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(components_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_0__/* .Desc */ .Xe, {
                                textAlign: "center",
                                typography: "$bodyMedium",
                                $largerThanMD: {
                                    typography: "$bodyXlarge"
                                },
                                color: "$contentInversePrimary",
                                children: fields === null || fields === void 0 ? void 0 : fields.description
                            })
                        }),
                        (fields === null || fields === void 0 ? void 0 : fields.ctaLink) && (fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Button */ .z, {
                            variant: "primary",
                            "aria-label": fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText,
                            analyticsName: "cosmos-landing-page-map-background-hero-cta-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
                            href: fields === null || fields === void 0 ? void 0 : fields.ctaLink,
                            label: fields === null || fields === void 0 ? void 0 : fields.ctaDisplayText,
                            size: "small",
                            maxWidth: "$165x",
                            height: "$60x",
                            borderRadius: "$7x",
                            py: "$10x",
                            px: "$12dot5x",
                            backgroundColor: "$backgroundAccentBrand"
                        })
                    ]
                })
            })
        ]
    });
};
var MapBackgroundHero = {
    render: RenderMapBackgroundHero
};
/* harmony default export */ __webpack_exports__["Z"] = (MapBackgroundHero);


/***/ }),

/***/ 96309:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(84402);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(62071);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _Grid__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97828);
/* harmony import */ var _shared_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23366);





var DESKTOP_CARD_ROW_MEDIA = "(min-width: 1201px)";
var getAvatarImageUrl = function(entry) {
    var ref, ref1, ref2;
    var imageUrl = (ref = entry.fields.image) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.file) === null || ref2 === void 0 ? void 0 : ref2.url;
    return imageUrl ? (0,_shared_utils__WEBPACK_IMPORTED_MODULE_2__/* .resizeTestimonialAvatarImageUrl */ .Fg)(imageUrl) : null;
};
var TestimonialCard = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var resizedImageUrl = getAvatarImageUrl(entry);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
        flex: 1,
        borderRadius: 36,
        p: 36,
        backgroundColor: "$backgroundTertiary",
        alignItems: "center",
        gap: "$12x",
        $smallerThanMD: {
            p: "$12x"
        },
        children: [
            resizedImageUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                width: 112,
                height: 112,
                $smallerThanMD: {
                    width: 80,
                    height: 80
                },
                borderRadius: "$full",
                overflow: "hidden",
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Image */ .E, {
                    source: {
                        uri: resizedImageUrl
                    },
                    alt: fields.name,
                    width: 112,
                    height: 112,
                    $smallerThanMD: {
                        width: 80,
                        height: 80
                    },
                    "$platform-web": {
                        objectFit: "cover"
                    }
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyMedium",
                color: "$contentPrimary",
                textAlign: "center",
                children: [
                    "“",
                    fields.quote,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                gap: "$2x",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                        tag: "p",
                        typography: "$labelLarge",
                        color: "$contentPrimary",
                        children: fields.name
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                        tag: "p",
                        typography: "$labelSmall",
                        color: "$contentTertiary",
                        children: fields.locationContext
                    })
                ]
            })
        ]
    });
};
var RenderPhotoTestimonials = function(entry) {
    var fields = entry.fields;
    var _cards;
    var cards = (_cards = fields.cards) !== null && _cards !== void 0 ? _cards : [];
    var avatarImageUrls = Array.from(new Set(cards.map(getAvatarImageUrl).filter(function(url) {
        return Boolean(url);
    })));
    var ref;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
        analyticsName: "cosmos-landing-page-photo-testimonials-".concat((ref = fields === null || fields === void 0 ? void 0 : fields.analyticsId) !== null && ref !== void 0 ? ref : entry.sys.id),
        trackImpression: true,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_0___default()), {
                children: avatarImageUrls.map(function(url, index) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("link", {
                        rel: "preload",
                        as: "image",
                        href: url,
                        media: index === 0 ? undefined : DESKTOP_CARD_ROW_MEDIA,
                        fetchPriority: "high"
                    }, "photo-testimonials-avatar-".concat(url));
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_Grid__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                py: "$32x",
                $smallerThanMD: {
                    py: "$16x"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                    "$platform-web": {
                        gridColumn: _Grid__WEBPACK_IMPORTED_MODULE_1__/* .gridStyles.colSpan12 */ .m.colSpan12
                    },
                    gap: "$20x",
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                            gap: "$6x",
                            children: [
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                    tag: "p",
                                    typography: "$labelSmall",
                                    color: "$contentAccentBrand",
                                    children: fields.eyebrow
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, {
                                    gap: "$4x",
                                    children: [
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "h2",
                                            typography: "$headerSmall",
                                            color: "$contentPrimary",
                                            children: fields.counterTarget ? "".concat(fields.counterTarget.toLocaleString("en-US"), " ").concat(fields.title) : fields.title
                                        }),
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Text */ .x, {
                                            tag: "p",
                                            typography: "$bodyMedium",
                                            color: "$contentTertiary",
                                            children: fields.description
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                            flexDirection: "row",
                            gap: "$10x",
                            $smallerThanLG: {
                                flexDirection: "column"
                            },
                            children: cards.map(function(card) {
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                                    flex: 1,
                                    minWidth: 280,
                                    $smallerThanLG: {
                                        minWidth: "auto"
                                    },
                                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(TestimonialCard, {
                                        entry: card
                                    })
                                }, card.sys.id);
                            })
                        })
                    ]
                })
            })
        ]
    });
};
var PhotoTestimonials = {
    render: RenderPhotoTestimonials
};
/* harmony default export */ __webpack_exports__["Z"] = (PhotoTestimonials);


/***/ }),

/***/ 6902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22901);
/* harmony import */ var _shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47456);



var bricksBgToToken = {
    white0: "$backgroundPrimary",
    warmgrey100: "$backgroundSecondary",
    earth100: "$backgroundSecondary",
    earth200: "$backgroundTertiary",
    brandBlue600: "$backgroundAccentBrand",
    warmgrey200: "$backgroundTertiary",
    warmgrey800: "$backgroundInversePrimary",
    warmgrey950: "$backgroundInversePrimary",
    neutrals100: "$backgroundInversePrimary"
};
var RenderSpacer = function(entry) {
    var fields = entry.fields;
    var componentTheme = fields.backgroundColor ? (0,_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_0__/* .getComponentThemeColors */ ._Y)(fields.backgroundColor) : (0,_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_0__/* .getComponentThemeColors */ ._Y)("White 0");
    var bgColor = componentTheme.bg ? String(componentTheme.bg) : "white0";
    var bgToken = bricksBgToToken[bgColor] || "$backgroundPrimary";
    var mobileHeight = parseInt(fields.mobileSpace, 10);
    // `!= null` so an authored desktop "0" stays 0 rather than inheriting mobile.
    var desktopHeight = fields.space != null ? parseInt(fields.space, 10) : mobileHeight;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        display: "block",
        className: "lp-spacer",
        backgroundColor: bgToken,
        "aria-hidden": true,
        height: mobileHeight,
        $largerThanSM: {
            height: desktopHeight
        }
    });
};
var Spacer = {
    render: RenderSpacer
};
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 94479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ CenteredLayout; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(37705);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(93089);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var _contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52058);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(64786);
/* harmony import */ var _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(46320);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(24439);
/* harmony import */ var _shared_Container__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(51462);
/* harmony import */ var _shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var _StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(96675);
/* harmony import */ var _StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13__);











var bodyParser = function(param) {
    var gridColumnConfig = param.gridColumnConfig, blockquoteGridColumn = param.blockquoteGridColumn, pGridColumn = param.pGridColumn, textAlign = param.textAlign, largerThanSMTextAlign = param.largerThanSMTextAlign;
    var _obj;
    return {
        renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "p",
                typography: "$bodyLarge",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: pGridColumn !== null && pGridColumn !== void 0 ? pGridColumn : gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.QUOTE, function(node, _) {
            var text = node.content.flatMap(function(p) {
                return "content" in p ? p.content : [];
            }).map(function(t) {
                return "value" in t ? t.value : "";
            }).join("");
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
                tag: "blockquote",
                ml: "$8",
                position: "relative",
                $largerThanSM: {
                    ml: "$0"
                },
                "$platform-web": {
                    gridColumn: blockquoteGridColumn
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "span",
                        "aria-hidden": true,
                        typography: "$headerMedium",
                        position: "absolute",
                        "$platform-web": {
                            right: "calc(100% + 16px)"
                        },
                        children: "“"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "p",
                        typography: "$headerMedium",
                        textAlign: textAlign,
                        $largerThanSM: largerThanSMTextAlign ? {
                            textAlign: largerThanSMTextAlign
                        } : undefined,
                        children: text
                    })
                ]
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_1, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h1",
                typography: "$subheaderLarge",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h2",
                typography: "$subheaderLarge",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_3, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h3",
                typography: "$subheaderMedium",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_4, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h4",
                typography: "$subheaderSmall",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_5, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h5",
                typography: "$bodyLarge",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_6, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                tag: "h6",
                typography: "$bodyMedium",
                textAlign: textAlign,
                $largerThanSM: largerThanSMTextAlign ? {
                    textAlign: largerThanSMTextAlign
                } : undefined,
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                tag: "ul",
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.OL_LIST, function(_, children) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                tag: "ol",
                "$platform-web": {
                    gridColumn: gridColumnConfig
                },
                children: children
            });
        }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.EMBEDDED_ENTRY, function(node) {
            var target = node.data.target;
            if (target.sys.contentType.sys.id === "lpComponentMedia") {
                var ref, ref1, ref2, ref3;
                var fields = target.fields;
                var ref4;
                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                    "$platform-web": {
                        gridColumn: fields.size === "Large" ? "1 / -1" : gridColumnConfig,
                        scrollMarginTop: "80px"
                    },
                    children: fields.image && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, {
                        source: {
                            uri: (ref4 = (ref = fields.image.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.file) === null || ref1 === void 0 ? void 0 : ref1.url) !== null && ref4 !== void 0 ? ref4 : ""
                        },
                        alt: ((ref2 = fields.image.fields) === null || ref2 === void 0 ? void 0 : ref2.description) || ((ref3 = fields.image.fields) === null || ref3 === void 0 ? void 0 : ref3.title) || "",
                        borderRadius: "$8x"
                    })
                });
            }
            var fields1 = target.fields;
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                id: fields1.elementID,
                "$platform-web": {
                    gridColumn: gridColumnConfig,
                    scrollMarginTop: "80px"
                },
                children: fields1.title && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields1.title)
            });
        }), _obj)
    };
};
var introOptions = {
    renderNode: (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
            tag: "p",
            typography: "$bodyLarge",
            children: children
        });
    })
};
var _obj;
var sidebarParse = {
    renderNode: (_obj = {}, (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.HEADING_2, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
            tag: "h2",
            color: "$contentSecondary",
            typography: "$headerMedium",
            fontWeight: "$medium",
            mb: "$6",
            pb: "$6",
            borderBottomColor: "$borderPrimary",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.UL_LIST, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
            tag: "ul",
            role: "list",
            mb: "$6",
            p: "$0",
            "$platform-web": {
                listStyle: "none"
            },
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.LIST_ITEM, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
            tag: "li",
            mb: "$6",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.BLOCKS.PARAGRAPH, function(_, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
            tag: "p",
            typography: "$bodyMedium",
            color: "$contentSecondary",
            children: children
        });
    }), (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_obj, _contentful_rich_text_types__WEBPACK_IMPORTED_MODULE_1__.INLINES.HYPERLINK, function(node, children) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
            href: node.data.uri,
            analyticsName: "cosmos-landing-page-standalone-text-sidebar",
            fontWeight: "$medium",
            mb: "$2",
            "$platform-web": {
                display: "block"
            },
            children: children
        });
    }), _obj)
};
// dialogId is for instances where the Standalone text is in a Sheet
var Header = function(param) {
    var entry = param.entry, dialogId = param.dialogId, centered = param.centered;
    var fields = entry.fields;
    var centeredTextProps = centered ? {
        $largerThanSM: {
            textAlign: "center"
        }
    } : {};
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
        tag: "header",
        mb: "$4",
        $largerThanSM: {
            mb: "$6"
        },
        children: [
            fields.title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .TitleWithAccent */ .aI, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({
                overRideTitleTag: "h1",
                title: fields.title,
                titleAccent: fields.titleAccent,
                titleSize: fields.titleSize,
                marginHorizontal: fields.layout === "Centered" ? "auto" : undefined
            }, centeredTextProps), {
                id: dialogId || undefined
            })),
            fields.subhead && (fields.titleSize === "Large" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Subhead */ .vF, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, centeredTextProps), {
                children: fields.subhead
            })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .SubheadSmall */ .Jm, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)({}, centeredTextProps), {
                children: fields.subhead
            })))
        ]
    });
};
var Cta = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var _ctaUrl;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Link */ .r, {
        "aria-label": fields.ctaDisplayText || undefined,
        analyticsName: "cosmos-landing-page-standalone-text-".concat(fields === null || fields === void 0 ? void 0 : fields.analyticsId),
        href: (_ctaUrl = fields.ctaUrl) !== null && _ctaUrl !== void 0 ? _ctaUrl : "",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Row */ .X, {
            alignItems: "center",
            gap: "$2",
            mt: "$6",
            $largerThanSM: {
                mt: "$8"
            },
            "$platform-web": {
                display: "inline-flex"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                    size: 15
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                    marginTop: -1,
                    tag: "p",
                    typography: "$bodyMedium",
                    fontWeight: "$medium",
                    color: "$backgroundAccentBrand",
                    whiteSpace: "nowrap",
                    children: fields.ctaDisplayText
                })
            ]
        })
    });
};
var SidebarLayout = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().grid12),
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                        "$platform-web": {
                            gridColumn: "1 / 9"
                        },
                        children: [
                            (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Header, {
                                entry: entry
                            }),
                            fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                                gap: "$8",
                                mb: "$8",
                                $largerThanSM: {
                                    mb: "$16"
                                },
                                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().introColumns),
                                children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                                mb: "$4",
                                gap: halfGap,
                                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().grid8),
                                $largerThanSM: {
                                    mb: "$0"
                                },
                                children: fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                                    gridColumnConfig: "1 / 7",
                                    blockquoteGridColumn: "2 / -1"
                                }))
                            })
                        ]
                    }),
                    fields.sidebar && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                        "$platform-web": {
                            gridColumn: "10 / -1"
                        },
                        children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.sidebar, sidebarParse)
                    })
                ]
            }),
            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Cta, {
                entry: entry
            })
        ]
    });
};
// Centered Layout is also used by Sheets
// dialogId is for instances where the Standalone text is in a Sheet
var CenteredLayout = function(param) {
    var entry = param.entry, dialogId = param.dialogId;
    var fields = entry.fields;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
        className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().grid12),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                gap: halfGap,
                "$platform-web": {
                    gridColumn: "3 / -3"
                },
                children: (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Header, {
                    entry: entry,
                    dialogId: dialogId,
                    centered: true
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                gap: halfGap,
                "$platform-web": {
                    gridColumn: "3 / -3"
                },
                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().grid8),
                children: [
                    fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                        gap: "$8",
                        mb: "$8",
                        $largerThanSM: {
                            mb: "$16"
                        },
                        "$platform-web": {
                            gridColumn: "1 / -1"
                        },
                        className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().introColumns),
                        children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
                    }),
                    fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                        gridColumnConfig: "2 / -2",
                        blockquoteGridColumn: "2 / -2",
                        largerThanSMTextAlign: "center"
                    }))
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                "$platform-web": {
                    gridColumn: "4 / -4"
                },
                $largerThanSM: {
                    alignItems: "center"
                },
                children: fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Cta, {
                    entry: entry
                })
            })
        ]
    });
};
var DefaultLayout = function(param) {
    var entry = param.entry;
    var fields = entry.fields;
    var _bodyPGap;
    var resolvedGap = (_bodyPGap = fields.bodyPGap) !== null && _bodyPGap !== void 0 ? _bodyPGap : 64;
    var halfGap = resolvedGap / 2;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .Fragment */ .HY, {
        children: [
            (fields.title || fields.subhead) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Header, {
                entry: entry
            }),
            fields.intro && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                gap: "$8",
                mb: "$8",
                $largerThanSM: {
                    mb: "$16"
                },
                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().introColumns),
                children: (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.intro, introOptions)
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Col */ .J, {
                gap: halfGap,
                className: (_StandaloneText_module_css__WEBPACK_IMPORTED_MODULE_13___default().grid12),
                children: fields.body && (0,_contentful_rich_text_react_renderer__WEBPACK_IMPORTED_MODULE_0__/* .documentToReactComponents */ .h)(fields.body, bodyParser({
                    gridColumnConfig: "1 / 7",
                    blockquoteGridColumn: "2 / 11",
                    pGridColumn: fields.analyticsId === "cash-plus-h2-standalone" ? "1 / 9" : undefined
                }))
            }),
            fields.ctaDisplayText && fields.ctaUrl && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(Cta, {
                entry: entry
            })
        ]
    });
};
var RenderStandaloneText = function(entry) {
    var fields = entry.fields;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_shared_Container__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .ZP, {
        children: fields.layout === "Sidebar" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(SidebarLayout, {
            entry: entry
        }) : fields.layout === "Centered" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(CenteredLayout, {
            entry: entry
        }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(DefaultLayout, {
            entry: entry
        })
    });
};
var StandaloneText = {
    render: RenderStandaloneText
};
/* harmony default export */ __webpack_exports__["Z"] = (StandaloneText);


/***/ }),

/***/ 23107:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ StickyCTAUtility; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(56865);
/* harmony import */ var _StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10654);
/* harmony import */ var _StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1__);




var ANIMATION_DURATION = 0.7;
var StickyCTAUtility = function(param) {
    var isVisible = param.isVisible, analyticsId = param.analyticsId, _top = param.top, top = _top === void 0 ? "2%" : _top;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), showStickyCTAUtility = ref[0], setShowStickyCTAUtility = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(undefined), animate = ref1[0], setAnimate = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        setAnimate(isVisible ? (_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().reveal) : (_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().hide));
        if (isVisible) {
            setShowStickyCTAUtility(true);
        }
        setTimeout(function() {
            setAnimate(undefined);
            if (!isVisible) {
                setShowStickyCTAUtility(false);
            }
        }, ANIMATION_DURATION * 1000);
    }, [
        isVisible
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Row */ .X, {
        display: showStickyCTAUtility ? "flex" : "none",
        className: "".concat((_StickyCTAUtility_module_css__WEBPACK_IMPORTED_MODULE_1___default().container)).concat(animate ? " ".concat(animate) : ""),
        "$platform-web": {
            position: "fixed",
            top: top
        },
        zIndex: 9999,
        mx: "auto",
        width: "$75",
        $largerThanSM: {
            width: "$90"
        },
        justifyContent: "space-between",
        alignItems: "center",
        p: "$1half",
        borderRadius: "$10x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Text */ .x, {
                tag: "p",
                typography: "$labelXlarge",
                px: "$4",
                $largerThanSM: {
                    px: "$5"
                },
                children: "Still selling?"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .z, {
                maxWidth: "$35",
                $largerThanLG: {
                    maxWidth: "$40"
                },
                onPress: function() {
                    return window.location.assign("/address-entry");
                },
                "aria-label": "sticky CTA utility",
                analyticsName: "cosmos-landing-page-sticky-cta-".concat(analyticsId),
                variant: "primary",
                size: "xsmall",
                label: "Get cash offer",
                minHeight: "$4",
                $largerThanMD: {
                    minHeight: "$13"
                }
            })
        ]
    });
};


/***/ }),

/***/ 13530:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "B": function() { return /* binding */ LPFauxBtn; },
/* harmony export */   "o": function() { return /* binding */ LPLink; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64978);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(22901);
/* harmony import */ var _styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47456);
/* harmony import */ var _Buttons_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(66382);
/* harmony import */ var _Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8__);








// Tell the button which keys from the component theme to use
// based on the variant name.
var getBtnTheme = function(variant) {
    var theme = {
        Primary: {
            bg: "buttonBg",
            color: "buttonColor",
            hover: "buttonHoverBg",
            active: "buttonActiveBg"
        },
        Secondary: {
            bg: "secondaryButtonBg",
            color: "secondaryButtonColor",
            hover: "secondaryButtonHoverBg",
            active: "secondaryButtonActiveBg"
        },
        Tertiary: {
            bg: "tertiaryButtonBg",
            color: "tertiaryButtonColor",
            hover: "tertiaryButtonHoverColor",
            active: "tertiaryButtonActiveColor"
        },
        Text: {
            bg: "transparent",
            color: "linkColor",
            hover: "linkHoverColor",
            active: "linkColor"
        }
    };
    return {
        bg: theme[variant].bg,
        color: theme[variant].color,
        hover: theme[variant].hover,
        active: theme[variant].active
    };
};
// Bricks-next token overrides per variant, used when bnTheme is provided.
var getBNBtnTheme = function(variant, bnTheme, getColorValue) {
    switch(variant){
        case "Secondary":
            return {
                bg: getColorValue(bnTheme.contentPrimary),
                color: getColorValue(bnTheme.bgPrimary),
                hover: getColorValue(bnTheme.secondaryBtnHover),
                active: getColorValue(bnTheme.contentPrimary)
            };
        case "Tertiary":
            return {
                bg: getColorValue(bnTheme.bgPrimaryLight),
                color: getColorValue(bnTheme.contentPrimary),
                hover: getColorValue(bnTheme.tertiaryBtnHover),
                active: getColorValue(bnTheme.bgPrimaryLight)
            };
        case "Primary":
        default:
            return {
                bg: getColorValue(bnTheme.bgAccentBrand),
                color: getColorValue(bnTheme.buttonLabelPrimary),
                hover: getColorValue(bnTheme.bgHoverAccentBrand),
                active: getColorValue(bnTheme.bgHoverAccentBrand)
            };
    }
};
// TODO: Remove component theme once bnTheme is completely implemented
var LPLink = function(_param) {
    var componentTheme = _param.componentTheme, bnTheme = _param.bnTheme, _ctaStyle = _param.ctaStyle, ctaStyle = _ctaStyle === void 0 ? "Primary" : _ctaStyle, ctaUrl = _param.ctaUrl, ctaDisplayText = _param.ctaDisplayText, ref = _param.ref, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "componentTheme",
        "bnTheme",
        "ctaStyle",
        "ctaUrl",
        "ctaDisplayText",
        "ref"
    ]);
    var btnTheme = getBtnTheme(ctaStyle);
    var getColorValue = function(bnColorToken) {
        return (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__.getToken)(bnColorToken, "color");
    };
    var bnBtn = bnTheme ? getBNBtnTheme(ctaStyle, bnTheme, getColorValue) : null;
    var ref1, ref2;
    var backgroundColor = (ref2 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.bg) !== null && ref2 !== void 0 ? ref2 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref1 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.bg]) !== null && ref1 !== void 0 ? ref1 : "brandBlue600");
    var ref3, ref4;
    var color = (ref4 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.color) !== null && ref4 !== void 0 ? ref4 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref3 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.color]) !== null && ref3 !== void 0 ? ref3 : "white0");
    var ref5, ref6;
    var hoverBg = (ref6 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.hover) !== null && ref6 !== void 0 ? ref6 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref5 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.hover]) !== null && ref5 !== void 0 ? ref5 : "white0");
    var ref7, ref8;
    var activeBg = (ref8 = bnBtn === null || bnBtn === void 0 ? void 0 : bnBtn.active) !== null && ref8 !== void 0 ? ref8 : (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)((ref7 = componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme[btnTheme.active]) !== null && ref7 !== void 0 ? ref7 : "white0");
    var ref9, ref10, ref11;
    return ctaStyle === "Text" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        color: (ref9 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkColor)) !== null && ref9 !== void 0 ? ref9 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkColor),
        cursor: "pointer",
        display: "inline-flex",
        href: ctaUrl,
        size: "medium",
        typography: "$labelMedium",
        mt: "$6",
        ref: ref
    }, props), {
        hoverStyle: {
            color: (ref10 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkHoverColor)) !== null && ref10 !== void 0 ? ref10 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkHover)
        },
        pressStyle: {
            color: (ref11 = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme === null || componentTheme === void 0 ? void 0 : componentTheme.linkColor)) !== null && ref11 !== void 0 ? ref11 : getColorValue(bnTheme === null || bnTheme === void 0 ? void 0 : bnTheme.linkHover)
        },
        children: ctaDisplayText
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Link */ .r, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        backgroundColor: backgroundColor,
        borderRadius: "$8x",
        className: (_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default().lpButton),
        color: color,
        cursor: "pointer",
        href: ctaUrl,
        display: "inline-flex",
        size: "medium",
        position: "relative",
        py: "$4",
        px: "$6",
        mt: "$6",
        width: "auto",
        ref: ref,
        style: {
            "--lp-btn-hover-bg": hoverBg
        },
        hoverStyle: {
            color: color
        },
        focusVisibleStyle: {
            color: color,
            backgroundColor: hoverBg
        },
        pressStyle: {
            color: color,
            backgroundColor: activeBg
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
            tag: "span",
            typography: "$labelLarge",
            color: color,
            zIndex: 5,
            children: ctaDisplayText
        })
    }));
};
var LPFauxBtn = function(_param) {
    var componentTheme = _param.componentTheme, _ctaStyle = _param.ctaStyle, ctaStyle = _ctaStyle === void 0 ? "Primary" : _ctaStyle, ctaDisplayText = _param.ctaDisplayText, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "componentTheme",
        "ctaStyle",
        "ctaDisplayText"
    ]);
    var btnTheme = getBtnTheme(ctaStyle);
    var backgroundColor = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.bg] : "brandBlue600");
    var color = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.color] : "white0");
    var hoverBg = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.hover] : "blue700");
    var activeBg = (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme ? componentTheme[btnTheme.active] : "blue700");
    return ctaStyle === "Text" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        tag: "span",
        typography: "$bodyMedium",
        color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkColor),
        cursor: "pointer",
        display: "inline-flex",
        mt: "$8"
    }, props), {
        hoverStyle: {
            color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkHoverColor)
        },
        pressStyle: {
            color: (0,_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .resolveBricksColor */ .pz)(componentTheme.linkColor)
        },
        children: ctaDisplayText
    })) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)({
        tag: "span",
        backgroundColor: backgroundColor,
        borderRadius: "$8x",
        className: (_Buttons_module_css__WEBPACK_IMPORTED_MODULE_8___default().lpButton),
        cursor: "pointer",
        display: "inline-flex",
        position: "relative",
        py: "$4",
        px: "$6",
        mt: "$8",
        width: "auto",
        style: {
            "--lp-btn-hover-bg": hoverBg
        },
        hoverStyle: {
            backgroundColor: backgroundColor
        },
        focusVisibleStyle: {
            backgroundColor: hoverBg
        },
        pressStyle: {
            backgroundColor: activeBg
        }
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Text */ .x, {
            tag: "span",
            typography: "$labelLarge",
            color: color,
            zIndex: 5,
            children: ctaDisplayText
        })
    }));
};


/***/ }),

/***/ 51462:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "IX": function() { return /* binding */ LandingPageSectionContainer; },
/* harmony export */   "z6": function() { return /* binding */ NetProceedsCalculatorContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22901);





var Container = function(_param) {
    var children = _param.children, backgroundColor = _param.backgroundColor, style = _param.style, noSectionSpacing = _param.noSectionSpacing, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "children",
        "backgroundColor",
        "style",
        "noSectionSpacing"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        display: "block",
        className: noSectionSpacing ? undefined : "lp-section",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
            backgroundColor: backgroundColor,
            style: style,
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
                display: "block",
                maxWidth: 1440,
                paddingHorizontal: "$10x",
                $largerThanSM: {
                    paddingHorizontal: "$20x"
                },
                $largerThanMD: {
                    paddingHorizontal: "$32x"
                },
                width: "100%",
                marginHorizontal: "auto"
            }, props), {
                children: children
            }))
        })
    });
};
var NetProceedsCalculatorContainer = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        display: "block",
        maxWidth: 1440,
        paddingHorizontal: "$10x",
        $largerThanSM: {
            paddingHorizontal: "$20x"
        },
        $largerThanMD: {
            paddingHorizontal: "$32x"
        },
        width: "100%",
        marginHorizontal: "auto"
    }, props), {
        children: children
    }));
};
var LandingPageSectionContainer = function(_param) {
    var children = _param.children, boxProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, {
        display: "block",
        className: "lp-section",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            marginTop: "$16x",
            display: "block",
            maxWidth: 1440,
            paddingHorizontal: "$10x",
            $largerThanSM: {
                paddingHorizontal: "$20x"
            },
            $largerThanMD: {
                paddingHorizontal: "$32x"
            },
            width: "100%",
            marginHorizontal: "auto"
        }, boxProps), {
            children: children
        }))
    });
};

/* harmony default export */ __webpack_exports__["ZP"] = (Container);


/***/ }),

/***/ 69886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ FCContentContainer; },
/* harmony export */   "W": function() { return /* binding */ FCContentContainerWrapper; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(55128);





function FCContentContainer(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    var $largerThanMD = rest.$largerThanMD, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(rest, [
        "$largerThanMD"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        paddingHorizontal: "$12x",
        $largerThanMD: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            maxWidth: 1400,
            paddingHorizontal: "$40x"
        }, $largerThanMD),
        width: "100%",
        flex: 1
    }, restProps), {
        children: children
    }));
}
function FCContentContainerWrapper(_param) {
    var children = _param.children, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Col */ .J, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        width: "100%",
        alignItems: "center"
    }, rest), {
        children: children
    }));
}


/***/ }),

/***/ 24241:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "XM": function() { return /* binding */ MarkerPulseClassName; },
/* harmony export */   "eO": function() { return /* binding */ MarkerFadeInClassName; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(34984);
/* harmony import */ var components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57945);
/* harmony import */ var _Marker_module_css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56936);
/* harmony import */ var _Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_Marker_module_css__WEBPACK_IMPORTED_MODULE_1__);







var MarkerPulseClassName = (_Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default().markerPulse);
var MarkerFadeInClassName = (_Marker_module_css__WEBPACK_IMPORTED_MODULE_1___default().markerFadeIn);
var Marker = function(_param) {
    var imageSource = _param.imageSource, _preload = _param.preload, preload = _preload === void 0 ? false : _preload, _lazy = _param.lazy, lazy = _lazy === void 0 ? true : _lazy, _animationDelay = _param.animationDelay, animationDelay = _animationDelay === void 0 ? "0s" : _animationDelay, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "imageSource",
        "preload",
        "lazy",
        "animationDelay"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_4__/* .Col */ .J, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        position: "absolute"
    }, props), {
        style: {
            animationDelay: animationDelay
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Row */ .X, {
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(components_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_0__/* .Picture */ .t, {
                preload: preload,
                lazy: lazy,
                sources: [
                    {
                        srcSet: imageSource,
                        media: "(min-width: 0px)",
                        key: imageSource
                    }
                ],
                objectFit: "cover"
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["ZP"] = (Marker);


/***/ }),

/***/ 38243:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96492);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(16064);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(54999);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(23515);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4701);
/* harmony import */ var framer_motion__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(45198);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56321);
/* harmony import */ var _StandaloneText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94479);
/* harmony import */ var _trapFocus__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43274);








var backdropVariants = {
    hidden: {
        opacity: 0,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            delay: 0.5,
            duration: 0.2
        }
    },
    visible: {
        opacity: 1,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.2
        }
    }
};
var boxVariants = {
    hidden: {
        y: "100%",
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.5
        }
    },
    visible: {
        y: 0,
        transition: {
            ease: [
                0.55,
                0,
                0.15,
                1
            ],
            duration: 0.75
        }
    }
};
var SheetContent = function(param) {
    var entry = param.entry, setIsVisible = param.setIsVisible;
    var dialogId = "dialog-".concat(Math.floor(Math.random() * 100 + 1), "-").concat(entry.sys.id);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var onComplete = function(definition) {
        // Only focus on main sheet container when the visible animation is complete
        // or it messes up the animation
        if (definition === "visible") {
            var ref;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)("div", {
        role: "presentation",
        onKeyDown: function(e) {
            return (0,_trapFocus__WEBPACK_IMPORTED_MODULE_4__/* .trapFocus */ .S)(e, containerRef);
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
            display: "block",
            bottom: 0,
            top: 0,
            left: 0,
            right: 0,
            pt: "$20",
            px: "$4",
            pb: "$0",
            zIndex: 3000,
            $largerThanSM: {
                pt: "$28",
                px: "$4",
                pb: "$0"
            },
            "$platform-web": {
                position: "fixed",
                display: "grid",
                gridTemplateRows: "1fr",
                gridTemplateColumns: "1fr",
                overflow: "auto",
                overscrollBehaviorY: "contain"
            },
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    onAnimationComplete: function(definition) {
                        onComplete(definition);
                    },
                    variants: boxVariants,
                    initial: "hidden",
                    animate: "visible",
                    exit: "hidden",
                    style: {
                        gridArea: "1 / 1 / -1 / -1",
                        zIndex: 10,
                        position: "relative"
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Box */ .x, {
                        display: "block",
                        tabIndex: -1,
                        ref: containerRef,
                        backgroundColor: "$backgroundPrimary",
                        maxWidth: "$360",
                        mx: "auto",
                        pt: "$16",
                        px: "$4",
                        pb: "$8",
                        role: "dialog",
                        "aria-labelledby": dialogId,
                        "aria-modal": true,
                        borderTopLeftRadius: "$8x",
                        borderTopRightRadius: "$8x",
                        minHeight: "100%",
                        $largerThanSM: {
                            pt: "$37",
                            px: "$4",
                            pb: "$8"
                        },
                        "$platform-web": {
                            outline: "0"
                        },
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .IconButton */ .hU, {
                                analyticsName: "",
                                "aria-label": "Close",
                                onPress: function() {
                                    return setIsVisible(false);
                                },
                                size: "large",
                                icon: {
                                    Component: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z),
                                    label: "Close"
                                },
                                backgroundColor: "$backgroundTertiary",
                                position: "absolute",
                                right: "$4",
                                top: "$4"
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_StandaloneText__WEBPACK_IMPORTED_MODULE_2__/* .CenteredLayout */ .B, {
                                entry: entry,
                                dialogId: dialogId
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
                    variants: backdropVariants,
                    initial: "hidden",
                    animate: "visible",
                    exit: "hidden",
                    style: {
                        gridArea: "1 / 1 / -1 / -1",
                        zIndex: 0
                    },
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .PressableBox */ .K, {
                        analyticsName: "",
                        onPress: function() {
                            return setIsVisible(false);
                        },
                        "aria-hidden": true,
                        bottom: 0,
                        top: 0,
                        left: 0,
                        right: 0,
                        "aria-label": "Close sheet",
                        "$platform-web": {
                            position: "fixed",
                            backgroundColor: "rgba(0, 0, 0, 0.2)"
                        }
                    })
                })
            ]
        })
    });
};
var Sheet = function(param) {
    var entry = param.entry, isVisible = param.isVisible, setIsVisible = param.setIsVisible, exitComplete = param.exitComplete;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), mounted = ref[0], setMounted = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return setMounted(true);
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.body.classList.toggle("has-sheet", isVisible);
    }, [
        isVisible
    ]);
    var escFunction = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(event) {
        if (event.key === "Escape") {
            setIsVisible(false);
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        document.addEventListener("keydown", escFunction, false);
        return function() {
            document.removeEventListener("keydown", escFunction, false);
        };
    }, [
        escFunction
    ]);
    return mounted ? /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_1__.createPortal)(/*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_11__/* .AnimatePresence */ .M, {
        initial: false,
        onExitComplete: function() {
            return exitComplete();
        },
        children: isVisible && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(framer_motion__WEBPACK_IMPORTED_MODULE_6__/* .motion.div */ .E.div, {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(SheetContent, {
                entry: entry,
                setIsVisible: setIsVisible
            })
        }, "sheet-".concat(entry.sys.id))
    }), document.body) : null;
};
/* harmony default export */ __webpack_exports__["Z"] = (Sheet);


/***/ }),

/***/ 91749:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Jm": function() { return /* binding */ SubheadSmall; },
/* harmony export */   "Xe": function() { return /* binding */ Desc; },
/* harmony export */   "aI": function() { return /* binding */ TitleWithAccent; },
/* harmony export */   "j4": function() { return /* binding */ Eyebrow; },
/* harmony export */   "vF": function() { return /* binding */ Subhead; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84402);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(23366);






var Eyebrow = function(_param) {
    var children = _param.children, size = _param.size, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children",
        "size"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "p",
        typography: size !== null && size !== void 0 ? size : "$bodySmall",
        fontWeight: "$medium",
        display: "block",
        color: "$borderStateHoverPrimary"
    }, props), {
        children: children
    }));
};
var Subhead = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "h4",
        display: "block",
        typography: "$bodyLarge",
        fontWeight: "$medium",
        color: "$contentPrimary"
    }, props), {
        children: children
    }));
};
var SubheadSmall = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "h3",
        typography: "$bodyLarge",
        $smallerThanLG: {
            typography: "$bodyMedium",
            fontWeight: "$medium"
        },
        fontWeight: "$medium",
        color: "$contentPrimary",
        display: "block"
    }, props), {
        children: children
    }));
};
var TitleWithAccent = function(_param) {
    var title = _param.title, titleAccent = _param.titleAccent, titleSize = _param.titleSize, titleColor = _param.titleColor, titleAccentColor = _param.titleAccentColor, breakTitles = _param.breakTitles, overRideTitleTag = _param.overRideTitleTag, $largerThanSM = _param.$largerThanSM, $largerThanMD = _param.$largerThanMD, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "title",
        "titleAccent",
        "titleSize",
        "titleColor",
        "titleAccentColor",
        "breakTitles",
        "overRideTitleTag",
        "$largerThanSM",
        "$largerThanMD"
    ]);
    var typography = {
        typography: titleSize === "Large" ? "$headerSmall" : "$headerMedium",
        $largerThanSM: {
            typography: titleSize === "Large" ? "$displaySmall" : "$headerMedium"
        },
        $largerThanMD: {
            typography: titleSize === "Large" ? "$displaySmall" : "$headerMedium"
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: overRideTitleTag || "h2"
    }, typography), {
        display: "block",
        maxWidth: "16ch",
        color: titleColor || "$contentPrimary",
        mb: "$8x",
        $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, typography.$largerThanSM, $largerThanSM),
        $largerThanMD: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, typography.$largerThanMD, $largerThanMD)
    }), props), {
        whiteSpace: "normal",
        children: [
            (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(title || ""),
            breakTitles && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)("br", {}),
            titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                tag: "span"
            }, typography), {
                color: titleAccentColor || "$contentTertiary",
                $largerThanSM: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, typography.$largerThanSM, $largerThanSM),
                $largerThanMD: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, typography.$largerThanMD, $largerThanMD)
            }), props), {
                whiteSpace: "normal",
                children: [
                    " ",
                    (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(titleAccent)
                ]
            }))
        ]
    }));
};
var Desc = function(_param) {
    var children = _param.children, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "children"
    ]);
    if (!children) return null;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
        tag: "p",
        color: "$contentPrimary",
        typography: "$bodyLarge",
        display: "block"
    }, props), {
        children: (0,_utils__WEBPACK_IMPORTED_MODULE_0__/* .markdownToReactElement */ .vl)(children)
    }));
};


/***/ }),

/***/ 198:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$C": function() { return /* binding */ GLASS_HEADER_HEIGHT; },
/* harmony export */   "Do": function() { return /* binding */ FULLBLEED_HERO_IMAGE_URL; },
/* harmony export */   "Iu": function() { return /* binding */ GLASS_NAV_ACTIVE_COLOR; },
/* harmony export */   "Zl": function() { return /* binding */ isTreatmentAnalyticsId; },
/* harmony export */   "rf": function() { return /* binding */ redirectToLogin; }
/* harmony export */ });
/* unused harmony export TREATMENT_ANALYTICS_IDS */
/* harmony import */ var _globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);

var GLASS_HEADER_HEIGHT = 72;
// No bricks-next semantic token available — used for nav active state and flyout section titles
var GLASS_NAV_ACTIVE_COLOR = "#B5CAFF";
var FULLBLEED_HERO_IMAGE_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2026-04-1775664739908-77107_hero-desktop-1728w.jpg?service=cosmos";
// Shared experiment identifier — used across hero, layout, and header gating logic
var TREATMENT_ANALYTICS_IDS = [
    "hero-test-vercel",
    "fc-address-entry-btf-test"
];
var isTreatmentAnalyticsId = function(analyticsId) {
    return Boolean(analyticsId && TREATMENT_ANALYTICS_IDS.includes(analyticsId.trim()));
};
var redirectToLogin = function() {
    if (true) {
        window.location.href = "".concat(_globals__WEBPACK_IMPORTED_MODULE_0__/* .COSMOS_URL */ .EQ, "/login?redirectTo=").concat(encodeURIComponent(window.location.pathname));
    }
};


/***/ }),

/***/ 19137:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "AJ": function() { return /* binding */ useStickyCTA; },
/* harmony export */   "DB": function() { return /* binding */ preloadHeroImages; },
/* harmony export */   "Ul": function() { return /* binding */ getStickyCTAFromRoot; },
/* harmony export */   "bx": function() { return /* binding */ useHeroContext; },
/* harmony export */   "yL": function() { return /* binding */ HeroProvider; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(48417);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26410);
/* harmony import */ var _shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57945);
/* harmony import */ var _heroConstants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83395);








var HeroContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(null);
var HeroProvider = function(param) {
    var variant = param.variant, analyticsPrefix = param.analyticsPrefix, children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(HeroContext.Provider, {
        value: {
            variant: variant,
            analyticsPrefix: analyticsPrefix
        },
        children: children
    });
};
var useHeroContext = function() {
    var context = (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(HeroContext);
    if (!context) {
        throw new Error("useHeroContext must be used within a HeroProvider");
    }
    return context;
};
var useStickyCTA = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), hasBeenInView = ref[0], setHasBeenInView = ref[1];
    var ref1 = (0,react_intersection_observer__WEBPACK_IMPORTED_MODULE_4__/* .useInView */ .YD)(), addressEntryRef = ref1.ref, addressEntryInView = ref1.inView;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (addressEntryInView) {
            setHasBeenInView(true);
        }
    }, [
        addressEntryInView
    ]);
    // Only show after user has scrolled past it at least once
    var showStickyCTAUtility = hasBeenInView && !addressEntryInView;
    return {
        addressEntryRef: addressEntryRef,
        showStickyCTAUtility: showStickyCTAUtility
    };
};
var preloadHeroImages = function(param) {
    var imageDesktopUrl = param.imageDesktopUrl, imageMobileUrl = param.imageMobileUrl;
    var preloadImages = [];
    if (imageDesktopUrl) {
        var _preloadImages;
        var sources = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_DESKTOP_PROPS */ .t6), {
            photoUrl: imageDesktopUrl
        })).sources;
        (_preloadImages = preloadImages).push.apply(_preloadImages, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources));
    }
    if (imageMobileUrl) {
        var _preloadImages1;
        var sources1 = (0,_shared_performance_pictures__WEBPACK_IMPORTED_MODULE_1__/* .generatePresetPictureSetProps */ .$c)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, _heroConstants__WEBPACK_IMPORTED_MODULE_2__/* .HERO_IMAGE_MOBILE_PROPS */ .Sy), {
            photoUrl: imageMobileUrl
        })).sources;
        (_preloadImages1 = preloadImages).push.apply(_preloadImages1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(sources1));
    }
    return preloadImages;
};
var getStickyCTAFromRoot = function(root) {
    var ref;
    return (root === null || root === void 0 ? void 0 : (ref = root.fields) === null || ref === void 0 ? void 0 : ref.stickyCta) || "";
};


/***/ }),

/***/ 34476:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "j": function() { return /* binding */ PressBox; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93089);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(84402);




var LOGO_HEIGHT = 20;
var PRESET = "square-256";
var createLogoUrl = function(baseUrl, dpr) {
    var params = new URLSearchParams({
        preset: PRESET,
        service: "cosmos",
        dpr: "".concat(dpr)
    });
    return "".concat(baseUrl, "?").concat(params.toString());
};
var FORBES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903565-83391.png";
var FORTUNE_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903560-61291.png";
var NEW_YORK_TIMES_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903555-88900.png";
var WALL_STREET_JOURNAL_LOGO_URL = "https://images.opendoor.com/source/s3/imgdrop-production/2023-07-1690500903562-10942.png";
var PRESS_LOGOS = [
    NEW_YORK_TIMES_LOGO_URL,
    FORBES_LOGO_URL,
    WALL_STREET_JOURNAL_LOGO_URL,
    FORTUNE_LOGO_URL, 
];
var PressBox = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        justifyContent: "center",
        width: "100%",
        $largerThanMD: {
            width: "auto"
        },
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            flexWrap: "wrap",
            columnGap: "$6x",
            padding: "$10x",
            alignItems: "center",
            justifyContent: "center",
            width: "100%",
            borderRadius: 0,
            $largerThanSM: {
                borderRadius: 20,
                width: "unset"
            },
            style: {
                backgroundColor: "rgba(242, 241, 240, 0.64)",
                backdropFilter: "blur(20px)"
            }
        }, props), {
            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .Row */ .X, {
                alignItems: "center",
                justifyContent: "center",
                style: {
                    display: "grid",
                    gridTemplateColumns: "repeat(3, max-content)",
                    gap: "24px",
                    width: "100%",
                    justifyItems: "center"
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .Text */ .x, {
                        tag: "span",
                        typography: "$bodyMedium",
                        color: "$contentStateInactivePrimary",
                        $smallerThanMD: {
                            width: "100%",
                            textAlign: "center"
                        },
                        children: "Featured in:"
                    }),
                    PRESS_LOGOS.map(function(photoUrl) {
                        var srcSet = [
                            "".concat(createLogoUrl(photoUrl, 1), " 1x"),
                            "".concat(createLogoUrl(photoUrl, 2), " 2x"),
                            "".concat(createLogoUrl(photoUrl, 3), " 3x"), 
                        ].join(", ");
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
                            height: LOGO_HEIGHT,
                            width: "auto",
                            display: "flex",
                            justifyContent: "center",
                            children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("img", {
                                src: createLogoUrl(photoUrl, 1),
                                srcSet: srcSet,
                                alt: "",
                                style: {
                                    height: "100%",
                                    width: "auto",
                                    objectFit: "contain"
                                }
                            })
                        }, photoUrl);
                    })
                ]
            })
        }))
    });
};


/***/ }),

/***/ 83395:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$B": function() { return /* binding */ HERO_FULLBLEED_IMAGE_PROPS; },
/* harmony export */   "Sy": function() { return /* binding */ HERO_IMAGE_MOBILE_PROPS; },
/* harmony export */   "t6": function() { return /* binding */ HERO_IMAGE_DESKTOP_PROPS; }
/* harmony export */ });
// Bricks-next breakpoints: SM (375px), MD (768px), LG (1201px), XL (1400px)
var BREAKPOINTS = {
    SM: 375,
    MD: 768,
    LG: 1201,
    XL: 1400
};
var HERO_DESKTOP_IMAGE_SIZES = [
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.LG,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.LG,
        maxWidth: BREAKPOINTS.XL,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.XL,
        maxWidth: null,
        preset: "square-1024"
    }, 
];
var HERO_MOBILE_IMAGE_SIZES = [
    {
        minWidth: 0,
        maxWidth: BREAKPOINTS.SM,
        preset: "square-256"
    },
    {
        minWidth: BREAKPOINTS.SM,
        maxWidth: BREAKPOINTS.MD,
        preset: "square-256"
    },
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.LG,
        preset: "square-512"
    }, 
];
var HERO_IMAGE_DESKTOP_PROPS = {
    sizes: HERO_DESKTOP_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};
var HERO_IMAGE_MOBILE_PROPS = {
    sizes: HERO_MOBILE_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};
var HERO_FULLBLEED_IMAGE_SIZES = [
    {
        minWidth: 0,
        maxWidth: BREAKPOINTS.SM,
        preset: "square-512"
    },
    {
        minWidth: BREAKPOINTS.SM,
        maxWidth: BREAKPOINTS.MD,
        preset: "square-1024"
    },
    {
        minWidth: BREAKPOINTS.MD,
        maxWidth: BREAKPOINTS.XL,
        preset: "square-1024"
    },
    {
        minWidth: BREAKPOINTS.XL,
        maxWidth: null,
        preset: "square-2048"
    }, 
];
var HERO_FULLBLEED_IMAGE_PROPS = {
    sizes: HERO_FULLBLEED_IMAGE_SIZES,
    debugImageSizes: false,
    lazy: false,
    preload: true,
    fetchPriority: "high"
};


/***/ }),

/***/ 47456:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CW": function() { return /* binding */ BNColorThemes; },
/* harmony export */   "_Y": function() { return /* binding */ getComponentThemeColors; },
/* harmony export */   "pz": function() { return /* binding */ resolveBricksColor; },
/* harmony export */   "u$": function() { return /* binding */ getBNComponentThemeColors; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93089);


// Bricks ColorScheme name → CSS hex value
// Used to translate old componentTheme color tokens for bricks-next components
var BRICKS_COLOR_TO_CSS = {
    // Brand blues
    brandBlue600: "#0040E6",
    blue50: "#F2F4F7",
    blue100: "#DFEAF8",
    blue200: "#BBD7FA",
    blue500: "#2B54EA",
    blue700: "#002F93",
    blue900: "#00256B",
    // Warm greys
    white0: "#FFFFFF",
    warmgrey100: "#FAF8F7",
    warmgrey200: "#ECE9E7",
    warmgrey300: "#DEDAD7",
    warmgrey700: "#9D9893",
    warmgrey800: "#736D68",
    warmgrey900: "#403E3C",
    warmgrey950: "#21201F",
    // Earth
    earth100: "#F3F3EE",
    earth200: "#ECE9E7",
    earth300: "#D7D7C4",
    earth700: "#C3C3AF",
    // Legacy
    neutrals100: "#21201F"
};
var _color;
/**
 * Resolve a bricks ColorScheme name to a CSS hex value that bricks-next
 * components can render. Returns the input unchanged if no mapping exists
 * (e.g. already a hex value or bricks-next token).
 *
 * The return type is intentionally loosened so the result can be passed
 * directly to bricks-next color/backgroundColor props without per-site casts.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
var resolveBricksColor = function(color) {
    return (_color = BRICKS_COLOR_TO_CSS[color]) !== null && _color !== void 0 ? _color : color;
};
var getComponentThemeColors = function(background) {
    var theme = {
        "White 0": {
            bg: "white0",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey200",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey300",
            tertiaryButtonActiveColor: "warmgrey200",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Off White": {
            bg: "warmgrey100",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey200",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey300",
            tertiaryButtonActiveColor: "warmgrey200",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Earth 100": {
            bg: "earth100",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "earth300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "earth700",
            tertiaryButtonActiveColor: "earth700",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Earth 200": {
            bg: "earth200",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "earth300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "earth700",
            tertiaryButtonActiveColor: "earth700",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Brand Blue 600": {
            bg: "brandBlue600",
            color: "white0",
            colorLight: "blue200",
            foregroundColor: "light",
            buttonBg: "warmgrey950",
            buttonColor: "white0",
            buttonHoverBg: "warmgrey900",
            buttonActiveBg: "warmgrey950",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "brandBlue600",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "blue500",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "blue700",
            tertiaryButtonActiveColor: "blue900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        "Warm Grey 200": {
            bg: "warmgrey200",
            color: "warmgrey950",
            colorLight: "warmgrey700",
            foregroundColor: "dark",
            buttonBg: "brandBlue600",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            buttonColor: "white0",
            secondaryButtonBg: "warmgrey950",
            secondaryButtonColor: "white0",
            secondaryButtonHoverBg: "warmgrey900",
            secondaryButtonActiveBg: "warmgrey950",
            tertiaryButtonBg: "warmgrey300",
            tertiaryButtonColor: "warmgrey950",
            tertiaryButtonHoverColor: "warmgrey100",
            tertiaryButtonActiveColor: "warmgrey300",
            linkColor: "blue700",
            linkAltColor: "warmgrey900",
            linkHoverColor: "blue500",
            cardHoverBg: "rgba(0, 0, 0, 0.05)",
            cardActiveBg: "rgba(0, 0, 0, 0.1)"
        },
        "Warm Grey 800": {
            bg: "warmgrey800",
            color: "white0",
            colorLight: "warmgrey300",
            foregroundColor: "light",
            buttonBg: "warmgrey950",
            buttonColor: "white0",
            buttonHoverBg: "warmgrey900",
            buttonActiveBg: "warmgrey900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey700",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey900",
            tertiaryButtonActiveColor: "warmgrey700",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        "Warm Grey 950": {
            bg: "warmgrey950",
            color: "white0",
            colorLight: "warmgrey700",
            foregroundColor: "light",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey900",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey700",
            tertiaryButtonActiveColor: "warmgrey900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        },
        Dark: {
            bg: "neutrals100",
            // you can adjust the rest of these colors below for "dark theme"
            color: "white0",
            colorLight: "warmgrey700",
            foregroundColor: "light",
            buttonBg: "brandBlue600",
            buttonColor: "white0",
            buttonHoverBg: "blue700",
            buttonActiveBg: "blue900",
            secondaryButtonBg: "white0",
            secondaryButtonColor: "warmgrey950",
            secondaryButtonHoverBg: "blue50",
            secondaryButtonActiveBg: "blue100",
            tertiaryButtonBg: "warmgrey900",
            tertiaryButtonColor: "white0",
            tertiaryButtonHoverColor: "warmgrey700",
            tertiaryButtonActiveColor: "warmgrey900",
            linkColor: "white0",
            linkAltColor: "white0",
            linkHoverColor: "blue50",
            cardHoverBg: "rgba(0, 0, 0, 0.1)",
            cardActiveBg: "rgba(0, 0, 0, 0.2)"
        }
    };
    var _background;
    var currentTheme = (_background = theme[background]) !== null && _background !== void 0 ? _background : theme["White 0"];
    return {
        bg: currentTheme.bg,
        color: currentTheme.color,
        colorLight: currentTheme.colorLight,
        foregroundColor: currentTheme.foregroundColor,
        buttonBg: currentTheme.buttonBg,
        buttonColor: currentTheme.buttonColor,
        buttonHoverBg: currentTheme.buttonHoverBg,
        buttonActiveBg: currentTheme.buttonActiveBg,
        secondaryButtonBg: currentTheme.secondaryButtonBg,
        secondaryButtonColor: currentTheme.secondaryButtonColor,
        secondaryButtonHoverBg: currentTheme.secondaryButtonHoverBg,
        secondaryButtonActiveBg: currentTheme.secondaryButtonActiveBg,
        tertiaryButtonBg: currentTheme.tertiaryButtonBg,
        tertiaryButtonColor: currentTheme.tertiaryButtonColor,
        tertiaryButtonHoverColor: currentTheme.tertiaryButtonHoverColor,
        tertiaryButtonActiveColor: currentTheme.tertiaryButtonActiveColor,
        linkColor: currentTheme.linkColor,
        linkAltColor: currentTheme.linkAltColor || currentTheme.linkColor,
        linkHoverColor: currentTheme.linkHoverColor,
        cardHoverBg: currentTheme.cardHoverBg,
        cardActiveBg: currentTheme.cardActiveBg
    };
};
var BNColorThemes;
(function(BNColorThemes) {
    BNColorThemes["Light"] = "Light";
    BNColorThemes["Dark"] = "Dark";
    BNColorThemes["Grey"] = "Grey";
})(BNColorThemes || (BNColorThemes = {}));
/**
 * Function to determine the BricksNext theme colors for components based on the background color value.
 * @param background - The type of background: 'Dark', 'Grey', or 'Light'.
 * @returns An object containing the IBNComponentThemeConfig.
 */ var getBNComponentThemeColors = function(background) {
    // Theme colors that are same for all the varients
    var commonThemeConfig = {
        contentPrimaryAccent: "$contentTertiary",
        bgAccentBrand: "$backgroundAccentBrand",
        bgHoverAccentBrand: "$backgroundStateHoverAccentBrand",
        buttonLabelPrimary: "$contentInversePrimary",
        linkColor: "$backgroundAccentBrand",
        linkHover: "$backgroundStateHoverAccentBrand"
    };
    switch(background){
        case "Dark":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundInversePrimary",
                contentPrimary: "$contentInversePrimary",
                bgPrimaryLight: "$backgroundInverseStateHoverSecondary",
                inactivePrimary: "$contentStateInactivePrimary",
                secondaryBtnHover: "$contentInverseSecondary",
                tertiaryBtnHover: "$backgroundInverseTertiary"
            });
        case "Grey":
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundTertiary",
                contentPrimary: "$contentPrimary",
                bgPrimaryLight: "$backgroundStateHoverPrimary",
                inactivePrimary: "$contentPrimary",
                secondaryBtnHover: "$contentSecondary",
                tertiaryBtnHover: "$backgroundSecondary"
            });
        case "Light":
        default:
            return (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({}, commonThemeConfig), {
                bgPrimary: "$backgroundPrimary",
                contentPrimary: "$contentPrimary",
                bgPrimaryLight: "$backgroundStateHoverPrimary",
                inactivePrimary: "$contentPrimary",
                secondaryBtnHover: "$contentSecondary",
                tertiaryBtnHover: "$backgroundTertiary"
            });
    }
};


/***/ }),

/***/ 16451:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "yH": function() { return /* binding */ StackStyle; }
/* harmony export */ });
/* unused harmony exports GutterSmall, Gutter, GutterLarge, OuterMargin, OuterMarginFlex */
var GutterSmall = "8px";
var Gutter = "16px";
var GutterLarge = "32px";
var OuterMargin = "20px";
var OuterMarginFlex = (/* unused pure expression or super */ null && ([
    "20px",
    null,
    "40px"
]));
var StackStyle = {
    "> * + *": {
        "margin-top": "16px"
    }
};


/***/ }),

/***/ 23366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$1": function() { return /* binding */ resizeTestimonialCardImageUrl; },
/* harmony export */   "Fg": function() { return /* binding */ resizeTestimonialAvatarImageUrl; },
/* harmony export */   "j5": function() { return /* binding */ resizeMapMarkerImageUrl; },
/* harmony export */   "jx": function() { return /* binding */ contentfulToImagesWorkerUrl; },
/* harmony export */   "kp": function() { return /* binding */ resizeMapBackgroundImageUrl; },
/* harmony export */   "rX": function() { return /* binding */ resizeImageUrl; },
/* harmony export */   "vl": function() { return /* binding */ markdownToReactElement; }
/* harmony export */ });
/* harmony import */ var markdown_it__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(58642);
/* harmony import */ var react_html_parser__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(17803);


var markdownItOptions = {
    html: true,
    breaks: true,
    linkify: true,
    typographer: true
};
/**
 * Converts a Markdown string to one or more React elements
 * @param {string} markdown
 * @param {boolean} [allowHtml=false] - whether to allow HTML in source content
 * @param {string} [strip=false] - whether to strip a tag from the output
 * @return {HTMLElement}
 */ var markdownToReactElement = function(markdown) {
    var allowHtml = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    markdownItOptions.html = allowHtml;
    var html = (0,markdown_it__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(markdownItOptions).renderInline(markdown);
    return (0,react_html_parser__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(html);
};
var SQUARE_PRESETS = [
    48,
    64,
    128,
    256,
    512,
    1024,
    2048
];
var LANDING_PAGE_IMAGE_PRESETS = {
    mapBackground: "square-2048",
    mapMarker: "square-512",
    testimonialAvatar: "square-256",
    testimonialCard: "3:2-sm"
};
// Returns the smallest square preset that covers targetWidth, or the largest as fallback.
var squarePresetFor = function(targetWidth) {
    var match = SQUARE_PRESETS.find(function(s) {
        return s >= targetWidth;
    });
    return "square-".concat(match !== null && match !== void 0 ? match : 2048);
};
var resizeImageUrlWithPreset = function(url, preset) {
    try {
        var normalizedUrl = url.startsWith("//") ? "https:".concat(url) : url;
        var parsed = new URL(normalizedUrl);
        if (parsed.hostname === "images.ctfassets.net") {
            var resizedUrl = new URL(contentfulToImagesWorkerUrl(normalizedUrl));
            resizedUrl.searchParams.set("service", "cosmos");
            resizedUrl.searchParams.set("preset", preset);
            return resizedUrl.toString();
        }
        if (parsed.hostname === "imgdrop.imgix.net") {
            var path = parsed.pathname.replace(/^\//, "");
            var resizedUrl1 = new URL("https://images.opendoor.com/source/s3/imgdrop-production/".concat(path));
            resizedUrl1.searchParams.set("service", "cosmos");
            resizedUrl1.searchParams.set("preset", preset);
            return resizedUrl1.toString();
        }
        if (parsed.hostname === "images.opendoor.com") {
            parsed.searchParams.set("service", "cosmos");
            parsed.searchParams.set("preset", preset);
            return parsed.toString();
        }
        return url;
    } catch (e) {
        return url;
    }
};
// Convert a CMS image URL (imgdrop.imgix.net or already-migrated images.opendoor.com)
// to a CDN URL sized via the nearest square preset.
var resizeImageUrl = function(url, targetWidth) {
    return resizeImageUrlWithPreset(url, squarePresetFor(targetWidth));
};
var resizeTestimonialAvatarImageUrl = function(url) {
    return resizeImageUrlWithPreset(url, LANDING_PAGE_IMAGE_PRESETS.testimonialAvatar);
};
var resizeTestimonialCardImageUrl = function(url) {
    return resizeImageUrlWithPreset(url, LANDING_PAGE_IMAGE_PRESETS.testimonialCard);
};
var resizeMapBackgroundImageUrl = function(url) {
    return resizeImageUrlWithPreset(url, LANDING_PAGE_IMAGE_PRESETS.mapBackground);
};
var resizeMapMarkerImageUrl = function(url) {
    return resizeImageUrlWithPreset(url, LANDING_PAGE_IMAGE_PRESETS.mapMarker);
};
var contentfulToImagesWorkerUrl = function(contentfulURL) {
    var normalized = contentfulURL.startsWith("//") ? "https:".concat(contentfulURL) : contentfulURL;
    var pathname = new URL(normalized).pathname;
    return "https://images.opendoor.com/source/contentful".concat(pathname);
};


/***/ }),

/***/ 36674:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ FloatingNavigationBar; },
/* harmony export */   "w": function() { return /* binding */ ActiveTab; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54999);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84402);


var ActiveTab;
(function(ActiveTab) {
    ActiveTab["Browse"] = "browse";
    ActiveTab["Favorites"] = "favorites";
})(ActiveTab || (ActiveTab = {}));
var FloatingNavigationBar = function(param) {
    var activeTab = param.activeTab, handleOnViewBrowse = param.handleOnViewBrowse, handleOnViewFavorites = param.handleOnViewFavorites, _shouldHide = param.shouldHide, shouldHide = _shouldHide === void 0 ? false : _shouldHide;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .x, {
        "$platform-web": {
            position: "fixed"
        },
        bottom: shouldHide ? -100 : 20,
        left: 0,
        right: 0,
        zIndex: 5,
        height: 70,
        width: 410,
        alignSelf: "center",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        margin: "auto",
        mb: 10,
        $smallerThanMD: {
            width: 210
        },
        backgroundColor: "$backgroundPrimary",
        py: 0,
        px: 10,
        shadow: "$default",
        borderRadius: "$4x",
        style: {
            transition: "bottom 0.25s"
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .PressableBox */ .K, {
                "aria-label": "Browse",
                width: 200,
                height: 50,
                marginHorizontal: "auto",
                padding: 6,
                analyticsName: "browse-toggle",
                "data-testid": "browse-toggle-button",
                alignSelf: "center",
                onPress: handleOnViewBrowse,
                $smallerThanMD: {
                    width: 100
                },
                backgroundColor: activeTab === ActiveTab.Browse ? "$backgroundInversePrimary" : "$backgroundPrimary",
                borderBottomLeftRadius: "$4x",
                borderBottomRightRadius: activeTab === ActiveTab.Browse ? "$4x" : "$2x",
                borderTopRightRadius: activeTab === ActiveTab.Browse ? "$4x" : "$2x",
                borderTopLeftRadius: "$4x",
                py: 30,
                shadow: "$default",
                pressStyle: {
                    backgroundColor: "$backgroundInversePrimary"
                },
                hoverStyle: {
                    backgroundColor: activeTab === ActiveTab.Browse ? "$backgroundInversePrimary" : "$backgroundTertiary"
                },
                style: {
                    transition: "background-color 0.25s"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    color: activeTab === ActiveTab.Browse ? "$contentInverseTertiary" : "$contentTertiary",
                    tag: "span",
                    typography: "$labelLarge",
                    children: "Browse"
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_2__/* .PressableBox */ .K, {
                "aria-label": "Favorites",
                width: 200,
                height: 50,
                marginHorizontal: "auto",
                padding: 6,
                analyticsName: "favorites-toggle",
                "data-testid": "browfavoritesse-toggle-button",
                alignSelf: "center",
                onPress: handleOnViewFavorites,
                backgroundColor: activeTab === ActiveTab.Favorites ? "$backgroundInversePrimary" : "$backgroundPrimary",
                py: 30,
                borderBottomLeftRadius: activeTab === ActiveTab.Favorites ? "$4x" : "$2x",
                borderBottomRightRadius: "$4x",
                borderTopLeftRadius: activeTab === ActiveTab.Favorites ? "$4x" : "$2x",
                borderTopRightRadius: "$4x",
                $smallerThanMD: {
                    width: 100
                },
                shadow: "$default",
                pressStyle: {
                    backgroundColor: "$backgroundInversePrimary"
                },
                hoverStyle: {
                    backgroundColor: activeTab === ActiveTab.Favorites ? "$backgroundInversePrimary" : "$backgroundTertiary"
                },
                style: {
                    transition: "background-color 0.25s"
                },
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Text */ .x, {
                    color: activeTab === "favorites" ? "$contentInverseTertiary" : "$contentTertiary",
                    tag: "span",
                    typography: "$labelLarge",
                    children: "Favorites"
                })
            })
        ]
    });
};


/***/ }),

/***/ 5787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ MapMarker; }
/* harmony export */ });
/* unused harmony export __resetMarkerImpressionsForTest */
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(99758);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(55128);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(31178);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(64978);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(54999);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96602);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(93287);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react_map_gl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18291);
/* harmony import */ var _MapMarker_module_css__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78743);
/* harmony import */ var _MapMarker_module_css__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_MapMarker_module_css__WEBPACK_IMPORTED_MODULE_8__);








function formatNumber(number) {
    return number.toLocaleString("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: number >= 1000000 ? 2 : 0,
        notation: "compact",
        compactDisplay: "short"
    });
}
var PRIMARY_PHOTO_WIDTH = 350;
var PRIMARY_PHOTO_HEIGHT = 150;
var SECONDARY_PHOTO_WIDTH = 172;
var SECONDARY_PHOTO_HEIGHT = 100;
var PRIMARY_PHOTO_PARAMS = new URLSearchParams({
    service: "cosmos",
    preset: "3:2-sm"
}).toString();
var THUMBNAIL_PHOTO_PARAMS = new URLSearchParams({
    service: "cosmos",
    preset: "3:2-xs"
}).toString();
var HOVER_INTENT_MS = 120;
// Favorited markers need extra room for the heart icon. Non-favorited markers
// render at the narrower width so anonymous users (who can never see a heart)
// and signed-in users with no favorite on this property do not carry unused
// reserved space. Late-arriving `propertyReactions` that flip isLiked=true
// will widen the marker then, which is acceptable for the rare favorite flip.
var MARKER_WIDTH_WITH_HEART = 76;
var MARKER_WIDTH_NO_HEART = 60;
var MARKER_HEIGHT = 28;
// Dedupe RUM impressions so panning does not fire a new `mapMarkerHover` every
// time a popup opens. The Set is cleared on SPA route changes so navigating
// between markets (/homes/a -> /homes/b) re-fires impressions for repeated
// addresses that appear in the new market's results.
var markerImpressionsFired = new Set();
var routerListenerAttached = false;
function ensureRouterListener() {
    if (routerListenerAttached || "object" === "undefined") {
        return;
    }
    routerListenerAttached = true;
    next_router__WEBPACK_IMPORTED_MODULE_1___default().events.on("routeChangeStart", function() {
        markerImpressionsFired.clear();
    });
}
// Test-only reset. The dedupe Set persists for the SPA session, so unit tests
// that render MapMarker multiple times need a way to reset it without relying
// on salted address tokens that mask bugs in the dedupe contract itself.
var __resetMarkerImpressionsForTest = function() {
    markerImpressionsFired.clear();
};
function trackMarkerImpression(addressToken) {
    if (!addressToken || markerImpressionsFired.has(addressToken)) {
        return;
    }
    ensureRouterListener();
    markerImpressionsFired.add(addressToken);
    try {
        var ref, ref1, ref2;
        (ref = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability.getDatadogRumClient */ .w.getDatadogRumClient) === null || ref === void 0 ? void 0 : (ref1 = ref.call(_opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_3__/* .globalObservability */ .w)) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.addAction) === null || ref2 === void 0 ? void 0 : ref2.call(ref1, "marketplace.mapMarkerHover", {
            addressToken: addressToken
        });
    } catch (e) {
    // analytics must never break the UI
    }
}
function buildPhotoSlots(photos) {
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(photos !== null && photos !== void 0 ? photos : [], 3), primary = ref[0], secondary = ref[1], tertiary = ref[2];
    return {
        primary: primary ? "".concat(primary, "?").concat(PRIMARY_PHOTO_PARAMS) : null,
        secondary: secondary ? "".concat(secondary, "?").concat(THUMBNAIL_PHOTO_PARAMS) : null,
        tertiary: tertiary ? "".concat(tertiary, "?").concat(THUMBNAIL_PHOTO_PARAMS) : null
    };
}
function buildMarkerAriaLabel(property) {
    var parts = [];
    if (property.listPrice != null) {
        parts.push("Property listed at $".concat(property.listPrice.toLocaleString()));
    } else {
        parts.push("Property");
    }
    var beds = property.beds != null ? "".concat(property.beds, " beds") : null;
    var baths = property.baths != null ? "".concat(property.baths, " baths") : null;
    var summary = [
        beds,
        baths
    ].filter(Boolean).join(", ");
    if (summary) {
        parts.push(summary);
    }
    if (property.isLiked) {
        parts.push("favorited");
    }
    return parts.join(", ");
}
var PopupImage = function(param) {
    var uri = param.uri, width = param.width, height = param.height, alt = param.alt, borderTopLeftRadius = param.borderTopLeftRadius, borderTopRightRadius = param.borderTopRightRadius;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), errored = ref[0], setErrored = ref[1];
    var showPlaceholder = !uri || errored;
    if (showPlaceholder) {
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
            width: width,
            height: height,
            backgroundColor: "$backgroundSecondary",
            borderTopLeftRadius: borderTopLeftRadius,
            borderTopRightRadius: borderTopRightRadius
        });
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_7__/* .Image */ .E, {
        alt: alt,
        source: {
            uri: uri,
            width: width,
            height: height
        },
        onError: function() {
            return setErrored(true);
        },
        borderTopLeftRadius: borderTopLeftRadius,
        borderTopRightRadius: borderTopRightRadius
    });
};
// Not wrapped in `memo`: callers pass a fresh `property` object on every
// MapMarker render, so shallow-prop comparison would always miss. The popup
// body only mounts while `isActive && isDesktop`, so re-renders are cheap
// enough to skip the optimization rather than add a custom comparator.
var PopupBody = function(param) {
    var property = param.property;
    var slots = buildPhotoSlots(property.photos);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        className: (_MapMarker_module_css__WEBPACK_IMPORTED_MODULE_8___default().popupEnter),
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PopupImage, {
                uri: slots.primary,
                width: PRIMARY_PHOTO_WIDTH,
                height: PRIMARY_PHOTO_HEIGHT,
                alt: "map-marker-primary-property-image",
                borderTopLeftRadius: "$8x",
                borderTopRightRadius: "$8x"
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                flexDirection: "row",
                justifyContent: "space-between",
                mt: 6,
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PopupImage, {
                        uri: slots.secondary,
                        width: SECONDARY_PHOTO_WIDTH,
                        height: SECONDARY_PHOTO_HEIGHT,
                        alt: "map-marker-secondary-property-image"
                    }),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PopupImage, {
                        uri: slots.tertiary,
                        width: SECONDARY_PHOTO_WIDTH,
                        height: SECONDARY_PHOTO_HEIGHT,
                        alt: "map-marker-tertiary-property-image"
                    })
                ]
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Col */ .J, {
                mt: "$10x",
                mx: "$10x",
                mb: "$8x",
                gap: "$3x",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X, {
                        alignItems: "baseline",
                        justifyContent: "space-between",
                        children: [
                            property.listPrice != null ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                typography: "$labelXlarge",
                                tag: "p",
                                color: "$contentPrimary",
                                children: "$".concat(property.listPrice.toLocaleString())
                            }) : null,
                            property.isLiked ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore bricks-next types size as 20|24, but 14 is valid at runtime
                                size: 14,
                                color: "$contentStateErrorDefault",
                                alignSelf: "center"
                            }) : null
                        ]
                    }),
                    function() {
                        var stats = [
                            property.beds != null ? "".concat(property.beds, " bds") : null,
                            property.baths != null ? "".concat(property.baths, " ba") : null,
                            property.livingSquareFootage != null ? "".concat(property.livingSquareFootage.toLocaleString(), " sqft") : null, 
                        ].filter(function(part) {
                            return part !== null;
                        });
                        if (stats.length === 0) {
                            return null;
                        }
                        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_10__/* .Row */ .X, {
                            alignItems: "baseline",
                            children: stats.map(function(part, index) {
                                return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                    children: [
                                        index > 0 ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            tag: "span",
                                            typography: "$bodySmall",
                                            color: "$contentStateInactiveSecondary",
                                            children: " • "
                                        }) : null,
                                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                            tag: "span",
                                            typography: "$bodySmall",
                                            color: "$contentSecondary",
                                            children: part
                                        })
                                    ]
                                }, part);
                            })
                        });
                    }(),
                    property.street ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                        tag: "p",
                        typography: "$bodySmall",
                        color: "$contentTertiary",
                        "$platform-web": {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap"
                        },
                        children: property.street
                    }) : null
                ]
            })
        ]
    });
};
var MapMarker = function(param) {
    var property = param.property, onClick = param.onClick, moveToTop = param.moveToTop, focusTopMarker = param.setFocused, isSelected = param.isSelected, isLoading = param.isLoading;
    var ref, ref1, ref2, ref3;
    var media = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__.useMedia)();
    var isDesktop = media.largerThanSM;
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isHovering = ref4[0], setIsHovering = ref4[1];
    var ref5 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isFocused = ref5[0], setIsFocused = ref5[1];
    var isActive = isHovering || isFocused || Boolean(isSelected) || Boolean(isLoading);
    var pressableRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var hoverTimerRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // Keyed by the preloaded href so the effect re-fires when the primary photo
    // URL changes. A simple boolean guard would block all subsequent preloads.
    var preloadedHrefRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // Mirror isFocused in a ref so the hover-intent timer callback always reads
    // the latest value instead of the closure captured at schedule time.
    var isFocusedRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(isFocused);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        isFocusedRef.current = isFocused;
    }, [
        isFocused
    ]);
    var popupId = "cosmos-map-marker-popup-".concat(property.addressToken);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        // Fire impressions regardless of viewport: focus / selection / loading can
        // all activate a marker on mobile (via tap-select) and those count as
        // engagement even when the desktop-only hover popup does not render.
        if (isActive) {
            trackMarkerImpression(property.addressToken);
        }
    }, [
        isActive,
        property.addressToken
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var ref;
        if (!isActive || !isDesktop) {
            return;
        }
        var primary = (ref = property.photos) === null || ref === void 0 ? void 0 : ref[0];
        if (!primary) {
            return;
        }
        var href = "".concat(primary, "?").concat(PRIMARY_PHOTO_PARAMS);
        if (preloadedHrefRef.current === href) {
            return;
        }
        preloadedHrefRef.current = href;
        var link = document.createElement("link");
        link.rel = "preload";
        link.as = "image";
        link.href = href;
        link.fetchPriority = "high";
        document.head.appendChild(link);
        return function() {
            var ref;
            (ref = link.parentNode) === null || ref === void 0 ? void 0 : ref.removeChild(link);
        };
    }, [
        isActive,
        isDesktop,
        property.photos
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (focusTopMarker) {
            var ref;
            (ref = pressableRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    }, [
        focusTopMarker
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!isFocused) {
            return;
        }
        var handler = function(e) {
            if (e.key === "Escape") {
                e.preventDefault();
                setIsFocused(false);
            }
        };
        window.addEventListener("keydown", handler);
        return function() {
            window.removeEventListener("keydown", handler);
        };
    }, [
        isFocused
    ]);
    var cancelHoverTimer = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        if (hoverTimerRef.current != null) {
            window.clearTimeout(hoverTimerRef.current);
            hoverTimerRef.current = null;
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        return function() {
            return cancelHoverTimer();
        };
    }, [
        cancelHoverTimer
    ]);
    var handleOnHover = function() {
        cancelHoverTimer();
        hoverTimerRef.current = window.setTimeout(function() {
            setIsHovering(true);
            moveToTop === null || moveToTop === void 0 ? void 0 : moveToTop(isFocusedRef.current);
        }, HOVER_INTENT_MS);
    };
    var handleOnMouseOut = function() {
        cancelHoverTimer();
        setIsHovering(false);
    };
    var handleOnFocus = function() {
        moveToTop === null || moveToTop === void 0 ? void 0 : moveToTop(true);
        setIsFocused(true);
    };
    var handleOnBlur = function() {
        setIsFocused(false);
    };
    var handleOnClick = function() {
        cancelHoverTimer();
        setIsHovering(false);
        setIsFocused(false);
        onClick();
    };
    var ariaLabel = buildMarkerAriaLabel(property);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react_map_gl__WEBPACK_IMPORTED_MODULE_2__/* .Marker */ .Jx, {
        latitude: (ref = property.location) === null || ref === void 0 ? void 0 : ref.lat,
        longitude: (ref1 = property.location) === null || ref1 === void 0 ? void 0 : ref1.lon,
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .PressableBox */ .K, {
                "aria-label": ariaLabel,
                "aria-expanded": isActive && isDesktop,
                "aria-describedby": isActive && isDesktop ? popupId : undefined,
                analyticsName: "property-marker-click",
                backgroundColor: isActive ? "$backgroundInversePrimary" : "$backgroundPrimary",
                borderRadius: "$32x",
                height: MARKER_HEIGHT,
                width: property.isLiked ? MARKER_WIDTH_WITH_HEART : MARKER_WIDTH_NO_HEART,
                zIndex: 1,
                tabIndex: 0,
                justifyContent: "center",
                alignItems: "center",
                onMouseEnter: handleOnHover,
                onMouseLeave: handleOnMouseOut,
                onFocus: handleOnFocus,
                onBlur: handleOnBlur,
                onPress: handleOnClick,
                ref: function(ref) {
                    pressableRef.current = ref;
                },
                "data-testid": "map-marker-".concat(property.addressToken),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "center",
                    children: isLoading ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                        tag: "span",
                        typography: "$labelSmall",
                        color: "$contentInversePrimary",
                        children: "•••"
                    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .Fragment */ .HY, {
                        children: [
                            property.isLiked ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                                // @ts-ignore bricks-next types size as 20|24, but 14 is valid at runtime
                                size: 14,
                                color: "$contentStateErrorDefault",
                                pr: 4
                            }) : null,
                            property.listPrice != null ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Text */ .x, {
                                tag: "span",
                                typography: "$labelSmall",
                                color: isActive ? "$contentInversePrimary" : "$contentPrimary",
                                children: formatNumber(property.listPrice)
                            }) : null
                        ]
                    })
                })
            }),
            isActive && isDesktop ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_map_gl__WEBPACK_IMPORTED_MODULE_2__/* .Popup */ .GI, {
                longitude: (ref2 = property.location) === null || ref2 === void 0 ? void 0 : ref2.lon,
                latitude: (ref3 = property.location) === null || ref3 === void 0 ? void 0 : ref3.lat,
                anchor: "bottom",
                offset: 20,
                closeButton: false,
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
                    id: popupId,
                    role: "region",
                    children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(PopupBody, {
                        property: property
                    })
                })
            }) : null
        ]
    }, "map-marker-".concat(property.addressToken));
};


/***/ }),

/***/ 29753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "q": function() { return /* binding */ MarketplaceMap; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22901);
/* harmony import */ var components_marketplace_map_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41777);
/* harmony import */ var helpers_globals__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89060);
/* harmony import */ var react_map_gl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(18291);
/* harmony import */ var mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46125);
/* harmony import */ var mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(mapbox_gl_dist_mapbox_gl_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _MarketplaceMap_module_css__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(55221);
/* harmony import */ var _MarketplaceMap_module_css__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_MarketplaceMap_module_css__WEBPACK_IMPORTED_MODULE_7__);







// Mapbox popup + marker overrides and the popup fade-in keyframe. Scoped to
// a local `.mapRoot` class (Next.js CSS Modules require at least one local
// selector per rule) and applied below via `className={styles.mapRoot}`. The
// keyframe inside the module is intentionally global so `MapMarker.tsx` can
// reference it by name in an inline `animation` declaration.

var MIN_ZOOM = 7;
var MAX_ZOOM = 17;
var MarketplaceMap = function(param) {
    var center = param.center, _dragPan = param.dragPan, dragPan = _dragPan === void 0 ? true : _dragPan, marketShape = param.marketShape, handleOnClick = param.handleOnClick, handleOnMapMove = param.handleOnMapMove, handleOnMoveEnd = param.handleOnMoveEnd, _showGeoLocationControls = param.showGeoLocationControls, showGeoLocationControls = _showGeoLocationControls === void 0 ? true : _showGeoLocationControls, mapMarkers = param.mapMarkers, mapRef = param.mapRef, zoom = param.zoom;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)("grab"), cursor = ref[0], setCursor = ref[1];
    var handleMouseEnter = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("pointer");
    }, []);
    var handleMouseLeave = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grab");
    }, []);
    var handleMouseDown = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grabbing");
    }, []);
    // This means that if the user clicks on a cluster and the map re-renders with
    // a new cluster under their cursor, they will incorrectly see the "grab"
    // cursor rather than "grabbing", but it's much more efficient than monitoring
    // "mousemove" and continually polling for map features under the cursor
    var handleMouseUp = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function() {
        return setCursor("grab");
    }, []);
    var initialViewState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        if (center) {
            return {
                longitude: center[1],
                latitude: center[0],
                zoom: zoom || MIN_ZOOM
            };
        }
        if (marketShape === null || marketShape === void 0 ? void 0 : marketShape.coordinates) {
            try {
                return {
                    bounds: (0,components_marketplace_map_utils__WEBPACK_IMPORTED_MODULE_4__/* .getBoundsFromShape */ .J)(marketShape)
                };
            } catch (e) {
                return {
                    longitude: 0,
                    latitude: 0,
                    zoom: MIN_ZOOM
                };
            }
        }
        throw new Error("MarketplaceMap: Must provide either center, initialCoordinates, or marketShape");
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Wrapper carries the CSS Module class that scopes the Mapbox popup +
    // marker overrides. We cannot put the class directly on <Map> because
    // react-map-gl does not forward `className` to the root container.
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Box */ .x, {
        className: (_MarketplaceMap_module_css__WEBPACK_IMPORTED_MODULE_7___default().mapRoot),
        width: "100%",
        height: "100vh",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(react_map_gl__WEBPACK_IMPORTED_MODULE_2__/* .Map */ .D5, {
            ref: mapRef,
            mapboxAccessToken: helpers_globals__WEBPACK_IMPORTED_MODULE_1__/* .MAPBOX_ACCESS_TOKEN */ .A4,
            mapStyle: helpers_globals__WEBPACK_IMPORTED_MODULE_1__/* .MAPBOX_MAP_STYLE */ .Hx,
            onMove: handleOnMapMove,
            onMoveEnd: handleOnMoveEnd,
            interactiveLayerIds: [],
            onMouseEnter: handleMouseEnter,
            onMouseLeave: handleMouseLeave,
            onMouseDown: handleMouseDown,
            onMouseUp: handleMouseUp,
            cursor: cursor,
            style: {
                width: "100%",
                height: "100%"
            },
            minZoom: zoom || MIN_ZOOM,
            maxZoom: MAX_ZOOM,
            initialViewState: initialViewState,
            fadeDuration: 0,
            onClick: handleOnClick,
            reuseMaps: true,
            dragPan: dragPan,
            children: [
                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_map_gl__WEBPACK_IMPORTED_MODULE_2__/* .NavigationControl */ .Pv, {
                    position: "top-left",
                    showCompass: false
                }),
                showGeoLocationControls && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(react_map_gl__WEBPACK_IMPORTED_MODULE_2__/* .GeolocateControl */ .$j, {
                    position: "top-right"
                }),
                mapMarkers
            ]
        })
    });
};


/***/ }),

/***/ 41777:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "J": function() { return /* binding */ getBoundsFromShape; },
/* harmony export */   "a": function() { return /* binding */ getShapeFromMap; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48417);

var getBoundsFromShape = function(shape) {
    var _Math, _Math1, _Math2, _Math3;
    var type = shape.type, coordinates = shape.coordinates;
    if (!Array.isArray(coordinates)) {
        throw new Error("MarketShape coordinates must be a valid array");
    }
    var polygons;
    if (type === "Polygon") {
        polygons = coordinates[0];
    } else if (type === "MultiPolygon") {
        polygons = coordinates.flat(2);
    } else {
        polygons = null;
    }
    if (!Array.isArray(polygons) || polygons.length === 0) {
        throw new Error(type === "Polygon" || type === "MultiPolygon" ? "Invalid polygon coordinates" : "Unsupported GeoJSON shape type: ".concat(type));
    }
    var lngs = polygons.map(function(coord) {
        return coord.lon;
    });
    var lats = polygons.map(function(coord) {
        return coord.lat;
    });
    return [
        [
            (_Math = Math).min.apply(_Math, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lngs)),
            (_Math1 = Math).min.apply(_Math1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lats))
        ],
        [
            (_Math2 = Math).max.apply(_Math2, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lngs)),
            (_Math3 = Math).max.apply(_Math3, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(lats))
        ], 
    ];
};
var getShapeFromMap = function(map) {
    var bounds = map.getBounds();
    var vertices = [
        {
            lon: bounds.getNorthWest().lng,
            lat: bounds.getNorthWest().lat
        },
        {
            lon: bounds.getNorthEast().lng,
            lat: bounds.getNorthEast().lat
        },
        {
            lon: bounds.getSouthEast().lng,
            lat: bounds.getSouthEast().lat
        },
        {
            lon: bounds.getSouthWest().lng,
            lat: bounds.getSouthWest().lat
        },
        // The first and last points of a polygon must be identical
        {
            lon: bounds.getNorthWest().lng,
            lat: bounds.getNorthWest().lat
        }, 
    ];
    return vertices;
};


/***/ }),

/***/ 76558:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "N3": function() { return /* binding */ articlesLoader; }
/* harmony export */ });
/* unused harmony export articleLiteFields */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(48417);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(92336);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96602);
/* harmony import */ var cms_api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(77182);
/* harmony import */ var components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(51462);
/* harmony import */ var components_landing_pages_v2_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(47456);
/* harmony import */ var components_shared_CardCarouselV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80842);
/* harmony import */ var components_shared_Multicard_MulticardCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67022);
/* harmony import */ var components_shared_Multicard_MulticardList__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34691);
/* harmony import */ var _helpers_pagination__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(15318);
/* harmony import */ var _CardSectionHeader__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22609);













var ARTICLES_PER_PAGE = 16;
var maparticlesToGenericMulticardDetails = function(article, theme, limit) {
    var ref, ref1;
    return {
        title: article === null || article === void 0 ? void 0 : article.articleName,
        imageUrl: (article === null || article === void 0 ? void 0 : (ref = article.openGraph) === null || ref === void 0 ? void 0 : (ref1 = ref.fields) === null || ref1 === void 0 ? void 0 : ref1.image) || "https://images.opendoor.com/source/s3/imgdrop-production/4b831192b06849a589afcef62a25757d.jpg?preset=square-2048",
        componentTheme: theme,
        redirectUrl: article === null || article === void 0 ? void 0 : article.slug,
        desc: (article === null || article === void 0 ? void 0 : article.articleSubtitle) || "",
        cardsLimit: limit
    };
};
var renderArticlesCards = function(entry, resolvedData) {
    var ref, ref1, ref2;
    var DEFAULT_CAROUSEL_CARDS_LIMIT = 4;
    var ref3, ref4;
    var articles = (ref4 = (ref3 = (ref = entry.fields) === null || ref === void 0 ? void 0 : ref.items) !== null && ref3 !== void 0 ? ref3 : resolvedData === null || resolvedData === void 0 ? void 0 : resolvedData.articles) !== null && ref4 !== void 0 ? ref4 : [];
    articles = articles.filter(function(a) {
        return !!a.fields;
    });
    var limit = !((ref1 = entry.fields) === null || ref1 === void 0 ? void 0 : ref1.limit) ? DEFAULT_CAROUSEL_CARDS_LIMIT : (ref2 = entry.fields) === null || ref2 === void 0 ? void 0 : ref2.limit;
    limit = articles.length < limit ? articles.length : limit;
    var componentTheme = (0,components_landing_pages_v2_shared_styles_ComponentTheme__WEBPACK_IMPORTED_MODULE_1__/* .getComponentThemeColors */ ._Y)(entry.fields.cardBackgroundColor || "Off White");
    if (articles.length === 0) {
        return null;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(components_landing_pages_v2_shared_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP, {
        paddingTop: "$32x",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_CardSectionHeader__WEBPACK_IMPORTED_MODULE_5__/* .CardSectionHeader */ .y, {
                titleSize: entry.fields.titleSize,
                title: entry.fields.title,
                titleAccent: entry.fields.titleAccent,
                desc: entry.fields.desc,
                eyebrow: entry.fields.eyebrow,
                subhead: entry.fields.subHead,
                display: entry.fields.display
            }),
            entry.fields.display === "list" ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_shared_Multicard_MulticardList__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                cards: articles.map(function(article) {
                    return maparticlesToGenericMulticardDetails(article.fields, componentTheme);
                }),
                columnNumber: 4,
                componentTheme: componentTheme,
                cardVerticalAlignment: ""
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_shared_CardCarouselV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                id: entry.sys.id,
                cards: articles,
                componentTheme: componentTheme,
                columnNumber: limit,
                renderCard: function(card, id) {
                    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(components_shared_Multicard_MulticardCard__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP, {
                        id: id,
                        card: maparticlesToGenericMulticardDetails(card.fields, componentTheme, limit),
                        componentTheme: componentTheme,
                        cardVerticalAlignment: "Top"
                    });
                }
            })
        ]
    });
};
// Fetch authors, editors, and reviewers if componentExperts is also in root
var fetchExperts = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(articles, root) {
        var _experts, _experts1, _experts2, isComponentExpertsFound, _content, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, content, ref, ref1, ref2, ref3, ref4, experts, authorIds, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, article, ref5, ref6, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, author, authorEntries, ref7, editorIds, _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, article1, _editors, _iteratorNormalCompletion4, _didIteratorError4, _iteratorError4, _iterator4, _step4, editor, editorEntries, ref8, reviewerIds, _iteratorNormalCompletion5, _didIteratorError5, _iteratorError5, _iterator5, _step5, article2, _reviewers, _iteratorNormalCompletion6, _didIteratorError6, _iteratorError6, _iterator6, _step6, reviewer, reviewerEntries;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    isComponentExpertsFound = false;
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = ((_content = root === null || root === void 0 ? void 0 : root.fields.body.content) !== null && _content !== void 0 ? _content : [])[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            content = _step.value;
                            ;
                            if (((ref = content.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentType) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sys) === null || ref4 === void 0 ? void 0 : ref4.id) === "componentExperts") {
                                isComponentExpertsFound = true;
                                break;
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (!isComponentExpertsFound) {
                        return [
                            2,
                            []
                        ];
                    }
                    experts = [];
                    authorIds = [];
                    _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                    try {
                        for(_iterator1 = articles[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                            article = _step1.value;
                            ;
                            ;
                            _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                            try {
                                for(_iterator2 = ((ref6 = (ref5 = article.fields) === null || ref5 === void 0 ? void 0 : ref5.authors) !== null && ref6 !== void 0 ? ref6 : [])[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                    author = _step2.value;
                                    authorIds.push(author.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError2 = true;
                                _iteratorError2 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                        _iterator2.return();
                                    }
                                } finally{
                                    if (_didIteratorError2) {
                                        throw _iteratorError2;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_0__/* .fetchEntriesById */ .x5)("author", authorIds)
                    ];
                case 1:
                    authorEntries = _state.sent();
                    (_experts = experts).push.apply(_experts, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(authorEntries.map(function(author) {
                        return (ref7 = author === null || author === void 0 ? void 0 : author.fields) !== null && ref7 !== void 0 ? ref7 : null;
                    })));
                    editorIds = [];
                    _iteratorNormalCompletion3 = true, _didIteratorError3 = false, _iteratorError3 = undefined;
                    try {
                        for(_iterator3 = articles[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true){
                            article1 = _step3.value;
                            ;
                            _iteratorNormalCompletion4 = true, _didIteratorError4 = false, _iteratorError4 = undefined;
                            try {
                                for(_iterator4 = ((_editors = article1.fields.editors) !== null && _editors !== void 0 ? _editors : [])[Symbol.iterator](); !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true){
                                    editor = _step4.value;
                                    editorIds.push(editor.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError4 = true;
                                _iteratorError4 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion4 && _iterator4.return != null) {
                                        _iterator4.return();
                                    }
                                } finally{
                                    if (_didIteratorError4) {
                                        throw _iteratorError4;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError3 = true;
                        _iteratorError3 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                                _iterator3.return();
                            }
                        } finally{
                            if (_didIteratorError3) {
                                throw _iteratorError3;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_0__/* .fetchEntriesById */ .x5)("editor", editorIds)
                    ];
                case 2:
                    editorEntries = _state.sent();
                    (_experts1 = experts).push.apply(_experts1, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(editorEntries.map(function(editor) {
                        return (ref8 = editor === null || editor === void 0 ? void 0 : editor.fields) !== null && ref8 !== void 0 ? ref8 : null;
                    })));
                    reviewerIds = [];
                    _iteratorNormalCompletion5 = true, _didIteratorError5 = false, _iteratorError5 = undefined;
                    try {
                        for(_iterator5 = articles[Symbol.iterator](); !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true){
                            article2 = _step5.value;
                            ;
                            _iteratorNormalCompletion6 = true, _didIteratorError6 = false, _iteratorError6 = undefined;
                            try {
                                for(_iterator6 = ((_reviewers = article2.fields.reviewers) !== null && _reviewers !== void 0 ? _reviewers : [])[Symbol.iterator](); !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true){
                                    reviewer = _step6.value;
                                    reviewerIds.push(reviewer.sys.id);
                                }
                            } catch (err) {
                                _didIteratorError6 = true;
                                _iteratorError6 = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion6 && _iterator6.return != null) {
                                        _iterator6.return();
                                    }
                                } finally{
                                    if (_didIteratorError6) {
                                        throw _iteratorError6;
                                    }
                                }
                            }
                        }
                    } catch (err) {
                        _didIteratorError5 = true;
                        _iteratorError5 = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion5 && _iterator5.return != null) {
                                _iterator5.return();
                            }
                        } finally{
                            if (_didIteratorError5) {
                                throw _iteratorError5;
                            }
                        }
                    }
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_0__/* .fetchEntriesById */ .x5)("reviewer", reviewerIds)
                    ];
                case 3:
                    reviewerEntries = _state.sent();
                    (_experts2 = experts).push.apply(_experts2, (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(reviewerEntries.reduce(function(acc, reviewer) {
                        if (!(reviewer === null || reviewer === void 0 ? void 0 : reviewer.fields)) {
                            return acc;
                        }
                        return acc.concat(reviewer.fields);
                    }, [])));
                    return [
                        2,
                        experts
                    ];
            }
        });
    });
    return function fetchExperts(articles, root) {
        return _ref.apply(this, arguments);
    };
}();
var articleLiteFields = "fields.slug,fields.articleName,fields.publishDate,metadata.tags,fields.openGraph";
var articleRichFields = "fields.headerSummary,fields.authors,fields.editors,fields.reviewers";
var articlesLoader = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)(function(input, root) {
        var pageProps, loaderReturn, articles, ref, tags, ref1, ref2, ref3, ref4, articlesCollection, totalArticles, missingFields, sentry, ref5, _id, authorIds, authorEntries, ref6;
        var _arguments = arguments;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_9__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    pageProps = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : {
                        paginationIndex: 0
                    };
                    loaderReturn = {
                        authors: [],
                        articles: [],
                        experts: [],
                        tagNamesLookup: [],
                        total: 0
                    };
                    articles = [];
                    if ("items" in input.fields) {
                        ;
                        articles = ((ref = input.fields) === null || ref === void 0 ? void 0 : ref.items) || [];
                    }
                    tags = [];
                    if (!(articles.length === 0)) return [
                        3,
                        2
                    ];
                    tags = (ref3 = input === null || input === void 0 ? void 0 : (ref1 = input.metadata) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.tags) === null || ref2 === void 0 ? void 0 : ref2.filter(function(item) {
                        var ref, ref1;
                        return (item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.type) === "Link" && (item === null || item === void 0 ? void 0 : (ref1 = item.sys) === null || ref1 === void 0 ? void 0 : ref1.linkType) === "Tag";
                    })) === null || ref3 === void 0 ? void 0 : ref3.map(function(item) {
                        var ref;
                        return item === null || item === void 0 ? void 0 : (ref = item.sys) === null || ref === void 0 ? void 0 : ref.id;
                    });
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_0__/* .fetchArticlesByTags */ .X$)(tags || (root === null || root === void 0 ? void 0 : root.fields.topics), {
                            select: "".concat(articleLiteFields, ",").concat(articleRichFields),
                            skip: (0,_helpers_pagination__WEBPACK_IMPORTED_MODULE_11__/* .getSkipOffset */ .ur)(pageProps.paginationIndex),
                            limit: ((ref4 = input.fields) === null || ref4 === void 0 ? void 0 : ref4.limit) || ARTICLES_PER_PAGE
                        })
                    ];
                case 1:
                    articlesCollection = _state.sent();
                    articles = (articlesCollection === null || articlesCollection === void 0 ? void 0 : articlesCollection.items) || [];
                    totalArticles = articlesCollection === null || articlesCollection === void 0 ? void 0 : articlesCollection.total;
                    loaderReturn.total = totalArticles;
                    loaderReturn.articles = articles;
                    _state.label = 2;
                case 2:
                    missingFields = loaderReturn.articles.some(function(article) {
                        return !article.fields;
                    });
                    if (missingFields) {
                        sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_12__/* .globalObservability.getSentryClient */ .w.getSentryClient();
                        if (sentry !== undefined) {
                            ;
                            (ref5 = sentry.withScope) === null || ref5 === void 0 ? void 0 : ref5.call(sentry, function(scope) {
                                var ref;
                                scope.setContext("Loader Variables", {
                                    pageProps: pageProps,
                                    tags: tags
                                });
                                (ref = sentry.captureMessage) === null || ref === void 0 ? void 0 : ref.call(sentry, "articlesLoader returned undefined articles.fields", "error");
                            });
                        }
                        // fall back to logging to the console just in case
                        // eslint-disable-next-line no-console
                        console.log("articlesLoader returned undefined articles.fields", "error", {
                            data: {
                                input: input,
                                tags: tags,
                                root: root,
                                pageProps: pageProps,
                                articles: loaderReturn.articles
                            }
                        });
                    }
                    authorIds = articles.map(function(a) {
                        var ref, ref1;
                        return (_id = (ref = a.fields) === null || ref === void 0 ? void 0 : (ref1 = ref.authors) === null || ref1 === void 0 ? void 0 : ref1[0].sys.id) !== null && _id !== void 0 ? _id : "";
                    });
                    return [
                        4,
                        (0,cms_api__WEBPACK_IMPORTED_MODULE_0__/* .fetchEntriesById */ .x5)("author", authorIds, {
                            select: "fields.displayName,fields.credential,fields.picture,fields.firstName,fields.lastName"
                        })
                    ];
                case 3:
                    authorEntries = _state.sent();
                    loaderReturn.authors = authorEntries.map(function(author) {
                        return (ref6 = author === null || author === void 0 ? void 0 : author.fields) !== null && ref6 !== void 0 ? ref6 : null;
                    }); // JSON serializer cannot accept undefined value
                    return [
                        4,
                        fetchExperts(articles, root)
                    ];
                case 4:
                    loaderReturn.experts = _state.sent();
                    return [
                        2,
                        loaderReturn
                    ];
            }
        });
    });
    return function articlesLoader(input, root) {
        return _ref.apply(this, arguments);
    };
}();
var RelatedArticles = {
    render: renderArticlesCards,
    loader: articlesLoader
};
/* harmony default export */ __webpack_exports__["ZP"] = (RelatedArticles);


/***/ }),

/***/ 80842:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16064);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(34984);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(96492);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46320);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(41515);
/* harmony import */ var _tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(24439);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(30069);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(57485);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59636);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4752);
/* harmony import */ var _CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3952);
/* harmony import */ var _CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(_CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10__);









var AdaptedArrowLeft = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z);
var AdaptedArrowRight = (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_5__/* .adaptExternalIcon */ .f)(_tabler_icons_react__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z);
var CardCarouselV2 = function(param) {
    var id = param.id, cards = param.cards, columnNumber = param.columnNumber, minHeight = param.minHeight, footerLink = param.footerLink, footerLinkButtonText = param.footerLinkButtonText, layoutTheme = param.layoutTheme, renderCard = param.renderCard, _prependLink = param.prependLink, prependLink = _prependLink === void 0 ? true : _prependLink;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        display: "block",
        pb: "$16",
        className: (_CardCarouselV2_module_css__WEBPACK_IMPORTED_MODULE_10___default().slider),
        "$platform-web": {
            boxSizing: "content-box"
        },
        mx: "auto",
        maxWidth: "$360",
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                modules: [
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Navigation */ .W_,
                    swiper__WEBPACK_IMPORTED_MODULE_1__/* .Pagination */ .tl
                ],
                pagination: {
                    clickable: true,
                    type: "bullets",
                    el: ".swiper-pagination-".concat(id)
                },
                navigation: {
                    prevEl: ".swiper-button-previous-".concat(id),
                    nextEl: ".swiper-button-next-".concat(id)
                },
                slidesPerView: 1.1,
                grabCursor: true,
                watchSlidesProgress: true,
                spaceBetween: 24,
                breakpoints: {
                    640: {
                        slidesPerView: 2
                    },
                    768: {
                        slidesPerView: columnNumber > 2 ? 3 : 2
                    },
                    1200: {
                        slidesPerView: columnNumber
                    }
                },
                children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, idx) {
                    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                        style: {
                            minHeight: minHeight
                        },
                        children: renderCard === null || renderCard === void 0 ? void 0 : renderCard(card, id)
                    }, idx);
                })
            }),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                justifyContent: "space-between",
                pt: "$8",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Row */ .X, {
                        gap: "$2half",
                        children: [
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .IconButton */ .hU, {
                                size: "medium",
                                variant: "default",
                                icon: {
                                    Component: AdaptedArrowLeft,
                                    label: "Previous slide",
                                    size: 20
                                },
                                className: "swiper-button-previous swiper-button-previous-".concat(id),
                                type: "button",
                                analyticsName: "swiper-button-previous-".concat(id)
                            }),
                            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__/* .IconButton */ .hU, {
                                size: "medium",
                                variant: "default",
                                icon: {
                                    Component: AdaptedArrowRight,
                                    label: "Next slide",
                                    size: 20
                                },
                                className: "swiper-button-next swiper-button-next-".concat(id),
                                type: "button",
                                analyticsName: "swiper-button-next-".concat(id)
                            })
                        ]
                    }),
                    footerLink && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_8__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                        analyticsName: "cosmos-multicard-see-all-link",
                        "aria-label": "see all link",
                        variant: layoutTheme === "Dark" ? "secondaryInverse" : "primary",
                        href: prependLink ? "/articles/topic/".concat(footerLink) : footerLink,
                        children: footerLinkButtonText || "See all"
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardCarouselV2);


/***/ }),

/***/ 22609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "y": function() { return /* binding */ CardSectionHeader; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(78049);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(84402);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(22901);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(57485);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59636);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(91749);
/* harmony import */ var _landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(23366);









function getTypographyTokens(screenSize, titleSize, display) {
    switch(screenSize){
        case "largerThanMD":
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            break;
        case "largerThanSM":
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$displaySmall",
                subheader: "$bodyLarge"
            };
            break;
        default:
            if (titleSize === "Default" && display === "carousel") return {
                title: "$headerSmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "carousel") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Default" && display === "list") return {
                title: "$headerSmall",
                subheader: "$bodyLarge"
            };
            if (titleSize === "Large" && display === "list") return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
            return {
                title: "$headerMedium",
                subheader: "$bodyLarge"
            };
    }
    return {
        title: "$headerMedium",
        subheader: "$bodyLarge"
    };
}
var TitleWithAccent = function(_param) {
    var title = _param.title, titleAccent = _param.titleAccent, titleSize = _param.titleSize, titleColor = _param.titleColor, titleAccentColor = _param.titleAccentColor, breakTitles = _param.breakTitles, display = _param.display, typography = _param.typography, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "title",
        "titleAccent",
        "titleSize",
        "titleColor",
        "titleAccentColor",
        "breakTitles",
        "display",
        "typography"
    ]);
    var titleTypographyTokens = {
        typography: typography.typography.title,
        $largerThanSM: {
            typography: typography.$largerThanSM.typography.title
        },
        $largerThanMD: {
            typography: typography.$largerThanMD.typography.title
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
        tag: "h2"
    }, titleTypographyTokens), {
        display: "block",
        maxWidth: "16ch",
        color: titleColor || "$contentPrimary",
        mb: "$8x"
    }), props), {
        whiteSpace: "normal",
        children: [
            (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .markdownToReactElement */ .vl)(title || ""),
            breakTitles && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)("br", {}),
            titleAccent && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                tag: "span"
            }, titleTypographyTokens), {
                color: titleAccentColor || "$contentTertiary"
            }), props), {
                whiteSpace: "normal",
                children: [
                    " ",
                    (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_3__/* .markdownToReactElement */ .vl)(titleAccent)
                ]
            }))
        ]
    }));
};
var CardSectionHeader = function(fields) {
    var titleSize = fields.titleSize, display = fields.display;
    var typography = {
        typography: getTypographyTokens("default", titleSize, display),
        $largerThanSM: {
            typography: getTypographyTokens("largerThanSM", titleSize, display)
        },
        $largerThanMD: {
            typography: getTypographyTokens("largerThanMD", titleSize, display)
        }
    };
    var subHeadTypographyTokens = {
        typography: typography.typography.subheader,
        $largerThanSM: {
            typography: typography.$largerThanSM.typography.subheader
        },
        $largerThanMD: {
            typography: typography.$largerThanMD.typography.subheader
        }
    };
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
        gap: "$16x",
        marginBottom: "$16x",
        maxWidth: "$744x",
        children: [
            fields.eyebrow && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Eyebrow */ .j4, {
                children: fields.eyebrow
            }),
            fields.title && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(TitleWithAccent, {
                title: fields.title,
                titleAccent: fields.titleAccent,
                titleSize: fields.titleSize,
                typography: typography
            }),
            (fields.subhead || fields.desc) && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_9__/* .Box */ .x, {
                gap: "$4x",
                children: [
                    fields.subhead && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_6__/* .Text */ .x, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({
                        tag: "h4",
                        display: "block"
                    }, subHeadTypographyTokens), {
                        fontWeight: "$medium",
                        color: "$contentPrimary",
                        children: fields.subhead
                    })),
                    fields.desc && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Desc */ .Xe, {
                        color: "$contentPrimary",
                        $largerThanMD: {
                            fontSize: fields.titleSize === "Large" ? 24 : "unset"
                        },
                        children: fields.desc
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 67022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DQ": function() { return /* binding */ getCardArch; },
/* harmony export */   "xu": function() { return /* binding */ CardImage; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42250);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96101);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(22901);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(64978);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12___default = /*#__PURE__*/__webpack_require__.n(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(46320);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(94322);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(84402);
/* harmony import */ var _landing_pages_v2_shared_Buttons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13530);
/* harmony import */ var _landing_pages_v2_shared_Sheet__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(38243);
/* harmony import */ var _landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91749);
/* harmony import */ var _landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(23366);











var convertMinHeight = function(value) {
    if (!value) return undefined;
    return parseInt(value.replace("px", ""), 10);
};
var TitleSizeTokens = {
    small: "$bodyXlarge",
    medium: "$subheaderXsmall",
    large: "$subheaderSmall"
};
var getCardArch = function(param) {
    var cardStyle = param.cardStyle, isArched = param.isArched;
    if (cardStyle === "Arch") {
        return true;
    }
    return isArched;
};
var CardImage = function(_param) {
    var isArched = _param.isArched, src = _param.src, alt = _param.alt, columnNumber = _param.columnNumber, backgroundImageSize = _param.backgroundImageSize, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(_param, [
        "isArched",
        "src",
        "alt",
        "columnNumber",
        "backgroundImageSize"
    ]);
    return(// eslint-disable-next-line @opendoor/no-html-elements
    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)("div", {
        css: /*#__PURE__*/ (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("div{background-size:", backgroundImageSize || "cover", ";}"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_8__/* .Image */ .E, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, props), {
            source: {
                uri: src,
                height: 180
            },
            flex: 1,
            minHeight: 160,
            $largerThanMD: {
                minHeight: 320
            },
            $largerThanSM: {
                minHeight: 200
            },
            // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
            height: columnNumber ? columnNumber > 3 ? 180 : 240 : 180,
            alt: alt,
            marginLeft: -16,
            maxWidth: "unset",
            width: "calc(100% + 32px)",
            borderTopLeftRadius: isArched ? "$full" : "$12x",
            borderTopRightRadius: isArched ? "$full" : "$12x",
            borderBottomLeftRadius: "$2x",
            borderBottomRightRadius: "$2x"
        }))
    }));
};
var MulticardCard = function(param) {
    var id = param.id, card = param.card, isArched = param.isArched, minHeight = param.minHeight, componentTheme = param.componentTheme, cardVerticalAlignment = param.cardVerticalAlignment, isAccordion = param.isAccordion, columnNumber = param.columnNumber;
    return (card.ctaSheet || card.redirectUrl) && !isAccordion ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardSheet, {
        card: card,
        minHeight: minHeight,
        isArched: getCardArch({
            cardStyle: card.cardStyle,
            isArched: isArched
        }),
        componentTheme: componentTheme,
        cardVerticalAlignment: cardVerticalAlignment,
        columnNumber: columnNumber
    }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        display: "flex",
        minHeight: minHeight === "auto" ? "auto" : convertMinHeight(minHeight),
        overflow: "hidden",
        borderTopLeftRadius: isArched ? "$full" : "$12x",
        borderTopRightRadius: isArched ? "$full" : "$12x",
        borderBottomLeftRadius: "$12x",
        borderBottomRightRadius: "$12x",
        // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
        paddingTop: card.imageUrl ? "$4x" : cardVerticalAlignment === "center" ? "$12x" : "$44x",
        paddingBottom: "$12x",
        paddingLeft: "$12x",
        paddingRight: "$12x",
        backgroundColor: (0,_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_12__.getToken)("$backgroundTertiary", "color"),
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MulticardCardDetails, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, card), {
            isArched: getCardArch({
                cardStyle: card.cardStyle,
                isArched: isArched
            }),
            cardVerticalAlignment: cardVerticalAlignment,
            componentTheme: componentTheme,
            redirectUrl: card.redirectUrl,
            isAccordion: isAccordion
        }))
    }, id);
};
var CardSheet = function(param) {
    var card = param.card, isArched = param.isArched, componentTheme = param.componentTheme, cardVerticalAlignment = param.cardVerticalAlignment, columnNumber = param.columnNumber, minHeight = param.minHeight;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isVisible = ref[0], setIsVisible = ref[1];
    var ctaRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    // When animation is complete
    var exitComplete = function() {
        if (card.ctaSheet) {
            var ref;
            (ref = ctaRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        }
    };
    // Make visual buttons work like Buttons
    var onKeyDown = function(e) {
        if (card.redirectUrl && !card.ctaSheet) {
            e.stopPropagation();
        } else if (e.key === " " || e.key === "Spacebar") {
            setIsVisible(true);
        }
    };
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), playHover = ref1[0], setPlayHover = ref1[1];
    // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
    var paddingTop = card.imageUrl ? "$4x" : cardVerticalAlignment === "center" ? "$12x" : "$44x", paddingBottom = "$12x";
    var _imageLayout = card.imageLayout, imageLayout = _imageLayout === void 0 ? "top" : _imageLayout, _backgroundImageSize = card.backgroundImageSize, backgroundImageSize = _backgroundImageSize === void 0 ? "cover" : _backgroundImageSize;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        "$platform-web": {
            minHeight: minHeight
        },
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                position: "relative",
                display: "flex",
                flexDirection: "column",
                width: "100%",
                height: "100%",
                overflow: "hidden",
                cursor: "pointer",
                borderTopRightRadius: isArched ? "$full" : "$12x",
                borderTopLeftRadius: isArched ? "$full" : "$12x",
                borderBottomLeftRadius: "$12x",
                borderBottomRightRadius: "$12x",
                paddingTop: imageLayout === "top" && backgroundImageSize !== "contain" ? paddingTop : paddingBottom,
                paddingLeft: "$12x",
                paddingRight: "$12x",
                paddingBottom: imageLayout === "top" && backgroundImageSize !== "contain" ? paddingBottom : paddingTop,
                "aria-label": card.ctaSheetLabel || "Open dialog",
                analyticsName: "cosmos-landing-page-multicard-".concat(card.analyticsId),
                outlineColor: "unset",
                href: !card.ctaSheet && card.redirectUrl ? card.redirectUrl : undefined,
                onPress: function() {
                    return card.ctaSheet && setIsVisible(true);
                },
                onPressIn: onKeyDown,
                ref: ctaRef,
                outlineWidth: 0,
                tabIndex: 0,
                backgroundColor: card.backgroundColor || "$backgroundTertiary",
                onMouseEnter: function() {
                    return setPlayHover(true);
                },
                onMouseLeave: function() {
                    return setPlayHover(false);
                },
                children: [
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(MulticardCardDetails, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)({}, card), {
                        isArched: isArched,
                        componentTheme: componentTheme,
                        cardVerticalAlignment: cardVerticalAlignment,
                        analyticsId: card.analyticsId,
                        columnNumber: columnNumber
                    })),
                    /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                        position: "absolute",
                        width: "100%",
                        height: "100%",
                        scale: playHover ? 2 : 0,
                        opacity: 0.08,
                        bottom: -200,
                        left: 0,
                        zIndex: 5,
                        animation: "decelerateFast",
                        borderTopRightRadius: "$full",
                        borderTopLeftRadius: "$full",
                        transformOrigin: "center bottom",
                        backgroundColor: "$backgroundInverseStateHoverSecondary"
                    }, "my-square")
                ]
            }),
            card.ctaSheet && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Sheet__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                entry: card.ctaSheet,
                isVisible: isVisible,
                setIsVisible: setIsVisible,
                exitComplete: exitComplete
            })
        ]
    });
};
var AccordionDetails = function(param) {
    var title = param.title, desc = param.desc;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_14__/* .Accordion */ .U, {
        variant: "regular",
        size: "medium",
        isFullWidth: true,
        analyticsName: "cosmos-multicard-accordion",
        items: [
            {
                title: title,
                description: desc ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                    typography: "$bodyMedium",
                    tag: "p",
                    color: "$contentPrimary",
                    children: (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .markdownToReactElement */ .vl)(desc)
                }) : ""
            }, 
        ]
    });
};
var MulticardCardDetails = function(param) {
    var eyebrow = param.eyebrow, imageUrl = param.imageUrl, title = param.title, subhead = param.subhead, desc = param.desc, ctaDisplayText = param.ctaDisplayText, ctaStyle = param.ctaStyle, isArched = param.isArched, isAccordion = param.isAccordion, componentTheme = param.componentTheme, redirectUrl = param.redirectUrl, analyticsId = param.analyticsId, columnNumber = param.columnNumber, titleSize = param.titleSize, _imageLayout = param.imageLayout, imageLayout = _imageLayout === void 0 ? "top" : _imageLayout, _backgroundImageSize = param.backgroundImageSize, backgroundImageSize = _backgroundImageSize === void 0 ? "cover" : _backgroundImageSize;
    var maxCardTitleLen = 48;
    var ref;
    var truncatedTitle = (ref = title && title.length > maxCardTitleLen ? "".concat(title.slice(0, maxCardTitleLen), "...") : title) !== null && ref !== void 0 ? ref : "";
    var titleSizeToken = TitleSizeTokens[titleSize || "large"];
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
        flexDirection: imageLayout === "bottom" ? "column-reverse" : "column",
        children: [
            imageUrl && (redirectUrl ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_13__/* .Link */ .r, {
                href: isAccordion ? redirectUrl : undefined,
                "aria-label": title || "",
                analyticsName: "cosmos-landing-page-multicard-".concat(analyticsId),
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardImage, {
                    isArched: !!isArched,
                    src: imageUrl,
                    alt: title || "Card Image",
                    flex: 1,
                    zIndex: 5,
                    mb: imageLayout === "top" && backgroundImageSize !== "contain" ? "$16x" : undefined,
                    columnNumber: columnNumber,
                    backgroundImageSize: backgroundImageSize
                })
            }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(CardImage, {
                isArched: !!isArched,
                src: imageUrl,
                alt: title || "",
                flex: 1,
                zIndex: 5,
                mb: imageLayout === "top" && backgroundImageSize !== "contain" ? "$16x" : undefined,
                columnNumber: columnNumber,
                backgroundImageSize: backgroundImageSize
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                flex: 1,
                children: isAccordion ? /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(AccordionDetails, {
                    title: truncatedTitle,
                    desc: desc || ""
                }) : /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .Fragment */ .HY, {
                    children: [
                        /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsxs */ .BX)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_11__/* .Box */ .x, {
                            zIndex: 5,
                            display: "flex",
                            children: [
                                eyebrow && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Typography__WEBPACK_IMPORTED_MODULE_3__/* .Eyebrow */ .j4, {
                                    mb: 2,
                                    children: eyebrow
                                }),
                                /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                                    typography: titleSizeToken,
                                    fontWeight: "$medium",
                                    tag: "h3",
                                    color: "$contentPrimary",
                                    mb: 5,
                                    children: truncatedTitle
                                })
                            ]
                        }),
                        subhead && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            tag: "p",
                            typography: "$bodyMedium",
                            color: "$contentPrimary",
                            fontWeight: "$medium",
                            children: subhead
                        }),
                        desc && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_15__/* .Text */ .x, {
                            typography: "$bodyMedium",
                            tag: "p",
                            color: "$contentPrimary",
                            children: (0,_landing_pages_v2_shared_utils__WEBPACK_IMPORTED_MODULE_4__/* .markdownToReactElement */ .vl)(desc)
                        }),
                        ctaDisplayText && /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_6__/* .jsx */ .tZ)(_landing_pages_v2_shared_Buttons__WEBPACK_IMPORTED_MODULE_1__/* .LPFauxBtn */ .B, {
                            componentTheme: componentTheme,
                            ctaDisplayText: ctaDisplayText,
                            ctaStyle: ctaStyle,
                            mt: "$5"
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (MulticardCard);


/***/ }),

/***/ 34691:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(22901);
/* harmony import */ var _MulticardCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67022);
/* harmony import */ var _MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(82946);
/* harmony import */ var _MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4__);





var MulticardList = function(param) {
    var cards = param.cards, componentTheme = param.componentTheme, columnNumber = param.columnNumber, isArched = param.isArched, isAccordion = param.isAccordion, minHeight = param.minHeight, cardVerticalAlignment = param.cardVerticalAlignment;
    /*#__PURE__*/ return (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_opendoor_bricks_next__WEBPACK_IMPORTED_MODULE_3__/* .Box */ .x, {
        tag: "ul",
        m: "$0",
        p: "$0",
        role: "list",
        gap: "$4",
        className: (_MulticardList_module_css__WEBPACK_IMPORTED_MODULE_4___default().list),
        style: {
            "--column-number": columnNumber
        },
        children: cards === null || cards === void 0 ? void 0 : cards.map(function(card, idx) {
            return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(_MulticardCard__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
                card: card,
                id: "".concat(idx),
                componentTheme: componentTheme,
                isArched: isArched,
                isAccordion: isAccordion,
                minHeight: minHeight,
                cardVerticalAlignment: cardVerticalAlignment,
                columnNumber: columnNumber
            }, idx);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MulticardList);


/***/ }),

/***/ 37987:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ shared_NewSellerFlowAddressInput; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/TextButton.tsx
var TextButton = __webpack_require__(55285);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ../cinderblocks/src/core/AddressInput/index.ts + 3 modules
var AddressInput = __webpack_require__(67974);
// EXTERNAL MODULE: ../observability/src/global.ts
var global = __webpack_require__(96602);
// EXTERNAL MODULE: ./src/helpers/observability.ts + 11 modules
var observability = __webpack_require__(50138);
// EXTERNAL MODULE: ./src/helpers/queryParams.ts
var queryParams = __webpack_require__(17706);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/router.js
var next_router = __webpack_require__(93287);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../bricks-next/src/components/Dialog/index.ts + 5 modules
var Dialog = __webpack_require__(62766);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/TextInput.tsx
var TextInput = __webpack_require__(78514);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/checkboxRadio/SimpleCheckbox.tsx
var SimpleCheckbox = __webpack_require__(46176);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(57854);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ./src/helpers/AddressValidationContext.tsx + 1 modules
var AddressValidationContext = __webpack_require__(18296);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(22225);
// EXTERNAL MODULE: ./src/components/landing-pages-v2/AddressConfirmationModal.helpers.ts
var AddressConfirmationModal_helpers = __webpack_require__(20530);
;// CONCATENATED MODULE: ./src/components/landing-pages-v2/AddressConfirmationModal.tsx













var Sentry = global/* globalObservability.getSentryClient */.w.getSentryClient();
var AddressConfirmationModal = function(param) {
    var isOpen = param.isOpen, setIsOpen = param.setIsOpen, partnerReferralId = param.partnerReferralId, initialAddress = param.initialAddress, pageSetPath = param.pageSetPath, trackingKeywords = param.trackingKeywords, channel = param.channel, inputLocation = param.inputLocation, trackingTaxonomy = param.trackingTaxonomy;
    var router = (0,next_router.useRouter)();
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref = (0,AddressValidationContext/* useAddressValidationContext */.oK)(), addressResults = ref.addressResults, setValidatedAddress = ref.setValidatedAddress, validatedAddress = ref.validatedAddress;
    var ref1 = (0,react.useState)((0,_object_spread/* default */.Z)({}, initialAddress)), address = ref1[0], setAddress = ref1[1];
    var ref2 = (0,react.useState)(""), unitNumberErrorText = ref2[0], setUnitNumberErrorText = ref2[1];
    var ref3 = (0,react.useState)(false), isConfirmLoading = ref3[0], setIsConfirmLoading = ref3[1];
    var ref4 = (0,react.useState)(false), noUnitChecked = ref4[0], setNoUnitChecked = ref4[1];
    var ref5 = (0,react.useState)(false), confirmSameUnitStreet = ref5[0], setConfirmSameUnitStreet = ref5[1];
    var ref6 = (0,react.useState)(""), relationshipValue = ref6[0], setRelationshipValue = ref6[1];
    var ref7 = (0,react.useState)(""), relationshipError = ref7[0], setRelationshipError = ref7[1];
    var isAddressUnitNumberMissing = addressResults === null || addressResults === void 0 ? void 0 : addressResults.includes("ADDRESS_MISSING_SUB_PREMISE");
    var streetNumber = (0,AddressConfirmationModal_helpers/* extractStreetNumber */.K)(initialAddress);
    var validateUnitInput = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, response, casaAddress, error, ref2;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            (0,api/* standardizeAddress */.ce)(address)
                        ];
                    case 1:
                        response = _state.sent();
                        if (!response || !response.data || response.errors && !(0,AddressConfirmationModal_helpers/* addressNotFound */.E)(response.errors[0])) {
                            setUnitNumberErrorText("An unexpected error occurred. Please try again.");
                            return [
                                2
                            ];
                        }
                        casaAddress = (ref1 = (ref = response.data) === null || ref === void 0 ? void 0 : ref.casa.findByFields) === null || ref1 === void 0 ? void 0 : ref1.address;
                        if ((casaAddress === null || casaAddress === void 0 ? void 0 : casaAddress.result.includes(AddressValidationContext/* ADDRESS_INVALID_RESULT */.le)) || response.errors && (0,AddressConfirmationModal_helpers/* addressNotFound */.E)(response.errors[0])) {
                            setUnitNumberErrorText("Unit number not found or entered incorrectly");
                            return [
                                2
                            ];
                        }
                        return [
                            2,
                            {
                                street1: casaAddress.street,
                                city: casaAddress.city,
                                state: casaAddress.state,
                                postal_code: casaAddress.postalCode,
                                unit: casaAddress.unitNumber,
                                id: casaAddress.uuid
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        (ref2 = Sentry.captureException) === null || ref2 === void 0 ? void 0 : ref2.call(Sentry, error);
                        setUnitNumberErrorText("An unexpected error occurred. Please try again.");
                        return [
                            2
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        });
        return function validateUnitInput() {
            return _ref.apply(this, arguments);
        };
    }();
    var routeToManualAddressPage = function() {
        router.push({
            pathname: "/manual-address-entry",
            query: (0,_object_spread/* default */.Z)({
                address: JSON.stringify(validatedAddress)
            }, trackingKeywords != null && {
                trackingKeywords: trackingKeywords
            }, pageSetPath != null && {
                pageSetPath: pageSetPath
            }, partnerReferralId != null && {
                partnerReferralId: partnerReferralId
            }, channel != null && {
                channel: channel
            })
        });
    };
    var proceedWithAddress = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(addressToUse) {
            var relationshipAnswers, error, ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setValidatedAddress(addressToUse);
                        relationshipAnswers = relationshipValue ? {
                            "seller.relation_to_owner": relationshipValue
                        } : undefined;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            (0,AddressValidationContext/* gateProceedToOnboardingFlow */.Qk)({
                                address: addressToUse,
                                product: "SELL_DIRECT",
                                trackEvent: trackEvent,
                                partnerReferralId: partnerReferralId,
                                addressUUID: addressToUse.id,
                                pageSetPath: pageSetPath,
                                trackingKeywords: trackingKeywords,
                                channel: channel,
                                inputLocation: inputLocation,
                                trackingTaxonomy: trackingTaxonomy,
                                relationshipAnswers: relationshipAnswers
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        error = _state.sent();
                        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error);
                        setUnitNumberErrorText("An unexpected error occurred. Please try again.");
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsConfirmLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function proceedWithAddress(addressToUse) {
            return _ref.apply(this, arguments);
        };
    }();
    var validateRelationship = function() {
        if (!relationshipValue) {
            setRelationshipError("Please select an option");
            return false;
        }
        setRelationshipError("");
        return true;
    };
    var handleRelationshipSelect = function(value) {
        setRelationshipValue(value);
        setRelationshipError("");
    };
    var handleNoUnitToggle = function() {
        var newChecked = !noUnitChecked;
        setNoUnitChecked(newChecked);
        if (newChecked) {
            setAddress(function(prev) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), {
                    unit: ""
                });
            });
            setUnitNumberErrorText("");
        }
    };
    var handleConfirm = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var validatedAddr;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsConfirmLoading(true);
                        if (!validateRelationship()) {
                            setIsConfirmLoading(false);
                            return [
                                2
                            ];
                        }
                        if (!(isAddressUnitNumberMissing && !noUnitChecked)) return [
                            3,
                            5
                        ];
                        if (!(address === null || address === void 0 ? void 0 : address.unit)) {
                            setUnitNumberErrorText('Enter a unit number or check "No unit number" below');
                            setIsConfirmLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            validateUnitInput()
                        ];
                    case 1:
                        validatedAddr = _state.sent();
                        if (!validatedAddr) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            proceedWithAddress(validatedAddr)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsConfirmLoading(false);
                        _state.label = 4;
                    case 4:
                        return [
                            3,
                            7
                        ];
                    case 5:
                        return [
                            4,
                            proceedWithAddress(address)
                        ];
                    case 6:
                        _state.sent();
                        _state.label = 7;
                    case 7:
                        return [
                            2
                        ];
                }
            });
        });
        return function handleConfirm() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleUnitNumberChange = function(input) {
        setConfirmSameUnitStreet(false);
        if (address) {
            setAddress((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, address), {
                unit: input
            }));
        }
        var validUnitNumberRegex = /^[A-Za-z0-9\s-#]+$/;
        if (input && !validUnitNumberRegex.test(input)) {
            setUnitNumberErrorText("Unit numbers can’t include special characters.");
        } else if (input === streetNumber) {
            setUnitNumberErrorText('If street and unit number are the same, tap "Same street and unit" below.');
        } else {
            setUnitNumberErrorText("");
        }
    };
    var ref8;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        isOpen: isOpen,
        dismissable: true,
        overlayColor: "dark",
        setIsOpen: setIsOpen,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
            width: 600,
            maxHeight: "90vh",
            overflow: "scroll",
            $smallerThanLG: {
                width: "100%"
            },
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                title: isAddressUnitNumberMissing ? "Is there a unit?" : "Is this the correct home address?",
                titleProps: {
                    fontSize: 32,
                    lineHeight: 40
                },
                description: "",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    flexDirection: "column",
                    gap: 24,
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            flexDirection: "column",
                            gap: 32,
                            $smallerThanLG: {
                                gap: 24
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "row",
                                    width: "100%",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    p: "$12x",
                                    backgroundColor: "$backgroundSecondary",
                                    borderRadius: "$12x",
                                    $smallerThanLG: {
                                        padding: "$8x",
                                        borderRadius: "$8x"
                                    },
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            flexDirection: "column",
                                            width: "60%",
                                            $smallerThanLG: {
                                                width: "70%"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                    tag: "p",
                                                    typography: "$bodyXlarge",
                                                    $smallerThanLG: {
                                                        typography: "$bodyLarge"
                                                    },
                                                    children: [
                                                        address === null || address === void 0 ? void 0 : address.street1,
                                                        (address === null || address === void 0 ? void 0 : address.unit) ? ", #".concat(address.unit) : ""
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                    tag: "p",
                                                    typography: "$bodyXlarge",
                                                    $smallerThanLG: {
                                                        typography: "$bodyLarge"
                                                    },
                                                    children: [
                                                        address === null || address === void 0 ? void 0 : address.city,
                                                        ", ",
                                                        address === null || address === void 0 ? void 0 : address.state,
                                                        " ",
                                                        address === null || address === void 0 ? void 0 : address.postal_code
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
                                            analyticsName: "cosmos-edit-address",
                                            label: "Edit",
                                            onPress: routeToManualAddressPage,
                                            size: "medium",
                                            variant: "primary"
                                        })
                                    ]
                                }),
                                isAddressUnitNumberMissing && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexDirection: "column",
                                    gap: 6,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                                            id: "cosmos-address-confirmation-input",
                                            size: "medium",
                                            title: "Add unit number, apt, floor, etc.",
                                            required: true,
                                            placeholder: "#1234",
                                            errorText: unitNumberErrorText,
                                            onChangeText: handleUnitNumberChange,
                                            disabled: noUnitChecked,
                                            value: (ref8 = address === null || address === void 0 ? void 0 : address.unit) !== null && ref8 !== void 0 ? ref8 : ""
                                        }),
                                        (address === null || address === void 0 ? void 0 : address.unit) === streetNumber && !confirmSameUnitStreet && !noUnitChecked && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
                                            variant: "primary",
                                            id: "same-street-unit",
                                            label: "Same street and unit",
                                            size: "medium",
                                            analyticsName: "cosmos-same-street-unit",
                                            trackImpression: true,
                                            onPress: function() {
                                                setUnitNumberErrorText("");
                                                setConfirmSameUnitStreet(true);
                                            }
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            "aria-label": "No unit number",
                                            analyticsName: "address-confirmation-no-unit-checkbox",
                                            flexDirection: "row",
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                                                    analyticsName: "address-confirmation-no-unit",
                                                    size: "medium",
                                                    ariaLabel: "No unit number",
                                                    value: "no-unit",
                                                    checked: noUnitChecked,
                                                    onPress: handleNoUnitToggle
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$bodyMedium",
                                                    color: "$contentSecondary",
                                                    children: "No unit number"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                                    analyticsName: "address-confirmation-relationship-dropdown",
                                    id: "address-confirmation-relationship",
                                    size: "medium",
                                    title: "Are you the owner of this home?",
                                    required: true,
                                    placeholderOption: {
                                        label: "Select"
                                    },
                                    options: [
                                        {
                                            value: "Self",
                                            label: "Yes, I own this home"
                                        },
                                        {
                                            value: "Agent",
                                            label: "No, I’m an agent"
                                        },
                                        {
                                            value: "AgentAndOwner",
                                            label: "I’m an agent, and own this home"
                                        },
                                        {
                                            value: "other",
                                            label: "Other"
                                        }, 
                                    ],
                                    onValueChange: function(value) {
                                        return handleRelationshipSelect(value);
                                    },
                                    errorText: relationshipError || undefined
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "100%",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                width: "100%",
                                analyticsName: "address-confirmation-modal-confirm",
                                label: "Confirm",
                                onPress: handleConfirm,
                                size: "medium",
                                variant: "primary",
                                loading: isConfirmLoading,
                                disabled: !relationshipValue || !!relationshipError || !!unitNumberErrorText || isAddressUnitNumberMissing && !(address === null || address === void 0 ? void 0 : address.unit) && !noUnitChecked
                            })
                        })
                    ]
                })
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/shared/NewSellerFlowAddressInput.tsx













var BelowActionButtonRegistration = function(param) {
    var isLoading = param.isLoading, onPress = param.onPress, onStateChange = param.onStateChange;
    // Cinderblocks exposes "submit the first address suggestion" through its suffix action hook.
    // Keep that adaptation in this shared wrapper so feature components can render an explicit below-field CTA.
    (0,react.useEffect)(function() {
        onStateChange({
            isLoading: Boolean(isLoading),
            onPress: onPress
        });
    }, [
        isLoading,
        onPress,
        onStateChange
    ]);
    return null;
};
var ManualEntryButton = function(param) {
    var onMouseDown = param.onMouseDown, onPress = param.onPress;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextButton/* TextButton */.A, {
        onMouseDown: onMouseDown,
        label: "Enter address manually instead",
        analyticsName: "cosmos-address-input-manual-entry",
        type: "button",
        onPress: onPress,
        width: "100%",
        variant: "primary",
        size: "medium",
        px: "$5",
        pt: "$2half",
        pb: "$5"
    });
};
var NewSellerFlowAddressInput = function(param) {
    var actionButton = param.actionButton, belowActionButton = param.belowActionButton, channel = param.channel, hideLabel = param.hideLabel, icon = param.icon, inputLocation = param.inputLocation, _listBoxAriaLabel = param.listBoxAriaLabel, listBoxAriaLabel = _listBoxAriaLabel === void 0 ? "addresses" : _listBoxAriaLabel, _listBoxId = param.listBoxId, listBoxId = _listBoxId === void 0 ? "cb1-listbox" : _listBoxId, pageSetPath = param.pageSetPath, placeholder = param.placeholder, trackingKeywords = param.trackingKeywords, trackingTaxonomy = param.trackingTaxonomy, _size = param.size, size = _size === void 0 ? "large" : _size;
    var router = (0,next_router.useRouter)();
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var ref = (0,react.useState)(""), searchTerm = ref[0], setSearchTerm = ref[1];
    var ref1 = (0,react.useState)(false), isFocused = ref1[0], setIsFocused = ref1[1];
    var belowActionButtonPressRef = react.useRef(function() {
        return undefined;
    });
    var ref2 = (0,react.useState)({
        isLoading: false,
        isRegistered: false
    }), belowActionButtonState = ref2[0], setBelowActionButtonState = ref2[1];
    var ref3 = (0,react.useState)(false), isConfirmationModalOpen = ref3[0], setIsConfirmationModalOpen = ref3[1];
    var ref4 = (0,react.useState)([]), predictions = ref4[0], setPredictions = ref4[1];
    var ref5 = (0,AddressValidationContext/* useAddressValidationContext */.oK)(), validatedAddress = ref5.validatedAddress, setValidatedAddress = ref5.setValidatedAddress, setAddressResults = ref5.setAddressResults, setFirstPrediction = ref5.setFirstPrediction, setPartnerReferralId = ref5.setPartnerReferralId, setPageSetPath = ref5.setPageSetPath, setTrackingKeywords = ref5.setTrackingKeywords, setChannel = ref5.setChannel;
    var partner_referral = (0,queryParams/* default */.Z)().partner_referral;
    var handleBelowActionButtonStateChange = (0,react.useCallback)(function(param) {
        var isLoading = param.isLoading, onPress = param.onPress;
        belowActionButtonPressRef.current = onPress;
        setBelowActionButtonState(function(current) {
            return current.isRegistered && current.isLoading === isLoading ? current : {
                isLoading: isLoading,
                isRegistered: true
            };
        });
    }, []);
    var handleBelowActionButtonPress = (0,react.useCallback)(function() {
        belowActionButtonPressRef.current();
    }, []);
    (0,react.useEffect)(function() {
        if (partner_referral) {
            setPartnerReferralId(partner_referral);
        }
        if (pageSetPath) {
            setPageSetPath(pageSetPath);
        }
        if (trackingKeywords) {
            setTrackingKeywords(trackingKeywords);
        }
        if (channel) {
            setChannel(channel);
        }
    }, [
        partner_referral,
        pageSetPath,
        trackingKeywords,
        channel
    ]);
    var handleMouseDown = (0,react.useCallback)(function(e) {
        e.preventDefault();
    }, []);
    var handleManualEntryPress = (0,react.useCallback)(function() {
        router.push({
            pathname: "/manual-address-entry",
            query: (0,_object_spread/* default */.Z)({}, trackingKeywords != null && {
                trackingKeywords: trackingKeywords
            }, partner_referral != null && {
                partnerReferralId: partner_referral
            }, pageSetPath != null && {
                pageSetPath: pageSetPath
            }, channel != null && {
                channel: channel
            })
        });
    }, [
        router,
        trackingKeywords,
        partner_referral,
        pageSetPath,
        channel
    ]);
    var handleFocus = (0,react.useCallback)(function() {
        setIsFocused(true);
    }, []);
    var handleBlur = (0,react.useCallback)(function() {
        setIsFocused(false);
    }, []);
    var handlePredictionsChange = function(newPredictions) {
        setPredictions(newPredictions);
        if (newPredictions.length > 0) {
            setFirstPrediction(newPredictions[0]);
        }
    };
    var handleSearchTermChange = (0,react.useCallback)(function(newSearchTerm) {
        setSearchTerm(newSearchTerm);
    }, []);
    var customAction = predictions.length < 5 && searchTerm !== "" && isFocused ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ManualEntryButton, {
        onMouseDown: handleMouseDown,
        onPress: handleManualEntryPress
    }) : undefined;
    var isBelowActionButtonReady = belowActionButtonState.isRegistered && searchTerm.trim() !== "" && predictions.length > 0;
    var resolvedActionButton = belowActionButton ? function(onPress, isLoading) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BelowActionButtonRegistration, {
            isLoading: isLoading,
            onPress: onPress,
            onStateChange: handleBelowActionButtonStateChange
        });
    } : actionButton;
    var handleAddressValidated = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(validationResult) {
            var validatedAddr, results, needsManualEntry, needsUnitSelection, selectedAddress;
            return (0,tslib_es6.__generator)(this, function(_state) {
                validatedAddr = validationResult.address, results = validationResult.results, needsManualEntry = validationResult.needsManualEntry, needsUnitSelection = validationResult.needsUnitSelection;
                selectedAddress = {
                    id: validatedAddr.id,
                    street1: validatedAddr.street1,
                    city: validatedAddr.city,
                    state: validatedAddr.state,
                    postal_code: validatedAddr.postal_code,
                    unit: validatedAddr.unit,
                    latitude: validatedAddr.latitude,
                    longitude: validatedAddr.longitude,
                    result: results,
                    source: validatedAddr.source
                };
                setAddressResults(results);
                setValidatedAddress(selectedAddress);
                // Redirect to manual entry if needed
                if (needsManualEntry) {
                    router.push({
                        pathname: "/manual-address-entry",
                        query: (0,_object_spread/* default */.Z)({
                            address: JSON.stringify(selectedAddress),
                            result: results
                        }, partner_referral != null && {
                            partnerReferralId: partner_referral
                        }, pageSetPath != null && {
                            pageSetPath: pageSetPath
                        }, trackingKeywords != null && {
                            trackingKeywords: trackingKeywords
                        }, channel != null && {
                            channel: channel
                        })
                    });
                    return [
                        2
                    ];
                }
                // Show confirmation modal if unit selection is needed
                if (needsUnitSelection) {
                    setIsConfirmationModalOpen(true);
                    return [
                        2
                    ];
                }
                setIsConfirmationModalOpen(true);
                return [
                    2
                ];
            });
        });
        return function handleAddressValidated(validationResult) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleError = function(error) {
        var _obj, ref;
        (ref = (_obj = global/* globalObservability.getSentryClient */.w.getSentryClient()).captureException) === null || ref === void 0 ? void 0 : ref.call(_obj, error);
    };
    var handleAddressSelect = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
            var ref;
            return (0,tslib_es6.__generator)(this, function(_state) {
                try {
                    ;
                    // Track analytics - flush immediately since navigation follows shortly
                    trackJourneyEvent("sell", "addressEntryV2", {
                        street1: address.street1,
                        city: address.city,
                        state: address.state,
                        postalCode: address.postal_code,
                        unit: address.unit,
                        latitude: address.latitude,
                        longitude: address.longitude,
                        sourcePage: router.asPath,
                        campaign: (ref = router.query) === null || ref === void 0 ? void 0 : ref.utm_campaign
                    }, {
                        flush: true
                    });
                } catch (e) {
                    handleError(e);
                }
                return [
                    2
                ];
            });
        });
        return function handleAddressSelect(address) {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Col/* Col */.J, {
        flex: 1,
        gap: belowActionButton ? "$3" : undefined,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                className: "od-address-input",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                    position: "relative",
                    className: "cta-input-form",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressInput/* default */.Z, {
                        id: "home-address-input",
                        label: "Enter your home address",
                        hideLabel: hideLabel,
                        placeholder: placeholder,
                        disabled: false,
                        onAddressSelect: handleAddressSelect,
                        onAddressValidated: handleAddressValidated,
                        validateAddress: true,
                        onError: handleError,
                        onPredictionsChange: handlePredictionsChange,
                        onSearchTermChange: handleSearchTermChange,
                        onFocus: handleFocus,
                        onBlur: handleBlur,
                        customAction: customAction,
                        listBoxId: listBoxId,
                        listBoxAriaLabel: listBoxAriaLabel,
                        actionButton: resolvedActionButton,
                        icon: icon,
                        size: size
                    })
                })
            }),
            belowActionButton === null || belowActionButton === void 0 ? void 0 : belowActionButton({
                onPress: handleBelowActionButtonPress,
                isLoading: belowActionButtonState.isLoading,
                isReady: isBelowActionButtonReady
            }),
            isConfirmationModalOpen && validatedAddress && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AddressConfirmationModal, {
                setIsOpen: setIsConfirmationModalOpen,
                isOpen: isConfirmationModalOpen,
                partnerReferralId: partner_referral,
                initialAddress: validatedAddress,
                pageSetPath: pageSetPath,
                trackingKeywords: trackingKeywords,
                channel: channel,
                inputLocation: inputLocation,
                trackingTaxonomy: trackingTaxonomy
            })
        ]
    });
};
/* harmony default export */ var shared_NewSellerFlowAddressInput = (NewSellerFlowAddressInput);


/***/ }),

/***/ 69814:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ useReturnExperienceContext; },
/* harmony export */   "Q": function() { return /* binding */ ReturnExperienceContextProvider; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _returnExperience__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86669);



var ReturnExperienceContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    returnExperienceData: null,
    showReturnExperience: false
});
var ReturnExperienceContextProvider = function(param) {
    var children = param.children, showReturnExperience = param.showReturnExperience;
    var returnExperienceData = (0,_returnExperience__WEBPACK_IMPORTED_MODULE_1__/* .useReturnExperience */ .lM)().returnExperienceData;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__/* .jsx */ .tZ)(ReturnExperienceContext.Provider, {
        value: {
            returnExperienceData: returnExperienceData,
            showReturnExperience: showReturnExperience
        },
        children: children
    });
};
var useReturnExperienceContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(ReturnExperienceContext);
};


/***/ }),

/***/ 9857:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O": function() { return /* binding */ captureError; }
/* harmony export */ });
/* harmony import */ var _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(96602);

var Sentry = _opendoor_observability_slim__WEBPACK_IMPORTED_MODULE_0__/* .globalObservability.getSentryClient */ .w.getSentryClient();
/**
 * Reports a handled error to Sentry, tagged with the operation that failed so
 * the failures are easy to group/search. Use for caught errors that are
 * recovered from (e.g. a query that falls back to an empty list).
 */ var captureError = function(error, op) {
    var ref;
    (ref = Sentry.withScope) === null || ref === void 0 ? void 0 : ref.call(Sentry, function(scope) {
        var ref;
        scope.setTag("op", op);
        (ref = Sentry.captureException) === null || ref === void 0 ? void 0 : ref.call(Sentry, error);
    });
};


/***/ }),

/***/ 89060:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A4": function() { return /* binding */ MAPBOX_ACCESS_TOKEN; },
/* harmony export */   "HP": function() { return /* binding */ OD_APP_URL; },
/* harmony export */   "Hx": function() { return /* binding */ MAPBOX_MAP_STYLE; },
/* harmony export */   "j_": function() { return /* binding */ HOMEPAGE_URL; }
/* harmony export */ });
/* harmony import */ var _components_globals__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(79758);
/* provided dependency */ var process = __webpack_require__(73656);

var HOMEPAGE_URL = {
    production: "https://www.opendoor.com",
    staging: "https://demo.simplersell.com",
    qa: "https://demo.simplersell.com",
    development: "http://localhost:3011/homepage-2019",
    localdev: process.env.LOCAL_HOMEPAGE_URL || "http://localhost:3011/homepage-2019",
    test: "https://www.opendoor.com"
}[_components_globals__WEBPACK_IMPORTED_MODULE_0__/* .DEPLOY_ENV */ .Zp];
// Public token; meant to be exposed client-side.
// URL restrictions are configured in the Mapbox admin panel.
var MAPBOX_ACCESS_TOKEN = "pk.eyJ1Ijoib3BlbmRvb3IiLCJhIjoiY21tbndmMnpoMDgwNzJzb3Jtdm5wejJpMiJ9.9hm2Ma2vzjbr5Tr4nt4hmA";
var MAPBOX_MAP_STYLE = "mapbox://styles/opendoor/cktkqasmc1gbe17pfo2cm7ybb";
var getIsIOS = function() {
    var userAgent = typeof navigator !== "undefined" && (navigator.userAgent || navigator.vendor);
    return userAgent && /iPad|iPhone|iPod/.test(userAgent);
};
var platform = getIsIOS() ? "ios" : "android";
var OD_APP_URL = {
    ios: "https://itunes.apple.com/us/app/opendoor-homes-all-day-open/id1143708068?mt=8",
    android: "https://play.google.com/store/apps/details?id=com.opendoor.buyerapp&hl=en"
}[platform];


/***/ }),

/***/ 83349:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "O_": function() { return /* binding */ getMarketDisplayNameForHeroV2; },
/* harmony export */   "UE": function() { return /* binding */ US_STATE_CODES_OPTIONS; }
/* harmony export */ });
/* unused harmony exports getMarketDisplayNameWithState, getActiveSellDirectMarketOptions */
var US_STATE_CODES = [
    "AL",
    "AK",
    "AZ",
    "AR",
    "CA",
    "CO",
    "CT",
    "DE",
    "FL",
    "GA",
    "HI",
    "ID",
    "IL",
    "IN",
    "IA",
    "KS",
    "KY",
    "LA",
    "ME",
    "MD",
    "MA",
    "MI",
    "MN",
    "MS",
    "MO",
    "MT",
    "NE",
    "NV",
    "NH",
    "NJ",
    "NM",
    "NY",
    "NC",
    "ND",
    "OH",
    "OK",
    "OR",
    "PA",
    "RI",
    "SC",
    "SD",
    "TN",
    "TX",
    "UT",
    "VT",
    "VA",
    "WA",
    "WV",
    "WI",
    "WY", 
];
var US_STATE_CODES_OPTIONS = US_STATE_CODES.map(function(c) {
    return {
        value: c,
        label: c
    };
});
var MARKET_TO_STATE_ABBREV = {
    Asheville: "NC",
    Atlanta: "GA",
    Austin: "TX",
    Bakersfield: "CA",
    Birmingham: "AL",
    Boise: "ID",
    Charlotte: "NC",
    Chattanooga: "TN",
    Cincinnati: "OH",
    Clarksville: "TN",
    Cleveland: "OH",
    "Colorado Springs": "CO",
    Columbia: "SC",
    Columbus: "OH",
    "Corpus Christi": "TX",
    Dallas: "TX",
    Denver: "CO",
    "Fort Collins": "CO",
    Greensboro: "NC",
    Greenville: "SC",
    Houston: "TX",
    Huntsville: "AL",
    Indianapolis: "IN",
    Jacksonville: "FL",
    "Johnson City": "TN",
    "Kansas City": "KS",
    Killeen: "TX",
    Knoxville: "TN",
    "Las Vegas": "NV",
    "Los Angeles": "CA",
    Louisville: "KY",
    Memphis: "TN",
    Miami: "FL",
    Minneapolis: "MN",
    Nashville: "TN",
    "New York New Jersey": "NY",
    "Northern Colorado": "CO",
    "Oklahoma City": "OK",
    Orlando: "FL",
    Phoenix: "AZ",
    Portland: "OR",
    Prescott: "AZ",
    Raleigh: "NC",
    Reno: "NV",
    Riverside: "CA",
    Sacramento: "CA",
    "Salt Lake City": "UT",
    "San Antonio": "TX",
    "San Diego": "CA",
    "Sf Bay Area": "CA",
    Springfield: "MO",
    "St Louis": "MO",
    Tampa: "FL",
    Tucson: "AZ",
    Tulsa: "OK",
    Unknown: "",
    "Washington Dc": "D.C.",
    Wichita: "KS"
};
var getMarketDisplayNameWithState = function(market) {
    var edgeCase = handleMarketDisplayNameWithStateEdgeCases(market || "");
    if (edgeCase) {
        return edgeCase;
    }
    var splits = market.split("_");
    var stateAbbrev = "";
    // check if last element is a state code, remove it temporarily
    if (splits.length > 1 && splits[splits.length - 1].length === 2 && US_STATE_CODES.indexOf(splits[splits.length - 1].toUpperCase()) >= 0) {
        stateAbbrev = splits[splits.length - 1];
        splits = splits.slice(0, splits.length - 1);
    }
    // Generate sentence casing and re-append the state code
    var lowerCaseSplits = splits.map(function(s) {
        return s.toLowerCase();
    });
    var sentenceCaseMarketName = lowerCaseSplits.map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(" ");
    // Any markets launched after Q1 2022 will be systematically constructed e.g. Phoenix, AZ
    // The above constant (MARKET_TO_STATE_ABBREV) is a helper for markets created prior to this system,
    // and does not need to be used/updated for any future markets.
    stateAbbrev = stateAbbrev === "" ? stateAbbrev = MARKET_TO_STATE_ABBREV[sentenceCaseMarketName] : stateAbbrev.toUpperCase();
    return sentenceCaseMarketName + ", " + stateAbbrev;
};
function handleMarketDisplayNameWithStateEdgeCases(market) {
    if (market === "clarksville_ky_tn") {
        return "Clarksville, TN";
    }
    if (market === "louisville_in_ky") {
        return "Louisville, KY";
    }
    if (market === "sf_bay_area") {
        return "San Francisco Bay Area, CA";
    }
    if (market === "new_york_new_jersey") {
        return "New York / New Jersey";
    }
    if (market === "washington_dc") {
        return "Washington, D.C.";
    }
    if (market === "southwest_fl") {
        return "Southwest Florida";
    }
    return undefined;
}
var getMarketDisplayNameForHeroV2 = function(market) {
    if (market === "" || market === undefined) {
        return null;
    }
    var edgeCase = handleMarketDisplayNameEdgeCasesForHeroV2(market || "");
    if (edgeCase) {
        return edgeCase;
    }
    var splits = market.split("_");
    // check if last element is a state code, remove it
    if (splits.length > 1 && splits[splits.length - 1].length === 2 && US_STATE_CODES.indexOf(splits[splits.length - 1].toUpperCase()) >= 0) {
        splits = splits.slice(0, splits.length - 1);
    }
    // Generate sentence casing
    var lowerCaseSplits = splits.map(function(s) {
        return s.toLowerCase();
    });
    var sentenceCaseMarketName = lowerCaseSplits.map(function(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }).join(" ");
    return sentenceCaseMarketName;
};
function handleMarketDisplayNameEdgeCasesForHeroV2(market) {
    if (market === "clarksville_ky_tn") {
        return "Clarksville";
    }
    if (market === "louisville_in_ky") {
        return "Louisville";
    }
    if (market === "sf_bay_area") {
        return "the Bay";
    }
    if (market === "new_york_new_jersey") {
        return "the Northeast";
    }
    if (market === "milwaukee_waukesha_wi") {
        return "Milwaukee";
    }
    if (market === "washington_dc") {
        return "DC";
    }
    if (market === "southwest_fl") {
        return "Florida";
    }
    return undefined;
}
var alphabetize = function(a, b) {
    // eslint-disable-next-line no-nested-ternary -- Grandfathered violation
    return a.label < b.label ? -1 : a.label > b.label ? 1 : 0;
};
var getActiveSellDirectMarketOptions = function(markets) {
    var activeSellDirectMarkets = markets.filter(function(market) {
        var ref;
        if ((ref = market.marketData) === null || ref === void 0 ? void 0 : ref.launchDate) {
            var ref1, ref2;
            // returns seconds since epoch
            var now = Date.now();
            // returns seconds since epoch
            var launchDate = Date.parse((ref1 = market.marketData) === null || ref1 === void 0 ? void 0 : ref1.launchDate);
            // Note: actual offset is +7 or +8 depending on daylight savings time
            // this doesn't have to be exact, so choosing +8
            var PST_OFFSET_MS = 8 * 60 * 60 * 1000;
            // only display the market is acive and the launch date has passed
            // add an offset, to standardize this check on PST
            return ((ref2 = market.marketData) === null || ref2 === void 0 ? void 0 : ref2.active) && launchDate + PST_OFFSET_MS <= now;
        }
    });
    var marketOptions = activeSellDirectMarkets.map(function(market) {
        var identifier = market.marketData.marketIdentifier;
        var option = {
            label: getMarketDisplayNameWithState(identifier),
            value: market.marketData.homesPath
        };
        return option;
    });
    return marketOptions.sort(alphabetize);
};


/***/ }),

/***/ 15318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$_": function() { return /* binding */ PAGE_ITEMS_LIMIT; },
/* harmony export */   "lA": function() { return /* binding */ getPaginationForData; },
/* harmony export */   "ur": function() { return /* binding */ getSkipOffset; }
/* harmony export */ });
var PAGE_ITEMS_LIMIT = 16;
var PAGINATION_CONTENT_TYPES = [
    "componentRelatedArticles",
    "componentRelatedExternalLinks",
    "lpComponentMulticard", 
];
/*
 * Returns an object with:
 * - Key: Content model ID e.g. componentRelatedArticles
 * - Value: Array of sys IDs for this content model type
 */ function createEmbeddedContentToSysIdsMap(document) {
    var ref;
    var initMap = Object.fromEntries(PAGINATION_CONTENT_TYPES.map(function(item) {
        return [
            item,
            []
        ];
    }));
    return document === null || document === void 0 ? void 0 : (ref = document.content) === null || ref === void 0 ? void 0 : ref.reduce(function(result, current) {
        var ref, ref1, ref2, ref3, ref4;
        var componentType = current === null || current === void 0 ? void 0 : (ref = current.data) === null || ref === void 0 ? void 0 : (ref1 = ref.target) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.sys) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.contentType) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.sys) === null || ref4 === void 0 ? void 0 : ref4.id;
        if ((current === null || current === void 0 ? void 0 : current.nodeType) === "embedded-entry-block" && (PAGINATION_CONTENT_TYPES === null || PAGINATION_CONTENT_TYPES === void 0 ? void 0 : PAGINATION_CONTENT_TYPES.includes(componentType))) {
            var ref5, ref6, ref7;
            var componentSysId = current === null || current === void 0 ? void 0 : (ref5 = current.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.target) === null || ref6 === void 0 ? void 0 : (ref7 = ref6.sys) === null || ref7 === void 0 ? void 0 : ref7.id;
            result[componentType].push(componentSysId);
        }
        return result;
    }, initMap);
}
/*
 * Topic page currently supports pagination for embedded entry blocks only when
 * the body contains only 1 type of related content (e.g. componentRelatedArticles,
 * componentRelatedExternalLinks). For example, pagination will NOT be shown if
 * the topic page body has 2 related article entries.
 */ function getPaginationForData(props, initCurrentPage) {
    var ref, ref1;
    var pagination = {};
    var embeddedContentMap = createEmbeddedContentToSysIdsMap(props.fields.body) || {};
    (ref = Object.keys(embeddedContentMap)) === null || ref === void 0 ? void 0 : ref.forEach(function(key) {
        var ref;
        var contentType = key;
        if (((ref = embeddedContentMap[contentType]) === null || ref === void 0 ? void 0 : ref.length) !== 1) {
            // Filter out any content types that don't have only 1 instance of it
            delete embeddedContentMap[contentType];
        }
    });
    var loaderDataId; // We use the loader data ID to get the total number of items for this content type
    if (((ref1 = Object.keys(embeddedContentMap)) === null || ref1 === void 0 ? void 0 : ref1.length) === 1) {
        var contentType = Object.keys(embeddedContentMap)[0];
        loaderDataId = embeddedContentMap[contentType][0];
        if (props.idToLoaderData[loaderDataId]) {
            var ref2;
            var total = ((ref2 = props.idToLoaderData[loaderDataId]) === null || ref2 === void 0 ? void 0 : ref2.total) || 0;
            pagination = getPaginationState(total, initCurrentPage);
        }
    }
    return pagination;
}
function getPaginationState(totalItems, initCurrentPage) {
    var lastPage = Math.ceil(totalItems / PAGE_ITEMS_LIMIT);
    var currentPage = initCurrentPage && initCurrentPage > 0 && initCurrentPage <= lastPage ? initCurrentPage : 1;
    return {
        showPagination: totalItems > PAGE_ITEMS_LIMIT,
        currentPage: currentPage,
        lastPage: lastPage,
        previousPage: currentPage > 1 ? currentPage - 1 : 0,
        nextPage: currentPage < lastPage ? currentPage + 1 : lastPage
    };
}
function getSkipOffset(pageIndex) {
    var skipMultiplier = pageIndex === 1 ? 0 : pageIndex - 1;
    var skip = skipMultiplier * PAGE_ITEMS_LIMIT;
    return skip;
}


/***/ }),

/***/ 86669:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "g": function() { return /* binding */ ExperienceType; },
/* harmony export */   "lM": function() { return /* binding */ useReturnExperience; }
/* harmony export */ });
/* unused harmony export getReturnExperienceData */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92336);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(37462);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(js_cookie__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _components_api__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22225);





var fetchSellerReturnExperience = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var sellerInputUUID, response, returnExperienceData;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    sellerInputUUID = js_cookie__WEBPACK_IMPORTED_MODULE_1___default().get("sellerInputUUID") || localStorage.getItem("sellerInputUUID");
                    if (!sellerInputUUID) {
                        return [
                            2
                        ];
                    }
                    localStorage.setItem("sellerInputUUID", sellerInputUUID);
                    return [
                        4,
                        _components_api__WEBPACK_IMPORTED_MODULE_2__/* .fetchSellerReturnExperience */ .cv(sellerInputUUID)
                    ];
                case 1:
                    response = _state.sent();
                    if (!response || !response.data) {
                        return [
                            2
                        ];
                    }
                    returnExperienceData = getReturnExperienceData(response.data, sellerInputUUID);
                    if (returnExperienceData.experienceType === null) {
                        return [
                            2
                        ];
                    }
                    return [
                        2,
                        {
                            returnExperienceData: returnExperienceData
                        }
                    ];
            }
        });
    });
    return function fetchSellerReturnExperience() {
        return _ref.apply(this, arguments);
    };
}();
var buildAddress = function(street, unitType, unitNumber, city, state, postalCode) {
    var address = "";
    if (street && unitNumber) {
        address = "".concat(street, " ").concat(unitType, " ").concat(unitNumber, ",");
    } else if (street) {
        address = "".concat(street);
    }
    if (city) {
        address += ", ".concat(city, ",");
    }
    if (state) {
        address += " ".concat(state);
    }
    if (postalCode) {
        address += " ".concat(postalCode);
    }
    return address;
};
var ExperienceType;
(function(ExperienceType) {
    ExperienceType[ExperienceType["offer_expired"] = 0] = "offer_expired";
    ExperienceType[ExperienceType["incomplete_flow"] = 1] = "incomplete_flow";
    ExperienceType[ExperienceType["offer_expiring"] = 2] = "offer_expiring";
    ExperienceType[ExperienceType["offer_decreased"] = 3] = "offer_decreased";
    ExperienceType[ExperienceType["offer_increased"] = 4] = "offer_increased";
    ExperienceType[ExperienceType["active_offer"] = 5] = "active_offer";
    ExperienceType[ExperienceType["direct_mailer"] = 6] = "direct_mailer";
})(ExperienceType || (ExperienceType = {}));
var OFFER_EXPIRY_DAYS_CUTOFF = 4;
var getReturnExperienceData = function(data, sellerInputUUID) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16;
    if (!((ref = data.sellDirect) === null || ref === void 0 ? void 0 : ref.getLead) && !((ref1 = data.reception) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.getSellerInput) === null || ref2 === void 0 ? void 0 : ref2.sellerInput.address)) {
        return {
            experienceType: null
        };
    }
    var answers = (ref3 = data.reception.getSellerInput) === null || ref3 === void 0 ? void 0 : ref3.sellerInput.answers;
    var productOfferings = (ref4 = data.reception.getSellerInput) === null || ref4 === void 0 ? void 0 : ref4.sellerInput.productOfferings;
    var sellDirectProductOffering = productOfferings === null || productOfferings === void 0 ? void 0 : productOfferings.find(function(po) {
        return po.product === "OPENDOOR_DIRECT";
    });
    var sellDirectDenied = sellDirectProductOffering === null || sellDirectProductOffering === void 0 ? void 0 : sellDirectProductOffering.deniedAt;
    // If the lead is denied for sell direct then there is no return experience for them.
    if (sellDirectDenied) {
        return {
            experienceType: null
        };
    }
    var sellerInputAddress = (ref5 = data.reception.getSellerInput) === null || ref5 === void 0 ? void 0 : ref5.sellerInput.address;
    var addressFull = buildAddress(sellerInputAddress.street, sellerInputAddress.unitType, sellerInputAddress.unitNumber, sellerInputAddress.city, sellerInputAddress.state, sellerInputAddress.postalCode);
    // Without an email the lead could not have qualified and thus we want to show the incomplete experience at this stage
    if (!answers.email) {
        var ref17, ref18;
        return {
            sellerInputUUID: sellerInputUUID,
            address: (ref17 = data.reception.getSellerInput) === null || ref17 === void 0 ? void 0 : ref17.sellerInput.address.street,
            addressFull: addressFull,
            experienceType: ExperienceType.incomplete_flow,
            sellerFlowLastCompletedSlug: (ref18 = data.reception.getSellerInput) === null || ref18 === void 0 ? void 0 : ref18.sellerInput.sellerFlowLastCompletedSlug
        };
    }
    // Check if the lead was qualified in web
    var hasSellDirectExperience = (ref6 = data.sellDirect.getLead) === null || ref6 === void 0 ? void 0 : ref6.lead.isQualified;
    if (!hasSellDirectExperience) {
        return {
            experienceType: null
        };
    }
    // user has a sell direct offer
    var lead = (ref7 = data.sellDirect.getLead) === null || ref7 === void 0 ? void 0 : ref7.lead;
    var address = (ref8 = lead.address) === null || ref8 === void 0 ? void 0 : ref8.street;
    var addressToken = (ref9 = lead.address) === null || ref9 === void 0 ? void 0 : ref9.uuid;
    var customerUUID = (ref10 = lead.customerV2) === null || ref10 === void 0 ? void 0 : ref10.uuid;
    var firstName = (ref11 = lead.customerV2) === null || ref11 === void 0 ? void 0 : ref11.firstName;
    var offerRequestSource = (ref12 = lead.latestOffer) === null || ref12 === void 0 ? void 0 : ref12.offerRequestSource;
    var currentOfferHeadlinePriceCents = (ref13 = lead.latestOffer) === null || ref13 === void 0 ? void 0 : ref13.headlinePriceCents;
    var previousOfferHeadlinePriceCents = (ref14 = lead.previousOffer) === null || ref14 === void 0 ? void 0 : ref14.headlinePriceCents;
    var offerState = (ref15 = lead.latestOffer) === null || ref15 === void 0 ? void 0 : ref15.state;
    var offerExpiresAt = (ref16 = lead.latestOffer) === null || ref16 === void 0 ? void 0 : ref16.preliminaryOfferExpirationDate;
    var isQualifiedLead = lead.isQualified;
    var offerExpiresInDays = undefined;
    if (offerExpiresAt) {
        var currentTime = new Date().getTime();
        var expirationTime = Date.parse(offerExpiresAt);
        // convert the milliseconds time difference into days and round up to nearest number of days
        offerExpiresInDays = Math.ceil((expirationTime - currentTime) / (1000 * 3600 * 24));
    }
    var experienceType = null;
    if (offerState == "EXPIRED" && isQualifiedLead) {
        // let's only set the experience type to be "offer_expired" when we know that this lead is eligible for offer refresh (qualified for opendoor direct)
        experienceType = ExperienceType.offer_expired;
    } else if (offerState == "SENT" && offerExpiresInDays && offerExpiresInDays > 0 && offerExpiresInDays <= OFFER_EXPIRY_DAYS_CUTOFF) {
        experienceType = ExperienceType.offer_expiring;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents - previousOfferHeadlinePriceCents >= 1000) {
        experienceType = ExperienceType.offer_increased;
    } else if (offerState == "SENT" && currentOfferHeadlinePriceCents && previousOfferHeadlinePriceCents && currentOfferHeadlinePriceCents < previousOfferHeadlinePriceCents) {
        experienceType = ExperienceType.offer_decreased;
    } else if (offerState == "SENT") {
        experienceType = ExperienceType.active_offer;
    }
    return {
        sellerInputUUID: sellerInputUUID,
        address: address,
        addressFull: addressFull,
        addressToken: addressToken,
        customerUUID: customerUUID,
        firstName: firstName,
        offerRequestSource: offerRequestSource,
        currentOfferHeadlinePriceCents: currentOfferHeadlinePriceCents,
        previousOfferHeadlinePriceCents: previousOfferHeadlinePriceCents,
        offerExpiresInDays: offerExpiresInDays,
        experienceType: experienceType
    };
};
// Custom hook to handle fetching return experience logic
var useReturnExperience = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        experienceType: null
    }), returnExperienceData = ref[0], setReturnExperienceData = ref[1];
    var returnExperienceShown = returnExperienceData.experienceType !== null;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        function start() {
            return _start.apply(this, arguments);
        }
        function _start() {
            _start = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
                var result;
                return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                fetchSellerReturnExperience()
                            ];
                        case 1:
                            result = _state.sent();
                            if (!result) {
                                return [
                                    2
                                ];
                            }
                            setReturnExperienceData(result.returnExperienceData);
                            return [
                                2
                            ];
                    }
                });
            });
            return _start.apply(this, arguments);
        }
        start();
    }, []);
    return {
        returnExperienceData: returnExperienceData,
        returnExperienceShown: returnExperienceShown
    };
};


/***/ }),

/***/ 55729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ _market_; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(60947);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(37705);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/tslib@2.8.1/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(92336);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../auth-fe/src/AuthContext.ts
var AuthContext = __webpack_require__(51087);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/Button.tsx
var Button = __webpack_require__(56865);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../bricks-next/src/components/Link/Link.tsx
var Link = __webpack_require__(46320);
// EXTERNAL MODULE: ../bricks-next/src/components/Toast/Toast.tsx
var Toast = __webpack_require__(26313);
// EXTERNAL MODULE: ./src/components/api/index.ts + 3 modules
var api = __webpack_require__(22225);
// EXTERNAL MODULE: ./src/components/marketplace/FloatingNavigationBar.tsx
var FloatingNavigationBar = __webpack_require__(36674);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/index.ts + 4 modules
var helpers = __webpack_require__(68139);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useMapRefs.ts

var useMapRefs = function() {
    var smallMap = (0,react.useRef)(null);
    var mediumMap = (0,react.useRef)(null);
    var largeMap = (0,react.useRef)(null);
    return {
        smallMap: smallMap,
        mediumMap: mediumMap,
        largeMap: largeMap
    };
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/mapping.ts
/**
 * Boundary translation between the marketplace UI's flat
 * `PropertySearchQuery` filter shape and Athena's product-shaped
 * `SavedSearchInput` / `SavedSearchFieldsFragment`.
 *
 * These functions are pure: no React, no I/O. The hook and UI components
 * compose them with `useSearchState` to round-trip filters.
 */ 


var SUPPORTED_PROPERTY_TYPES = [
    "HOME",
    "CONDO",
    "TOWNHOME", 
];
var buildPropertyTypes = function(query) {
    var types = [];
    if (query.singleFamily) {
        types.push("HOME");
    }
    if (query.condo) {
        types.push("CONDO");
    }
    if (query.townhome) {
        types.push("TOWNHOME");
    }
    // Collapse "all selected" to "any" so the persisted search behaves like
    // the UI default state (matches `getInitialPropertyTypes` in useSearchState.ts).
    return types.length === SUPPORTED_PROPERTY_TYPES.length ? [] : types;
};
// The Cosmos UI exposes a strict subset of `SavedSearchFilters` (no upper
// bounds for beds/baths, no Opendoor-owned or FHA toggles, and HOA is a
// single `noHoas` boolean rather than a numeric cap). Without preserving the
// caller-provided previous record, an update from Cosmos would silently
// clobber whatever another client (mobile, athlete-fe) stored in those
// fields. The `previous` parameter is the existing `SavedSearchFieldsFragment`
// being edited; pass `null`/omit on the initial add path.
var resolveHoaCap = function(noHoas, previousHoaCap) {
    if (noHoas) {
        return 0;
    }
    // `noHoas: false` in Cosmos can mean either "no HOA filter" or "I never
    // saw an HOA filter to toggle off" — both render identically in the UI.
    // If the previous record had a finite non-zero cap (e.g. $500), preserve
    // it so editing an unrelated field doesn't wipe out an HOA cap set on
    // another surface.
    if (previousHoaCap != null && previousHoaCap > 0) {
        return previousHoaCap;
    }
    return null;
};
function toSavedSearchInput(query, name, previous) {
    var previousFilters = previous === null || previous === void 0 ? void 0 : previous.filters;
    var _market, _zoneIds, _vertices, _minListPrice, _maxListPrice, _bedrooms, ref, _bathrooms, ref1, _minSquareFootage, _maxSquareFootage, _minLotSize, _maxLotSize, _minYearBuilt, _maxYearBuilt, ref2, _canSelfTour, _hasSingleStory, _hasPool, ref3;
    return {
        name: name,
        location: {
            market: (_market = query.market) !== null && _market !== void 0 ? _market : null,
            zoneIds: (_zoneIds = query.zoneIds) !== null && _zoneIds !== void 0 ? _zoneIds : null,
            vertices: (_vertices = query.vertices) !== null && _vertices !== void 0 ? _vertices : null
        },
        filters: {
            minPriceDollars: (_minListPrice = query.minListPrice) !== null && _minListPrice !== void 0 ? _minListPrice : null,
            maxPriceDollars: (_maxListPrice = query.maxListPrice) !== null && _maxListPrice !== void 0 ? _maxListPrice : null,
            maxMonthlyHoaFeeDollars: resolveHoaCap(query.noHoas, previousFilters === null || previousFilters === void 0 ? void 0 : previousFilters.maxMonthlyHoaFeeDollars),
            minBedrooms: (_bedrooms = query.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : null,
            // Cosmos has no UI for max-bound bed/bath filters; preserve any value
            // set by another client instead of clobbering it with `null` on update.
            maxBedrooms: (ref = previousFilters === null || previousFilters === void 0 ? void 0 : previousFilters.maxBedrooms) !== null && ref !== void 0 ? ref : null,
            minBathrooms: (_bathrooms = query.bathrooms) !== null && _bathrooms !== void 0 ? _bathrooms : null,
            maxBathrooms: (ref1 = previousFilters === null || previousFilters === void 0 ? void 0 : previousFilters.maxBathrooms) !== null && ref1 !== void 0 ? ref1 : null,
            minSqft: (_minSquareFootage = query.minSquareFootage) !== null && _minSquareFootage !== void 0 ? _minSquareFootage : null,
            maxSqft: (_maxSquareFootage = query.maxSquareFootage) !== null && _maxSquareFootage !== void 0 ? _maxSquareFootage : null,
            minLotSqft: (_minLotSize = query.minLotSize) !== null && _minLotSize !== void 0 ? _minLotSize : null,
            maxLotSqft: (_maxLotSize = query.maxLotSize) !== null && _maxLotSize !== void 0 ? _maxLotSize : null,
            minYearBuilt: (_minYearBuilt = query.minYearBuilt) !== null && _minYearBuilt !== void 0 ? _minYearBuilt : null,
            maxYearBuilt: (_maxYearBuilt = query.maxYearBuilt) !== null && _maxYearBuilt !== void 0 ? _maxYearBuilt : null,
            // Same rationale as max bed/bath: no Cosmos UI, so preserve on update.
            opendoorOwnedOnly: (ref2 = previousFilters === null || previousFilters === void 0 ? void 0 : previousFilters.opendoorOwnedOnly) !== null && ref2 !== void 0 ? ref2 : false,
            selfTourableOnly: (_canSelfTour = query.canSelfTour) !== null && _canSelfTour !== void 0 ? _canSelfTour : false,
            singleStoryOnly: (_hasSingleStory = query.hasSingleStory) !== null && _hasSingleStory !== void 0 ? _hasSingleStory : false,
            hasPoolOnly: (_hasPool = query.hasPool) !== null && _hasPool !== void 0 ? _hasPool : false,
            fhaEligibleOnly: (ref3 = previousFilters === null || previousFilters === void 0 ? void 0 : previousFilters.fhaEligibleOnly) !== null && ref3 !== void 0 ? ref3 : false,
            propertyTypes: buildPropertyTypes(query)
        }
    };
}
function toPropertySearchQuery(saved) {
    var types = saved.filters.propertyTypes;
    var allOrNone = types.length === 0 || types.length === SUPPORTED_PROPERTY_TYPES.length;
    var vertices = saved.location.vertices.length > 0 ? saved.location.vertices.map(function(v) {
        return {
            lat: v.lat,
            lon: v.lon
        };
    }) : undefined;
    var _market, _minBedrooms, _minBathrooms, _minPriceDollars, _maxPriceDollars, _minSqft, _maxSqft, _minLotSqft, _maxLotSqft, _minYearBuilt, _maxYearBuilt;
    return {
        market: (_market = saved.location.market) !== null && _market !== void 0 ? _market : undefined,
        zoneIds: saved.location.zoneIds.length > 0 ? (0,_to_consumable_array/* default */.Z)(saved.location.zoneIds) : undefined,
        vertices: vertices,
        bedrooms: (_minBedrooms = saved.filters.minBedrooms) !== null && _minBedrooms !== void 0 ? _minBedrooms : null,
        bathrooms: (_minBathrooms = saved.filters.minBathrooms) !== null && _minBathrooms !== void 0 ? _minBathrooms : null,
        minListPrice: (_minPriceDollars = saved.filters.minPriceDollars) !== null && _minPriceDollars !== void 0 ? _minPriceDollars : null,
        maxListPrice: (_maxPriceDollars = saved.filters.maxPriceDollars) !== null && _maxPriceDollars !== void 0 ? _maxPriceDollars : null,
        minSquareFootage: (_minSqft = saved.filters.minSqft) !== null && _minSqft !== void 0 ? _minSqft : null,
        maxSquareFootage: (_maxSqft = saved.filters.maxSqft) !== null && _maxSqft !== void 0 ? _maxSqft : null,
        minLotSize: (_minLotSqft = saved.filters.minLotSqft) !== null && _minLotSqft !== void 0 ? _minLotSqft : null,
        maxLotSize: (_maxLotSqft = saved.filters.maxLotSqft) !== null && _maxLotSqft !== void 0 ? _maxLotSqft : null,
        minYearBuilt: (_minYearBuilt = saved.filters.minYearBuilt) !== null && _minYearBuilt !== void 0 ? _minYearBuilt : null,
        maxYearBuilt: (_maxYearBuilt = saved.filters.maxYearBuilt) !== null && _maxYearBuilt !== void 0 ? _maxYearBuilt : null,
        noHoas: saved.filters.maxMonthlyHoaFeeDollars === 0,
        canSelfTour: saved.filters.selfTourableOnly || null,
        hasSingleStory: saved.filters.singleStoryOnly || null,
        hasPool: saved.filters.hasPoolOnly || null,
        singleFamily: allOrNone || types.includes("HOME"),
        condo: allOrNone || types.includes("CONDO"),
        townhome: allOrNone || types.includes("TOWNHOME")
    };
}
function formatSavedSearchName(query) {
    var parts = [];
    if (query.bedrooms) {
        parts.push("".concat(query.bedrooms, "+ bd"));
    }
    if (query.minListPrice || query.maxListPrice) {
        var minK = query.minListPrice ? "$".concat(Math.round(query.minListPrice / 1000), "k") : "";
        var maxK = query.maxListPrice ? "$".concat(Math.round(query.maxListPrice / 1000), "k") : "";
        parts.push([
            minK,
            maxK
        ].filter(Boolean).join("–"));
    }
    if (query.hasPool) {
        parts.push("pool");
    }
    if (query.market) {
        parts.push("in ".concat(formatMarketSlug(query.market)));
    }
    return parts.length > 0 ? parts.join(", ") : "My saved search";
}
// Opendoor market slugs are lowercase tokens joined by hyphens or underscores
// (`san-antonio`, `los_angeles`) — both separators are canonical (see
// CANONICAL_MARKET_SLUG in SavedSearchesDropdown.tsx). The label appears in
// user-facing names and alert subjects, so render every word with title
// casing and a space separator.
var formatMarketSlug = function(slug) {
    return slug.split(/[-_]/).filter(function(word) {
        return word.length > 0;
    }).map(function(word) {
        return word[0].toUpperCase() + word.slice(1);
    }).join(" ");
};
function hasValidLocation(query) {
    var ref, ref1;
    var ref2, ref3;
    return !!query.market || ((ref2 = (ref = query.zoneIds) === null || ref === void 0 ? void 0 : ref.length) !== null && ref2 !== void 0 ? ref2 : 0) > 0 || ((ref3 = (ref1 = query.vertices) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref3 !== void 0 ? ref3 : 0) > 0;
}
var DEFAULT_MARKET_FALLBACK = "phoenix";
// Heuristic shape check for a routable market slug, not a membership test
// against the live market set (that set lives behind SSR/`GetActiveBuyMarkets`
// and isn't available to this pure helper). Real market identifiers are
// lowercase alphabetic words joined by hyphens/underscores (`phoenix`,
// `las-vegas`, `clarksville_ky_tn`) and never contain digits — see
// `OdProtosCommonMarket_Market` and `helpers/markets.ts`. Requiring alphabetic
// segments rejects the two values cross-client/pre-canonicalization saved
// searches realistically smuggle into `location.market`:
//   - display labels with spaces/capitals (`Downtown Phoenix`), and
//   - address-like slugs carrying street numbers / zips
//     (`825-cloister-way-mckinney-tx-75069`),
// both of which would otherwise route to a non-resolvable `/homes/<value>`.
// A surviving unknown-but-alphabetic slug still falls back gracefully: SSR
// market resolution (`tryGetMarketCoordinates` → `getServerSideProps`) returns
// `notFound`/the default market rather than erroring. zoneIds/vertices keep
// driving the result set via the query string, so the default-market base is
// safe.
var CANONICAL_MARKET_SLUG = /^[a-z]+(?:[-_][a-z]+)*$/;
// Mirrors the marketplace path conventions in `src/pages/homes/[market].tsx`:
//   single-zone   -> /homes/zid_<id>
//   market-only   -> /homes/<market>
//   multi-zone    -> /homes/<market or fallback>?zoneIds=...
var pickPathname = function(savedSearch) {
    var _location = savedSearch.location, zoneIds = _location.zoneIds, market = _location.market;
    if (zoneIds.length === 1) {
        return "/homes/zid_".concat(zoneIds[0]);
    }
    if (market && CANONICAL_MARKET_SLUG.test(market)) {
        return "/homes/".concat(market);
    }
    return "/homes/".concat(DEFAULT_MARKET_FALLBACK);
};
// A market-level saved search for the market already loaded on the page can be
// applied with an in-page refetch. Zone/polygon searches and cross-market
// switches need fresh SSR data (market shape, coordinates, zone resolution),
// so those callers must hard-navigate instead.
var canApplySavedSearchInPlace = function(savedSearch, marketIdentifier) {
    return !!savedSearch.location.market && savedSearch.location.market === marketIdentifier && savedSearch.location.zoneIds.length === 0 && savedSearch.location.vertices.length === 0;
};
function buildSaveSearchQuery(param) {
    var canonical = param.canonical, marketIdentifier = param.marketIdentifier, selectedZoneId = param.selectedZoneId, vertices = param.vertices;
    return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, canonical), {
        market: marketIdentifier !== null && marketIdentifier !== void 0 ? marketIdentifier : null,
        zoneIds: selectedZoneId ? [
            selectedZoneId
        ] : null,
        vertices: vertices && vertices.length > 0 ? vertices : null
    });
}

// EXTERNAL MODULE: ../../node_modules/.pnpm/@sentry+core@7.120.4/node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(94);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSearchQueries.ts






var getPropertyList = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload, page) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyList((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
                    page: page
                }))
            ];
        });
    });
    return function getPropertyList(payload, page) {
        return _ref.apply(this, arguments);
    };
}();
var getPropertyListAndSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
        var page, searchResult, listResult;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    page = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : 0;
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetMarketplacePropertySearch((0,_object_spread/* default */.Z)({}, payload))
                    ];
                case 1:
                    searchResult = _state.sent();
                    return [
                        4,
                        getPropertyList(payload, page)
                    ];
                case 2:
                    listResult = _state.sent();
                    return [
                        2,
                        {
                            searchResult: searchResult,
                            listResult: listResult
                        }
                    ];
            }
        });
    });
    return function getPropertyListAndSearch(payload) {
        return _ref.apply(this, arguments);
    };
}();
var updateQueryParams = function(input) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var queryParams = buildQueryParams(input, opts);
    window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(queryParams));
};
var buildQueryParams = function(input) {
    var ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _seedFromUrl = ref.seedFromUrl, seedFromUrl = _seedFromUrl === void 0 ? true : _seedFromUrl;
    // Seeding from the current URL lets in-place filter updates preserve unrelated
    // params. Callers navigating to a different search (e.g. switching saved
    // searches) must opt out so stale params don't leak into the canonical query.
    var urlParams = new URLSearchParams(seedFromUrl ? window.location.search : "");
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(input)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _value = (0,src_sliced_to_array/* default */.Z)(_step.value, 2), key = _value[0], value = _value[1];
            if (key === "zoneIds") {
                urlParams.set("zoneIds", value === null || value === void 0 ? void 0 : value.join(","));
            } else if (key === "vertices") {
                value.forEach(function(vertex, indx) {
                    urlParams.set("vertex_".concat(indx), encodeURI(JSON.stringify(vertex)));
                });
            } else if (key === "market") {
                urlParams.set("market", value);
            } else if (typeof value === "boolean") {
                urlParams.set(key, value.toString());
            } else if (value) {
                urlParams.set(key, value.toString());
            } else {
                urlParams.delete(key);
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return urlParams;
};
var buildVerticesQueryParams = function(vertices) {
    var urlParams = new URLSearchParams(window.location.search);
    vertices.forEach(function(vertex, indx) {
        urlParams.set("vertex_".concat(indx), encodeURI(JSON.stringify(vertex)));
    });
    return urlParams;
};
var buildAddressPreviewParams = function(addressToken) {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.set("preview_aid", addressToken);
    return urlParams;
};
var removeAddressPreviewParams = function() {
    var urlParams = new URLSearchParams(window.location.search);
    urlParams.delete("preview_aid");
    return urlParams;
};
// Maps URL param aliases to their canonical PropertySearchQuery field names
var PARAM_ALIASES = {
    minBeds: "bedrooms",
    minBaths: "bathrooms",
    minPrice: "minListPrice",
    maxPrice: "maxListPrice",
    singleStory: "hasSingleStory",
    mustHavePool: "hasPool"
};
var parseQueryParams = function(urlParams) {
    var queryParams = {};
    queryParams.vertices = [];
    Object.entries(urlParams).sort(function(a, b) {
        return a[0].localeCompare(b[0]);
    }).forEach(function(param) {
        var _param = _sliced_to_array(param, 2), key = _param[0], value = _param[1];
        var normalizedKey = PARAM_ALIASES[key] || key;
        if (normalizedKey === "zoneIds" && typeof value === "string") {
            queryParams.zoneIds = value.split(",");
        } else if (key.startsWith("vertex_") && typeof value === "string") {
            queryParams.vertices.push(JSON.parse(decodeURI(value)));
        } else {
            if (!isNaN(Number(value))) {
                queryParams[normalizedKey] = Number(value);
            } else if (value === "true" || value === "false") {
                queryParams[normalizedKey] = value === "true";
            } else {
                queryParams[normalizedKey] = value;
            }
        }
    });
    return queryParams;
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useMarketplaceSearch.ts






/**
 * Owns the marketplace result set (search + list), the single loading flag, an
 * error flag, and the shared fetch primitive every search entry point uses.
 * Hosts keep their own URL/location bookkeeping and call `runSearch` /
 * `loadNextPage` instead of re-implementing the fetch → apply → loading dance.
 *
 * The result state is seeded once from SSR props (the marketplace page is
 * long-lived and never remounts on navigation), so result-changing flows must
 * go through this hook rather than relying on prop re-hydration.
 */ var useMarketplaceSearch = function(initialSearch, initialList) {
    var ref = (0,react.useState)(initialSearch), propertySearchData = ref[0], setPropertySearchData = ref[1];
    var ref1 = (0,react.useState)(initialList), propertyListData = ref1[0], setPropertyListData = ref1[1];
    var ref2 = (0,react.useState)(false), isLoading = ref2[0], setIsLoading = ref2[1];
    // Set when a current (non-superseded) request genuinely fails, so the host
    // can show a retry/toast instead of silently leaving stale results on screen.
    var ref3 = (0,react.useState)(false), hasError = ref3[0], setHasError = ref3[1];
    // Every full search shares this primitive, so a slow request (e.g. a viewport
    // pan) can resolve after a newer one (e.g. a saved-search selection). Tag each
    // request with a monotonic id and only let the latest one apply results or
    // release the loading flag, so a stale response can't clobber newer results
    // or hide a spinner a newer request is still showing.
    var latestRequestId = (0,react.useRef)(0);
    var clearError = (0,react.useCallback)(function() {
        return setHasError(false);
    }, []);
    // Runs a full search (list + aggregate) and applies the results. Returns
    // `applied` when this request is current and succeeded, `failed` when it is
    // current but errored, and `superseded` when a newer request started while it
    // was in flight (so callers can gate follow-up state on `applied` only).
    var runSearch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload) {
            var requestId, ref, ref1, ref2, searchResult, listResult, ref3, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestId = latestRequestId.current += 1;
                        setIsLoading(true);
                        setHasError(false);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        return [
                            4,
                            getPropertyListAndSearch(payload)
                        ];
                    case 2:
                        ref2 = _state.sent(), searchResult = ref2.searchResult, listResult = ref2.listResult;
                        if (requestId !== latestRequestId.current) {
                            return [
                                2,
                                "superseded"
                            ];
                        }
                        if (searchResult === null || searchResult === void 0 ? void 0 : (ref = searchResult.marketplace) === null || ref === void 0 ? void 0 : ref.propertySearch) {
                            setPropertySearchData(searchResult.marketplace.propertySearch);
                        }
                        setPropertyListData((ref3 = listResult === null || listResult === void 0 ? void 0 : (ref1 = listResult.marketplace) === null || ref1 === void 0 ? void 0 : ref1.propertyList) !== null && ref3 !== void 0 ? ref3 : null);
                        return [
                            2,
                            "applied"
                        ];
                    case 3:
                        e = _state.sent();
                        esm_exports/* captureException */.Tb(e);
                        if (requestId !== latestRequestId.current) {
                            return [
                                2,
                                "superseded"
                            ];
                        }
                        setHasError(true);
                        return [
                            2,
                            "failed"
                        ];
                    case 4:
                        // Only the latest request owns the loading flag — an older request
                        // resolving late must not clear a spinner a newer one is still showing.
                        if (requestId === latestRequestId.current) {
                            setIsLoading(false);
                        }
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    // Appends the next page of list results. Returns `appended` on success,
    // `empty` when there was nothing to append, `failed` on a fetch error (so the
    // caller can avoid advancing its page counter and can surface a retry), and
    // `superseded` when a newer full search started while the page was in flight.
    var loadNextPage = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(payload, nextPage) {
            var requestId, res, propertyList, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestId = latestRequestId.current;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            getPropertyList(payload, nextPage)
                        ];
                    case 2:
                        res = _state.sent();
                        if (requestId !== latestRequestId.current) {
                            return [
                                2,
                                "superseded"
                            ];
                        }
                        propertyList = res.marketplace.propertyList;
                        if (!propertyList) {
                            return [
                                2,
                                "empty"
                            ];
                        }
                        setPropertyListData(function(prev) {
                            if (prev === null || prev === void 0 ? void 0 : prev.results) {
                                var _results, _count;
                                return {
                                    results: (0,_to_consumable_array/* default */.Z)(prev.results).concat((0,_to_consumable_array/* default */.Z)((_results = propertyList.results) !== null && _results !== void 0 ? _results : [])),
                                    count: (_count = propertyList.count) !== null && _count !== void 0 ? _count : 0,
                                    nextPage: propertyList.nextPage
                                };
                            }
                            return propertyList;
                        });
                        return [
                            2,
                            "appended"
                        ];
                    case 3:
                        e = _state.sent();
                        esm_exports/* captureException */.Tb(e);
                        if (requestId !== latestRequestId.current) {
                            return [
                                2,
                                "superseded"
                            ];
                        }
                        setHasError(true);
                        return [
                            2,
                            "failed"
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return function(payload, nextPage) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    return {
        propertySearchData: propertySearchData,
        propertyListData: propertyListData,
        setPropertyListData: setPropertyListData,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        hasError: hasError,
        clearError: clearError,
        runSearch: runSearch,
        loadNextPage: loadNextPage
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/utils.ts

/**
 * For use with Dropdown values and options to prevent invalid states in filter ranges
 *
 * @param options a list of RangeOptions for a Dropdown
 * @param op whether options should be accepted above or below the limit
 * @param limit a stringified integer representing the limit
 * @returns the filtered list of RangeOptionsZ
 */ var filterIntOptions = function(options, op, limit) {
    if (!limit) {
        return options.slice();
    }
    var limitVal = parseInt(limit, 10);
    if (isNaN(limitVal)) {
        return options.slice();
    }
    return options.filter(function(option) {
        var val = parseInt(option.value, 10);
        if (op === "gt") {
            return val > limitVal;
        }
        return val < limitVal;
    });
};
var MapSearchZoom;
(function(MapSearchZoom) {
    MapSearchZoom[MapSearchZoom["CITY"] = 9] = "CITY";
    MapSearchZoom[MapSearchZoom["ZIP"] = 11] = "ZIP";
    MapSearchZoom[MapSearchZoom["NEIGHBORHOOD"] = 13] = "NEIGHBORHOOD";
})(MapSearchZoom || (MapSearchZoom = {}));
// Based on API limits
var MAX_MARKETS = 150;
// Fallback market when none specified or invalid
var DEFAULT_MARKET = "PHOENIX";
var getZoomForLocationType = function(zoneType) {
    if (zoneType === "(Zip code)") {
        return MapSearchZoom.ZIP;
    }
    if (zoneType === "(Neighborhood)") {
        return MapSearchZoom.NEIGHBORHOOD;
    }
    return MapSearchZoom.CITY;
};
/**
 * Convert GeoJSON polygon coordinates to GeoPoint format
 */ var convertToGeoPointVertices = function(vertices) {
    var ref;
    return (ref = vertices === null || vertices === void 0 ? void 0 : vertices.map(function(polygon) {
        return polygon.map(function(param) {
            var _param = _sliced_to_array(param, 2), lon = _param[0], lat = _param[1];
            return {
                lon: lon,
                lat: lat
            };
        });
    })) !== null && ref !== void 0 ? ref : [];
};
var utils_buildPropertyTypes = function(singleFamily, condo, townhome) {
    var propertyTypes = [];
    if (singleFamily) {
        propertyTypes.push("HOUSE");
    }
    if (condo) {
        propertyTypes.push("CONDO");
    }
    if (townhome) {
        propertyTypes.push("TOWNHOUSE");
    }
    return propertyTypes;
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useSearchState.ts




/**
 * Builds a search payload directly from a canonical query rather than from the
 * hook's live state. `useSearchState`'s state setters are async, so callers
 * that want to fetch with values they're applying in the same tick (e.g.
 * switching to a saved search) must build the payload from those values
 * explicitly instead of relying on `buildSearchPayload`.
 */ var buildPayloadFromQuery = function(query, location) {
    var propertyTypes = utils_buildPropertyTypes(query.singleFamily, query.condo, query.townhome);
    var _bathrooms, _bedrooms, _canSelfTour, _hasPool, _maxListPrice, _maxSquareFootage, _maxYearBuilt, _minListPrice, _minSquareFootage, _minYearBuilt, _hasSingleStory;
    // `noHoas` is a UI boolean; the search API only accepts `maxHoaMonthlyFee`,
    // so "no HOAs" maps to a $0 ceiling and an unset filter maps to null.
    // Lot-size (`minLotSize`/`maxLotSize`) has no GraphQL search input yet, so it
    // is intentionally not forwarded here — it stays in canonical state for the
    // URL and saved searches until the backend supports it.
    var payload = {
        bathrooms: (_bathrooms = query.bathrooms) !== null && _bathrooms !== void 0 ? _bathrooms : 0,
        bedrooms: (_bedrooms = query.bedrooms) !== null && _bedrooms !== void 0 ? _bedrooms : 0,
        canSelfTour: (_canSelfTour = query.canSelfTour) !== null && _canSelfTour !== void 0 ? _canSelfTour : null,
        hasPool: (_hasPool = query.hasPool) !== null && _hasPool !== void 0 ? _hasPool : false,
        maxHoaMonthlyFee: query.noHoas ? 0 : null,
        maxListPrice: (_maxListPrice = query.maxListPrice) !== null && _maxListPrice !== void 0 ? _maxListPrice : null,
        maxSquareFootage: (_maxSquareFootage = query.maxSquareFootage) !== null && _maxSquareFootage !== void 0 ? _maxSquareFootage : null,
        maxYearBuilt: (_maxYearBuilt = query.maxYearBuilt) !== null && _maxYearBuilt !== void 0 ? _maxYearBuilt : null,
        minListPrice: (_minListPrice = query.minListPrice) !== null && _minListPrice !== void 0 ? _minListPrice : null,
        minSquareFootage: (_minSquareFootage = query.minSquareFootage) !== null && _minSquareFootage !== void 0 ? _minSquareFootage : null,
        minYearBuilt: (_minYearBuilt = query.minYearBuilt) !== null && _minYearBuilt !== void 0 ? _minYearBuilt : null,
        propertyTypes: propertyTypes,
        singleStoryOnly: (_hasSingleStory = query.hasSingleStory) !== null && _hasSingleStory !== void 0 ? _hasSingleStory : false
    };
    // Location is mutually exclusive: vertices > zoneIds > market.
    var vertices = location.vertices, zoneIds = location.zoneIds, market = location.market;
    if (vertices === null || vertices === void 0 ? void 0 : vertices.length) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            vertices: vertices
        });
    }
    if (zoneIds === null || zoneIds === void 0 ? void 0 : zoneIds.length) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            zoneIds: zoneIds
        });
    }
    if (market) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, payload), {
            market: market
        });
    }
    return payload;
};
var getInitialPropertyTypes = function(queryParams) {
    var hasAnyPropertyTypeParam = (queryParams === null || queryParams === void 0 ? void 0 : queryParams.singleFamily) !== undefined || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.condo) !== undefined || (queryParams === null || queryParams === void 0 ? void 0 : queryParams.townhome) !== undefined;
    if (hasAnyPropertyTypeParam) {
        var ref, ref1, ref2;
        return {
            singleFamily: (ref = queryParams === null || queryParams === void 0 ? void 0 : queryParams.singleFamily) !== null && ref !== void 0 ? ref : false,
            condo: (ref1 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.condo) !== null && ref1 !== void 0 ? ref1 : false,
            townhome: (ref2 = queryParams === null || queryParams === void 0 ? void 0 : queryParams.townhome) !== null && ref2 !== void 0 ? ref2 : false
        };
    }
    return {
        singleFamily: true,
        condo: true,
        townhome: true
    };
};
var useSearchState = function(queryParams) {
    var initialPropertyTypes = getInitialPropertyTypes(queryParams);
    var ref = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.bedrooms) || 0), minBeds = ref[0], setBedrooms = ref[1];
    var ref1 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.bathrooms) || 0), minBaths = ref1[0], setBathrooms = ref1[1];
    var ref2 = (0,react.useState)(null), canSelfTour = ref2[0], setCanSelfTour = ref2[1];
    var ref3 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minListPrice) || null), minPrice = ref3[0], setMinPrice = ref3[1];
    var ref4 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxListPrice) || null), maxPrice = ref4[0], setMaxPrice = ref4[1];
    var ref5 = (0,react.useState)(initialPropertyTypes.singleFamily), singleFamily = ref5[0], setSingleFamily = ref5[1];
    var ref6 = (0,react.useState)(initialPropertyTypes.condo), condo = ref6[0], setCondo = ref6[1];
    var ref7 = (0,react.useState)(initialPropertyTypes.townhome), townhome = ref7[0], setTownhome = ref7[1];
    var ref8 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.noHoas) || false), noHoas = ref8[0], setNoHoas = ref8[1];
    var ref9 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.hasSingleStory) || false), singleStory = ref9[0], setSingleStory = ref9[1];
    var ref10 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.hasPool) || false), mustHavePool = ref10[0], setMustHavePool = ref10[1];
    var ref11 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minYearBuilt) || null), minYearBuilt = ref11[0], setMinYearBuilt = ref11[1];
    var ref12 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxYearBuilt) || null), maxYearBuilt = ref12[0], setMaxYearBuilt = ref12[1];
    var ref13 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minLotSize) || null), minLotSize = ref13[0], setMinLotSize = ref13[1];
    var ref14 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxLotSize) || null), maxLotSize = ref14[0], setMaxLotSize = ref14[1];
    var ref15 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.minSquareFootage) || null), minSquareFootage = ref15[0], setMinSquareFootage = ref15[1];
    var ref16 = (0,react.useState)((queryParams === null || queryParams === void 0 ? void 0 : queryParams.maxSquareFootage) || null), maxSquareFootage = ref16[0], setMaxSquareFootage = ref16[1];
    var ref17 = (0,react.useState)(0), pageNumber = ref17[0], setPageNumber = ref17[1];
    var resetPage = function() {
        return setPageNumber(0);
    };
    // Replaces every filter value at once from a canonical query (e.g. when a
    // saved search is applied). Property types follow the same all-or-nothing
    // convention as initial hydration.
    var applyCanonical = function(query) {
        var propertyTypes = getInitialPropertyTypes(query);
        setBedrooms(query.bedrooms || 0);
        setBathrooms(query.bathrooms || 0);
        var _canSelfTour;
        setCanSelfTour((_canSelfTour = query.canSelfTour) !== null && _canSelfTour !== void 0 ? _canSelfTour : null);
        setMinPrice(query.minListPrice || null);
        setMaxPrice(query.maxListPrice || null);
        setSingleFamily(propertyTypes.singleFamily);
        setCondo(propertyTypes.condo);
        setTownhome(propertyTypes.townhome);
        setNoHoas(query.noHoas || false);
        setSingleStory(query.hasSingleStory || false);
        setMustHavePool(query.hasPool || false);
        setMinYearBuilt(query.minYearBuilt || null);
        setMaxYearBuilt(query.maxYearBuilt || null);
        setMinLotSize(query.minLotSize || null);
        setMaxLotSize(query.maxLotSize || null);
        setMinSquareFootage(query.minSquareFootage || null);
        setMaxSquareFootage(query.maxSquareFootage || null);
        setPageNumber(0);
    };
    var resetFilters = function() {
        setBathrooms(0);
        setBedrooms(0);
        setCanSelfTour(null);
        setCondo(true);
        setMaxLotSize(null);
        setMaxPrice(null);
        setMaxSquareFootage(null);
        setMaxYearBuilt(null);
        setMinLotSize(null);
        setMinPrice(null);
        setMinSquareFootage(null);
        setMinYearBuilt(null);
        setMustHavePool(false);
        setNoHoas(false);
        setPageNumber(0);
        setSingleFamily(true);
        setSingleStory(false);
        setTownhome(true);
    };
    var getCanonical = function() {
        return {
            bedrooms: minBeds,
            bathrooms: minBaths,
            canSelfTour: canSelfTour,
            minListPrice: minPrice,
            maxListPrice: maxPrice,
            singleFamily: singleFamily,
            condo: condo,
            townhome: townhome,
            noHoas: noHoas,
            hasSingleStory: singleStory,
            hasPool: mustHavePool,
            minYearBuilt: minYearBuilt,
            maxYearBuilt: maxYearBuilt,
            minLotSize: minLotSize,
            maxLotSize: maxLotSize,
            minSquareFootage: minSquareFootage,
            maxSquareFootage: maxSquareFootage
        };
    };
    // Builds a payload from current filter state, with optional overrides for
    // values being changed in the same tick (which the async state setters
    // wouldn't reflect yet) and for the location.
    var buildSearchPayload = function() {
        var override = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        return buildPayloadFromQuery((0,_object_spread/* default */.Z)({}, getCanonical(), override), override);
    };
    return {
        resetFilters: resetFilters,
        resetPage: resetPage,
        applyCanonical: applyCanonical,
        buildSearchPayload: buildSearchPayload,
        getCanonical: getCanonical,
        get: {
            minBeds: minBeds,
            minBaths: minBaths,
            canSelfTour: canSelfTour,
            minPrice: minPrice,
            maxPrice: maxPrice,
            singleFamily: singleFamily,
            condo: condo,
            townhome: townhome,
            noHoas: noHoas,
            singleStory: singleStory,
            mustHavePool: mustHavePool,
            minYearBuilt: minYearBuilt,
            maxYearBuilt: maxYearBuilt,
            minLotSize: minLotSize,
            maxLotSize: maxLotSize,
            minSquareFootage: minSquareFootage,
            maxSquareFootage: maxSquareFootage,
            pageNumber: pageNumber
        },
        set: {
            setBedrooms: setBedrooms,
            setBathrooms: setBathrooms,
            setCanSelfTour: setCanSelfTour,
            setMinPrice: setMinPrice,
            setMaxPrice: setMaxPrice,
            setSingleFamily: setSingleFamily,
            setCondo: setCondo,
            setTownhome: setTownhome,
            setNoHoas: setNoHoas,
            setSingleStory: setSingleStory,
            setMustHavePool: setMustHavePool,
            setMinYearBuilt: setMinYearBuilt,
            setMaxYearBuilt: setMaxYearBuilt,
            setMinLotSize: setMinLotSize,
            setMaxLotSize: setMaxLotSize,
            setMinSquareFootage: setMinSquareFootage,
            setMaxSquareFootage: setMaxSquareFootage,
            setPageNumber: setPageNumber
        }
    };
};

;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useMarketplaceSearchController.ts









/**
 * The marketplace search session for `/homes/[market]`: it owns the result set
 * + loading flag (via `useMarketplaceSearch`) and the location the next search
 * runs against (map polygon, selected zone, or bare market), and exposes the
 * semantic search verbs the page used to hand-roll.
 *
 * Every entry point previously repeated the same "sync URL → build payload →
 * run → reset page" dance with a copy of the location expression; centralizing
 * it here keeps those flows in one tested place and stops the page (already a
 * large component) from accreting more orchestration.
 */ var useMarketplaceSearchController = function(param) {
    var initialSearch = param.initialSearch, initialList = param.initialList, searchState = param.searchState, marketInfo = param.marketInfo;
    var ref = useMarketplaceSearch(initialSearch, initialList), propertySearchData = ref.propertySearchData, propertyListData = ref.propertyListData, setPropertyListData = ref.setPropertyListData, isLoading = ref.isLoading, setIsLoading = ref.setIsLoading, hasError = ref.hasError, clearError = ref.clearError, runSearch = ref.runSearch, loadNextPage = ref.loadNextPage;
    var ref1 = (0,react.useState)(marketInfo.shape.coordinates[0]), vertices = ref1[0], setVertices = ref1[1];
    var ref2 = (0,react.useState)(), selectedLocation = ref2[0], setSelectedLocation = ref2[1];
    var ref3 = (0,react.useState)(), selectedAddress = ref3[0], setSelectedAddress = ref3[1];
    // The location the next search runs against. `buildPayloadFromQuery` treats
    // these as mutually exclusive (vertices > zoneIds > market); zone selection
    // clears `vertices` so a chosen zone wins, otherwise the current map polygon
    // (or, when empty, the bare market) drives results.
    var currentSearchLocation = (0,react.useMemo)(function() {
        return {
            market: marketInfo.name,
            vertices: vertices,
            zoneIds: (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value) ? [
                selectedLocation.value
            ] : null
        };
    }, [
        marketInfo.name,
        vertices,
        selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value
    ]);
    // Runs a search against the current location, optionally overriding filter
    // values being set in the same tick (the async filter setters wouldn't be
    // visible to `buildSearchPayload` yet). Backs both the quick and full filter
    // menus.
    var applyFilters = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var filterOverride, status;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    filterOverride = _arguments.length > 0 && _arguments[0] !== void 0 ? _arguments[0] : {};
                    return [
                        4,
                        runSearch(searchState.buildSearchPayload((0,_object_spread/* default */.Z)({}, filterOverride, currentSearchLocation)))
                    ];
                case 1:
                    status = _state.sent();
                    // Only rewrite the URL / reset the page once the filtered results are on
                    // screen. A failed (e.g. Athena rate-limit) or superseded fetch must not
                    // leave the URL advertising filters the visible listings don't reflect;
                    // the previous applied query stays in the URL so a retry is consistent.
                    if (status !== "applied") {
                        return [
                            2
                        ];
                    }
                    updateQueryParams((0,_object_spread/* default */.Z)({}, searchState.getCanonical(), filterOverride));
                    searchState.resetPage();
                    return [
                        2
                    ];
            }
        });
    }), [
        searchState,
        runSearch,
        currentSearchLocation
    ]);
    // Runs a polygon search for a freshly drawn/panned map viewport and, once its
    // results are on screen, adopts it as the active location, clearing any
    // selected zone so later "load more" / "save search" actions don't reuse the
    // stale zone.
    var applyViewport = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(coordinates) {
            var status, queryString;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            runSearch(searchState.buildSearchPayload({
                                vertices: coordinates
                            }))
                        ];
                    case 1:
                        status = _state.sent();
                        // A failed or superseded pan (e.g. a rapid pan replaced by a newer one, or
                        // a saved-search selection mid-flight) must not strand the URL, list, or
                        // active location on a viewport whose results never applied — that would
                        // leave later load-more / save-search actions using a polygon the visible
                        // results and URL don't match.
                        if (status !== "applied") {
                            return [
                                2
                            ];
                        }
                        queryString = buildVerticesQueryParams(coordinates);
                        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(queryString));
                        updateQueryParams(searchState.getCanonical());
                        searchState.resetPage();
                        setVertices(coordinates);
                        setSelectedLocation(undefined);
                        return [
                            2
                        ];
                }
            });
        });
        return function(coordinates) {
            return _ref.apply(this, arguments);
        };
    }(), [
        searchState,
        runSearch
    ]);
    // Appends the next page of list results for the current search.
    var loadMore = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var nextPage, status;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!(propertyListData === null || propertyListData === void 0 ? void 0 : propertyListData.nextPage)) {
                        return [
                            2
                        ];
                    }
                    nextPage = searchState.get.pageNumber + 1;
                    return [
                        4,
                        loadNextPage(searchState.buildSearchPayload(currentSearchLocation), nextPage)
                    ];
                case 1:
                    status = _state.sent();
                    // Only advance the page counter when a page was actually appended; on a
                    // failed fetch the hook flags the error and the "see more" affordance stays
                    // so the user can retry.
                    if (status === "appended") {
                        searchState.set.setPageNumber(nextPage);
                    }
                    return [
                        2
                    ];
            }
        });
    }), [
        propertyListData === null || propertyListData === void 0 ? void 0 : propertyListData.nextPage,
        searchState,
        currentSearchLocation,
        loadNextPage
    ]);
    // Applies a saved search selected from the dropdown. A same-market,
    // market-level search is applied in place (refetch + update filters + rewrite
    // the URL) so the user stays in their session. Zone/polygon searches and
    // cross-market switches need fresh SSR data (market shape, coordinates, zone
    // resolution), so we hard-navigate for those — the long-lived page never
    // re-hydrates its mount-time state from new props, so a soft route change
    // would leave results stale.
    var applySavedSearch = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(savedSearch) {
            var query, definedQuery, params, status, params1;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        query = toPropertySearchQuery(savedSearch);
                        definedQuery = Object.fromEntries(Object.entries(query).filter(function(param) {
                            var _param = (0,src_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
                            return value !== undefined;
                        }));
                        if (!canApplySavedSearchInPlace(savedSearch, marketInfo.identifier)) {
                            params = buildQueryParams(definedQuery, {
                                seedFromUrl: false
                            });
                            window.location.assign("".concat(pickPathname(savedSearch), "?").concat(params.toString()));
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            runSearch(buildPayloadFromQuery(query, {
                                market: marketInfo.name
                            }))
                        ];
                    case 1:
                        status = _state.sent();
                        if (status !== "applied") {
                            return [
                                2
                            ];
                        }
                        searchState.applyCanonical(query);
                        setSelectedLocation(undefined);
                        setSelectedAddress(undefined);
                        setVertices(marketInfo.shape.coordinates[0]);
                        searchState.resetPage();
                        params1 = buildQueryParams(definedQuery, {
                            seedFromUrl: false
                        });
                        window.history.replaceState({}, "", "/homes/".concat(marketInfo.identifier, "?").concat(params1.toString()));
                        return [
                            2
                        ];
                }
            });
        });
        return function(savedSearch) {
            return _ref.apply(this, arguments);
        };
    }(), [
        marketInfo,
        searchState,
        runSearch
    ]);
    // The canonical query handed to the save-search button. `getCanonical()`
    // omits location, so the active market/zone/polygon is merged back in here.
    // We persist the routing slug (`identifier`), never the display `name`, so a
    // zone page's label isn't written into the saved search and later routed to a
    // non-existent `/homes/<label>`.
    var getSaveSearchQuery = (0,react.useCallback)(function() {
        return buildSaveSearchQuery({
            canonical: searchState.getCanonical(),
            marketIdentifier: marketInfo.identifier,
            selectedZoneId: selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value,
            vertices: vertices
        });
    }, [
        searchState,
        marketInfo.identifier,
        selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.value,
        vertices
    ]);
    return {
        propertySearchData: propertySearchData,
        propertyListData: propertyListData,
        setPropertyListData: setPropertyListData,
        isLoading: isLoading,
        setIsLoading: setIsLoading,
        hasError: hasError,
        clearError: clearError,
        vertices: vertices,
        setVertices: setVertices,
        selectedLocation: selectedLocation,
        setSelectedLocation: setSelectedLocation,
        selectedAddress: selectedAddress,
        setSelectedAddress: setSelectedAddress,
        applyFilters: applyFilters,
        applyViewport: applyViewport,
        loadMore: loadMore,
        applySavedSearch: applySavedSearch,
        getSaveSearchQuery: getSaveSearchQuery
    };
};

// EXTERNAL MODULE: ./src/components/marketplace/map/MarketplaceMap.tsx
var MarketplaceMap = __webpack_require__(29753);
// EXTERNAL MODULE: ./src/components/marketplace/map/MapMarker.tsx
var MapMarker = __webpack_require__(5787);
;// CONCATENATED MODULE: ./src/components/marketplace/map/MarketplaceMapMarker.tsx






var MarketplaceMapMarker = function(param) {
    var property = param.property, handleFetchPropertyDetails = param.handleFetchPropertyDetails, propertyReactions = param.propertyReactions, isSelected = param.isSelected, isLoading = param.isLoading;
    var ref, ref1;
    var addressToken = property.addressToken;
    if (addressToken === null || addressToken === undefined) {
        return null;
    }
    var lat = (ref = property.location) === null || ref === void 0 ? void 0 : ref.lat;
    if (lat === undefined) {
        return null;
    }
    var lon = (ref1 = property.location) === null || ref1 === void 0 ? void 0 : ref1.lon;
    if (lon === undefined) {
        return null;
    }
    var handleOnClick = function() {
        handleFetchPropertyDetails(addressToken);
        var urlParams = buildAddressPreviewParams(addressToken);
        window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
    };
    var reactionForMarker = propertyReactions === null || propertyReactions === void 0 ? void 0 : propertyReactions[addressToken];
    var _isLiked;
    var isLiked = reactionForMarker ? reactionForMarker === "REACTION_LIKE" : (_isLiked = property.isLiked) !== null && _isLiked !== void 0 ? _isLiked : false;
    var markerProperty = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, property), {
        addressToken: addressToken,
        location: {
            lat: lat,
            lon: lon
        },
        isLiked: isLiked
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapMarker/* MapMarker */.O, {
        property: markerProperty,
        onClick: handleOnClick,
        isSelected: isSelected,
        isLoading: isLoading
    }, property.addressToken);
};

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(88149);
// EXTERNAL MODULE: ../bricks-next/src/components/PhotoCarousel/PhotoCarousel.tsx + 1 modules
var PhotoCarousel = __webpack_require__(20608);
// EXTERNAL MODULE: ../bricks-next/src/components/Button/IconButton.tsx
var IconButton = __webpack_require__(96492);
// EXTERNAL MODULE: ./src/components/marketplace/helpers/galleryPhotos.ts
var galleryPhotos = __webpack_require__(32448);
;// CONCATENATED MODULE: ./src/components/marketplace/map/types.ts
var MOBILE_CAROUSEL_HEIGHT_SM = 260;
var MOBILE_CAROUSEL_HEIGHT_MD = 414;

;// CONCATENATED MODULE: ./src/components/marketplace/map/PhotoCarousel.tsx






// Carousel nav arrows are hidden below this viewport width because they
// overlap the photo on narrow phones.
var HIDE_NAVIGATION_MAX_WIDTH_PX = 600;
// Mirrors the standalone PDP desktop gallery (GalleryPhotos
// GALLERY_SOURCE_SET_CONFIG) so the mini PDP carousel renders at parity on
// desktop. The <1201 tier matches the standalone PDP mobile carousel
// (components/marketplace/property/media/PhotoCarousel.tsx).
var PRESET_TIERS = [
    {
        minWidth: 0,
        maxWidth: 1201,
        preset: "3:2-md",
        presetScale: "2/3"
    },
    {
        minWidth: 1201,
        maxWidth: 1400,
        preset: "3:2-lg",
        presetScale: "3/4"
    },
    {
        minWidth: 1400,
        maxWidth: null,
        preset: "3:2-xl",
        presetScale: "1"
    }, 
];
// Below this viewport width the standalone PDP carousel pins dpr=1 to keep
// cellular payloads bounded; above it we follow the standalone PDP gallery's
// [1, 2, 3] srcset ladder by selecting the actual devicePixelRatio.
// Intentionally aligned with the first PRESET_TIERS breakpoint so the "mobile
// tier" and "mobile dpr cap" move together.
var MOBILE_DPR_CAP_MAX_WIDTH_PX = 1201;
var ref;
var pickPresetTier = function(viewportWidth) {
    return (ref = PRESET_TIERS.find(function(tier) {
        return viewportWidth >= tier.minWidth && (tier.maxWidth == null || viewportWidth < tier.maxWidth);
    })) !== null && ref !== void 0 ? ref : PRESET_TIERS[0];
};
var buildPhotoUrl = function(photo, viewportWidth, devicePixelRatio) {
    // Floor plans: skip the 3:2 crop preset because cabinet renders a cropped
    // source at those presets, which clips edges off portrait floor plans.
    // bricks-next PhotoCarousel's Image uses resizeMode: cover so the natural
    // aspect still gets cover-cropped to the carousel container, but at least
    // the server isn't pre-cropping too.
    if (photo.isFloorPlan) {
        return (0,galleryPhotos/* buildFloorPlanSrc */.Ru)(photo.url);
    }
    var tier = pickPresetTier(viewportWidth);
    var dpr = viewportWidth < MOBILE_DPR_CAP_MAX_WIDTH_PX ? 1 : Math.max(1, Math.min(3, Math.round(devicePixelRatio)));
    var params = new URLSearchParams({
        preset: tier.preset,
        presetScale: tier.presetScale,
        service: "cosmos",
        auto: "format,compress",
        dpr: String(dpr)
    });
    return "".concat(photo.url, "?").concat(params.toString());
};
var PhotoCarousel_PhotoCarousel = function(param) {
    var photos = param.photos, onClose = param.onClose, _isRounded = param.isRounded, isRounded = _isRounded === void 0 ? false : _isRounded, onOpenShareModal = param.onOpenShareModal, onPhotoClick = param.onPhotoClick, height = param.height;
    var ref = (0,react.useState)(false), shouldHideNavigation = ref[0], setShouldHideNavigation = ref[1];
    // SSR default renders the mobile-equivalent URL (dpr=1, 3:2-md@2/3), matching
    // prior behavior. The real viewport/dpr are read on mount and the carousel
    // upgrades to the standalone PDP gallery preset on desktop / Retina.
    //
    // Known tradeoff: a desktop-Retina visitor fetches the dpr=1 URL during SSR
    // paint and then the dpr=2 upgrade URL after hydration (double fetch). We
    // accept this because (a) mini PDPs open inside an already-interactive SPA
    // so the SSR image rarely appears at all for most users, (b) pinning the
    // SSR default higher would inflate mobile payloads (the common case), and
    // (c) a `srcset`-based fix would require upstream changes in
    // bricks-next PhotoCarousel. Revisit if LCP regressions surface.
    var ref1 = (0,react.useState)({
        width: 1024,
        dpr: 1
    }), viewport = ref1[0], setViewport = ref1[1];
    var carouselRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        var updateViewport = function() {
            setViewport({
                width: window.innerWidth,
                dpr: window.devicePixelRatio || 1
            });
        };
        updateViewport();
        window.addEventListener("resize", updateViewport);
        return function() {
            return window.removeEventListener("resize", updateViewport);
        };
    }, []);
    var mappedPhotos = (0,react.useMemo)(function() {
        return (photos === null || photos === void 0 ? void 0 : photos.map(function(photo) {
            var ref;
            return {
                url: buildPhotoUrl(photo, viewport.width, viewport.dpr),
                alt: photo.isFloorPlan ? ((ref = photo.label) === null || ref === void 0 ? void 0 : ref.trim()) || "Floor plan" : ""
            };
        })) || [];
    }, [
        photos,
        viewport.width,
        viewport.dpr
    ]);
    (0,react.useEffect)(function() {
        var carousel = carouselRef.current;
        var startY = 0;
        var startX = 0;
        var handleTouchStart = function(e) {
            startY = e.touches[0].clientY; // Set start Y to the initial touch Y position
            startX = e.touches[0].clientX; // Set start X to the initial touch X position
        };
        var handleTouchMove = function(e) {
            // Calculate the difference between current touch position and start position
            var moveY = e.touches[0].clientY - startY;
            var moveX = e.touches[0].clientX - startX;
            // We're doing this because we want to allow vertical scrolling
            // if the user starts scrolling vertically first
            // But if they start scrolling horizontally first, we want to prevent vertical scrolling
            if (Math.abs(moveX) > Math.abs(moveY)) {
                e.preventDefault(); // Prevent Vertical scrolling
            } else {
                e.stopPropagation(); // Prevent Horizontal scrolling
            }
        };
        if (carousel) {
            carousel.addEventListener("touchstart", handleTouchStart, {
                passive: true
            });
            carousel.addEventListener("touchmove", handleTouchMove, {
                passive: false
            });
        }
        return function() {
            if (carousel) {
                // Clean up event listeners
                carousel.removeEventListener("touchstart", handleTouchStart);
                carousel.removeEventListener("touchmove", handleTouchMove);
            }
        };
    }, [
        carouselRef
    ]);
    (0,react.useEffect)(function() {
        var carousel = carouselRef.current;
        if (!carousel || !onPhotoClick) {
            return;
        }
        // Use `closest('img')` instead of `event.target.tagName === 'IMG'` so the
        // handler still fires when the click lands on a descendant of the image
        // (e.g. a future overlay/badge or a wrapper span added by the carousel).
        var handleClick = function(event) {
            var target = event.target;
            if (!(0,_instanceof/* default */.Z)(target, Element)) {
                return;
            }
            if (target.closest("img")) {
                onPhotoClick();
            }
        };
        carousel.addEventListener("click", handleClick);
        return function() {
            carousel.removeEventListener("click", handleClick);
        };
    }, [
        onPhotoClick
    ]);
    (0,react.useEffect)(function() {
        var updateNavVisibility = function() {
            setShouldHideNavigation(window.innerWidth < HIDE_NAVIGATION_MAX_WIDTH_PX);
        };
        updateNavVisibility();
        window.addEventListener("resize", updateNavVisibility);
        return function() {
            return window.removeEventListener("resize", updateNavVisibility);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        position: "relative",
        aspectRatio: PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE,
        justifyContent: "center",
        overflow: "hidden",
        width: "100%",
        ref: carouselRef,
        $smallerThanMD: {
            height: MOBILE_CAROUSEL_HEIGHT_SM
        },
        $smallerThanLG: {
            height: MOBILE_CAROUSEL_HEIGHT_MD
        },
        // The base SQUARE aspectRatio is overridden on mobile by the fixed
        // heights above. On desktop (>= LG breakpoint = 1201px) the panel is
        // ~50% of the viewport width, so SQUARE would push the carousel to
        // ~100vh. Match the standalone PDP GalleryPhotos hero split at 16:9
        // instead. Uses $largerThanMD because in bricks-next media.ts,
        // `largerThanMD` = minWidth LG (1201px); `largerThanLG` = minWidth XL
        // (1400px), which would leave 1201-1399px viewports stuck at SQUARE
        // despite PRESET_TIERS / MOBILE_DPR_CAP_MAX_WIDTH_PX already treating
        // them as desktop.
        $largerThanMD: {
            mt: 0,
            aspectRatio: PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                id: "close-button",
                size: "large",
                onPress: onClose,
                analyticsName: "marketplace-carousel-back-button",
                top: "$8x",
                left: 24,
                position: "absolute",
                zIndex: 1,
                "data-testid": "map-pdp-close-button"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ShareButton */.Tz, {
                id: "share-button",
                size: "large",
                onPress: onOpenShareModal,
                analyticsName: "marketplace-carousel-share-button",
                top: "$8x",
                right: 24,
                position: "absolute",
                zIndex: 1
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel/* PhotoCarousel */.c, {
                photos: mappedPhotos,
                hideNavigation: shouldHideNavigation,
                // BricksPhotoCarousel exposes a single, non-media-query `aspectRatio`
                // prop. Mirror the outer Box's responsive aspect ratio here off the
                // same `viewport.width` we already track for photo-URL selection so
                // the inner carousel stays congruent with its container. Without this
                // the inner box renders SQUARE (e.g. 640x640) inside a 16:9 outer
                // (640x360) and the image overflows / looks cropped on desktop. Same
                // 1201 split point as PRESET_TIERS / $largerThanMD.
                aspectRatio: viewport.width >= MOBILE_DPR_CAP_MAX_WIDTH_PX ? PhotoCarousel/* PhotoCarouselAspectRatios.DEFAULT */.r.DEFAULT : PhotoCarousel/* PhotoCarouselAspectRatios.SQUARE */.r.SQUARE,
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                height: height || "100%",
                isRounded: isRounded || false
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/property/index.ts + 7 modules
var marketplace_property = __webpack_require__(60793);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyCTAs.tsx + 2 modules
var PropertyCTAs = __webpack_require__(14527);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyDetails.tsx + 3 modules
var PropertyDetails = __webpack_require__(63602);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertyStatus.tsx
var PropertyStatus = __webpack_require__(28656);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/PropertySummary.tsx
var PropertySummary = __webpack_require__(40785);
// EXTERNAL MODULE: ./src/components/shared/Divider.tsx
var Divider = __webpack_require__(49957);
// EXTERNAL MODULE: ./src/components/shared/hooks/useInView.tsx + 1 modules
var useInView = __webpack_require__(35926);
;// CONCATENATED MODULE: ./src/components/marketplace/map/MiniPropertyDetailPage.tsx













var MiniPropertyDetailPage = function(param) {
    var property = param.property, onClose = param.onClose;
    var ref = (0,react.useState)(false), isShareModalOpen = ref[0], setIsShareModalOpen = ref[1];
    var ref1 = (0,react.useState)(false), isLightboxOpen = ref1[0], setIsLightboxOpen = ref1[1];
    var ref2 = (0,react.useState)(0), selectedPhotoIndex = ref2[0], setSelectedPhotoIndex = ref2[1];
    var ctaRef = (0,react.useRef)(null);
    var inView = (0,useInView/* useInViewAfterLoad */.D)({
        ref: ctaRef,
        threshold: 0,
        initialInView: true
    }).inView;
    // Refs mirror the overlay open flags synchronously so our keydown handler
    // always reads the latest value without depending on React state batching.
    var isLightboxOpenRef = (0,react.useRef)(false);
    var isShareModalOpenRef = (0,react.useRef)(false);
    var handleOnClose = (0,react.useCallback)(function() {
        var urlParams = removeAddressPreviewParams();
        // `replaceState` swaps the current history entry in place; it does NOT
        // push a new one, so repeated Escape-close → reopen cycles cannot stack
        // entries and break the browser Back button.
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        onClose();
    }, [
        onClose
    ]);
    // Close the mini PDP on Escape. Register in the capture phase so this
    // handler always runs before the bricks-next Lightbox's document-level
    // bubble-phase keydown listener. That guarantees a stable Escape precedence
    // (Lightbox > ShareModal > mini PDP) regardless of mount order: if the
    // Lightbox is open when Escape is pressed, the ref is still true here, we
    // bail, and the Lightbox's own listener runs next and closes it. Without
    // capture-phase ordering, a flipped mount sequence (StrictMode remount or
    // future code-splitting reshuffle) could let the Lightbox close first,
    // flip the ref to false, and then the mini PDP handler would incorrectly
    // also close the panel on the same keypress.
    (0,react.useEffect)(function() {
        var handleKeyDown = function(event) {
            if (event.key !== "Escape") {
                return;
            }
            if (isLightboxOpenRef.current || isShareModalOpenRef.current) {
                return;
            }
            handleOnClose();
        };
        document.addEventListener("keydown", handleKeyDown, true);
        return function() {
            return document.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [
        handleOnClose
    ]);
    // Floor plans intentionally omitted here: the bricks-next PhotoCarousel
    // cover-crops portrait plans. They remain accessible via the Lightbox,
    // which renders the full ordered list (listing photos + floor plans) with
    // resizeMode: contain.
    //
    // Kept above the `!property` early return so all hooks run in the same
    // order on every render (react-hooks/rules-of-hooks).
    var carouselPhotos = (0,react.useMemo)(function() {
        return (0,helpers/* buildCarouselPhotos */.Dt)(property);
    }, [
        property === null || property === void 0 ? void 0 : property.photos,
        property === null || property === void 0 ? void 0 : property.floorPlanPhotos
    ]);
    if (!property) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {});
    }
    var handleToggleShareModal = function() {
        setIsShareModalOpen(function(prev) {
            var next = !prev;
            isShareModalOpenRef.current = next;
            return next;
        });
    };
    // Separate open/close handlers instead of a toggle: bricks-next `Lightbox`
    // registers a document-level keydown listener that fires `handleClose()` on
    // Escape regardless of `isOpen`. Passing a toggle would flip a closed
    // lightbox OPEN on Escape while the mini PDP is active.
    var openLightbox = function() {
        isLightboxOpenRef.current = true;
        setSelectedPhotoIndex(0);
        setIsLightboxOpen(true);
    };
    var closeLightbox = function() {
        isLightboxOpenRef.current = false;
        setIsLightboxOpen(false);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        height: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                photos: carouselPhotos,
                onClose: handleOnClose,
                onOpenShareModal: handleToggleShareModal,
                onPhotoClick: openLightbox
            }, "mini-pdp-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                position: "relative",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        px: 48,
                        pt: 24,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyStatus/* PropertyStatus */.R, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertySummary/* PropertySummary */.b, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                ref: ctaRef,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyCTAs/* PropertyCTAs */.y, {
                                    property: property
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                                mt: "$24x"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyDetails/* PropertyDetails */.l, {
                                property: property
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* FooterCTA */.Vf, {
                        property: property,
                        isVisible: !inView
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* Lightbox */.ey, {
                        handleClose: closeLightbox,
                        isOpen: isLightboxOpen,
                        property: property,
                        selectedPhotoIndex: selectedPhotoIndex
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                property: property,
                isOpen: isShareModalOpen,
                onClose: handleToggleShareModal
            }, "share-modal-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
        ]
    }, "mini-pdp-".concat(property === null || property === void 0 ? void 0 : property.addressToken));
};

// EXTERNAL MODULE: ./src/components/landing-pages-v2/shared/NavMenuContext.tsx
var NavMenuContext = __webpack_require__(47052);
// EXTERNAL MODULE: ../bricks-next/src/components/inputs/TextInput.tsx
var TextInput = __webpack_require__(78514);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/PressableBox.tsx
var PressableBox = __webpack_require__(54999);
// EXTERNAL MODULE: ./src/helpers/formatters.ts
var formatters = __webpack_require__(52868);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lodash@4.17.21/node_modules/lodash/debounce.js
var debounce = __webpack_require__(77837);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./src/components/marketplace/helpers/useOutsideCaller.ts


var useOutsideCaller = function(cb, refs) {
    (0,react.useEffect)(function() {
        var handleClickOutside = function(event) {
            var target = null;
            if ((0,_instanceof/* default */.Z)(event.target, Node)) {
                target = event.target;
            }
            if (refs.every(function(ref) {
                return !ref.current || !ref.current.contains(target);
            })) {
                cb();
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        refs
    ]);
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/LocationSearch.tsx












var formatZoneType = function(zoneType) {
    switch(zoneType){
        case "CITY":
            return "(City)";
        case "COUNTY":
            return "(County)";
        case "ZIP_CODE":
            return "(Zip code)";
        case "NEIGHBORHOOD":
        case "SUBNEIGHBORHOOD":
        case "MACRO_NEIGHBORHOOD":
            return "(Neighborhood)";
        default:
            return "";
    }
};
var QUERY_STRING_MIN_LENGTH = 2;
var SEARCH_DEBOUNCE_MS = 400;
var MapLocationSearch = function(param) {
    var isFocused = param.isFocused, selectedAddress = param.selectedAddress, setSelectedAddress = param.setSelectedAddress, selectedLocation = param.selectedLocation, setSelectedLocation = param.setSelectedLocation;
    var ref = (0,react.useState)(selectedLocation ? [
        selectedLocation
    ] : undefined), locationOptions = ref[0], setLocationOptions = ref[1];
    var ref1 = (0,react.useState)(), addressOptions = ref1[0], setAddressOptions = ref1[1];
    var ref2 = (0,react.useState)(), query = ref2[0], setQuery = ref2[1];
    var ref3 = (0,react.useState)(false), isLocationFocused = ref3[0], setIsLocationFocused = ref3[1];
    var ref4 = (0,react.useState)(false), isDropdownFocused = ref4[0], setIsDropdownFocused = ref4[1];
    var ref5 = (0,react.useState)(false), isFetchingSuggestions = ref5[0], setIsFetchingSuggestions = ref5[1];
    var ref6 = (0,react.useState)(false), fetchError = ref6[0], setFetchError = ref6[1];
    var containerRef = (0,react.useRef)(null);
    var abortControllerRef = (0,react.useRef)(null);
    var debouncedSearchLocations = (0,react.useMemo)(function() {
        var fetchLocations = function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(queryStr) {
                var ref, controller, ref1, ref2, ref3, ref4, ref5, types, client, ref6, locationsResp, addressResp, ref7, zones, ref8, error;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
                            if (!(queryStr && queryStr.length > QUERY_STRING_MIN_LENGTH)) return [
                                3,
                                6
                            ];
                            controller = new AbortController();
                            abortControllerRef.current = controller;
                            setIsFetchingSuggestions(true);
                            setFetchError(false);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                4,
                                5
                            ]);
                            types = queryStr.match(/^\d/) ? [
                                "ZIP_CODE"
                            ] : [
                                "CITY",
                                "NEIGHBORHOOD",
                                "SUBNEIGHBORHOOD"
                            ];
                            client = (0,api/* getAthenaClient */.k8)(undefined, {
                                signal: controller.signal
                            });
                            return [
                                4,
                                Promise.all([
                                    client.SearchLocations({
                                        query: queryStr,
                                        types: types
                                    }),
                                    client.AddressSearch({
                                        query: queryStr
                                    })
                                ])
                            ];
                        case 2:
                            ref6 = src_sliced_to_array/* default.apply */.Z.apply(void 0, [
                                _state.sent(),
                                2
                            ]), locationsResp = ref6[0], addressResp = ref6[1];
                            zones = (ref7 = locationsResp === null || locationsResp === void 0 ? void 0 : (ref1 = locationsResp.geoDataStore) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.searchZonesByTextQuery) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.zones) === null || ref3 === void 0 ? void 0 : ref3.map(function(result) {
                                var ref;
                                var zone = result.zone;
                                return {
                                    label: (zone === null || zone === void 0 ? void 0 : zone.name) + ", " + (zone === null || zone === void 0 ? void 0 : zone.stateAbbr),
                                    zoneType: formatZoneType(zone === null || zone === void 0 ? void 0 : zone.zoneType),
                                    value: zone === null || zone === void 0 ? void 0 : zone.uuid,
                                    coordinates: (zone === null || zone === void 0 ? void 0 : zone.centroid) ? (ref = JSON.parse(zone === null || zone === void 0 ? void 0 : zone.centroid)) === null || ref === void 0 ? void 0 : ref.coordinates : [
                                        0,
                                        0
                                    ],
                                    population: zone === null || zone === void 0 ? void 0 : zone.population
                                };
                            }).sort(function(a, b) {
                                if (a.population && b.population) {
                                    return b.population - a.population;
                                }
                                return 0;
                            })) !== null && ref7 !== void 0 ? ref7 : [];
                            setLocationOptions(zones);
                            setAddressOptions((ref8 = addressResp === null || addressResp === void 0 ? void 0 : (ref4 = addressResp.marketplace) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.addressSearch) === null || ref5 === void 0 ? void 0 : ref5.properties) !== null && ref8 !== void 0 ? ref8 : []);
                            return [
                                3,
                                5
                            ];
                        case 3:
                            error = _state.sent();
                            if ((0,_instanceof/* default */.Z)(error, DOMException) && error.name === "AbortError") {
                                return [
                                    2
                                ];
                            }
                            esm_exports/* captureException */.Tb(error);
                            setFetchError(true);
                            setLocationOptions(undefined);
                            setAddressOptions(undefined);
                            return [
                                3,
                                5
                            ];
                        case 4:
                            if (!controller.signal.aborted) {
                                setIsFetchingSuggestions(false);
                            }
                            return [
                                7
                            ];
                        case 5:
                            return [
                                3,
                                7
                            ];
                        case 6:
                            abortControllerRef.current = null;
                            setLocationOptions(undefined);
                            setAddressOptions(undefined);
                            setIsFetchingSuggestions(false);
                            setFetchError(false);
                            _state.label = 7;
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            });
            return function fetchLocations(queryStr) {
                return _ref.apply(this, arguments);
            };
        }();
        return debounce_default()(fetchLocations, SEARCH_DEBOUNCE_MS);
    }, []);
    (0,react.useEffect)(function() {
        debouncedSearchLocations(query);
        return function() {
            var ref;
            debouncedSearchLocations.cancel();
            (ref = abortControllerRef.current) === null || ref === void 0 ? void 0 : ref.abort();
        };
    }, [
        query,
        debouncedSearchLocations
    ]);
    useOutsideCaller(function() {
        setIsLocationFocused(false);
        setIsDropdownFocused(false);
    }, [
        containerRef
    ]);
    var handleLocationSearch = function(search) {
        setQuery(search);
    };
    var handleLocationFocus = function() {
        setIsLocationFocused(true);
        setQuery("");
        setSelectedLocation(undefined);
        setSelectedAddress(undefined);
    };
    var handleDropdownFocus = function() {
        return setIsDropdownFocused(true);
    };
    var handleDropdownBlur = function() {
        setIsLocationFocused(false);
        setIsDropdownFocused(false);
    };
    var handleLocationSelect = function(e) {
        if (!(0,_instanceof/* default */.Z)(e.target, HTMLElement)) {
            return;
        }
        if (e.target.dataset.location) {
            var selectedLoc = JSON.parse(e.target.dataset.location);
            setSelectedLocation(selectedLoc);
            setSelectedAddress(undefined);
            handleDropdownBlur();
            handleLocationSearch("");
        }
    };
    var handleAddressSelect = function(e) {
        if (!(0,_instanceof/* default */.Z)(e.target, HTMLElement)) {
            return;
        }
        if (e.target.dataset.addresstoken) {
            var selectedAddr = addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.find(// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            function(addr) {
                var ref, ref1;
                return addr.addressToken === (e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.dataset) === null || ref1 === void 0 ? void 0 : ref1.addresstoken);
            });
            if (selectedAddr) {
                setSelectedAddress(selectedAddr);
                setSelectedLocation(undefined);
                handleDropdownBlur();
                handleLocationSearch("");
            }
        }
    };
    var ref7, ref8;
    var hasSuggestionResults = ((ref7 = locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.length) !== null && ref7 !== void 0 ? ref7 : 0) > 0 || ((ref8 = addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.length) !== null && ref8 !== void 0 ? ref8 : 0) > 0;
    var showNoResultsMessage = (0,react.useMemo)(function() {
        if (!query || query.length <= QUERY_STRING_MIN_LENGTH) {
            return false;
        }
        if (isFetchingSuggestions || fetchError) {
            return false;
        }
        return !hasSuggestionResults;
    }, [
        query,
        isFetchingSuggestions,
        fetchError,
        hasSuggestionResults
    ]);
    var shouldShowDropdown = (0,react.useMemo)(function() {
        return !!query && (isLocationFocused || isDropdownFocused) && (hasSuggestionResults || showNoResultsMessage || isFetchingSuggestions || fetchError);
    }, [
        query,
        hasSuggestionResults,
        showNoResultsMessage,
        isFetchingSuggestions,
        fetchError,
        isLocationFocused,
        isDropdownFocused, 
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        ref: containerRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "label",
                typography: "$labelMedium",
                color: "$contentPrimary",
                mb: 12,
                $smallerThanMD: {
                    display: "none"
                },
                children: "Location"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                ariaLabel: "Location search",
                id: "locations-search",
                "data-testid": "location-search-input",
                name: "locations",
                size: "small",
                $smallerThanMD: {
                    size: "xsmall",
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    width: "85%"
                },
                ml: isFocused ? 20 : 0,
                placeholder: "City, neighborhood, street address, or ZIP",
                onChangeText: handleLocationSearch,
                onFocus: handleLocationFocus,
                prefilledValue: (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.fullAddress) || (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label)
            }, (selectedAddress === null || selectedAddress === void 0 ? void 0 : selectedAddress.fullAddress) || (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                id: "locations",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        zIndex: 10000,
                        backgroundColor: "$backgroundPrimary",
                        position: "absolute",
                        height: 25,
                        display: shouldShowDropdown ? "flex" : "none",
                        width: "100%",
                        borderStyle: "solid",
                        borderColor: "$borderAccentBrand",
                        borderTopWidth: 0,
                        borderLeftWidth: 1,
                        borderRightWidth: 1,
                        borderBottomWidth: 0,
                        left: 0,
                        top: -15,
                        onFocus: handleDropdownFocus,
                        onBlur: handleDropdownBlur
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        position: "absolute",
                        backgroundColor: "$backgroundPrimary",
                        zIndex: 10000,
                        minHeight: 120,
                        maxHeight: 400,
                        display: shouldShowDropdown ? "flex" : "none",
                        width: "100%",
                        borderStyle: "solid",
                        borderWidth: 1,
                        borderBottomLeftRadius: "$8x",
                        borderLeftWidth: 1,
                        borderBottomRightRadius: "$8x",
                        borderTopWidth: 0,
                        borderColor: "$borderAccentBrand",
                        left: 0,
                        top: 5,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        overflowY: "scroll",
                        overflowX: "hidden",
                        onFocus: handleDropdownFocus,
                        onBlur: handleDropdownBlur,
                        children: [
                            isFetchingSuggestions ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                px: 20,
                                py: 20,
                                width: "100%",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    color: "$contentSecondary",
                                    children: "Searching…"
                                })
                            }) : null,
                            fetchError ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                px: 20,
                                py: 20,
                                width: "100%",
                                role: "alert",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    color: "$contentPrimary",
                                    children: "Something went wrong. Please try again."
                                })
                            }) : null,
                            showNoResultsMessage ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                px: 20,
                                py: 20,
                                width: "100%",
                                role: "status",
                                "aria-live": "polite",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodySmall",
                                        color: "$contentPrimary",
                                        mb: 8,
                                        children: "No matches yet"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelSmall",
                                        color: "$contentSecondary",
                                        children: "Try a street number and name, ZIP code, or city. You can also pan the map to search this area."
                                    })
                                ]
                            }) : null,
                            query && (locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.length) && locationOptions.length > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: "$backgroundPrimary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$labelSmall",
                                        ml: 20,
                                        children: "Locations"
                                    }),
                                    locationOptions === null || locationOptions === void 0 ? void 0 : locationOptions.map(function(item, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            borderBottomWidth: 1,
                                            borderBottomColor: "$borderSecondary",
                                            alignItems: "flex-start",
                                            hoverStyle: {
                                                backgroundColor: "$backgroundSecondary"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                                "aria-label": "Select ".concat(item.label),
                                                "data-testid": "search-result-".concat(item.value),
                                                analyticsName: "comos-map-select-location",
                                                onPress: handleLocationSelect,
                                                position: "relative",
                                                px: 20,
                                                py: 20,
                                                mt: index === 0 ? 10 : 0,
                                                flexDirection: "row",
                                                pressStyle: {
                                                    backgroundColor: "$backgroundSecondary"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                    tag: "span",
                                                    typography: "$bodySmall",
                                                    "data-location": JSON.stringify(item),
                                                    children: [
                                                        item.label,
                                                        " ",
                                                        item.zoneType
                                                    ]
                                                })
                                            })
                                        }, item.label);
                                    })
                                ]
                            }) : null,
                            query && addressOptions && (addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.length) > 0 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                flexDirection: "column",
                                width: "100%",
                                backgroundColor: "$backgroundPrimary",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        mt: 24,
                                        typography: "$labelSmall",
                                        ml: 20,
                                        children: "Listings"
                                    }),
                                    addressOptions === null || addressOptions === void 0 ? void 0 : addressOptions.map(function(item, index) {
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                            borderBottomWidth: 1,
                                            borderBottomColor: "$borderSecondary",
                                            alignItems: "flex-start",
                                            hoverStyle: {
                                                backgroundColor: "$backgroundSecondary"
                                            },
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                                                "aria-label": "Select ".concat(item.fullAddress),
                                                analyticsName: "cosmos-map-select-address",
                                                onPress: handleAddressSelect,
                                                position: "relative",
                                                px: 20,
                                                py: 20,
                                                mt: index === 0 ? 10 : 0,
                                                flexDirection: "row",
                                                pressStyle: {
                                                    backgroundColor: "$backgroundSecondary"
                                                },
                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                                    flexDirection: "column",
                                                    alignItems: "flex-start",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$bodySmall",
                                                            width: "100%",
                                                            "data-addresstoken": item.addressToken,
                                                            children: item.fullAddress
                                                        }),
                                                        item.priceCents && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$labelXsmall",
                                                            alignSelf: "flex-start",
                                                            "data-addresstoken": item.addressToken,
                                                            children: (0,formatters/* formatCurrency */.xG)(item.priceCents)
                                                        })
                                                    ]
                                                })
                                            })
                                        }, item.addressToken || item.fullAddress || String(index));
                                    })
                                ]
                            }) : null
                        ]
                    })
                ]
            }, "location-results-".concat(query))
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/MobileHeaderFilters.tsx





var MobileHeaderFilters = function(param) {
    var isFocused = param.isFocused, selectedLocation = param.selectedLocation, setSelectedLocation = param.setSelectedLocation, onBack = param.onBack, onOpenFilters = param.onOpenFilters, selectedAddress = param.selectedAddress, setSelectedAddress = param.setSelectedAddress;
    var closeMenu = (0,NavMenuContext/* useNavMenu */.m)().closeMenu;
    (0,react.useEffect)(function() {
        if (isFocused) {
            closeMenu();
        }
    }, [
        isFocused,
        closeMenu
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapLocationSearch, {
                selectedAddress: selectedAddress,
                setSelectedAddress: setSelectedAddress,
                setSelectedLocation: setSelectedLocation,
                selectedLocation: selectedLocation,
                isFocused: isFocused
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "absolute",
                backgroundColor: "$backgroundPrimary",
                top: 10,
                right: "5%",
                zIndex: 10000,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* FilterButton */.Lb, {
                    size: "small",
                    analyticsName: "cosmos-marketplace-map-header-filter-button",
                    onPress: onOpenFilters
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                position: "absolute",
                backgroundColor: "$backgroundPrimary",
                top: 10,
                left: "2%",
                zIndex: 10000,
                display: isFocused ? "flex" : "none",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* ChevronBackButton */.jd, {
                    size: "small",
                    analyticsName: "cosmos-marketplace-map-location-search-back-button",
                    onPress: onBack
                })
            })
        ]
    });
};

// EXTERNAL MODULE: ../shared-fe/src/formatUtils.ts
var formatUtils = __webpack_require__(70899);
// EXTERNAL MODULE: ./src/components/marketplace/property/PropertySection/Pricing.tsx
var Pricing = __webpack_require__(29990);
;// CONCATENATED MODULE: ./src/components/marketplace/property/PropertySection/MiniMapPropertySummary.tsx





var MiniMapPropertySummary = function(param) {
    var property = param.property;
    var ref, ref1;
    var formattedStreet = (0,helpers/* formatStreetAddress */.Dm)(property.street, property.unitType, property.unitNumber);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        tag: "hgroup",
        $largerThanMD: {
            display: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                tag: "h1",
                pb: 24,
                color: "$contentPrimary",
                fontWeight: "$regular",
                typography: "$subheaderXsmall",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderXsmall",
                        fontWeight: "$regular",
                        children: formattedStreet
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("br", {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                        tag: "span",
                        typography: "$subheaderXsmall",
                        fontWeight: "$regular",
                        children: [
                            property.city,
                            ", ",
                            property.state,
                            " ",
                            property.zip
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                tag: "section",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Pricing/* PricingTraditional */.n, {
                        listPrice: property === null || property === void 0 ? void 0 : property.listPrice
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.bedrooms,
                                    " bds"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.bathrooms,
                                    " ba"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: [
                                    property.sqFtTotalLiving,
                                    " sqft"
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: "$bodySmall",
                                color: "$contentStateInactivePrimary",
                                mx: 4,
                                children: "\xb7"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodySmall",
                                color: "$contentSecondary",
                                children: (property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment) && "".concat((0,formatUtils/* formatCurrency */.xG)(property === null || property === void 0 ? void 0 : property.estimatedMonthlyPayment), "/month est.")
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "row",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: "$bodySmall",
                            color: "$contentSecondary",
                            children: !!(property === null || property === void 0 ? void 0 : (ref = property.schoolDistricts) === null || ref === void 0 ? void 0 : ref.length) && "".concat(property === null || property === void 0 ? void 0 : (ref1 = property.schoolDistricts) === null || ref1 === void 0 ? void 0 : ref1.join(" & "))
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/MobileMiniPropertyDetailPage.tsx









var SWIPE_THRESHOLD = 50;
var MobileMiniPropertyDetailPage = function(param) {
    var property = param.property, onClose = param.onClose;
    var ref = (0,react.useState)(false), isShareModalOpen = ref[0], setIsShareModalOpen = ref[1];
    var ref1 = (0,react.useState)(null), swipeStartY = ref1[0], setSwipeStartY = ref1[1];
    var handleTouchStart = function(e) {
        var touch = e.touches[0];
        setSwipeStartY(touch.clientY);
    };
    var handleOnClose = function() {
        var urlParams = removeAddressPreviewParams();
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        onClose();
    };
    var handleToggleShareModal = function() {
        setIsShareModalOpen(function(prev) {
            return !prev;
        });
    };
    // Handle the end of the touch and check if it's a swipe down
    var handleTouchEnd = function(e) {
        if (swipeStartY === null) return;
        var touch = e.changedTouches[0];
        var swipeDistance = touch.clientY - swipeStartY;
        if (swipeDistance > SWIPE_THRESHOLD) {
            handleOnClose();
        }
        setSwipeStartY(null);
    };
    var handleOnClick = function() {
        window.location.href = "/properties/".concat(property === null || property === void 0 ? void 0 : property.slug, "/aid_").concat(property === null || property === void 0 ? void 0 : property.addressToken);
    };
    // Floor plans intentionally omitted here: the bricks-next PhotoCarousel
    // cover-crops portrait plans. Tapping a photo navigates to the full PDP,
    // where floor plans are rendered uncropped in the gallery and Lightbox.
    var carouselPhotos = (0,react.useMemo)(function() {
        return (0,helpers/* buildCarouselPhotos */.Dt)(property);
    }, [
        property === null || property === void 0 ? void 0 : property.photos,
        property === null || property === void 0 ? void 0 : property.floorPlanPhotos
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                backgroundColor: "$backgroundPrimary",
                width: "100%",
                borderTopLeftRadius: "$16x",
                borderTopRightRadius: "$16x",
                height: "75vh",
                flexDirection: "column",
                onTouchStart: handleTouchStart,
                onTouchEnd: handleTouchEnd,
                exitStyle: {
                    height: "0vh"
                },
                animation: "accelerateSlow",
                touchAction: "none",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $largerThanSM: {
                            height: MOBILE_CAROUSEL_HEIGHT_MD
                        },
                        mb: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                            photos: carouselPhotos,
                            onClose: handleOnClose,
                            onOpenShareModal: handleToggleShareModal,
                            isRounded: true,
                            height: MOBILE_CAROUSEL_HEIGHT_MD,
                            onPhotoClick: handleOnClick
                        }, "med-mobile-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            height: MOBILE_CAROUSEL_HEIGHT_SM
                        },
                        $largerThanSM: {
                            display: "none"
                        },
                        mb: 24,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PhotoCarousel_PhotoCarousel, {
                            photos: carouselPhotos,
                            onClose: handleOnClose,
                            onOpenShareModal: handleToggleShareModal,
                            isRounded: true,
                            height: MOBILE_CAROUSEL_HEIGHT_SM,
                            onPhotoClick: handleOnClick
                        }, "sm-mobile-carousel-".concat(property === null || property === void 0 ? void 0 : property.addressToken))
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        px: 20,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiniMapPropertySummary, {
                                property: property
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                analyticsName: "mobile-map-pdp-link",
                                href: "/properties/".concat(property === null || property === void 0 ? void 0 : property.slug, "/aid_").concat(property === null || property === void 0 ? void 0 : property.addressToken),
                                size: "small",
                                variant: "secondary",
                                label: "View home",
                                mt: 10
                            })
                        ]
                    })
                ]
            }, "mobile-mini-pdp-".concat(property === null || property === void 0 ? void 0 : property.addressToken)),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ShareModal */.V8, {
                property: property,
                isOpen: isShareModalOpen,
                onClose: handleToggleShareModal
            })
        ]
    });
};

// EXTERNAL MODULE: ../bricks-next/src/components/Loader/Loader.tsx + 2 modules
var Loader = __webpack_require__(37495);
;// CONCATENATED MODULE: ./src/components/marketplace/map/PropertyList.tsx






var PropertyList = function(param) {
    var isLoading = param.isLoading, handleOnSeeMore = param.handleOnSeeMore, propertyListData = param.propertyListData;
    var ref = (0,react.useState)(false), isLoadingMore = ref[0], setIsLoadingMore = ref[1];
    var propertyCards = (0,react.useMemo)(function() {
        var ref;
        return propertyListData === null || propertyListData === void 0 ? void 0 : (ref = propertyListData.results) === null || ref === void 0 ? void 0 : ref.map(function(listing, index) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                mb: 24,
                $largerThanXS: {
                    width: "100%"
                },
                $largerThanSM: {
                    width: "100%"
                },
                $largerThanMD: {
                    width: "48%"
                },
                $largerThanLG: {
                    width: "48%"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(marketplace_property/* ListingCard */.dF, {
                    listing: listing
                })
            }, index);
        });
    }, [
        propertyListData
    ]);
    var onSeeMore = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setIsLoadingMore(true);
                        return [
                            4,
                            handleOnSeeMore()
                        ];
                    case 1:
                        _state.sent();
                        setTimeout(function() {
                            return setIsLoadingMore(false);
                        }, 500);
                        return [
                            2
                        ];
                }
            });
        });
        return function onSeeMore() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flexWrap: "wrap",
                justifyContent: "space-between",
                flexDirection: "row",
                "data-testid": "map-property-list",
                children: isLoading ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Loader/* Loader */.a, {
                        backgroundColor: "$backgroundPrimary",
                        size: "large"
                    })
                }) : propertyCards
            }),
            (propertyListData === null || propertyListData === void 0 ? void 0 : propertyListData.nextPage) && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "more-property-list",
                "data-testid": "map-more-property-list",
                label: "Show more",
                onPress: onSeeMore,
                size: "medium",
                variant: "secondary",
                mb: 30,
                loading: isLoadingMore
            })
        ]
    });
};

// EXTERNAL MODULE: ../bricks-next/src/components/inputs/Dropdown/Dropdown.tsx + 1 modules
var Dropdown = __webpack_require__(57854);
// EXTERNAL MODULE: ./src/components/globals.ts
var globals = __webpack_require__(79758);
;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/featureFlag.ts

/**
 * Saved-search UI is staging-only for now. Cosmos local/production auth is
 * currently broken, so we keep the create/switch/rename/delete surfaces off
 * the customer-facing `production` build and only expose them on staging (and
 * other non-prod environments) for testing.
 */ var SAVED_SEARCHES_ENABLED = globals/* DEPLOY_ENV */.Zp !== "production";

// EXTERNAL MODULE: ../bricks-next/src/components/Dialog/index.ts + 5 modules
var Dialog = __webpack_require__(62766);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Col.tsx
var Col = __webpack_require__(55128);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Row.tsx
var Row = __webpack_require__(34984);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/createReactComponent.mjs + 1 modules
var createReactComponent = __webpack_require__(25793);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconPencil.mjs
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const __iconNode = [["path", { "d": "M4 20h4l10.5 -10.5a2.828 2.828 0 1 0 -4 -4l-10.5 10.5v4", "key": "svg-0" }], ["path", { "d": "M13.5 6.5l4 4", "key": "svg-1" }]];
const IconPencil = (0,createReactComponent/* default */.Z)("outline", "pencil", "Pencil", __iconNode);


//# sourceMappingURL=IconPencil.mjs.map

;// CONCATENATED MODULE: ../../node_modules/.pnpm/@tabler+icons-react@3.44.0_@types+react@18.3.28_react@18.3.1/node_modules/@tabler/icons-react/dist/esm/icons/IconTrash.mjs
/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */



const IconTrash_iconNode = [["path", { "d": "M4 7l16 0", "key": "svg-0" }], ["path", { "d": "M10 11l0 6", "key": "svg-1" }], ["path", { "d": "M14 11l0 6", "key": "svg-2" }], ["path", { "d": "M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12", "key": "svg-3" }], ["path", { "d": "M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3", "key": "svg-4" }]];
const IconTrash = (0,createReactComponent/* default */.Z)("outline", "trash", "Trash", IconTrash_iconNode);


//# sourceMappingURL=IconTrash.mjs.map

// EXTERNAL MODULE: ./src/helpers/observability.ts + 11 modules
var observability = __webpack_require__(50138);
;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/ConfirmDeleteDialog.tsx





var GENERIC_ERROR = "Failed to delete search. Please try again.";
var ConfirmDeleteDialog = function(param) {
    var savedSearch = param.savedSearch, isOpen = param.isOpen, onClose = param.onClose, onConfirmDelete = param.onConfirmDelete;
    var ref = (0,react.useState)(false), submitting = ref[0], setSubmitting = ref[1];
    var ref1 = (0,react.useState)(null), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var handleClose = (0,react.useCallback)(function() {
        if (submitting) {
            return;
        }
        onClose();
    }, [
        submitting,
        onClose
    ]);
    var handleConfirm = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var result, _errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (submitting) {
                        return [
                            2
                        ];
                    }
                    setSubmitting(true);
                    setErrorMessage(null);
                    return [
                        4,
                        onConfirmDelete(savedSearch.id)
                    ];
                case 1:
                    result = _state.sent();
                    setSubmitting(false);
                    if (result.success) {
                        onClose();
                        return [
                            2
                        ];
                    }
                    setErrorMessage((_errorMessage = result.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : GENERIC_ERROR);
                    return [
                        2
                    ];
            }
        });
    }), [
        onConfirmDelete,
        savedSearch.id,
        submitting,
        onClose
    ]);
    var confirmLabel = "Delete";
    if (submitting) {
        confirmLabel = "Deleting…";
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        analyticsName: "confirm-delete-saved-search-dialog",
        isOpen: isOpen,
        setIsOpen: handleClose,
        dismissable: !submitting,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            width: "100%",
            $largerThanSM: {
                width: 360
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                    title: "Delete saved search?",
                    description: 'This will remove "'.concat(savedSearch.name, '". You can’t undo this action.'),
                    children: errorMessage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        pt: 12,
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "p",
                            typography: "$bodySmall",
                            color: "$contentStateErrorDefault",
                            role: "alert",
                            children: errorMessage
                        })
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Actions */.V.Actions, {
                    buttonOneProps: {
                        analyticsName: "confirm-delete-saved-search-cancel",
                        label: "Cancel",
                        variant: "secondary",
                        onPress: handleClose,
                        disabled: submitting
                    },
                    buttonTwoProps: {
                        analyticsName: "confirm-delete-saved-search-confirm",
                        label: confirmLabel,
                        variant: "primary",
                        onPress: handleConfirm,
                        disabled: submitting,
                        loading: submitting
                    }
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/RenameSavedSearchDialog.tsx






var SAVE_SEARCH_NAME_MAX_LENGTH = 80;
var RenameSavedSearchDialog_GENERIC_ERROR = "Failed to rename search. Please try again.";
var RenameSavedSearchDialog = function(param) {
    var savedSearch = param.savedSearch, isOpen = param.isOpen, onClose = param.onClose, onRename = param.onRename;
    var ref = (0,react.useState)(savedSearch.name), name = ref[0], setName = ref[1];
    var ref1 = (0,react.useState)(false), submitting = ref1[0], setSubmitting = ref1[1];
    var ref2 = (0,react.useState)(null), errorMessage = ref2[0], setErrorMessage = ref2[1];
    var inputRef = (0,react.useRef)(null);
    // Reset name + error whenever a different saved search is opened for rename.
    (0,react.useEffect)(function() {
        if (isOpen) {
            setName(savedSearch.name);
            setErrorMessage(null);
            queueMicrotask(function() {
                var ref;
                (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
            });
        }
    }, [
        isOpen,
        savedSearch.name,
        savedSearch.id
    ]);
    var handleClose = (0,react.useCallback)(function() {
        if (submitting) {
            return;
        }
        onClose();
    }, [
        submitting,
        onClose
    ]);
    var handleSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var trimmedName, query, input, result, _errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    trimmedName = name.trim();
                    if (!trimmedName || submitting) {
                        return [
                            2
                        ];
                    }
                    if (trimmedName === savedSearch.name) {
                        onClose();
                        return [
                            2
                        ];
                    }
                    setSubmitting(true);
                    setErrorMessage(null);
                    query = toPropertySearchQuery(savedSearch);
                    input = toSavedSearchInput(query, trimmedName, savedSearch);
                    return [
                        4,
                        onRename(savedSearch.id, input)
                    ];
                case 1:
                    result = _state.sent();
                    setSubmitting(false);
                    if (result.success) {
                        onClose();
                        return [
                            2
                        ];
                    }
                    setErrorMessage((_errorMessage = result.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : RenameSavedSearchDialog_GENERIC_ERROR);
                    return [
                        2
                    ];
            }
        });
    }), [
        name,
        savedSearch,
        submitting,
        onRename,
        onClose
    ]);
    var trimmedName = name.trim();
    var canSubmit = !submitting && trimmedName.length > 0;
    var submitLabel = "Save";
    if (submitting) {
        submitLabel = "Saving…";
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
        analyticsName: "rename-saved-search-dialog",
        isOpen: isOpen,
        setIsOpen: handleClose,
        dismissable: !submitting,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
            width: "100%",
            $largerThanSM: {
                width: 360
            },
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                    title: "Rename saved search",
                    description: "Update the label for this saved search.",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        pt: 16,
                        pb: 8,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                                ref: inputRef,
                                size: "medium",
                                title: "Search name",
                                value: name,
                                onChangeText: setName,
                                maxLength: SAVE_SEARCH_NAME_MAX_LENGTH,
                                analyticsName: "rename-saved-search-name-input",
                                placeholder: "My saved search"
                            }),
                            errorMessage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "p",
                                typography: "$bodySmall",
                                color: "$contentStateErrorDefault",
                                role: "alert",
                                mt: 8,
                                children: errorMessage
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Actions */.V.Actions, {
                    buttonOneProps: {
                        analyticsName: "rename-saved-search-cancel",
                        label: "Cancel",
                        variant: "secondary",
                        onPress: handleClose,
                        disabled: submitting
                    },
                    buttonTwoProps: {
                        analyticsName: "rename-saved-search-submit",
                        label: submitLabel,
                        variant: "primary",
                        onPress: handleSubmit,
                        disabled: !canSubmit,
                        loading: submitting
                    }
                })
            ]
        })
    });
};

// EXTERNAL MODULE: ./src/helpers/captureError.ts
var captureError = __webpack_require__(9857);
;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/useSavedSearches.ts




/**
 * React hook for fetching and mutating the authenticated buyer's saved
 * searches. Reads through the product-shaped `customerAccount.buying.savedSearches`
 * API; customer identity is resolved server-side from the session cookie.
 *
 * Cosmos uses `graphql-request` via the generated SDK exposed by
 * `getAthenaClient()`, so this hook composes a small module-level store +
 * `useSyncExternalStore` instead of Apollo `useQuery`/`useMutation`. The store
 * is shared by every consumer (the switcher dropdown, the save button, the
 * rename/delete dialogs), so a create/update/delete from any surface refetches
 * once and all mounted consumers re-render — no prop-drilling or context, and
 * no stale per-instance copies that only refresh on reload.
 */ 


var useSavedSearches_ref, ref1;
// The Athena resolver rejects saved searches without any location (market,
// zone, or polygon) with `success: false`. Catch that here so the hook
// surfaces a uniform client-side error without paying for a round-trip.
var inputHasLocation = function(input) {
    var ref2, ref3;
    return !!input.location.market || ((useSavedSearches_ref = (ref2 = input.location.zoneIds) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && useSavedSearches_ref !== void 0 ? useSavedSearches_ref : 0) > 0 || ((ref1 = (ref3 = input.location.vertices) === null || ref3 === void 0 ? void 0 : ref3.length) !== null && ref1 !== void 0 ? ref1 : 0) > 0;
};
var LOCATION_REQUIRED_ERROR = "A location is required to save a search.";
var storeState = {
    savedSearches: [],
    loading: false
};
var listeners = new Set();
// Latest in-flight request, so a stale response from a previous auth state
// (e.g. logout-mid-fetch) cannot overwrite fresher state.
var requestId = 0;
// Latest auth state, so a mutation that resolves after logout doesn't refetch
// against an unauthenticated session.
var loggedIn = false;
var subscribe = function(listener) {
    listeners.add(listener);
    return function() {
        listeners.delete(listener);
    };
};
var getSnapshot = function() {
    return storeState;
};
var setStoreState = function(next) {
    storeState = (0,_object_spread/* default */.Z)({}, storeState, next);
    listeners.forEach(function(listener) {
        return listener();
    });
};
var fetchSavedSearches = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function() {
        var id, ref, ref1, data, ref2, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    id = ++requestId;
                    setStoreState({
                        loading: true
                    });
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        4,
                        5
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().GetSavedSearches()
                    ];
                case 2:
                    data = _state.sent();
                    if (id !== requestId) {
                        return [
                            2
                        ];
                    }
                    setStoreState({
                        savedSearches: (ref2 = data === null || data === void 0 ? void 0 : (ref = data.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : ref1.savedSearches) !== null && ref2 !== void 0 ? ref2 : []
                    });
                    return [
                        3,
                        5
                    ];
                case 3:
                    e = _state.sent();
                    (0,captureError/* captureError */.O)(e, "GetSavedSearches");
                    if (id !== requestId) {
                        return [
                            2
                        ];
                    }
                    setStoreState({
                        savedSearches: []
                    });
                    return [
                        3,
                        5
                    ];
                case 4:
                    if (id === requestId) {
                        setStoreState({
                            loading: false
                        });
                    }
                    return [
                        7
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function fetchSavedSearches() {
        return _ref.apply(this, arguments);
    };
}();
var clearSavedSearches = function() {
    requestId++;
    setStoreState({
        savedSearches: [],
        loading: false
    });
};
var addSavedSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(input) {
        var ref, ref1, ref2, res, payload, ref3, ref4, ref5, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!inputHasLocation(input)) {
                        return [
                            2,
                            {
                                success: false,
                                errorMessage: LOCATION_REQUIRED_ERROR,
                                savedSearch: null
                            }
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().AddSavedSearch({
                            input: input
                        })
                    ];
                case 2:
                    res = _state.sent();
                    payload = res === null || res === void 0 ? void 0 : (ref = res.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.savedSearches) === null || ref2 === void 0 ? void 0 : ref2.add;
                    if (!((payload === null || payload === void 0 ? void 0 : payload.success) && loggedIn)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        fetchSavedSearches()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            success: (ref3 = payload === null || payload === void 0 ? void 0 : payload.success) !== null && ref3 !== void 0 ? ref3 : false,
                            errorMessage: (ref4 = payload === null || payload === void 0 ? void 0 : payload.errorMessage) !== null && ref4 !== void 0 ? ref4 : null,
                            savedSearch: (ref5 = payload === null || payload === void 0 ? void 0 : payload.savedSearch) !== null && ref5 !== void 0 ? ref5 : null
                        }
                    ];
                case 5:
                    e = _state.sent();
                    (0,captureError/* captureError */.O)(e, "AddSavedSearch");
                    return [
                        2,
                        {
                            success: false,
                            errorMessage: "Unexpected error",
                            savedSearch: null
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function addSavedSearch(input) {
        return _ref.apply(this, arguments);
    };
}();
var updateSavedSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id, input) {
        var ref, ref1, ref2, res, payload, ref3, ref4, ref5, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!inputHasLocation(input)) {
                        return [
                            2,
                            {
                                success: false,
                                errorMessage: LOCATION_REQUIRED_ERROR,
                                savedSearch: null
                            }
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().UpdateSavedSearch({
                            id: id,
                            input: input
                        })
                    ];
                case 2:
                    res = _state.sent();
                    payload = res === null || res === void 0 ? void 0 : (ref = res.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.savedSearches) === null || ref2 === void 0 ? void 0 : ref2.update;
                    if (!((payload === null || payload === void 0 ? void 0 : payload.success) && loggedIn)) return [
                        3,
                        4
                    ];
                    return [
                        4,
                        fetchSavedSearches()
                    ];
                case 3:
                    _state.sent();
                    _state.label = 4;
                case 4:
                    return [
                        2,
                        {
                            success: (ref3 = payload === null || payload === void 0 ? void 0 : payload.success) !== null && ref3 !== void 0 ? ref3 : false,
                            errorMessage: (ref4 = payload === null || payload === void 0 ? void 0 : payload.errorMessage) !== null && ref4 !== void 0 ? ref4 : null,
                            savedSearch: (ref5 = payload === null || payload === void 0 ? void 0 : payload.savedSearch) !== null && ref5 !== void 0 ? ref5 : null
                        }
                    ];
                case 5:
                    e = _state.sent();
                    (0,captureError/* captureError */.O)(e, "UpdateSavedSearch");
                    return [
                        2,
                        {
                            success: false,
                            errorMessage: "Unexpected error",
                            savedSearch: null
                        }
                    ];
                case 6:
                    return [
                        2
                    ];
            }
        });
    });
    return function updateSavedSearch(id, input) {
        return _ref.apply(this, arguments);
    };
}();
var removeSavedSearch = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(id) {
        var ref, ref1, ref2, res, payload, ref3, ref4, e;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        4,
                        ,
                        5
                    ]);
                    return [
                        4,
                        (0,api/* getAthenaClient */.k8)().RemoveSavedSearch({
                            id: id
                        })
                    ];
                case 1:
                    res = _state.sent();
                    payload = res === null || res === void 0 ? void 0 : (ref = res.customerAccount) === null || ref === void 0 ? void 0 : (ref1 = ref.buying) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.savedSearches) === null || ref2 === void 0 ? void 0 : ref2.remove;
                    if (!((payload === null || payload === void 0 ? void 0 : payload.success) && loggedIn)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        fetchSavedSearches()
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    return [
                        2,
                        {
                            success: (ref3 = payload === null || payload === void 0 ? void 0 : payload.success) !== null && ref3 !== void 0 ? ref3 : false,
                            errorMessage: (ref4 = payload === null || payload === void 0 ? void 0 : payload.errorMessage) !== null && ref4 !== void 0 ? ref4 : null
                        }
                    ];
                case 4:
                    e = _state.sent();
                    (0,captureError/* captureError */.O)(e, "RemoveSavedSearch");
                    return [
                        2,
                        {
                            success: false,
                            errorMessage: "Unexpected error"
                        }
                    ];
                case 5:
                    return [
                        2
                    ];
            }
        });
    });
    return function removeSavedSearch(id) {
        return _ref.apply(this, arguments);
    };
}();
/**
 * Resets the module-level store. Exported for tests (and HMR) to isolate state
 * between runs; not used by application code.
 */ var __resetSavedSearchesStoreForTest = function() {
    storeState = {
        savedSearches: [],
        loading: false
    };
    requestId += 1;
    loggedIn = false;
};
function useSavedSearches() {
    var authentication = (0,AuthContext/* useAuth */.aC)().authentication;
    var authState = authentication === null || authentication === void 0 ? void 0 : authentication.state;
    var isLoggedIn = authState === "authenticated";
    var snapshot = (0,react.useSyncExternalStore)(subscribe, getSnapshot, getSnapshot);
    (0,react.useEffect)(function() {
        loggedIn = isLoggedIn;
        if (isLoggedIn) {
            void fetchSavedSearches();
            return;
        }
        // `authenticating` is the transient state emitted on initial load and
        // session refresh. Clearing the list (and flipping the dropdown's
        // visibility guard) during it would let a background re-render tear down
        // an open saved-searches menu, so we keep the existing list and only reset
        // on a definitively logged-out state.
        if (authState === "authenticating") {
            return;
        }
        clearSavedSearches();
    }, [
        isLoggedIn,
        authState
    ]);
    return {
        isLoggedIn: isLoggedIn,
        loading: snapshot.loading,
        savedSearches: snapshot.savedSearches,
        add: addSavedSearch,
        update: updateSavedSearch,
        remove: removeSavedSearch,
        refetch: fetchSavedSearches
    };
}

;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/SavedSearchesDropdown.tsx









var SavedSearchesDropdown = function(param) {
    var onApplySavedSearch = param.onApplySavedSearch, _size = param.size, size = _size === void 0 ? "small" : _size;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    // Single source of truth for the list and its mutations. The rename/delete
    // dialogs run their mutation through this same instance (via the injected
    // `update`/`remove`) so the list refetches and updates here in place.
    var ref = useSavedSearches(), savedSearches = ref.savedSearches, update = ref.update, remove = ref.remove;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(null), pendingRename = ref2[0], setPendingRename = ref2[1];
    var ref3 = (0,react.useState)(null), pendingDelete = ref3[0], setPendingDelete = ref3[1];
    var handleSelect = (0,react.useCallback)(function(savedSearch) {
        trackEvent("cta-click", "saved-search-selected", {
            savedSearchId: savedSearch.id,
            market: savedSearch.location.market
        });
        // Delegate to the host page, which owns the marketplace search state and
        // decides whether to refetch results in place or hard-navigate. The
        // previous `router.push` only updated the URL — the long-lived page never
        // re-hydrated from the new params, so the result set never changed.
        onApplySavedSearch(savedSearch);
        setIsOpen(false);
    }, [
        onApplySavedSearch,
        trackEvent
    ]);
    var handleOpen = (0,react.useCallback)(function() {
        setIsOpen(true);
    }, []);
    var handleOpenRename = (0,react.useCallback)(function(savedSearch) {
        setPendingRename(savedSearch);
    }, []);
    var handleOpenDelete = (0,react.useCallback)(function(savedSearch) {
        setPendingDelete(savedSearch);
    }, []);
    var handleCloseRename = (0,react.useCallback)(function() {
        setPendingRename(null);
    }, []);
    var handleCloseDelete = (0,react.useCallback)(function() {
        setPendingDelete(null);
    }, []);
    var hasSavedSearches = savedSearches.length > 0;
    // Keep rendering while the menu is open even if the list transiently empties
    // (e.g. an auth re-evaluation), so a background re-render can't tear down the
    // open menu before the user has acted on it.
    if (!SAVED_SEARCHES_ENABLED || !hasSavedSearches && !isOpen) {
        return null;
    }
    var buttonLabel = "Saved searches (".concat(savedSearches.length, ")");
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            hasSavedSearches && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "saved-searches-dropdown-trigger",
                label: buttonLabel,
                onPress: handleOpen,
                size: size,
                variant: "secondary"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
                analyticsName: "saved-searches-dropdown-dialog",
                isOpen: isOpen,
                setIsOpen: setIsOpen,
                dismissable: true,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                    width: "100%",
                    $largerThanSM: {
                        width: 420
                    },
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                        title: "Your saved searches",
                        description: "Tap a search to switch between them, or rename and delete here.",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Col/* Col */.J, {
                            pt: 4,
                            children: savedSearches.map(function(savedSearch, index) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SavedSearchRow, {
                                    savedSearch: savedSearch,
                                    isLast: index === savedSearches.length - 1,
                                    onSelect: handleSelect,
                                    onRename: handleOpenRename,
                                    onDelete: handleOpenDelete
                                }, savedSearch.id);
                            })
                        })
                    })
                })
            }),
            pendingRename && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RenameSavedSearchDialog, {
                savedSearch: pendingRename,
                isOpen: pendingRename !== null,
                onClose: handleCloseRename,
                onRename: update
            }),
            pendingDelete && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ConfirmDeleteDialog, {
                savedSearch: pendingDelete,
                isOpen: pendingDelete !== null,
                onClose: handleCloseDelete,
                onConfirmDelete: remove
            })
        ]
    });
};
var SavedSearchRow = function(param) {
    var savedSearch = param.savedSearch, isLast = param.isLast, onSelect = param.onSelect, onRename = param.onRename, onDelete = param.onDelete;
    var handleSelect = (0,react.useCallback)(function() {
        onSelect(savedSearch);
    }, [
        onSelect,
        savedSearch
    ]);
    var handleRename = (0,react.useCallback)(function() {
        onRename(savedSearch);
    }, [
        onRename,
        savedSearch
    ]);
    var handleDelete = (0,react.useCallback)(function() {
        onDelete(savedSearch);
    }, [
        onDelete,
        savedSearch
    ]);
    // The name is the primary tap target (switch); rename/delete are compact,
    // secondary icon actions so the row stays scannable and the full name shows.
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
        alignItems: "center",
        gap: 8,
        py: 14,
        borderBottomWidth: isLast ? 0 : 1,
        borderBottomColor: "$borderSecondary",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                flex: 1,
                analyticsName: "saved-search-select",
                "aria-label": "Switch to saved search ".concat(savedSearch.name),
                onPress: handleSelect,
                py: 4,
                pr: 8,
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                    tag: "p",
                    typography: "$bodyMedium",
                    numberOfLines: 2,
                    textAlign: "left",
                    children: savedSearch.name
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Row/* Row */.X, {
                alignItems: "center",
                gap: 2,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        analyticsName: "saved-search-rename",
                        "aria-label": "Rename ".concat(savedSearch.name),
                        onPress: handleRename,
                        p: 10,
                        borderRadius: 8,
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconPencil, {
                            size: 18,
                            "aria-hidden": true
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PressableBox/* PressableBox */.K, {
                        analyticsName: "saved-search-delete",
                        "aria-label": "Delete ".concat(savedSearch.name),
                        onPress: handleDelete,
                        p: 10,
                        borderRadius: 8,
                        alignItems: "center",
                        justifyContent: "center",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconTrash, {
                            size: 18,
                            "aria-hidden": true
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/QuickFilters.tsx





var QuickFilters = function(param) {
    var bathrooms = param.bathrooms, bedrooms = param.bedrooms, onFilterChange = param.onFilterChange, isLoadingFilter = param.isLoadingFilter, setSelectedAddress = param.setSelectedAddress, selectedAddress = param.selectedAddress, setSelectedLocation = param.setSelectedLocation, selectedLocation = param.selectedLocation, onFiltersButtonClick = param.onFiltersButtonClick, isFocused = param.isFocused, onApplySavedSearch = param.onApplySavedSearch;
    var handleOnBedroomsChange = function(value) {
        onFilterChange(value, bathrooms);
    };
    var handleOnBathroomsChange = function(value) {
        onFilterChange(bedrooms, value);
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        justifyContent: "space-between",
        flexDirection: "row",
        width: "100%",
        my: 25,
        gap: 20,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                flex: 2,
                width: "40%",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapLocationSearch, {
                    isFocused: isFocused,
                    selectedAddress: selectedAddress,
                    setSelectedAddress: setSelectedAddress,
                    setSelectedLocation: setSelectedLocation,
                    selectedLocation: selectedLocation
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                flex: 1,
                minWidth: 88,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                    id: "bedrooms",
                    name: "bedrooms",
                    prefilledValue: (bedrooms === null || bedrooms === void 0 ? void 0 : bedrooms.toString()) || undefined,
                    options: [
                        {
                            label: "1+",
                            value: "1"
                        },
                        {
                            label: "2+",
                            value: "2"
                        },
                        {
                            label: "3+",
                            value: "3"
                        },
                        {
                            label: "4+",
                            value: "4"
                        }, 
                    ],
                    placeholderOption: {
                        label: "0",
                        value: undefined
                    },
                    size: "small",
                    title: "Beds",
                    onValueChange: handleOnBedroomsChange
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                $smallerThanLG: {
                    display: "none"
                },
                flex: 1,
                minWidth: 88,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                    id: "bathrooms",
                    name: "bathrooms",
                    prefilledValue: (bathrooms === null || bathrooms === void 0 ? void 0 : bathrooms.toString()) || undefined,
                    options: [
                        {
                            label: "1+",
                            value: "1"
                        },
                        {
                            label: "2+",
                            value: "2"
                        },
                        {
                            label: "3+",
                            value: "3"
                        },
                        {
                            label: "4+",
                            value: "4"
                        }, 
                    ],
                    placeholderOption: {
                        label: "0",
                        value: undefined
                    },
                    size: "small",
                    title: "Baths",
                    onValueChange: handleOnBathroomsChange
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "filter-property-search",
                "data-testid": "filter-property-search",
                label: "Filters",
                onPress: onFiltersButtonClick,
                size: "xsmall",
                variant: "secondary",
                height: "65%",
                alignSelf: "flex-end",
                flex: 1,
                maxWidth: 82,
                minWidth: "min-content",
                loading: isLoadingFilter
            }),
            SAVED_SEARCHES_ENABLED && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                alignSelf: "flex-end",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SavedSearchesDropdown, {
                    onApplySavedSearch: onApplySavedSearch
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/savedSearches/SaveSearchButton.tsx









var SaveSearchButton_SAVE_SEARCH_NAME_MAX_LENGTH = 80;
var NO_LOCATION_HINT = "Pick a market, neighborhood, or area on the map first.";
var SaveSearchButton_GENERIC_ERROR = "Failed to save search. Please try again.";
// The marketplace doesn't have an in-page login modal, so unauthenticated
// users are bounced to `/login?redirectTo=...` matching `usePropertyReactions`.
var redirectToLogin = function() {
    var redirectTo = "".concat(window.location.pathname).concat(window.location.search);
    window.location.assign("/login?redirectTo=".concat(encodeURIComponent(redirectTo)));
};
var SaveSearchButton = function(param) {
    var query = param.query, _variant = param.variant, variant = _variant === void 0 ? "secondary" : _variant, _size = param.size, size = _size === void 0 ? "medium" : _size, onSaved = param.onSaved;
    var ref = useSavedSearches(), isLoggedIn = ref.isLoggedIn, add = ref.add;
    var trackEvent = (0,observability/* useObservability */.C3)().trackEvent;
    var ref1 = (0,react.useState)(false), isOpen = ref1[0], setIsOpen = ref1[1];
    var ref2 = (0,react.useState)(""), name = ref2[0], setName = ref2[1];
    var ref3 = (0,react.useState)(false), submitting = ref3[0], setSubmitting = ref3[1];
    var ref4 = (0,react.useState)(null), errorMessage = ref4[0], setErrorMessage = ref4[1];
    // Bricks-next `TextInput` forwards a React Native TextInput ref; we use it
    // to drive focus once the Dialog portal mounts.
    var inputRef = (0,react.useRef)(null);
    var validLocation = hasValidLocation(query);
    (0,react.useEffect)(function() {
        if (!isOpen) {
            return;
        }
        // Microtask defer so the Dialog content has time to mount before we
        // dispatch focus into it.
        queueMicrotask(function() {
            var ref;
            (ref = inputRef.current) === null || ref === void 0 ? void 0 : ref.focus();
        });
    }, [
        isOpen
    ]);
    var handleOpenDialog = (0,react.useCallback)(function() {
        if (!isLoggedIn) {
            redirectToLogin();
            return;
        }
        setName(formatSavedSearchName(query));
        setErrorMessage(null);
        setIsOpen(true);
    }, [
        isLoggedIn,
        query
    ]);
    var handleClose = (0,react.useCallback)(function() {
        if (submitting) {
            return;
        }
        setIsOpen(false);
    }, [
        submitting
    ]);
    var handleSubmit = (0,react.useCallback)(/*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var trimmedName, result, ref, ref1, ref2, ref3, ref4, ref5, ref6, _errorMessage;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    trimmedName = name.trim();
                    if (!trimmedName || submitting) {
                        return [
                            2
                        ];
                    }
                    setSubmitting(true);
                    setErrorMessage(null);
                    return [
                        4,
                        add(toSavedSearchInput(query, trimmedName))
                    ];
                case 1:
                    result = _state.sent();
                    setSubmitting(false);
                    if (result.success) {
                        ;
                        ;
                        trackEvent("cta-click", "save-search-created", {
                            savedSearchId: (ref = result.savedSearch) === null || ref === void 0 ? void 0 : ref.id,
                            market: query.market,
                            zoneIdsCount: (ref4 = (ref1 = query.zoneIds) === null || ref1 === void 0 ? void 0 : ref1.length) !== null && ref4 !== void 0 ? ref4 : 0,
                            verticesCount: (ref5 = (ref2 = query.vertices) === null || ref2 === void 0 ? void 0 : ref2.length) !== null && ref5 !== void 0 ? ref5 : 0
                        });
                        setIsOpen(false);
                        ;
                        onSaved === null || onSaved === void 0 ? void 0 : onSaved((ref6 = (ref3 = result.savedSearch) === null || ref3 === void 0 ? void 0 : ref3.id) !== null && ref6 !== void 0 ? ref6 : "");
                        return [
                            2
                        ];
                    }
                    setErrorMessage((_errorMessage = result.errorMessage) !== null && _errorMessage !== void 0 ? _errorMessage : SaveSearchButton_GENERIC_ERROR);
                    return [
                        2
                    ];
            }
        });
    }), [
        add,
        name,
        onSaved,
        query,
        submitting,
        trackEvent
    ]);
    var trimmedName = name.trim();
    var canSubmit = !submitting && trimmedName.length > 0;
    var triggerHint = validLocation ? undefined : NO_LOCATION_HINT;
    var submitLabel = "Save";
    if (submitting) {
        submitLabel = "Saving…";
    }
    if (!SAVED_SEARCHES_ENABLED) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                analyticsName: "save-search-button",
                label: "Save search",
                onPress: handleOpenDialog,
                size: size,
                $smallerThanMD: {
                    size: "small",
                    flex: 1,
                    minWidth: 0
                },
                variant: variant,
                disabled: !validLocation,
                "aria-label": validLocation ? "Save search" : "Save search. ".concat(triggerHint)
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog */.V, {
                analyticsName: "save-search-dialog",
                isOpen: isOpen,
                setIsOpen: handleClose,
                dismissable: !submitting,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                    width: "100%",
                    $largerThanSM: {
                        width: 360
                    },
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Content */.V.Content, {
                            title: "Name your saved search",
                            description: "Give your search a name so you can find it later.",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                pt: 16,
                                pb: 8,
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TextInput/* TextInput */.o, {
                                        ref: inputRef,
                                        size: "medium",
                                        title: "Search name",
                                        value: name,
                                        onChangeText: setName,
                                        maxLength: SaveSearchButton_SAVE_SEARCH_NAME_MAX_LENGTH,
                                        analyticsName: "save-search-name-input",
                                        placeholder: "My saved search"
                                    }),
                                    errorMessage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                        tag: "p",
                                        typography: "$bodySmall",
                                        color: "$contentStateErrorDefault",
                                        role: "alert",
                                        mt: 8,
                                        children: errorMessage
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dialog/* Dialog.Actions */.V.Actions, {
                            buttonOneProps: {
                                analyticsName: "save-search-cancel",
                                label: "Cancel",
                                variant: "secondary",
                                onPress: handleClose,
                                disabled: submitting
                            },
                            buttonTwoProps: {
                                analyticsName: "save-search-submit",
                                label: submitLabel,
                                variant: "primary",
                                onPress: handleSubmit,
                                disabled: !canSubmit,
                                loading: submitting
                            }
                        })
                    ]
                })
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/BedroomsBathroomsFilter.tsx


var RoomSizeOptions = [
    {
        label: "1+",
        value: "1"
    },
    {
        label: "2+",
        value: "2"
    },
    {
        label: "3+",
        value: "3"
    },
    {
        label: "4+",
        value: "4"
    }, 
];
var BedroomsBathroomsFilter = function(param) {
    var minBaths = param.minBaths, minBeds = param.minBeds, handleMinBathsChange = param.handleMinBathsChange, handleMinBedsChange = param.handleMinBedsChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Beds/Baths"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        mt: 24,
                        children: "Beds"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "30%",
                        $smallerThanMD: {
                            width: "40%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "Min beds",
                                value: "0"
                            },
                            options: RoomSizeOptions.slice(),
                            onValueChange: handleMinBedsChange,
                            size: "small",
                            prefilledValue: minBeds || undefined
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        mt: 24,
                        children: "Baths"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "30%",
                        $smallerThanMD: {
                            width: "40%"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "Min baths",
                                value: "0"
                            },
                            options: RoomSizeOptions.slice(),
                            onValueChange: handleMinBathsChange,
                            size: "small",
                            prefilledValue: minBaths || undefined
                        })
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ../bricks-next/src/components/inputs/checkboxRadio/SimpleCheckbox.tsx
var SimpleCheckbox = __webpack_require__(46176);
;// CONCATENATED MODULE: ./src/components/marketplace/search/HomeFeaturesFilter.tsx


var HomeFeaturesFilter = function(param) {
    var noHoas = param.noHoas, fhaEligible = param.fhaEligible, mustHavePool = param.mustHavePool, singleStory = param.singleStory, handleNoHoasChange = param.handleNoHoasChange, handleFhaEligibleChange = param.handleFhaEligibleChange, handleSingleStoryChange = param.handleSingleStoryChange, handlePoolChange = param.handlePoolChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                color: "$contentPrimary",
                alignSelf: "flex-start",
                mb: 20,
                children: "Home features"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "No HOA Only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "hoa-checkbox",
                        analyticsName: "hoa-checkbox",
                        id: "hoa-checkbox",
                        size: "medium",
                        name: "hoa",
                        value: "true",
                        defaultChecked: !!noHoas,
                        onPress: handleNoHoasChange
                    })
                ]
            }),
            handleSingleStoryChange && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Single-story only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "single-story-checkbox",
                        analyticsName: "single-story-checkbox",
                        id: "single-story-checkbox",
                        size: "medium",
                        name: "singleStory",
                        value: "true",
                        defaultChecked: !!singleStory,
                        onPress: handleSingleStoryChange
                    })
                ]
            }),
            handleFhaEligibleChange && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "FHA Eligible Only"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "fha-checkbox",
                        analyticsName: "fha-checkbox",
                        id: "fha-checkbox",
                        size: "medium",
                        name: "fha",
                        value: "true",
                        defaultChecked: !!fhaEligible,
                        onPress: handleFhaEligibleChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "With Pool Only (includes community pools)"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "pool-checkbox",
                        analyticsName: "pool-checkbox",
                        id: "pool-checkbox",
                        size: "medium",
                        name: "pool",
                        value: "true",
                        defaultChecked: !!mustHavePool,
                        onPress: handlePoolChange
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/HomeTypeFilter.tsx


var HomeTypeFilter = function(param) {
    var singleFamily = param.singleFamily, townhome = param.townhome, condo = param.condo, handleSingleFamilyChange = param.handleSingleFamilyChange, handleTownhomeChange = param.handleTownhomeChange, handleCondoChange = param.handleCondoChange;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        justifyContent: "space-between",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                color: "$contentPrimary",
                alignSelf: "flex-start",
                mb: 20,
                children: "Home type"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Single-family homes"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "single-family-home-checkbox",
                        analyticsName: "sfh-checkbox",
                        id: "single-family-home-checkbox",
                        size: "medium",
                        name: "singleFamily",
                        value: "true",
                        defaultChecked: !!singleFamily,
                        onPress: handleSingleFamilyChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                my: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Townhomes"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "townhome-checkbox",
                        analyticsName: "townhome-checkbox",
                        id: "townhome-checkbox",
                        size: "medium",
                        name: "townhome",
                        value: "true",
                        defaultChecked: !!townhome,
                        onPress: handleTownhomeChange
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 10,
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        color: "$contentPrimary",
                        children: "Condos"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SimpleCheckbox/* SimpleCheckbox */.A, {
                        ariaLabel: "condo-checkbox",
                        analyticsName: "condo-checkbox",
                        id: "condo-checkbox",
                        size: "medium",
                        name: "condo",
                        value: "true",
                        defaultChecked: !!condo,
                        onPress: handleCondoChange
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/LotSizeFilter.tsx



var LotSizeOptions = [
    {
        label: "2000 sq ft",
        value: "2000"
    },
    {
        label: "4000 sq ft",
        value: "4000"
    },
    {
        label: "6000 sq ft",
        value: "6000"
    },
    {
        label: "8000 sq ft",
        value: "8000"
    },
    {
        label: "0.25 acres",
        value: "10890"
    },
    {
        label: "0.5 acres",
        value: "21780"
    },
    {
        label: "1 acre",
        value: "43560"
    },
    {
        label: "2 acres+",
        value: "87120"
    }, 
];
var LotSizeFilter = function(param) {
    var minLotSize = param.minLotSize, maxLotSize = param.maxLotSize, handleMinLotSizeChange = param.handleMinLotSizeChange, handleMaxLotSizeChange = param.handleMaxLotSizeChange, handleError = param.handleError, errors = param.errors;
    var onMinLotSizeChange = function(value) {
        if (maxLotSize && parseInt(value, 10) > parseInt(maxLotSize, 10)) {
            handleError("minLotSize", "Min lot size must be less than max lot size");
            return;
        }
        handleError("minLotSize", "");
        handleMinLotSizeChange(value);
    };
    var onMaxLotSizeChange = function(value) {
        if (minLotSize && parseInt(value, 10) < parseInt(minLotSize, 10)) {
            handleError("maxLotSize", "Max lot size must be greater than min lot size");
            return;
        }
        handleError("maxLotSize", "");
        handleMaxLotSizeChange(value);
    };
    var minOptions = filterIntOptions(LotSizeOptions, "lt", maxLotSize !== null && maxLotSize !== void 0 ? maxLotSize : undefined);
    var maxOptions = filterIntOptions(LotSizeOptions, "gt", minLotSize !== null && minLotSize !== void 0 ? minLotSize : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Lot size"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-lot-size-dropdown",
                            options: minOptions,
                            onValueChange: onMinLotSizeChange,
                            size: "small",
                            prefilledValue: minLotSize || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minLotSize"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            "data-testid": "max-lot-size-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxLotSizeChange,
                            size: "small",
                            prefilledValue: maxLotSize || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxLotSize"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/PriceFilter.tsx



var PriceRangeOptions = [
    {
        label: "$100,000",
        value: "10000000"
    },
    {
        label: "$200,000",
        value: "20000000"
    },
    {
        label: "$300,000",
        value: "30000000"
    },
    {
        label: "$400,000",
        value: "40000000"
    },
    {
        label: "$500,000",
        value: "50000000"
    },
    {
        label: "$600,000",
        value: "60000000"
    },
    {
        label: "$700,000",
        value: "70000000"
    },
    {
        label: "$800,000",
        value: "80000000"
    },
    {
        label: "$900,000",
        value: "90000000"
    },
    {
        label: "$1,000,000",
        value: "100000000"
    },
    {
        label: "$1,250,000",
        value: "125000000"
    },
    {
        label: "$1,500,000",
        value: "150000000"
    },
    {
        label: "$1,750,000",
        value: "175000000"
    }, 
];
var PriceFilter = function(param) {
    var minPrice = param.minPrice, maxPrice = param.maxPrice, handleMinPriceChange = param.handleMinPriceChange, handleMaxPriceChange = param.handleMaxPriceChange, handleError = param.handleError, errors = param.errors;
    var onMinPriceChange = function(value) {
        if (maxPrice && parseInt(value, 10) > parseInt(maxPrice, 10)) {
            handleError("minPrice", "Min price must be less than max price");
            return;
        }
        handleError("minPrice", "");
        handleMinPriceChange(value);
    };
    var onMaxPriceChange = function(value) {
        if (minPrice && parseInt(value, 10) < parseInt(minPrice, 10)) {
            handleError("maxPrice", "Max price must be greater than min price");
            return;
        }
        handleError("maxPrice", "");
        handleMaxPriceChange(value);
    };
    var minOptions = filterIntOptions(PriceRangeOptions, "lt", maxPrice !== null && maxPrice !== void 0 ? maxPrice : undefined);
    var maxOptions = filterIntOptions(PriceRangeOptions, "gt", minPrice !== null && minPrice !== void 0 ? minPrice : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Price range"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            id: "price-filter-min",
                            "data-testid": "price-filter-min",
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            options: minOptions,
                            onValueChange: onMinPriceChange,
                            size: "small",
                            prefilledValue: minPrice || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minPrice"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            id: "price-filter-max",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            options: maxOptions.concat({
                                label: "$2,000,000+",
                                value: "500000000"
                            }),
                            onValueChange: onMaxPriceChange,
                            size: "small",
                            prefilledValue: maxPrice || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxPrice"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/SquareFootageFilter.tsx



var SquareFootageOptions = [
    {
        label: "1,000 sq ft",
        value: "1000"
    },
    {
        label: "1,500 sq ft",
        value: "1500"
    },
    {
        label: "2,000 sq ft",
        value: "2000"
    },
    {
        label: "2,500 sq ft",
        value: "2500"
    },
    {
        label: "3,000 sq ft",
        value: "3000"
    },
    {
        label: "3,500 sq ft",
        value: "3500"
    },
    {
        label: "4,000 sq ft",
        value: "4000"
    },
    {
        label: "5,000 sq ft",
        value: "5000"
    }, 
];
var SquareFootageFilter = function(param) {
    var minSquareFootage = param.minSquareFootage, maxSquareFootage = param.maxSquareFootage, handleMinSquareFootageChange = param.handleMinSquareFootageChange, handleMaxSquareFootageChange = param.handleMaxSquareFootageChange, handleError = param.handleError, errors = param.errors;
    var onMinSquareFootageChange = function(value) {
        if (maxSquareFootage && parseInt(value, 10) >= parseInt(maxSquareFootage, 10)) {
            handleError("minSquareFootage", "Min square footage must be less than max square footage");
            return;
        }
        handleError("minSquareFootage", "");
        handleMinSquareFootageChange(value);
    };
    var onMaxSquareFootageChange = function(value) {
        if (minSquareFootage && parseInt(value, 10) < parseInt(minSquareFootage, 10)) {
            handleError("maxSquareFootage", "Max square footage must be greater than min square footage");
            return;
        }
        handleError("maxSquareFootage", "");
        handleMaxSquareFootageChange(value);
    };
    var minOptions = filterIntOptions(SquareFootageOptions, "lt", maxSquareFootage !== null && maxSquareFootage !== void 0 ? maxSquareFootage : undefined);
    var maxOptions = filterIntOptions(SquareFootageOptions, "gt", minSquareFootage !== null && minSquareFootage !== void 0 ? minSquareFootage : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Square feet"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-square-footage-dropdown",
                            options: minOptions,
                            onValueChange: onMinSquareFootageChange,
                            size: "small",
                            prefilledValue: minSquareFootage || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minSquareFootage"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "10000"
                            },
                            "data-testid": "max-square-footage-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxSquareFootageChange,
                            size: "small",
                            prefilledValue: maxSquareFootage || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxSquareFootage"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/YearBuiltFilter.tsx



var YearBuiltOptions = [
    {
        label: "1900",
        value: "1900"
    },
    {
        label: "1920",
        value: "1920"
    },
    {
        label: "1940",
        value: "1940"
    },
    {
        label: "1960",
        value: "1960"
    },
    {
        label: "1980",
        value: "1980"
    },
    {
        label: "2000",
        value: "2000"
    },
    {
        label: "2005",
        value: "2005"
    },
    {
        label: "2010",
        value: "2010"
    },
    {
        label: "2015",
        value: "2015"
    },
    {
        label: "2016",
        value: "2016"
    },
    {
        label: "2017",
        value: "2017"
    },
    {
        label: "2018",
        value: "2018"
    },
    {
        label: "2019",
        value: "2019"
    },
    {
        label: "2020",
        value: "2020"
    },
    {
        label: "2021",
        value: "2021"
    },
    {
        label: "2022",
        value: "2022"
    },
    {
        label: "2023",
        value: "2023"
    },
    {
        label: "2024",
        value: "2024"
    }, 
];
var YearBuiltFilter = function(param) {
    var minYearBuilt = param.minYearBuilt, maxYearBuilt = param.maxYearBuilt, handleMinYearBuiltChange = param.handleMinYearBuiltChange, handleMaxYearBuiltChange = param.handleMaxYearBuiltChange, handleError = param.handleError, errors = param.errors;
    var onMinYearBuildChange = function(value) {
        if (maxYearBuilt && parseInt(value, 10) > parseInt(maxYearBuilt, 10)) {
            handleError("minYearBuilt", "Min year built must be less than max year built");
            return;
        }
        handleError("minYearBuilt", "");
        handleMinYearBuiltChange(value);
    };
    var onMaxPriceChange = function(value) {
        if (minYearBuilt && parseInt(value, 10) < parseInt(minYearBuilt, 10)) {
            handleError("maxYearBuilt", "Max year built must be greater than min year built");
            return;
        }
        handleError("maxYearBuilt", "");
        handleMaxYearBuiltChange(value);
    };
    var minOptions = filterIntOptions(YearBuiltOptions, "lt", maxYearBuilt !== null && maxYearBuilt !== void 0 ? maxYearBuilt : undefined);
    var maxOptions = filterIntOptions(YearBuiltOptions, "gt", minYearBuilt !== null && minYearBuilt !== void 0 ? minYearBuilt : undefined);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        flexDirection: "column",
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                tag: "p",
                typography: "$labelXlarge",
                children: "Year built"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                width: "100%",
                justifyContent: "space-between",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No min",
                                value: "0"
                            },
                            "data-testid": "min-year-built-dropdown",
                            options: minOptions,
                            onValueChange: onMinYearBuildChange,
                            size: "small",
                            prefilledValue: minYearBuilt || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["minYearBuilt"]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: "48%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Dropdown/* Dropdown */.L, {
                            title: " ",
                            placeholderOption: {
                                label: "No max",
                                value: "500000000"
                            },
                            "data-testid": "max-year-built-dropdown",
                            options: maxOptions,
                            onValueChange: onMaxPriceChange,
                            size: "small",
                            prefilledValue: maxYearBuilt || undefined,
                            errorText: errors === null || errors === void 0 ? void 0 : errors["maxYearBuilt"]
                        })
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/SearchFilters.tsx









var SearchFilters = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceFilter, {
                minPrice: props === null || props === void 0 ? void 0 : props.minPrice,
                maxPrice: props === null || props === void 0 ? void 0 : props.maxPrice,
                handleMinPriceChange: props.handleMinPriceChange,
                handleMaxPriceChange: props.handleMaxPriceChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BedroomsBathroomsFilter, {
                minBaths: props === null || props === void 0 ? void 0 : props.minBaths,
                minBeds: props === null || props === void 0 ? void 0 : props.minBeds,
                handleMinBathsChange: props.handleMinBathsChange,
                handleMinBedsChange: props.handleMinBedsChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeTypeFilter, {
                singleFamily: props === null || props === void 0 ? void 0 : props.singleFamily,
                condo: props === null || props === void 0 ? void 0 : props.condo,
                townhome: props === null || props === void 0 ? void 0 : props.townhome,
                handleSingleFamilyChange: props.handleSingleFamilyChange,
                handleCondoChange: props.handleCondoChange,
                handleTownhomeChange: props.handleTownhomeChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HomeFeaturesFilter, {
                noHoas: props === null || props === void 0 ? void 0 : props.noHoas,
                singleStory: props === null || props === void 0 ? void 0 : props.singleStory,
                fhaEligible: props === null || props === void 0 ? void 0 : props.fhaEligible,
                mustHavePool: props === null || props === void 0 ? void 0 : props.mustHavePool,
                handleNoHoasChange: props.handleNoHoasChange,
                handleSingleStoryChange: props.handleSingleStoryChange,
                handleFhaEligibleChange: props.handleFhaEligibleChange,
                handlePoolChange: props.handlePoolChange
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(YearBuiltFilter, {
                minYearBuilt: props === null || props === void 0 ? void 0 : props.minYearBuilt,
                maxYearBuilt: props === null || props === void 0 ? void 0 : props.maxYearBuilt,
                handleMinYearBuiltChange: props.handleMinYearBuiltChange,
                handleMaxYearBuiltChange: props.handleMaxYearBuiltChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SquareFootageFilter, {
                minSquareFootage: props === null || props === void 0 ? void 0 : props.minSquareFootage,
                maxSquareFootage: props === null || props === void 0 ? void 0 : props.maxSquareFootage,
                handleMinSquareFootageChange: props.handleMinSquareFootageChange,
                handleMaxSquareFootageChange: props.handleMaxSquareFootageChange,
                handleError: props.handleError,
                errors: props.errors
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Divider/* Divider */.i, {
                my: "$15x"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LotSizeFilter, {
                minLotSize: props === null || props === void 0 ? void 0 : props.minLotSize,
                maxLotSize: props === null || props === void 0 ? void 0 : props.maxLotSize,
                handleMinLotSizeChange: props.handleMinLotSizeChange,
                handleMaxLotSizeChange: props.handleMaxLotSizeChange,
                handleError: props.handleError,
                errors: props.errors
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/map/SearchFilters.tsx









var MapSearchFilters = function(props) {
    // Dropdown in bricks-next only reads prefilledValue on mount (uncontrolled).
    // We use a key to force re-render when filters reset OR when QuickFilters
    // updates bed/bath values externally.
    var ref = (0,react.useState)(0), resetFiltersKey = ref[0], setResetFiltersKey = ref[1];
    var handleResetFilters = function() {
        var ref;
        setResetFiltersKey(function(prev) {
            return prev + 1;
        });
        (ref = props.onResetFilters) === null || ref === void 0 ? void 0 : ref.call(props);
    };
    var searchDisabled = (props === null || props === void 0 ? void 0 : props.errors) ? Object.keys(props.errors).length > 0 : false;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
        width: "100%",
        flexDirection: "column",
        height: "100%",
        backgroundColor: "$backgroundPrimary",
        style: {
            overflowY: "scroll",
            overflowX: "hidden"
        },
        "data-testid": "map-search-filters",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "baseline",
                my: 12,
                mx: 36,
                $smallerThanLG: {
                    mx: 12
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$labelLarge",
                        mb: 24,
                        $largerThanMD: {
                            display: "none"
                        },
                        children: "Filters"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(IconButton/* CloseButton */.PZ, {
                        analyticsName: "close-property-search-filters",
                        "data-testid": "close-property-search-filters",
                        onPress: props.onClose,
                        size: "large",
                        variant: "default",
                        p: 10,
                        $largerThanMD: {
                            p: 0,
                            ml: -10
                        }
                    })
                ]
            }),
            props.onApplySavedSearch && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                mx: 36,
                mb: 12,
                $smallerThanLG: {
                    mx: 24
                },
                alignItems: "flex-start",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SavedSearchesDropdown, {
                    onApplySavedSearch: props.onApplySavedSearch
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                mt: 24,
                mb: 12,
                mx: 36,
                $smallerThanLG: {
                    mx: 24
                },
                children: /*#__PURE__*/ (0,react.createElement)(SearchFilters, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                    key: "".concat(resetFiltersKey, "-").concat(props.minBeds, "-").concat(props.minBaths)
                }))
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                flexDirection: "row",
                justifyContent: "flex-end",
                alignItems: "center",
                $smallerThanMD: {
                    justifyContent: "space-between",
                    px: 16,
                    flexWrap: "wrap"
                },
                backgroundColor: "$backgroundPrimary",
                bottom: 0,
                gap: 8,
                width: "100%",
                px: 24,
                py: 12,
                zIndex: 1,
                style: {
                    position: "sticky"
                },
                children: [
                    props.saveSearchQuery && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(SaveSearchButton, {
                        query: props.saveSearchQuery,
                        variant: "secondary"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "property-search-filters-reset",
                        label: "Reset filters",
                        onPress: handleResetFilters,
                        size: "medium",
                        variant: "secondary",
                        minWidth: 150,
                        $smallerThanMD: {
                            size: "small",
                            minWidth: 0,
                            flex: 1
                        }
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                        analyticsName: "property-search-filters",
                        label: "Search",
                        onPress: props.onApplyFilters,
                        size: "medium",
                        variant: "primary",
                        loading: props.isLoading,
                        minWidth: 150,
                        $smallerThanMD: {
                            size: "small",
                            minWidth: 0,
                            flexBasis: "100%",
                            flexGrow: 1
                        },
                        disabled: searchDisabled
                    })
                ]
            })
        ]
    });
};

// EXTERNAL MODULE: ./src/components/marketplace/map/utils.ts
var utils = __webpack_require__(41777);
// EXTERNAL MODULE: ../../node_modules/.pnpm/next@12.3.4_@babel+core@7.29.0_@types+react-dom@18.3.7_@types+react@18.3.28__@types+rea_8a835da27f6bd732d06ca598c0c17f05/node_modules/next/head.js
var head = __webpack_require__(62071);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/helpers/globals.ts
var helpers_globals = __webpack_require__(89060);
;// CONCATENATED MODULE: ./src/components/marketplace/MarketplaceSeoHead.tsx



var HUB_CANONICAL = "/homes";
var MarketplaceSeoHead = function(param) {
    var marketInfo = param.marketInfo, activeMarkets = param.activeMarkets, canonicalOverride = param.canonicalOverride;
    var isHubPage = canonicalOverride === HUB_CANONICAL;
    var marketDisplayName = marketInfo.displayName || marketInfo.name;
    var currentMarket = activeMarkets.find(function(m) {
        return m.identifier === marketInfo.identifier || m.displayName === marketDisplayName;
    });
    var stateAbbreviation = (currentMarket === null || currentMarket === void 0 ? void 0 : currentMarket.displayState) || "";
    var locationText = stateAbbreviation ? "".concat(marketDisplayName, ", ").concat(stateAbbreviation) : marketDisplayName;
    var pageTitle = "Houses for sale in ".concat(marketDisplayName, " | Opendoor");
    var pageDescription = "Explore houses for sale in ".concat(locationText, " with Opendoor. Get instant access to listings, photos, and home details, and schedule self-guided tours today.");
    var marketListSchema;
    if (isHubPage) {
        pageTitle = "Homes for Sale | Browse All Markets | Opendoor";
        pageDescription = "Explore homes for sale across 50+ US markets with Opendoor. Browse listings, view photos, and home details, and schedule self-guided tours today.";
        marketListSchema = {
            "@context": "https://schema.org",
            "@type": "ItemList",
            name: "Opendoor Markets",
            numberOfItems: activeMarkets.length,
            itemListElement: activeMarkets.map(function(market, idx) {
                return {
                    "@type": "ListItem",
                    position: idx + 1,
                    item: {
                        "@type": "WebPage",
                        name: "Homes for sale in ".concat(market.displayName),
                        url: "".concat(helpers_globals/* HOMEPAGE_URL */.j_).concat(market.homesPath)
                    }
                };
            })
        };
    }
    var canonicalPath = canonicalOverride !== null && canonicalOverride !== void 0 ? canonicalOverride : "/homes/".concat(marketInfo.name.toLowerCase());
    var canonicalUrl = "".concat(helpers_globals/* HOMEPAGE_URL */.j_).concat(canonicalPath);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)((head_default()), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("title", {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                name: "description",
                content: pageDescription
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("link", {
                rel: "canonical",
                href: canonicalUrl
            }),
            isHubPage && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:title",
                        content: pageTitle
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:description",
                        content: pageDescription
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:url",
                        content: canonicalUrl
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("meta", {
                        property: "og:site_name",
                        content: "Opendoor"
                    })
                ]
            }),
            marketListSchema && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("script", {
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(marketListSchema)
                }
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/marketplace/search/filterHelpers.ts
/**
 * Type conversion helpers for filter components.
 *
 * Filter UI components expect string props (for form inputs),
 * but state/SSR data uses numbers. These helpers formalize
 * the conversion at the component boundary.
 */ /**
 * Converts a number to a string for filter component props.
 * Coalesces undef/null to null.
 */ var toFilterString = function(val) {
    return val != null ? String(val) : null;
};
/**
 * Converts a price in dollars to a display string (cents * 100).
 * Filter components display prices in cents for formatting.
 * Coalesces undef/null to null.
 */ var dollarToCentsString = function(dollars) {
    return dollars != null ? String(dollars * 100) : null;
};

// EXTERNAL MODULE: ./src/components/properties/shared/MarketplaceMapLayout.tsx
var MarketplaceMapLayout = __webpack_require__(35344);
;// CONCATENATED MODULE: ../../node_modules/.pnpm/use-debounce@10.1.1_@types+react@18.3.28_react@18.3.1/node_modules/use-debounce/dist/index.module.js
function c(e,u,c,i){var l=this,a=(0,react.useRef)(null),o=(0,react.useRef)(0),f=(0,react.useRef)(0),v=(0,react.useRef)(null),d=(0,react.useRef)([]),s=(0,react.useRef)(),m=(0,react.useRef)(),h=(0,react.useRef)(e),g=(0,react.useRef)(!0),x=(0,react.useRef)(),E=(0,react.useRef)();h.current=e;var b="undefined"!=typeof window,p=!u&&0!==u&&b;if("function"!=typeof e)throw new TypeError("Expected a function");u=+u||0;var y=!!(c=c||{}).leading,w=!("trailing"in c)||!!c.trailing,T=!!c.flushOnExit&&w,O="maxWait"in c,F="debounceOnServer"in c&&!!c.debounceOnServer,L=O?Math.max(+c.maxWait||0,u):null,A=(0,react.useMemo)(function(){var r=function(r){var n=d.current,t=s.current;return d.current=s.current=null,o.current=r,f.current=f.current||r,m.current=h.current.apply(t,n)},n=function(r,n){p&&cancelAnimationFrame(v.current),v.current=p?requestAnimationFrame(r):setTimeout(r,n)},t=function(r){if(!g.current)return!1;var n=r-a.current;return!a.current||n>=u||n<0||O&&r-o.current>=L},e=function(n){return v.current=null,w&&d.current?r(n):(d.current=s.current=null,m.current)},c=function r(){var c=Date.now();if(y&&f.current===o.current&&A(),t(c))return e(c);if(g.current){var i=u-(c-a.current),l=O?Math.min(i,L-(c-o.current)):i;n(r,l)}},A=function(){i&&i({})},D=function(){if(b||F){var e,i=Date.now(),f=t(i);if(d.current=[].slice.call(arguments),s.current=l,a.current=i,T&&!x.current&&(x.current=function(){var r;"hidden"===(null==(r=globalThis.document)?void 0:r.visibilityState)&&E.current.flush()},null==(e=globalThis.document)||null==e.addEventListener||e.addEventListener("visibilitychange",x.current)),f){if(!v.current&&g.current)return o.current=a.current,n(c,u),y?r(a.current):m.current;if(O)return n(c,u),r(a.current)}return v.current||n(c,u),m.current}};return D.cancel=function(){var r=v.current;r&&(p?cancelAnimationFrame(v.current):clearTimeout(v.current)),o.current=0,d.current=a.current=s.current=v.current=null,r&&i&&i({})},D.isPending=function(){return!!v.current},D.flush=function(){return v.current?e(Date.now()):m.current},D},[y,O,u,L,w,T,p,b,F,i]);return E.current=A,(0,react.useEffect)(function(){return g.current=!0,function(){var r;T&&E.current.flush(),x.current&&(null==(r=globalThis.document)||null==r.removeEventListener||r.removeEventListener("visibilitychange",x.current),x.current=null),g.current=!1}},[T]),A}function i(r,n){return r===n}function l(n,t,l){var a=l&&l.equalityFn||i,o=r(n),f=e({})[1],v=c(u(function(r){o.current=r,f({})},[f]),t,l,f),d=r(n);return a(d.current,n)||(v(n),d.current=n),[o.current,v]}function a(r,n,t){var e=void 0===t?{}:t,u=e.leading,i=e.trailing,l=e.flushOnExit;return c(r,n,{maxWait:n,leading:void 0===u||u,trailing:void 0===i||i,flushOnExit:void 0!==l&&l})}
//# sourceMappingURL=index.module.js.map

;// CONCATENATED MODULE: ./src/pages/homes/[market].tsx































var Page = function(param) {
    var propertyList = param.propertyList, propertySearch = param.propertySearch, marketInfo = param.marketInfo, queryParams = param.queryParams, activeMarkets = param.activeMarkets, header = param.header, footer = param.footer, canonicalOverride = param.canonicalOverride;
    var ref = (0,AuthContext/* useAuth */.aC)(), authentication = ref.authentication, user = ref.user;
    var trackJourneyEvent = (0,observability/* useObservability */.C3)().trackJourneyEvent;
    var isLoggedIn = (authentication === null || authentication === void 0 ? void 0 : authentication.state) === "authenticated";
    var ref1 = useMapRefs(), smallMap = ref1.smallMap, mediumMap = ref1.mediumMap, largeMap = ref1.largeMap;
    var searchState = useSearchState(queryParams);
    // The marketplace search session: result set, loading flag, the location the
    // next search runs against, and the semantic search verbs the handlers call.
    var ref2 = useMarketplaceSearchController({
        initialSearch: propertySearch,
        initialList: propertyList,
        searchState: searchState,
        marketInfo: marketInfo
    }), propertySearchData = ref2.propertySearchData, propertyListData = ref2.propertyListData, isLoading = ref2.isLoading, setIsLoading = ref2.setIsLoading, hasError = ref2.hasError, clearError = ref2.clearError, setVertices = ref2.setVertices, selectedLocation = ref2.selectedLocation, setSelectedLocation = ref2.setSelectedLocation, selectedAddress = ref2.selectedAddress, setSelectedAddress = ref2.setSelectedAddress, applyFilters = ref2.applyFilters, applyViewport = ref2.applyViewport, loadMore = ref2.loadMore, applySavedSearch = ref2.applySavedSearch, getSaveSearchQuery = ref2.getSaveSearchQuery;
    var _get = searchState.get, minBeds = _get.minBeds, minBaths = _get.minBaths, canSelfTour = _get.canSelfTour, minPrice = _get.minPrice, maxPrice = _get.maxPrice, singleFamily = _get.singleFamily, condo = _get.condo, townhome = _get.townhome, noHoas = _get.noHoas, singleStory = _get.singleStory, mustHavePool = _get.mustHavePool, minYearBuilt = _get.minYearBuilt, maxYearBuilt = _get.maxYearBuilt, minLotSize = _get.minLotSize, maxLotSize = _get.maxLotSize, minSquareFootage = _get.minSquareFootage, maxSquareFootage = _get.maxSquareFootage;
    // UX states
    var ref3 = (0,react.useState)(), errors = ref3[0], setErrors = ref3[1];
    var ref4 = (0,react.useState)(false), showList = ref4[0], setShowList = ref4[1];
    var ref5 = (0,react.useState)(false), showFilters = ref5[0], setShowFilters = ref5[1];
    var ref6 = (0,react.useState)(false), showPdp = ref6[0], setShowPdp = ref6[1];
    var ref7 = (0,react.useState)(), propertyReactions = ref7[0], setPropertyReactions = ref7[1];
    var ref8 = (0,react.useState)(FloatingNavigationBar/* ActiveTab.Browse */.w.Browse), activeTab = ref8[0], setActiveTab = ref8[1];
    // Map marker information
    var ref9 = (0,react.useState)(null), topMarker = ref9[0], setTopMarker = ref9[1];
    var ref10 = (0,react.useState)(null), loadingAddressToken = ref10[0], setLoadingAddressToken = ref10[1];
    // Individual property details
    var ref11 = (0,react.useState)(), propertyDetails = ref11[0], setPropertyDetails = ref11[1];
    var ref12 = (0,helpers/* usePropertyReactions */.O8)(propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken, "REACTION_SOURCE_GALLERY"), isLiked = ref12.isLiked, onClickReaction = ref12.onClickReaction;
    var handleFetchPropertyDetails = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(addressToken) {
            var ref, result, urlParams;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        setLoadingAddressToken(addressToken);
                        return [
                            4,
                            (0,api/* getAthenaClient */.k8)().GetMarketplacePropertyCoreDetails({
                                addressToken: addressToken
                            })
                        ];
                    case 1:
                        result = _state.sent();
                        setPropertyDetails((ref = result.marketplace) === null || ref === void 0 ? void 0 : ref.property);
                        setShowFilters(false);
                        setShowPdp(true);
                        setLoadingAddressToken(null);
                        urlParams = buildAddressPreviewParams(addressToken);
                        window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
                        return [
                            2
                        ];
                }
            });
        });
        return function(addressToken) {
            return _ref.apply(this, arguments);
        };
    }(), []);
    (0,react.useEffect)(function() {
        if (queryParams === null || queryParams === void 0 ? void 0 : queryParams.preview_aid) {
            handleFetchPropertyDetails(queryParams.preview_aid);
        }
    }, [
        queryParams === null || queryParams === void 0 ? void 0 : queryParams.preview_aid
    ]);
    var flyTo = function(location) {
        var zoom = getZoomForLocationType(location.zoneType);
        [
            smallMap,
            mediumMap,
            largeMap
        ].forEach(function(map) {
            var ref;
            (ref = map.current) === null || ref === void 0 ? void 0 : ref.flyTo({
                center: location.coordinates,
                zoom: zoom
            });
        });
    };
    var mapMarkers = (0,react.useMemo)(function() {
        var ref, ref1, ref2;
        setTopMarker(null);
        var selectedAddressToken = propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken;
        var ref3, ref4;
        var markers = (ref2 = (ref1 = propertySearchData === null || propertySearchData === void 0 ? void 0 : (ref = propertySearchData.results) === null || ref === void 0 ? void 0 : ref.slice().sort(function(a, b) {
            var ref, ref1;
            return ((ref3 = (ref = b.location) === null || ref === void 0 ? void 0 : ref.lat) !== null && ref3 !== void 0 ? ref3 : 0) - ((ref4 = (ref1 = a.location) === null || ref1 === void 0 ? void 0 : ref1.lat) !== null && ref4 !== void 0 ? ref4 : 0);
        })) === null || ref1 === void 0 ? void 0 : ref1.map(function(p) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMapMarker, {
                property: p,
                topMarker: topMarker,
                handleFetchPropertyDetails: handleFetchPropertyDetails,
                setTopMarker: setTopMarker,
                propertyReactions: propertyReactions,
                isSelected: p.addressToken === selectedAddressToken,
                isLoading: p.addressToken === loadingAddressToken
            }, p.id);
        })) === null || ref2 === void 0 ? void 0 : ref2.filter(Boolean);
        return markers !== null && markers !== void 0 ? markers : [];
    }, [
        propertySearchData,
        propertyReactions,
        propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken,
        loadingAddressToken
    ]);
    var handleError = function(key, val) {
        if (val === "") {
            return setErrors(function(prev) {
                if (prev && prev[key]) {
                    delete prev[key];
                    return (0,_object_spread/* default */.Z)({}, prev);
                }
                return;
            });
        }
        return setErrors(function(prev) {
            return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prev), (0,_define_property/* default */.Z)({}, key, val));
        });
    };
    var getReactions = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var ref, ref1, ref2, ref3, reactions, reducedReactions;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(isLoggedIn && (user === null || user === void 0 ? void 0 : user.customerUuid))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            (0,api/* getAthenaClient */.k8)().GetBuyerPropertyReactions({
                                customerId: user.customerUuid
                            })
                        ];
                    case 1:
                        reactions = _state.sent();
                        reducedReactions = reactions === null || reactions === void 0 ? void 0 : (ref = reactions.buyerService) === null || ref === void 0 ? void 0 : (ref1 = ref.getBuyer) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.buyer) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.reactions) === null || ref3 === void 0 ? void 0 : ref3.reduce(function(reactions, reaction) {
                            reactions[reaction.addressId] = reaction.reaction;
                            return reactions;
                        }, {});
                        setPropertyReactions(reducedReactions);
                        _state.label = 2;
                    case 2:
                        return [
                            2
                        ];
                }
            });
        });
        return function getReactions() {
            return _ref.apply(this, arguments);
        };
    }();
    (0,react.useEffect)(function() {
        if ((marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.identifier) && !canonicalOverride) {
            var urlParams = buildQueryParams(queryParams);
            window.history.pushState({}, "", "/homes/".concat(marketInfo.identifier, "?").concat(urlParams));
        }
    }, []);
    (0,react.useEffect)(function() {
        getReactions();
    }, [
        isLoggedIn
    ]);
    (0,react.useEffect)(function() {
        window.addEventListener("propertyReactionEvent", getReactions);
        return function() {
            return window.removeEventListener("propertyReactionEvent", getReactions);
        };
    }, []);
    // Track property view events
    (0,react.useEffect)(function() {
        if (showPdp && propertyDetails) {
            trackJourneyEvent("marketplaceProperty", "detailPageView", {
                addressUuid: propertyDetails === null || propertyDetails === void 0 ? void 0 : propertyDetails.addressToken
            });
        }
    }, [
        showPdp,
        propertyDetails
    ]);
    // Close the PDP (if open) when a user taps on the browser's back button
    (0,react.useEffect)(function() {
        var handleBackButton = function() {
            hidePropertyDetails();
            var urlParams = removeAddressPreviewParams();
            window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
        };
        window.addEventListener("popstate", handleBackButton);
        return function() {
            return window.removeEventListener("popstate", handleBackButton);
        };
    }, []);
    // Smaller filter menu on desktop that allows for immediate querying
    var handleQuickFilterChange = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(bedrooms, bathrooms) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        handleSetBedrooms(bedrooms);
                        handleSetBathrooms(bathrooms);
                        return [
                            4,
                            applyFilters({
                                bedrooms: Number(bedrooms),
                                bathrooms: Number(bathrooms)
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        });
        return function handleQuickFilterChange(bedrooms, bathrooms) {
            return _ref.apply(this, arguments);
        };
    }();
    // Mobile filter menu CTA click handler to trigger a search, close the filter
    // menu, and fly to the selected location.
    var handleMobileFilterClick = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (selectedLocation) {
                            flyTo(selectedLocation);
                        }
                        return [
                            4,
                            applyFilters()
                        ];
                    case 1:
                        _state.sent();
                        setShowFilters(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function handleMobileFilterClick() {
            return _ref.apply(this, arguments);
        };
    }();
    // Desktop full-filter "Search" CTA. Wraps `applyFilters` so the press event
    // isn't forwarded as a filter override.
    var handleApplyFilters = (0,react.useCallback)(function() {
        void applyFilters();
    }, [
        applyFilters
    ]);
    var handleCloseFilters = (0,react.useCallback)(function() {
        setShowFilters(false);
    }, []);
    var setSearchAreaFromMapBounds = (0,react.useCallback)(function(map) {
        return applyViewport((0,utils/* getShapeFromMap */.a)(map));
    }, [
        applyViewport
    ]);
    var hidePropertyDetails = (0,react.useCallback)(function() {
        setShowPdp(false);
    }, []);
    var closePropertyDetails = (0,react.useCallback)(function() {
        setShowPdp(false);
        setPropertyDetails(null);
        var urlParams = removeAddressPreviewParams();
        window.history.replaceState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
    }, []);
    var debouncedSetSearchAreaFromViewport = c(setSearchAreaFromMapBounds, 200);
    var handleOnMoveEnd = (0,react.useCallback)(function(e) {
        debouncedSetSearchAreaFromViewport(e.target);
    }, [
        debouncedSetSearchAreaFromViewport
    ]);
    var handleSetBedrooms = function(value) {
        return searchState.set.setBedrooms(Number(value));
    };
    var handleSetBathrooms = function(value) {
        return searchState.set.setBathrooms(Number(value));
    };
    var handleSetCanSelfTour = function(value) {
        return searchState.set.setCanSelfTour(value === "true");
    };
    var handleMinPriceChange = function(minPrice) {
        return searchState.set.setMinPrice(Number(minPrice) / 100);
    };
    var handleMaxPriceChange = function(maxPrice) {
        return searchState.set.setMaxPrice(Number(maxPrice) / 100);
    };
    var handleSingleFamilyChange = function(_, checked) {
        return searchState.set.setSingleFamily(!!checked);
    };
    var handleCondoChange = function(_, checked) {
        return searchState.set.setCondo(!!checked);
    };
    var handleTownhomeChange = function(_, checked) {
        return searchState.set.setTownhome(!!checked);
    };
    var handleNoHoasChange = function(_, checked) {
        return searchState.set.setNoHoas(!!checked);
    };
    var handleSingleStoryChange = function(_, checked) {
        return searchState.set.setSingleStory(!!checked);
    };
    var handlePoolChange = function(_, checked) {
        return searchState.set.setMustHavePool(!!checked);
    };
    var handleMinYearBuiltChange = function(minYearBuilt) {
        return searchState.set.setMinYearBuilt(Number(minYearBuilt));
    };
    var handleMaxYearBuiltChange = function(maxYearBuilt) {
        return searchState.set.setMaxYearBuilt(Number(maxYearBuilt));
    };
    var handleMinLotSizeChange = function(minLotSize) {
        return searchState.set.setMinLotSize(Number(minLotSize));
    };
    var handleMaxLotSizeChange = function(maxLotSize) {
        return searchState.set.setMaxLotSize(Number(maxLotSize));
    };
    var handleMinSquareFootageChange = function(min) {
        return searchState.set.setMinSquareFootage(Number(min));
    };
    var handleMaxSquareFootageChange = function(max) {
        return searchState.set.setMaxSquareFootage(Number(max));
    };
    var handleShowList = function() {
        setShowList(true);
    };
    var handleShowMap = function() {
        return setShowList(false);
    };
    var onFiltersButtonClick = function() {
        setPropertyDetails(null);
        closePropertyDetails();
        setShowList(false);
        setShowPdp(false);
        setShowFilters(true);
    };
    var handleSetSelectedLocation = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(location) {
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!location) {
                    setSelectedLocation(undefined);
                    return [
                        2
                    ];
                }
                setIsLoading(true);
                setSelectedLocation(location);
                setVertices([]);
                setIsMobileHeaderFocused(false);
                flyTo(location);
                window.history.pushState({}, "", "/homes/zid_".concat(location.value));
                return [
                    2
                ];
            });
        });
        return function handleSetSelectedLocation(location) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleSetSelectedAddress = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(address) {
            var urlParams;
            return (0,tslib_es6.__generator)(this, function(_state) {
                if (!address) {
                    setSelectedAddress(undefined);
                    return [
                        2
                    ];
                }
                setSelectedAddress(address);
                handleFetchPropertyDetails(address.addressToken);
                setIsMobileHeaderFocused(false);
                urlParams = buildAddressPreviewParams(address.addressToken);
                window.history.pushState({}, "", "".concat(window.location.pathname, "?").concat(urlParams));
                return [
                    2
                ];
            });
        });
        return function handleSetSelectedAddress(address) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleOnMobileFilterClick = function() {
        setShowList(false);
        setShowPdp(false);
        setShowFilters(true);
    };
    var ref13 = (0,react.useState)(false), isMobileHeaderFocused = ref13[0], setIsMobileHeaderFocused = ref13[1];
    var handleOnMobileHeaderFocus = function() {
        setIsMobileHeaderFocused(true);
    };
    var handleOnMobileHeaderBlur = function() {
        setIsMobileHeaderFocused(false);
    };
    var handleOnViewFavorites = function() {
        setActiveTab(FloatingNavigationBar/* ActiveTab.Favorites */.w.Favorites);
        window.location.assign("/favorites");
    };
    var RenderBody = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(MarketplaceMapLayout/* default */.Z, {
        header: header,
        footer: footer !== null && footer !== void 0 ? footer : undefined,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                $smallerThanMD: {
                    flexDirection: "column"
                },
                $largerThanSM: {
                    flexDirection: "row"
                },
                overflow: "hidden",
                height: "100%",
                width: "100%",
                backgroundColor: "$backgroundPrimary",
                position: "relative",
                borderTopWidth: "$1x",
                borderTopColor: "$borderPrimary",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        width: isMobileHeaderFocused ? "95%" : "calc(100% - 200px)",
                        height: 60,
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        top: 5,
                        zIndex: 8000,
                        left: isMobileHeaderFocused ? 10 : 55,
                        onBlur: handleOnMobileHeaderBlur,
                        onFocus: handleOnMobileHeaderFocus,
                        style: {
                            position: "fixed",
                            transition: "width 0.25s, left 0.25s"
                        },
                        $largerThanSM: {
                            display: "none"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                            width: "100%",
                            flexDirection: "column",
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileHeaderFilters, {
                                isFocused: isMobileHeaderFocused,
                                setSelectedAddress: handleSetSelectedAddress,
                                selectedAddress: selectedAddress,
                                setSelectedLocation: handleSetSelectedLocation,
                                selectedLocation: selectedLocation,
                                onBack: handleOnMobileHeaderBlur,
                                onOpenFilters: handleOnMobileFilterClick
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100vh",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        "aria-hidden": showList || showFilters,
                        opacity: showList || showFilters ? 0 : 1,
                        style: {
                            transition: showList || showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showList || showFilters ? "hidden" : "visible"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                                mapRef: smallMap,
                                handleOnClick: closePropertyDetails,
                                handleOnMoveEnd: handleOnMoveEnd,
                                marketShape: marketInfo.shape,
                                mapMarkers: mapMarkers
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                bottom: 80,
                                width: 80,
                                marginHorizontal: "auto",
                                padding: 6,
                                analyticsName: "list-view",
                                label: "List",
                                "data-testid": "mobile-list-view",
                                onPress: handleShowList,
                                size: "small",
                                variant: "secondaryInverse",
                                mb: 30,
                                display: showList ? "none" : "flex",
                                style: {
                                    position: "fixed"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanMD: {
                            display: "none"
                        },
                        $largerThanMD: {
                            display: "none"
                        },
                        flexBasis: "50%",
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        "aria-hidden": showFilters,
                        opacity: showFilters ? 0 : 1,
                        style: {
                            transition: showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showFilters ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                            mapRef: mediumMap,
                            handleOnClick: closePropertyDetails,
                            handleOnMoveEnd: handleOnMoveEnd,
                            marketShape: marketInfo.shape,
                            mapMarkers: mapMarkers
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $smallerThanLG: {
                            display: "none"
                        },
                        flexBasis: "50%",
                        flex: 1,
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        touchAction: "none",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceMap/* MarketplaceMap */.q, {
                            mapRef: largeMap,
                            handleOnClick: closePropertyDetails,
                            handleOnMoveEnd: handleOnMoveEnd,
                            marketShape: marketInfo.shape,
                            mapMarkers: mapMarkers
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        id: "small-property-list",
                        $largerThanSM: {
                            display: "none"
                        },
                        alignItems: "center",
                        position: "absolute",
                        height: "100%",
                        width: "100%",
                        zIndex: 3,
                        px: 20,
                        backgroundColor: "$backgroundPrimary",
                        "aria-hidden": !showList,
                        opacity: showList ? 1 : 0,
                        style: {
                            overflowY: "scroll",
                            transition: showList ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showList ? "visible" : "hidden",
                            transform: showList ? "" : "translateY(100vh)"
                        },
                        marginHorizontal: "auto",
                        pb: 130,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                width: "100%",
                                px: 24,
                                height: "100%",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    flexWrap: "wrap",
                                    justifyContent: "space-between",
                                    flexDirection: "column",
                                    pb: 52,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$bodySmall",
                                            my: 24,
                                            children: [
                                                propertySearchData === null || propertySearchData === void 0 ? void 0 : propertySearchData.count,
                                                " homes"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyList, {
                                            isLoading: isLoading,
                                            handleOnSeeMore: loadMore,
                                            propertyListData: propertyListData
                                        }),
                                        activeMarkets && activeMarkets.length > 0 && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            mt: 48,
                                            mb: 110,
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                    tag: "p",
                                                    typography: "$bodyMedium",
                                                    mb: 24,
                                                    fontWeight: "$medium",
                                                    children: "Popular Markets"
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                                    style: {
                                                        display: "grid",
                                                        gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                                                        gap: "16px"
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                            href: "/homes-for-sale-near-me",
                                                            display: "block",
                                                            analyticsName: "market-link-near-me",
                                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                                tag: "p",
                                                                typography: "$bodyMedium",
                                                                color: "$contentSecondary",
                                                                children: "Homes for sale near me"
                                                            })
                                                        }),
                                                        activeMarkets.map(function(market) {
                                                            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                                href: "/homes/".concat(market.identifier),
                                                                display: "block",
                                                                analyticsName: "market-link-".concat(market.identifier),
                                                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                                    tag: "p",
                                                                    typography: "$bodyMedium",
                                                                    color: "$contentSecondary",
                                                                    children: [
                                                                        "Houses for sale in ",
                                                                        market.displayName
                                                                    ]
                                                                })
                                                            }, market.identifier);
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Button/* Button */.z, {
                                bottom: 80,
                                width: 80,
                                marginHorizontal: "auto",
                                padding: 6,
                                display: showList ? "flex" : "none",
                                analyticsName: "list-view",
                                "data-testid": "mobile-map-view",
                                alignSelf: "center",
                                label: "Map",
                                onPress: handleShowMap,
                                size: "small",
                                variant: "secondaryInverse",
                                mb: 30,
                                style: {
                                    position: "fixed"
                                }
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "property-list-container",
                        flexDirection: "column",
                        $smallerThanMD: {
                            display: "none"
                        },
                        backgroundColor: "$backgroundPrimary",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        flexBasis: "50%",
                        position: "relative",
                        "aria-hidden": showPdp || showFilters,
                        opacity: showPdp || showFilters ? 0 : 1,
                        style: {
                            transition: showPdp || showFilters ? "opacity 0.5s, visibility 0.5s" : "opacity 0.5s",
                            visibility: showPdp || showFilters ? "hidden" : "visible"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                            height: "100%",
                            px: 48,
                            pt: 12,
                            display: "flex",
                            width: "100%",
                            zIndex: 1,
                            "data-testid": "desktop-property-list",
                            style: {
                                overflowY: "scroll"
                            },
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(QuickFilters, {
                                    bedrooms: String(minBeds),
                                    bathrooms: String(minBaths),
                                    selectedAddress: selectedAddress,
                                    setSelectedAddress: handleSetSelectedAddress,
                                    setSelectedLocation: handleSetSelectedLocation,
                                    selectedLocation: selectedLocation,
                                    onFilterChange: handleQuickFilterChange,
                                    isLoadingFilter: isLoading,
                                    onFiltersButtonClick: onFiltersButtonClick,
                                    isFocused: isMobileHeaderFocused,
                                    onApplySavedSearch: applySavedSearch
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                    tag: "p",
                                    typography: "$bodySmall",
                                    mb: 24,
                                    children: [
                                        propertySearchData === null || propertySearchData === void 0 ? void 0 : propertySearchData.count,
                                        " homes for sale near",
                                        " ",
                                        (selectedLocation === null || selectedLocation === void 0 ? void 0 : selectedLocation.label) || (marketInfo === null || marketInfo === void 0 ? void 0 : marketInfo.displayName) || "you"
                                    ]
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PropertyList, {
                                    isLoading: isLoading,
                                    handleOnSeeMore: loadMore,
                                    propertyListData: propertyListData
                                }),
                                activeMarkets && activeMarkets.length > 0 && !isLoading && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                    mt: 48,
                                    mb: 100,
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                            tag: "p",
                                            typography: "$bodyMedium",
                                            mb: 24,
                                            fontWeight: "$medium",
                                            children: "Popular Markets"
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                                            style: {
                                                display: "grid",
                                                gridTemplateColumns: "repeat(auto-fill, minmax(250px, 1fr))",
                                                gap: "16px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                    href: "/homes-for-sale-near-me",
                                                    display: "block",
                                                    analyticsName: "market-link-near-me",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                                        tag: "p",
                                                        typography: "$bodyMedium",
                                                        color: "$contentSecondary",
                                                        children: "Homes for sale near me"
                                                    })
                                                }),
                                                activeMarkets.map(function(market) {
                                                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Link/* Link */.r, {
                                                        href: "/homes/".concat(market.identifier),
                                                        display: "block",
                                                        analyticsName: "market-link-".concat(market.identifier),
                                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Text/* Text */.x, {
                                                            tag: "p",
                                                            typography: "$bodyMedium",
                                                            color: "$contentSecondary",
                                                            children: [
                                                                "Houses for sale in ",
                                                                market.displayName
                                                            ]
                                                        })
                                                    }, market.identifier);
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "small-medium-filters",
                        $largerThanMD: {
                            display: "none"
                        },
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                        zIndex: 15000,
                        top: -5,
                        backgroundColor: "$backgroundPrimary",
                        "aria-hidden": !showFilters,
                        opacity: showFilters ? 1 : 0,
                        style: {
                            position: "fixed",
                            transition: showFilters ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showFilters ? "visible" : "hidden",
                            transform: showFilters ? "" : "translateY(-100vh)"
                        },
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapSearchFilters, {
                            minBeds: toFilterString(minBeds),
                            minBaths: toFilterString(minBaths),
                            canSelfTour: canSelfTour,
                            minPrice: dollarToCentsString(minPrice),
                            maxPrice: dollarToCentsString(maxPrice),
                            singleFamily: singleFamily,
                            condo: condo,
                            townhome: townhome,
                            noHoas: noHoas,
                            singleStory: singleStory,
                            mustHavePool: mustHavePool,
                            minYearBuilt: toFilterString(minYearBuilt),
                            maxYearBuilt: toFilterString(maxYearBuilt),
                            minLotSize: toFilterString(minLotSize),
                            maxLotSize: toFilterString(maxLotSize),
                            minSquareFootage: toFilterString(minSquareFootage),
                            maxSquareFootage: toFilterString(maxSquareFootage),
                            handleError: handleError,
                            handleMinBedsChange: handleSetBedrooms,
                            handleMinBathsChange: handleSetBathrooms,
                            onCanSelfTourChange: handleSetCanSelfTour,
                            handleMinSquareFootageChange: handleMinSquareFootageChange,
                            handleMaxSquareFootageChange: handleMaxSquareFootageChange,
                            handleMinPriceChange: handleMinPriceChange,
                            handleMaxPriceChange: handleMaxPriceChange,
                            handleSingleFamilyChange: handleSingleFamilyChange,
                            handleCondoChange: handleCondoChange,
                            handleTownhomeChange: handleTownhomeChange,
                            handleNoHoasChange: handleNoHoasChange,
                            handleSingleStoryChange: handleSingleStoryChange,
                            handlePoolChange: handlePoolChange,
                            handleMinYearBuiltChange: handleMinYearBuiltChange,
                            handleMaxYearBuiltChange: handleMaxYearBuiltChange,
                            handleMinLotSizeChange: handleMinLotSizeChange,
                            handleMaxLotSizeChange: handleMaxLotSizeChange,
                            onApplyFilters: handleMobileFilterClick,
                            onResetFilters: searchState.resetFilters,
                            onClose: handleCloseFilters,
                            isLoading: isLoading,
                            errors: errors,
                            saveSearchQuery: getSaveSearchQuery(),
                            onApplySavedSearch: applySavedSearch
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        id: "pdp-filters-container",
                        flexDirection: "column",
                        $smallerThanLG: {
                            display: "none"
                        },
                        width: "50%",
                        height: "100%",
                        backgroundColor: "$backgroundPrimary",
                        borderTopWidth: 1,
                        borderTopColor: "$borderPrimary",
                        right: 0,
                        position: "absolute",
                        zIndex: 2,
                        "aria-hidden": !showFilters,
                        opacity: showFilters ? 1 : 0,
                        style: {
                            transition: showFilters ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showFilters ? "visible" : "hidden",
                            transform: showFilters ? "" : "translateX(50vh)"
                        },
                        "data-testid": "desktop-filters",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MapSearchFilters, {
                            minBeds: toFilterString(minBeds),
                            minBaths: toFilterString(minBaths),
                            canSelfTour: canSelfTour,
                            minPrice: dollarToCentsString(minPrice),
                            maxPrice: dollarToCentsString(maxPrice),
                            singleFamily: singleFamily,
                            condo: condo,
                            townhome: townhome,
                            noHoas: noHoas,
                            singleStory: singleStory,
                            mustHavePool: mustHavePool,
                            minYearBuilt: toFilterString(minYearBuilt),
                            maxYearBuilt: toFilterString(maxYearBuilt),
                            minLotSize: toFilterString(minLotSize),
                            maxLotSize: toFilterString(maxLotSize),
                            minSquareFootage: toFilterString(minSquareFootage),
                            maxSquareFootage: toFilterString(maxSquareFootage),
                            handleError: handleError,
                            handleMinBedsChange: handleSetBedrooms,
                            handleMinBathsChange: handleSetBathrooms,
                            onCanSelfTourChange: handleSetCanSelfTour,
                            handleMinSquareFootageChange: handleMinSquareFootageChange,
                            handleMaxSquareFootageChange: handleMaxSquareFootageChange,
                            handleMinPriceChange: handleMinPriceChange,
                            handleMaxPriceChange: handleMaxPriceChange,
                            handleSingleFamilyChange: handleSingleFamilyChange,
                            handleCondoChange: handleCondoChange,
                            handleTownhomeChange: handleTownhomeChange,
                            handleNoHoasChange: handleNoHoasChange,
                            handleSingleStoryChange: handleSingleStoryChange,
                            handlePoolChange: handlePoolChange,
                            handleMinYearBuiltChange: handleMinYearBuiltChange,
                            handleMaxYearBuiltChange: handleMaxYearBuiltChange,
                            handleMinLotSizeChange: handleMinLotSizeChange,
                            handleMaxLotSizeChange: handleMaxLotSizeChange,
                            onApplyFilters: handleApplyFilters,
                            onResetFilters: searchState.resetFilters,
                            onClose: handleCloseFilters,
                            isLoading: isLoading,
                            errors: errors,
                            saveSearchQuery: getSaveSearchQuery()
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        flexDirection: "column",
                        $smallerThanMD: {
                            display: "none"
                        },
                        height: "100%",
                        width: "50%",
                        backgroundColor: "$backgroundPrimary",
                        borderTopColor: "$borderPrimary",
                        position: "absolute",
                        right: 0,
                        zIndex: 2,
                        "aria-hidden": !showFilters,
                        opacity: showPdp ? 1 : 0,
                        style: {
                            overflowY: "scroll",
                            transition: showPdp ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showPdp ? "visible" : "hidden",
                            transform: showPdp ? "" : "translateX(50vh)"
                        },
                        children: propertyDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MiniPropertyDetailPage, {
                            property: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, propertyDetails), {
                                isLiked: isLiked,
                                onClickReaction: onClickReaction
                            }),
                            onClose: closePropertyDetails
                        }, propertyDetails.addressToken)
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        $largerThanSM: {
                            display: "none"
                        },
                        position: "absolute",
                        width: "calc(100% - 20px)",
                        marginHorizontal: "$5x",
                        height: "75vh",
                        backgroundColor: "$backgroundPrimary",
                        borderTopLeftRadius: "$16x",
                        borderTopRightRadius: "$16x",
                        overflow: "hidden",
                        zIndex: 3000,
                        "aria-hidden": !showPdp,
                        opacity: showPdp ? 1 : 0,
                        bottom: 0,
                        style: {
                            transition: showPdp ? "transform 0.5s ease, opacity 0.5s" : "transform 0.5s ease, opacity 0.5s, visibility 0.5s",
                            visibility: showPdp ? "visible" : "hidden",
                            transform: showPdp ? "" : "translateY(75vh)"
                        },
                        children: propertyDetails && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MobileMiniPropertyDetailPage, {
                            property: propertyDetails,
                            onClose: closePropertyDetails
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(FloatingNavigationBar/* FloatingNavigationBar */.u, {
                handleOnViewFavorites: handleOnViewFavorites,
                activeTab: activeTab,
                shouldHide: showPdp
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Toast/* Toast */.F, {
                analyticsName: "marketplace-search-error-toast",
                isOpen: hasError,
                onClose: clearError,
                message: "We couldn’t update results. Please try again.",
                hasError: true
            })
        ]
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(MarketplaceSeoHead, {
                marketInfo: marketInfo,
                activeMarkets: activeMarkets,
                canonicalOverride: canonicalOverride !== null && canonicalOverride !== void 0 ? canonicalOverride : undefined
            }),
            RenderBody
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ var _market_ = (Page);


/***/ }),

/***/ 3468:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(93089);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(78049);
/* harmony import */ var react_native_svg__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(24734);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);






var SvgRightArrow = function(_param) {
    var _size = _param.size, size = _size === void 0 ? 24 : _size, _color = _param.color, color = _color === void 0 ? "$contentPrimary" : _color, inProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
        "size",
        "color"
    ]);
    var outProps = {};
    if (size) {
        outProps.width = size;
        outProps.height = size;
    }
    if (color) {
        var colorToken = (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color");
        outProps.color = colorToken;
    }
    var props = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        viewBox: "0 0 24 24"
    }, inProps, outProps);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Svg */ .ny, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        xmlns: "http://www.w3.org/2000/svg",
        width: 24,
        height: 24,
        fill: "none"
    }, props), {
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__/* .jsx */ .tZ)(react_native_svg__WEBPACK_IMPORTED_MODULE_0__/* .Path */ .y$, {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M11.116 4.116a1.25 1.25 0 0 1 1.768 0l7 7a1.25 1.25 0 0 1 0 1.768l-7 7a1.25 1.25 0 0 1-1.768-1.768l4.866-4.866H5a1.25 1.25 0 1 1 0-2.5h10.982l-4.866-4.866a1.25 1.25 0 0 1 0-1.768",
            clipRule: "evenodd"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (SvgRightArrow);


/***/ }),

/***/ 94322:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "U": function() { return /* binding */ Accordion; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+accordion@1.110.0_react@18.3.1/node_modules/@tamagui/accordion/dist/jsx/Accordion.js + 1 modules
var jsx_Accordion = __webpack_require__(36278);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../bricks-next/src/__generated__/icons/ChevronDown.tsx
var ChevronDown = __webpack_require__(75683);
// EXTERNAL MODULE: ../bricks-next/src/helpers/analytics.tsx
var analytics = __webpack_require__(77453);
// EXTERNAL MODULE: ../bricks-next/src/helpers/useObservabilitySafe.ts
var useObservabilitySafe = __webpack_require__(26217);
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
// EXTERNAL MODULE: ../bricks-next/src/components/Text/index.tsx
var Text = __webpack_require__(84402);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Animated/index.js + 46 modules
var Animated = __webpack_require__(22559);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Easing/index.js + 2 modules
var Easing = __webpack_require__(12057);
;// CONCATENATED MODULE: ../bricks-next/src/components/Accordion/HeightAnimator.tsx




/**
 * Tamagui's Accordion.HeightAnimator has some bugs, so this is our own
 * implementation.
 * - Bug #1: For Tamagui Views, height isn't actually animatable on native.
 *   Solution: use Animated.View instead of Tamagui's `animation` prop.
 * - Bug #2: On iOS, onLayout gets called again when the content is still open,
 *   so the height is never recalculated to 0. Solution: check isOpen before
 *   setting the height in the onLayout handler.
 * - Bug #3: The absolute positioned element doesn't take up the full width of
 *   the parent. Solution: set left and right to 0.
 * For Tamagui's Accordion.HeightAnimator implementation, see:
 * https://github.com/tamagui/tamagui/blob/master/packages/accordion/src/Accordion.tsx
 */ var HeightAnimator = function(param) {
    var isOpen = param.isOpen, children = param.children;
    var height = (0,react.useRef)(new Animated/* default.Value */.Z.Value(0));
    var setHeight = function(toValue) {
        Animated/* default.timing */.Z.timing(height.current, {
            toValue: toValue,
            // TODO: see if we can use tokens for animation values
            duration: 100,
            easing: Easing/* default.bezier */.Z.bezier(0.42, 0, 1.0, 1.0),
            useNativeDriver: false
        }).start();
    };
    (0,react.useEffect)(function() {
        if (!isOpen) {
            setHeight(0);
        }
    }, [
        isOpen
    ]);
    var onLayout = (0,cjs.useEvent)(function(param) {
        var nativeEvent = param.nativeEvent;
        if (isOpen && nativeEvent.layout.height) {
            setHeight(nativeEvent.layout.height);
        }
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Animated/* default.View */.Z.View, {
        style: {
            height: height.current
        },
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(cjs.View, {
            position: "absolute",
            left: 0,
            right: 0,
            onLayout: onLayout,
            children: children
        })
    });
};

;// CONCATENATED MODULE: ../bricks-next/src/components/Accordion/Accordion.tsx












var accordionTokens = Components/* tokens.accordion */.T.accordion;
/**
 * This component renders a list of collapsible content items.
 *
 * Key points to note:
 * - All content is passed via the `items` prop. Each item has a "title" that is
 *   always visible and a "description" that is visible when the item is
 *   expanded. If you only have one item of content, pass one object (with both
 *   a title and a description) to the `items` prop.
 * - Each item's `description` is usually a string, but you can pass JSX to
 *   render more complex content.
 */ var Accordion = /*#__PURE__*/ (0,react.forwardRef)(function Accordion(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? false : _trackImpression, inViewThreshold = _param.inViewThreshold, showDivider = _param.showDivider, _showBottomDivider = _param.showBottomDivider, showBottomDivider = _showBottomDivider === void 0 ? true : _showBottomDivider, isFullWidth = _param.isFullWidth, _variant = _param.variant, variant = _variant === void 0 ? "regular" : _variant, disabled = _param.disabled, items = _param.items, _titleAlign = _param.titleAlign, titleAlign = _titleAlign === void 0 ? "left" : _titleAlign, _orientation = _param.orientation, orientation = _orientation === void 0 ? "top" : _orientation, _defaultOpen = _param.defaultOpen, defaultOpen = _defaultOpen === void 0 ? false : _defaultOpen, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "showDivider",
        "showBottomDivider",
        "isFullWidth",
        "variant",
        "disabled",
        "items",
        "titleAlign",
        "orientation",
        "defaultOpen"
    ]);
    var _$ref = (0,cjs.useProps)(propsIn), _size = _$ref.size, size = _size === void 0 ? "medium" : _size;
    var singleValue;
    var multipleValue;
    if (defaultOpen) {
        if (items.length > 1) {
            multipleValue = items.map(function(item) {
                return item.title;
            });
        } else if (items.length > 0) {
            singleValue = items[0].title;
        }
    }
    var accordionItems = items === null || items === void 0 ? void 0 : items.map(function(accordionItem, idx) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccordionItem, {
            showDivider: idx !== items.length - 1 ? showDivider : showDivider && showBottomDivider,
            isFullWidth: isFullWidth,
            disabled: disabled,
            variant: variant,
            size: size,
            title: accordionItem.title,
            description: accordionItem.description,
            titleAlign: titleAlign,
            orientation: orientation,
            analyticsName: analyticsName,
            suffix: accordionItem.suffix,
            eyebrowText: accordionItem.eyebrowText,
            defaultOpen: defaultOpen
        }, accordionItem.title);
    });
    var accordion = accordionItems.length > 1 ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx_Accordion/* Accordion */.U, {
        overflow: "hidden",
        defaultValue: multipleValue,
        type: "multiple",
        children: accordionItems
    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx_Accordion/* Accordion */.U, {
        overflow: "hidden",
        defaultValue: singleValue,
        type: "single",
        collapsible: true,
        children: accordionItems
    });
    if (analyticsName && trackImpression) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(analytics/* ComponentWithViewTracking */.o, {
            Component: accordion,
            analyticsName: analyticsName,
            eventName: "accordionViewEvent",
            inViewThreshold: inViewThreshold,
            ref: ref
        });
    }
    return accordion;
});
var AccordionItem = function(param) {
    var showDivider = param.showDivider, isFullWidth = param.isFullWidth, disabled = param.disabled, title = param.title, description = param.description, size = param.size, variant = param.variant, titleAlign = param.titleAlign, orientation = param.orientation, analyticsName = param.analyticsName, suffix = param.suffix, eyebrowText = param.eyebrowText, defaultOpen = param.defaultOpen;
    var showSuffix = !isFullWidth && suffix;
    var trackJourneyEvent = (0,useObservabilitySafe/* useObservabilitySafe */.r)().trackJourneyEvent;
    var ref = (0,react.useState)(defaultOpen !== null && defaultOpen !== void 0 ? defaultOpen : false), isOpen = ref[0], setIsOpen = ref[1];
    var triggerColor = "$contentPrimary";
    if (disabled) {
        triggerColor = accordionTokens.color.content.state.inactive;
    }
    var handlePress = function() {
        setIsOpen(function(prevIsOpen) {
            return !prevIsOpen;
        });
        // Track accordion click event for analytics
        if (analyticsName) {
            var data = {
                targetName: analyticsName,
                accordionName: title
            };
            trackJourneyEvent("platform", "accordionClickEvent", data);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(jsx_Accordion/* Accordion.Item */.U.Item, {
        value: title,
        "data-testid": "accordionTamagui-item",
        flexDirection: orientation === "top" ? "column" : "column-reverse",
        borderBottomWidth: showDivider ? "$default" : 0,
        borderBottomColor: showDivider ? "$borderPrimary" : "unset",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(jsx_Accordion/* Accordion.Trigger */.U.Trigger, {
                height: accordionTokens.size.height[size],
                gap: accordionTokens.padding.betweenEyebrowAndValueText[size],
                justifyContent: "center",
                backgroundColor: "$transparent",
                borderWidth: 0,
                onPress: handlePress,
                focusVisibleStyle: {
                    // Make sure all of the outline is visible, even with overflow="hidden"
                    outlineOffset: -1
                },
                paddingHorizontal: 0,
                disabled: disabled,
                pointerEvents: disabled ? "none" : "auto",
                children: [
                    eyebrowText && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                        alignItems: titleAlign === "right" ? "flex-end" : "flex-start",
                        paddingRight: "$12x",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                            tag: "span",
                            typography: accordionTokens.typography.eyebrow.default,
                            fontWeight: accordionTokens.fontWeight.eyebrowOverride,
                            color: accordionTokens.color.content.eyebrow,
                            children: eyebrowText
                        })
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Box/* Box */.x, {
                        flexDirection: "row",
                        alignItems: "center",
                        justifyContent: isFullWidth ? "space-between" : titleAlign === "right" ? "flex-end" : "flex-start",
                        columnGap: accordionTokens.padding.betweenTextChevron.default,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                                tag: "span",
                                typography: accordionTokens.typography[size][variant],
                                fontWeight: variant === "regular" ? accordionTokens.fontWeight.valueTextOverride : undefined,
                                color: triggerColor,
                                textAlign: "left",
                                children: title
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                rotate: isOpen ? "180deg" : "0deg",
                                animation: "accelerateDecelerateFastest",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronDown/* default */.Z, {
                                    size: 20,
                                    color: triggerColor
                                })
                            }),
                            showSuffix && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
                                flexGrow: 1,
                                children: suffix
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(HeightAnimator, {
                isOpen: isOpen,
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(jsx_Accordion/* Accordion.Content */.U.Content, {
                    enterStyle: {
                        opacity: 0
                    },
                    exitStyle: {
                        opacity: 0
                    },
                    animation: "accelerateDecelerateFastest",
                    paddingBottom: accordionTokens.padding.betweenContentAndDivider[size],
                    children: typeof description === "string" ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Text/* Text */.x, {
                        tag: "p",
                        typography: "$bodyMedium",
                        children: description
                    }) : description
                })
            })
        ]
    });
};


/***/ }),

/***/ 96101:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "E": function() { return /* binding */ Image_Image; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react-native-web@0.19.13_encoding@0.1.13_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/react-native-web/dist/exports/Image/index.js + 2 modules
var Image = __webpack_require__(45506);
// EXTERNAL MODULE: ../bricks-next/src/helpers/analytics.tsx
var analytics = __webpack_require__(77453);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
;// CONCATENATED MODULE: ../bricks-next/src/components/Image/helpers.tsx

var ImageTokens = Components/* tokens.image */.T.image;
/**
 * Generate border radius
 * - Currently by variant and orientation
 */ var getBorderRadiusByVariant = function(variant, orientation) {
    switch(variant){
        case "arch":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius["16x"],
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius["16x"]
            };
        case "circle":
            return {
                borderTopLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderTopRightRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomLeftRadius: ImageTokens.radius.imageCornerRadius.full,
                borderBottomRightRadius: ImageTokens.radius.imageCornerRadius.full
            };
        case "article":
            return {
                borderTopLeftRadius: orientation === "top" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderTopRightRadius: orientation === "top" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomLeftRadius: orientation === "bottom" || orientation === "left" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"],
                borderBottomRightRadius: orientation === "bottom" || orientation === "right" ? ImageTokens.radius.imageCornerRadius["8x"] : ImageTokens.radius.imageCornerRadius["2x"]
            };
        default:
            return {};
    }
};

;// CONCATENATED MODULE: ../bricks-next/src/components/Image/Image.tsx










var BaseImageReactNative = (0,cjs.styled)(Image/* default */.Z, {
    name: "Image",
    variants: {
        variant: function(variant, extras) {
            var props = extras.props;
            var orientation = props.orientation || "";
            return getBorderRadiusByVariant(variant, orientation);
        }
    }
});
/**
 * Image is an abstract styled component that renders a `<img>` element on web.
 * Some important things to note:
 * - The `source` prop is required. Typically, this will be an object that
 *   includes a `uri` pointing to a remote image asset. In other cases,
 *   `source` could be a local image asset that gets "required" into the bundle.
 * - `source.width` and `source.height` refer to the dimensions of the image
 *   resource, not the rendered image. To control the rendered image size, use
 *   the `width` and `height` props.
 * - Orientation is required if `variant` is "article"
 * - If `variant` is "circle", the rendered height will be the same as the
 *   rendered width (the `height` prop will be ignored)
 * - Image does not support press handlers like `onPress`. For a11y reasons, you should only use interactive components like Button to handle press interactions.
 */ var Image_Image = /*#__PURE__*/ (0,react.forwardRef)(function Image(_param, ref) {
    var analyticsName = _param.analyticsName, _trackImpression = _param.trackImpression, trackImpression = _trackImpression === void 0 ? false : _trackImpression, inViewThreshold = _param.inViewThreshold, source = _param.source, _enableZoom = _param.enableZoom, enableZoom = _enableZoom === void 0 ? false : _enableZoom, inProps = (0,_object_without_properties/* default */.Z)(_param, [
        "analyticsName",
        "trackImpression",
        "inViewThreshold",
        "source",
        "enableZoom"
    ]);
    if (inProps.variant === "circle") {
        inProps.height = inProps.width;
    }
    // Workaround for react-native-web Image setting width and height in the
    // rendered element's style attribute. Compare with how tamagui solves this:
    // https://github.com/tamagui/tamagui/blob/master/packages/image/src/Image.tsx#L53
    var _$ref = (0,_sliced_to_array/* default */.Z)((0,cjs.usePropsAndStyle)(inProps), 2), props = _$ref[0], style = _$ref[1];
    // Handle pinch to zoom on web
    (0,react.useEffect)(function() {
        var imageRef = cjs.isWebTouchable && ref && "current" in ref ? ref.current : undefined;
        if (cjs.isWebTouchable && imageRef && enableZoom) {
            var imageElementScale = 1;
            var SCALE_MAX = 4;
            var start = {
                x: 0,
                y: 0,
                distance: 0
            };
            // Calculate distance between two fingers
            var distance = function(event) {
                return Math.hypot(event.touches[0].pageX - event.touches[1].pageX, event.touches[0].pageY - event.touches[1].pageY);
            };
            var handleTouchStart = function(event) {
                if (event.touches.length === 2) {
                    event.preventDefault(); // Prevent page scroll
                    // Calculate where the fingers have started on the X and Y axis
                    start.x = (event.touches[0].pageX + event.touches[1].pageX) / 2;
                    start.y = (event.touches[0].pageY + event.touches[1].pageY) / 2;
                    start.distance = distance(event);
                }
            };
            var handleTouchMove = function(event) {
                if (event.touches.length === 2) {
                    event.preventDefault(); // Prevent page scroll
                    // Safari provides event.scale as two fingers move on the screen
                    // For other browsers just calculate the scale manually
                    var scale;
                    if (event === null || event === void 0 ? void 0 : event.scale) {
                        scale = event.scale;
                    } else {
                        var deltaDistance = distance(event);
                        scale = deltaDistance / start.distance;
                    }
                    imageElementScale = Math.min(Math.max(1, scale), SCALE_MAX);
                    // Calculate how much the fingers have moved on the X and Y axis
                    var deltaX = ((event.touches[0].pageX + event.touches[1].pageX) / 2 - start.x) * 2; // x2 for accelarated movement
                    var deltaY = ((event.touches[0].pageY + event.touches[1].pageY) / 2 - start.y) * 2; // x2 for accelarated movement
                    // Transform the image to make it grow and move with fingers
                    var transform = "translate3d(".concat(deltaX, "px, ").concat(deltaY, "px, 0) scale(").concat(imageElementScale, ")");
                    imageRef.style.transform = transform;
                    imageRef.style.webkitTransform = transform;
                    imageRef.style.zIndex = "9999";
                    imageRef.style.transition = "ease 150ms";
                }
            };
            var handleTouchEnd = function() {
                // Reset image to it's original format
                imageRef.style.transform = "";
                imageRef.style.webkitTransform = "";
                imageRef.style.zIndex = "";
            };
            imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchstart", handleTouchStart);
            imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchmove", handleTouchMove);
            imageRef === null || imageRef === void 0 ? void 0 : imageRef.addEventListener("touchend", handleTouchEnd);
            return function() {
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchstart", handleTouchStart);
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchmove", handleTouchMove);
                imageRef === null || imageRef === void 0 ? void 0 : imageRef.removeEventListener("touchend", handleTouchEnd);
            };
        }
        return undefined;
    }, [
        ref,
        enableZoom
    ]);
    var BaseImageWithProps = /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(BaseImageReactNative, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        accessibilityLabel: props.alt,
        source: source,
        style: style,
        ref: ref
    }));
    if (analyticsName && trackImpression) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(analytics/* ComponentWithViewTracking */.o, (0,_object_spread/* default */.Z)({
            Component: BaseImageWithProps,
            analyticsName: analyticsName,
            eventName: "imageViewEvent",
            inViewThreshold: inViewThreshold,
            ref: ref
        }, props));
    }
    return BaseImageWithProps;
});


/***/ }),

/***/ 37495:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ Loader; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@emotion+react@11.11.1_@types+react@18.3.28_react@18.3.1/node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(78049);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@opendoor+tokens-studio@16.2.0/node_modules/@opendoor/tokens-studio/dist/bricks-next/tokens/Components.js
var Components = __webpack_require__(64069);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@tamagui+core@1.110.0_react@18.3.1/node_modules/@tamagui/core/dist/cjs/index.js
var cjs = __webpack_require__(64978);
// EXTERNAL MODULE: ../../node_modules/.pnpm/lottie-react-native@7.0.0_@dotlottie+react-player@1.6.19_@types+react@18.3.28_react@18._2e2fde213233d6c2c4ce1ae8c0a8fbad/node_modules/lottie-react-native/lib/module/index.js + 7 modules
var lib_module = __webpack_require__(79183);
;// CONCATENATED MODULE: ../bricks-next/src/assets/animations/SpinnerNoLogo.json
var SpinnerNoLogo_namespaceObject = JSON.parse('{"nm":"Main Scene","ddd":0,"h":500,"w":500,"meta":{"g":"@lottiefiles/creator 1.26.0"},"layers":[{"ty":4,"nm":"Runner 1","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[-52.98,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001]],"v":[[100,3.3799999999999955],[100,3.3799999999999955],[196,99.38],[196,208.18],[176.8,227.38],[23.19999999999999,227.38],[4,208.18],[4,99.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[1,1,1]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":69},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":79},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":82},{"s":[100],"t":93}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":69},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":79},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":82},{"s":[98],"t":93}]},"m":1},{"ty":"tr","a":{"a":0,"k":[0,0.3849999999999909]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0.3849999999999909]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":68},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":69},{"s":[100],"t":93}]}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":1},{"ty":4,"nm":"Runner 2","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":60},{"s":[0],"t":61}]}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[-52.98,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001]],"v":[[100,3.3799999999999955],[100,3.3799999999999955],[196,99.38],[196,208.18],[176.8,227.38],[23.19999999999999,227.38],[4,208.18],[4,99.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[1,1,1]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":53},{"s":[100],"t":60}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":53},{"s":[98],"t":60}]},"m":1},{"ty":"tr","a":{"a":0,"k":[0,0.3849999999999909]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0.3849999999999909]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":2},{"ty":4,"nm":"Runner","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":38},{"s":[0],"t":39}]}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[-52.98,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001]],"v":[[100,3.3799999999999955],[100,3.3799999999999955],[196,99.38],[196,208.18],[176.8,227.38],[23.19999999999999,227.38],[4,208.18],[4,99.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[1,1,1]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[2],"t":1},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":13},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":26},{"s":[100],"t":38}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":1},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[2],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":13},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[99],"t":26},{"s":[100],"t":38}]},"m":1},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":3},{"ty":4,"nm":"Shape Layer 1","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0],[-52.98,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001],[0,0]],"v":[[100,3.38],[100,3.38],[196,99.38],[196,208.18],[176.8,227.38],[23.2,227.38],[4,208.18],[4,99.38000000000001],[100,3.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[0.8745,0.8588,0.8471]}},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":4}],"v":"5.7.0","fr":30,"op":97,"ip":0,"assets":[]}');
;// CONCATENATED MODULE: ../bricks-next/src/assets/animations/SpinnerWithLogo.json
var SpinnerWithLogo_namespaceObject = JSON.parse('{"nm":"Main Scene","ddd":0,"h":500,"w":500,"meta":{"g":"@lottiefiles/creator 1.29.0"},"layers":[{"ty":4,"nm":"Grey Runner Third","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0],[-52.98,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001],[0,0]],"v":[[100,3.38],[100,3.38],[196,99.38],[196,208.18],[176.8,227.38],[23.2,227.38],[4,208.18],[4,99.38000000000001],[100,3.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[0.2471,0.2275,0.2314]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":69},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":79},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":82},{"s":[100],"t":93}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":69},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":79},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":82},{"s":[98],"t":93}]},"m":1},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":68},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":69},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":93},{"s":[0],"t":94}]}}]}],"ind":1},{"ty":4,"nm":"Grey Runner Second","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0],[-52.98,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001],[0,0]],"v":[[100,3.38],[100,3.38],[196,99.38],[196,208.18],[176.8,227.38],[23.2,227.38],[4,208.18],[4,99.38000000000001],[100,3.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[0.2471,0.2275,0.2314]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":53},{"s":[100],"t":60}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":48},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":53},{"s":[98],"t":60}]},"m":1},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[0],"t":38},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":39},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":60},{"s":[0],"t":61}]}}]}],"ind":2},{"ty":4,"nm":"Grey Runner First","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0],[-52.98,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001],[0,0]],"v":[[100,3.38],[100,3.38],[196,99.38],[196,208.18],[176.8,227.38],[23.2,227.38],[4,208.18],[4,99.38000000000001],[100,3.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[0.2471,0.2275,0.2314]}},{"ty":"tm","bm":0,"hd":false,"nm":"Trim Path","e":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[2],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":13},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":26},{"s":[100],"t":38}]},"o":{"a":0,"k":0},"s":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[1],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[2],"t":4},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[77],"t":13},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[98],"t":16},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[99],"t":26},{"s":[100],"t":38}]},"m":1},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[100,115.38499999999999]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":1,"k":[{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":0},{"o":{"x":0.167,"y":0.167},"i":{"x":0.833,"y":0.833},"s":[100],"t":38},{"s":[0],"t":39}]}}]}],"ind":3},{"ty":4,"nm":"Shape Layer 1","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[100,115.38499999999999]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,250]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0,-52.97999999999999],[0,0],[10.599999999999994,0],[0,0],[0,10.599999999999994],[0,0],[-52.98,0]],"o":[[0,0],[52.97999999999999,0],[0,0],[0,10.599999999999994],[0,0],[-10.6,0],[0,0],[0,-52.98000000000001],[0,0]],"v":[[100,3.38],[100,3.38],[196,99.38],[196,208.18],[176.8,227.38],[23.2,227.38],[4,208.18],[4,99.38000000000001],[100,3.38]]}}},{"ty":"st","bm":0,"hd":false,"nm":"Stroke","lc":1,"lj":1,"ml":10,"o":{"a":0,"k":100},"w":{"a":0,"k":6},"c":{"a":0,"k":[1,1,1]}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":4},{"ty":4,"nm":"Logo","sr":1,"st":0,"op":150,"ip":0,"hd":false,"ddd":0,"bm":0,"hasMask":false,"ao":0,"ks":{"a":{"a":0,"k":[20.724999999999994,29]},"s":{"a":0,"k":[150,150]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[250,256]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}},"shapes":[{"ty":"gr","bm":0,"ln":"Layer_1","hd":false,"nm":"Layer_1","it":[{"ty":"gr","bm":0,"hd":false,"nm":"Group 1","it":[{"ty":"sh","bm":0,"hd":false,"nm":"Path 1","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[0,0],[0.6499999999999986,0],[0,0],[0.34999999999999964,-0.44999999999999574],[0,0],[0,-0.22999999999999687],[0,0],[-0.31999999999999984,0],[0,0],[0,0.3100000000000023],[0,0],[0.14999999999999858,0.18999999999999773]],"o":[[-0.9699999999999989,-1.259999999999998],[-0.3500000000000014,-0.46000000000000085],[0,0],[-0.6500000000000004,0],[0,0],[-0.1499999999999999,0.18999999999999773],[0,0],[0,0.3100000000000023],[0,0],[0.3200000000000003,0],[0,0],[0,-0.22999999999999687],[0,0]],"v":[[38.64,54.84],[33.93,48.720000000000006],[32.33,47.99000000000001],[9.12,47.99000000000001],[7.52,48.720000000000006],[2.8099999999999996,54.84],[2.5799999999999996,55.49],[2.5799999999999996,56.42],[3.1599999999999997,56.980000000000004],[38.29,56.980000000000004],[38.87,56.42],[38.87,55.49],[38.64,54.84]]}}},{"ty":"sh","bm":0,"hd":false,"nm":"Path 2","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[-9.530000000000001,0],[0,-14.380000000000003],[9.529999999999998,0],[0,13.910000000000004]],"o":[[0,-15.25],[10.18,0],[0,15.359999999999996],[-10.17,-7.105427357601002e-15],[0,0]],"v":[[0.72,22.29],[20.96,1.01],[40.72,21.360000000000003],[20.48,42.57000000000001],[0.72,22.29]]}}},{"ty":"sh","bm":0,"hd":false,"nm":"Path 3","d":1,"ks":{"a":0,"k":{"c":true,"i":[[0,0],[6.509999999999998,0],[0,-13.680000000000001],[-6.630000000000003,0],[0,13.629999999999999]],"o":[[0,-13.56],[-5.74,0],[0,13.680000000000001],[5.859999999999999,0],[0,0]],"v":[[29.48,22.63],[20.6,3.4399999999999977],[11.96,21.06],[20.840000000000003,40.129999999999995],[29.480000000000004,22.619999999999994]]}}},{"ty":"fl","bm":0,"hd":false,"nm":"Fill","c":{"a":0,"k":[1,1,1]},"r":2,"o":{"a":0,"k":100}},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]},{"ty":"tr","a":{"a":0,"k":[0,0]},"s":{"a":0,"k":[100,100]},"sk":{"a":0,"k":0},"p":{"a":0,"k":[0,0]},"r":{"a":0,"k":0},"sa":{"a":0,"k":0},"o":{"a":0,"k":100}}]}],"ind":5}],"v":"5.7.0","fr":30,"op":99,"ip":0,"assets":[]}');
// EXTERNAL MODULE: ../bricks-next/src/components/Box/Box.tsx
var Box = __webpack_require__(22901);
;// CONCATENATED MODULE: ../bricks-next/src/components/Loader/Loader.tsx








var loaderTokens = Components/* tokens.loaders */.T.loaders;
/**
 * Loader Component
 *
 * @example
 * //Usage example:
 *
 * <Loader size="small" withLogo backgroundColor="black"/>
 *
 *
 * @param {LoaderProps} props - The props for the component.
 * @returns {React.JSX.Element} The rendered component.
 */ var Loader = function(_param) {
    var backgroundColor = _param.backgroundColor, withLogo = _param.withLogo, onAnimationFailure = _param.onAnimationFailure, propsIn = (0,_object_without_properties/* default */.Z)(_param, [
        "backgroundColor",
        "withLogo",
        "onAnimationFailure"
    ]);
    var ref = (0,cjs.useProps)(propsIn), _size = ref.size, size = _size === void 0 ? "small" : _size;
    var loaderType = withLogo ? "spinnerWithLogo" : "spinnerNoLogo";
    var width = loaderTokens.size[loaderType].width[size], height = loaderTokens.size[loaderType].height[size], bgColor = backgroundColor || loaderTokens.color.background.spinnerWithLogo;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Box/* Box */.x, {
        width: width,
        height: height,
        backgroundColor: bgColor,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lib_module/* default */.Z, {
            style: {
                width: "100%",
                height: "100%"
            },
            source: withLogo ? SpinnerWithLogo_namespaceObject : SpinnerNoLogo_namespaceObject,
            autoPlay: true,
            loop: true,
            onAnimationFailure: onAnimationFailure
        })
    });
};


/***/ }),

/***/ 16064:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ adaptExternalIcon; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(36690);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(59106);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(78049);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64978);
/* harmony import */ var _tamagui_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_tamagui_core__WEBPACK_IMPORTED_MODULE_2__);





/**
 * Creates a compatibility wrapper for external icon components (e.g., from @tabler/icons-react)
 * to work with IconButton and other bricks-next components that expect the BricksSvgProps signature.
 *
 * @param IconComponent - The external icon component to wrap
 * @returns A component that matches the expected IconButton icon signature
 *
 * @example
 * ```tsx
 * import { IconBrandGoogle } from '@tabler/icons-react';
 * import { adaptExternalIcon } from '@opendoor/bricks-next';
 *
 * const GoogleIcon = adaptExternalIcon(IconBrandGoogle);
 *
 * <IconButton
 *   icon={{ Component: GoogleIcon, label: 'Sign in with Google' }}
 *   size="medium"
 * />
 * ```
 */ function adaptExternalIcon(IconComponent) {
    var AdaptedIcon = function(_param) {
        var _size = _param.size, size = _size === void 0 ? 24 : _size, color = _param.color, ariaLabel = _param["aria-label"], props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_param, [
            "size",
            "color",
            "aria-label"
        ]);
        // Convert color token to a string value using getToken
        var tokenValue = color ? (0,_tamagui_core__WEBPACK_IMPORTED_MODULE_2__.getToken)(color, "color") : undefined;
        var iconColor = tokenValue !== undefined ? String(tokenValue) : undefined;
        return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(IconComponent, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
            size: size,
            color: iconColor,
            "aria-label": ariaLabel
        }, props));
    };
    AdaptedIcon.displayName = "AdaptedIcon(".concat(IconComponent.displayName || IconComponent.name || "Icon", ")");
    return AdaptedIcon;
}


/***/ }),

/***/ 43547:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"table":"ComparisonTable_table__swUM5","borderLayout":"ComparisonTable_borderLayout__RVdZ5","noBorderLayout":"ComparisonTable_noBorderLayout__06m8F","leftAlign":"ComparisonTable_leftAlign___9Tpj","centerAlign":"ComparisonTable_centerAlign__MQgFD","tableImage":"ComparisonTable_tableImage__dB9eP"};

/***/ }),

/***/ 10586:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heroImageWrapper":"HeroV2_heroImageWrapper___mRK8","heroLeftGradient":"HeroV2_heroLeftGradient__keay8","heroTopGradient":"HeroV2_heroTopGradient__WhS_j","treatmentImageWrapper":"HeroV2_treatmentImageWrapper__qjH34"};

/***/ }),

/***/ 82466:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"containerVideoMaxHeight":"LWCHeroCard_containerVideoMaxHeight___V3B6","containerImageMaxHeight":"LWCHeroCard_containerImageMaxHeight__h9CEX","containerMinHeight":"LWCHeroCard_containerMinHeight__6qoFO","videoFlexWrapper":"LWCHeroCard_videoFlexWrapper__8nBXc","imagePositionWrapper":"LWCHeroCard_imagePositionWrapper__Epooh","video":"LWCHeroCard_video__I9sc2"};

/***/ }),

/***/ 96675:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"grid12":"StandaloneText_grid12__cuSBu","grid8":"StandaloneText_grid8__ZXcoc","introColumns":"StandaloneText_introColumns__Q0zVe"};

/***/ }),

/***/ 10654:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"reveal":"StickyCTAUtility_reveal__dnjbT","hide":"StickyCTAUtility_hide__m_YNZ","container":"StickyCTAUtility_container__QsIih"};

/***/ }),

/***/ 66382:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"lpButton":"Buttons_lpButton__keCak"};

/***/ }),

/***/ 75422:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"optionsList":"ListBox_optionsList__6NpZo","optionsScroll":"ListBox_optionsScroll__WmXCp","ctaButton":"ListBox_ctaButton__Cf1zk"};

/***/ }),

/***/ 56936:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"markerPulse":"Marker_markerPulse__CKEK_","marker-pulse":"Marker_marker-pulse__h9kgv","markerFadeIn":"Marker_markerFadeIn__2mAxD","marker-fade-in":"Marker_marker-fade-in__MUDJR"};

/***/ }),

/***/ 78743:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"popupEnter":"MapMarker_popupEnter__9q8T8"};

/***/ }),

/***/ 55221:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"mapRoot":"MarketplaceMap_mapRoot__ST_O8"};

/***/ }),

/***/ 3952:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"slider":"CardCarouselV2_slider__0eSSc"};

/***/ }),

/***/ 82946:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"list":"MulticardList_list__JOGOw"};

/***/ }),

/***/ 44371:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 44944:
/***/ (function() {

/* (ignored) */

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5653,4607,9115,820,9560,1028,7032,7573,8748,6184,6545,8948,6772,9183,3448,6240,1500,8291,1154,6492,7109,3476,2766,589,2687,5344,9606,3931,5779,9774,2888,179], function() { return __webpack_exec__(95834); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);